import type { Dict } from '../types';

export const ptBR: Dict = {
  'chat.amrCard.switchTitle': 'Falha ao chamar o modelo — esta execução está pausada',
  'chat.amrCard.switchBody': 'Mude para o serviço oficial de modelos do Crie3 Cloud — sem precisar configurar API Key. Após entrar, autorizar e recarregar, esta execução será repetida automaticamente.',
  'chat.amrCard.chipOfficial': 'Hospedagem oficial',
  'chat.amrCard.chipNoKey': 'Sem API Key',
  'chat.amrCard.chipAutoRetry': 'Nova tentativa automática após entrar',
  'chat.amrCard.switchCta': 'Mudar para Crie3 Cloud e tentar novamente',
  'chat.amrError.authMessage': 'Sua conta Crie3 Cloud ainda não está autorizada. Autorize-a e esta execução será repetida automaticamente.',
  'chat.amrError.balanceMessage': 'Seu saldo Crie3 Cloud acabou. Recarregue para continuar esta execução.',
  'chat.amrError.authorizeCta': 'Autorizar e tentar novamente',
  'chat.amrError.rechargeCta': 'Recarregar Crie3 Cloud',
  'chat.amrBalanceGate.title': 'Faça upgrade e continue criando',
  'chat.amrBalanceGate.message': 'Créditos insuficientes (restam {balance}). Faça upgrade do plano ou recarregue e a tarefa pode começar na hora.',
  'chat.amrBalanceGate.benefitsTitle': 'O que o Crie3 Cloud oferece',
  'chat.amrBalanceGate.benefit1': 'Sem chave de API, vários modelos à escolha',
  'chat.amrBalanceGate.benefit2': 'Agente de design SOTA integrado, sem configuração',
  'chat.amrBalanceGate.benefit3': 'Serviço oficial e confiável',
  'chat.amrBalanceGate.benefit4': 'Sempre evoluindo: publique em 1 clique, crie imagem, vídeo e áudio, trabalhe em equipe e mais',
  'chat.amrBalanceGate.laterCta': 'Agora não',
  'chat.amrBalanceGate.plansCta': 'Fazer upgrade',
  'chat.amrBalanceGate.signedOutTitle': 'Entre para começar a criar',
  'chat.amrBalanceGate.signedOutMessage': 'Você está usando o agente Crie3 Cloud — entre e esta tarefa pode começar na hora.',
  'chat.amrBalanceGate.signInCta': 'Entrar',
  'chat.amrBalanceGate.watchingWallet': 'Continuaremos automaticamente assim que seu saldo for atualizado.',
  'chat.amrLowBalance.title': 'Créditos acabando',
  'chat.amrLowBalance.message': 'Restam apenas {balance} — provavelmente não é o bastante para concluir esta tarefa. Recarregue ou faça upgrade antes.',
  'chat.amrLowBalance.rechargeCta': 'Recarregar',
  'chat.amrLowBalance.proceedCta': 'Iniciar mesmo assim',
  'chat.amrLowBalance.dontRemind': 'Não perguntar novamente',
  'chat.amrArtifactUpgrade.title': 'Continue refinando com modelos mais potentes',
  'chat.amrArtifactUpgrade.message': 'Desbloqueie modelos avançados, mais tarefas paralelas e mais créditos mensais.',
  'chat.amrArtifactUpgrade.benefit1': 'Mais modelos avançados, incluindo Fable 5 e GPT-5.6',
  'chat.amrArtifactUpgrade.benefit2': 'Até 10 vezes mais tarefas simultâneas',
  'chat.amrArtifactUpgrade.benefit3': 'Até 300 vezes mais créditos mensais',
  'chat.amrArtifactUpgrade.benefit4': 'Fila prioritária nos horários de pico para gerar mais rápido',
  'chat.amrArtifactUpgrade.promoBanner': 'Por tempo limitado: economize até 67% nos planos de assinatura',
  'chat.amrArtifactUpgrade.countdownLabel': 'Termina em',
  'chat.amrArtifactUpgrade.plansCta': 'Faça upgrade agora, até 67% de desconto',
  'chat.amrArtifactUpgrade.homePlansCta': 'Economize 67%',
  'chat.amrArtifactUpgrade.laterCta': 'Continuar com Free e enviar',
  'chat.amrArtifactUpgrade.homeTitle': 'Sua criação está pronta. Leve a próxima ideia ainda mais longe.',
  'chat.amrArtifactUpgrade.homeMessage': 'Faça upgrade para modelos mais potentes, mais tarefas paralelas e mais créditos.',
  'chat.amrArtifactUpgrade.homeArtifactCta': 'Ver criação',
  'chat.antigravityError.launchTerminalCta': 'Entrar pelo terminal',
  'chat.antigravityError.launchSwitchModelCta': 'Alternar modelo no terminal',
  'chat.connectionDropped': 'A conexão com o serviço do modelo caiu antes de a resposta terminar — geralmente uma rede ou proxy instável. Tente novamente.',
  'chat.runError.title.authRequired': 'Autorização necessária',
  'chat.runError.title.balance': 'Saldo insuficiente',
  'chat.runError.title.connectionDropped': 'Conexão interrompida',
  'chat.runError.title.signInRequired': 'Login necessário',
  'chat.runError.title.rateLimited': 'Limite de uso atingido',
  'chat.runError.title.generic': 'A tarefa falhou',
  'chat.runError.signInMessage.amr': 'O agente Crie3 Cloud ainda não fez login — faça login para começar a usá-lo.',
  'chat.runError.signInMessage.other': '{agent} não fez login. Verifique o status de login localmente. Recomendamos o agente Crie3 Cloud — mais estável e econômico.',
  'chat.runError.agentFallback': 'o agente',
  'chat.runError.sourceLabel': 'Origem do erro',
  'chat.runError.sourceExpandAria': 'Expandir origem do erro',
  'chat.runError.sourceCollapseAria': 'Recolher origem do erro',
  'chat.runError.title.cliMissing': 'Agente não instalado',
  'chat.runError.title.promptTooLarge': 'Entrada muito longa',
  'chat.runError.title.modelUnavailable': 'Modelo indisponível',
  'chat.runError.title.upstreamUnavailable': 'Serviço temporariamente indisponível',
  'chat.runError.title.toolLoop': 'Preso em um loop',
  'chat.runError.title.outputInvalid': 'Saída do modelo inválida',
  'chat.runError.title.runtimeConfig': 'Erro de configuração',
  'chat.runError.cliMissingMessage': 'A ferramenta de linha de comando do {agent} não foi encontrada. Instale-a e verifique se está no PATH, depois tente novamente.',
  'chat.runError.promptTooLargeMessage': 'Esta mensagem ficou maior do que o assistente consegue ler de uma vez. Escreva um pedido mais curto, tire anexos ou comece uma conversa nova e tente de novo.',
  'chat.runError.modelUnavailableMessage': 'O modelo selecionado está indisponível ou não existe. Troque para outro modelo em Configurações e tente novamente.',
  'chat.runError.rateLimitedMessage': 'Você atingiu o limite de uso do serviço do modelo. Aguarde um momento e tente novamente, ou troque para outro modelo ou serviço.',
  'chat.runError.upstreamUnavailableMessage': 'O serviço do modelo está temporariamente indisponível — geralmente instabilidade upstream ou um problema de rede/proxy. Tente novamente em instantes.',
  'chat.runError.toolLoopMessage': 'O {agent} repetiu a mesma ação sem progredir e foi interrompido. Verifique o arquivo ou comando de destino e tente novamente.',
  'chat.runError.outputInvalidMessage': 'O modelo produziu uma saída inválida e este turno foi interrompido. Tentar novamente costuma resolver.',
  'chat.runError.runtimeConfigMessage': 'A configuração de runtime do agente selecionado é inválida, então a execução não pôde iniciar. Atualize para a versão mais recente ou contate o suporte.',
  'chat.runError.title.quotaExhausted': "Cota esgotada",
  'chat.runError.title.timedOut': "Tempo esgotado",
  'chat.runError.title.emptyOutput': "Sem saída",
  'chat.hostedAgentName': "Agente Crie3",
  'chat.plain.warningTruncated': 'A resposta foi interrompida por segurança. Peça de novo, de preferência com mais detalhes.',
  'chat.plain.warningRepeatedStopped': 'A mesma etapa falhou várias vezes seguidas, então o trabalho parou. Tente pedir de novo ou descrever de outro jeito.',
  'chat.plain.warningRepeatedStuck': 'A mesma etapa está falhando várias vezes seguidas e pode travar o trabalho.',
  'chat.runError.hostedGenericMessage': 'A tarefa não terminou. Tente de novo em instantes — se continuar acontecendo, fale com a gente.',
  'chat.plain.details': "Ver detalhes técnicos",
  'chat.plain.detailsHide': "Ocultar detalhes técnicos",
  'chat.brandAudit.needsFixes': "Precisa de ajustes ({count})",
  'chat.brandAudit.syncFailed': "Não foi possível atualizar a marca agora: {error}",
  'chat.brandAudit.checkFailed': "Não foi possível conferir a marca agora.",
  'chat.brandEnrichmentStartFailed': 'Não foi possível iniciar o refino agora. Tente de novo em instantes.',
  'chat.designNoResult': 'O Crie3 terminou sem gerar a peça. Tente pedir de novo — se continuar acontecendo, conte o que você pediu que a gente investiga.',
  'chat.designDeliveryFailed': 'A peça foi criada, mas o Crie3 não conseguiu salvar no projeto. Tente de novo.',
  'chat.runError.title.sessionExpired': "Sessão expirada",
  'chat.runError.title.gitBashMissing': "Git Bash ausente",
  'chat.runError.quotaExhaustedMessage': "A cota ou o limite de cobrança do seu serviço de modelo acabou, então tentar de novo não vai ajudar. Recarregue com seu provedor ou mude para outro modelo ou serviço.",
  'chat.runError.workspaceCreditsMessage': "Seu espaço de trabalho ficou sem créditos. Adicione créditos (ou peça ao proprietário do espaço para recarregar) ou mude para outro modelo ou serviço.",
  'chat.runError.timedOutMessage': "Esta execução demorou demais e foi interrompida. Tente novamente ou reduza a tarefa e repita.",
  'chat.runError.inactivityTimeoutMessage': "O agente ficou sem nova saída por tempo demais e foi interrompido por tempo esgotado. Tentar de novo costuma retomá-lo.",
  'chat.runError.emptyOutputMessage': "O agente terminou sem produzir nenhuma saída. Isso costuma ser temporário, tente novamente.",
  'chat.runError.sessionExpiredMessage': "A sessão retomada havia expirado. Ela foi redefinida, então tente novamente para iniciar uma nova execução.",
  'chat.runError.gitBashMissingMessage': "O Git Bash é necessário para executar este agente no Windows, mas não foi encontrado. Instale o Git para Windows e tente novamente.",
  'common.cancel': 'Cancelar',
  'chat.selectFromLibrary': 'Importar da biblioteca',
  'chat.importFigma': 'Importar do Figma',
  'chat.plus.group.files': 'Arquivos',
  'chat.plus.group.code': 'Código',
  'chat.plus.group.designs': 'Designs',
  'chat.plus.group.other': 'Outros',
  'chat.plus.attachFiles': 'Anexar arquivos',
  'chat.plus.referenceProject': 'Referenciar outro projeto',
  'chat.plus.linkLocalCode': 'Vincular código local',
  'chat.plus.uploadFig': 'Enviar arquivo .fig',
  'chat.plus.learnHow': 'Saiba como',
  'chat.plus.designSystem': 'Design system',
  'chat.plus.skills': 'Skills',
  'chat.plus.noSkills': 'Nenhuma skill disponível',
  'chat.plus.connectors': 'Conectores',
  'chat.plus.plugins': 'Plugins',
  'chat.plus.mcp': 'MCP',
  'chat.referenceProject.title': 'Referenciar outro projeto',
  'chat.referenceProject.search': 'Buscar projetos…',
  'chat.referenceProject.empty': 'Nenhum projeto corresponde a “{query}”',
  'chat.referenceProject.emptyAll': 'Ainda não há outros projetos',
  'chat.referenceProject.loadFailed': 'Não foi possível carregar os projetos. Verifique se o daemon está em execução e tente novamente.',
  'chat.referenceProject.confirm': 'Referenciar projeto',
  'chat.contextPrompt.referenceProject': 'Use o projeto do Crie3 “{name}” como contexto de referência. Seu caminho local é: {path}. Antes de criar ou modificar qualquer coisa, busque e leia este diretório quando for útil.',
  'chat.contextPrompt.localCode': 'Use a pasta de código local “{name}” como referência de código. Seu caminho absoluto é: {path}. Leia os arquivos relevantes quando for útil e mantenha a consistência com a implementação existente.',
  'chat.figmaHelp.title': 'Como baixar um arquivo .fig',
  'chat.figmaHelp.intro': 'No Figma web ou no app desktop:',
  'chat.figmaHelp.step1': 'Abra o arquivo no Figma.',
  'chat.figmaHelp.step2': 'Vá em File → Save local copy... (web: menu principal → File).',
  'chat.figmaHelp.step3': 'O Figma baixa um arquivo .fig. Arraste-o para o compositor ou faça o envio.',
  'chat.figmaHelp.note': 'O arquivo .fig é processado localmente e não é enviado ao Figma.',
  'designFiles.library.label': 'Importar da biblioteca',
  'designFiles.library.title': 'Importar da biblioteca',
  'libraryPicker.title': 'Importar da biblioteca',
  'libraryPicker.searchPlaceholder': 'Pesquisar na biblioteca…',
  'libraryPicker.empty': 'Ainda não há recursos na sua biblioteca',
  'libraryPicker.allKinds': 'Todos',
  'libraryPicker.add': 'Importar',
  'libraryPicker.loading': 'Carregando…',
  'common.save': 'Salvar',
  'common.close': 'Fechar',
  'common.clear': 'Limpar',
  'common.delete': 'Excluir',
  'common.rename': 'Renomear',
  'common.edit': 'Editar',
  'common.preview': 'Prévia',
  'common.share': 'Compartilhar',
  'common.search': 'Buscar',
  'common.searchEllipsis': 'Buscar…',
  'common.loading': 'Carregando…',
  'common.all': 'Todos',
  'common.none': 'Nenhum',
  'common.default': 'Padrão',
  'common.installed': 'instalado',
  'common.notInstalled': 'não instalado',
  'common.active': 'ativo',
  'common.disabled': 'Desativado',
  'common.enabled': 'Ativado',
  'common.selected': 'selecionado',
  'common.create': 'Criar',
  'common.openPreview': 'Abrir prévia',
  'common.exitFullscreen': 'Sair da tela cheia',
  'common.fullscreen': 'Tela cheia',
  'common.openInNewTab': 'Abrir em nova aba',
  'common.exportPdf': 'Exportar como PDF',
  'common.exportZip': 'Baixar como .zip',
  'common.exportHtml': 'Exportar como HTML independente',
  'common.exportImage': 'Exportar como imagem',
  'common.exportImageFailed': 'Não foi possível gerar a imagem. Tente de novo.',
  'common.justNow': 'agora mesmo',
  'common.minutesAgo': 'há {n} min',
  'common.hoursAgo': 'há {n} h',
  'common.daysAgo': 'há {n} d',
  'common.weeksAgo': 'há {n}sem',
  'common.now': 'agora',
  'common.minutesShort': '{n} min',
  'common.hoursShort': '{n} h',
  'common.daysShort': '{n} d',
  'common.untitled': 'Sem título',
  'designBrowser.savePageBrief': 'Save page brief',
  'designBrowser.menu': 'Menu do navegador',
  'designBrowser.copyScreenshot': 'Copy screenshot',
  'designBrowser.hardReload': 'Hard reload',
  'designBrowser.copyUrl': 'Copiar URL',
  'designBrowser.openExternal': 'Open externally',
  'designBrowser.downloadPage': 'Download page',
  'designBrowser.downloadPageBusy': 'Baixando página...',
  'designBrowser.clearHistory': 'Clear history',
  'designBrowser.clearCookies': 'Clear cookies',
  'designBrowser.clearAllData': 'Clear all browser data',
  'designBrowser.status.noUrlToCopy': 'Nenhuma URL para copiar.',
  'designBrowser.status.urlCopied': 'URL copiada.',
  'designBrowser.status.openHttpFirst': 'Abra primeiro uma página http ou https.',
  'designBrowser.status.openBeforeScreenshot': 'Abra uma página antes de fazer uma captura de tela.',
  'designBrowser.status.screenshotSaved': 'Captura de tela salva.',
  'designBrowser.status.screenshotFailed': 'Falha na captura de tela.',
  'designBrowser.status.openBeforeBrief': 'Abra uma página antes de salvar um brief.',
  'designBrowser.status.briefSaveFailed': 'Falha ao salvar o brief da página.',
  'designBrowser.status.openBeforeDownload': 'Abra uma página antes de salvar um snapshot.',
  'designBrowser.status.pageSnapshotStarted': 'Salvando snapshot da página...',
  'designBrowser.status.pageSnapshotUnsupported': 'Esta página não pode ser arquivada.',
  'designBrowser.status.pageSnapshotFailed': 'Falha ao salvar o snapshot da página.',
  'designBrowser.status.pageSnapshotSaved': 'Snapshot da página salvo (HTML + CSS).',
  'designBrowser.status.viewDesignFiles': 'Ver arquivos de design',
  'designBrowser.status.downloadAssistHint': 'Passo 2: clique em Baixar Página aqui, aguarde a confirmação do snapshot salvo e volte ao card Próximo Passo à esquerda e clique em Continuar extração.',
  'designBrowser.status.desktopDataUnavailable': 'Os dados do navegador desktop não estão disponíveis aqui.',
  'designBrowser.status.browserDataCleared': 'Dados do navegador limpos.',
  'designBrowser.status.browserDataClearFailed': 'Falha ao limpar os dados do navegador.',
  'designBrowser.status.historyCleared': 'Histórico limpo.',
  'plugins.availableDetails.provenance': 'Procedência',
  'plugins.availableDetails.provenanceLine': 'de {source} · {trust} · {resolved}',
  'plugins.availableDetails.provenanceLineWithIntegrity': 'de {source} · {trust} · {resolved} · {integrity}',
  'plugins.availableDetails.install': 'Instalar',
  'plugins.availableDetails.version': 'Versão',
  'plugins.availableDetails.pluginVersion': 'Versão do plugin',
  'plugins.availableDetails.copyInstallCommand': 'Copiar comando de instalação',
  'plugins.availableDetails.copied': 'Copiado',
  'plugins.availableDetails.deprecatedPrefix': 'Obsoleto: {message}',
  'plugins.availableDetails.deprecatedFallback': 'Esta versão foi marcada como obsoleta.',
  'plugins.availableDetails.yanked': 'Removida.',
  'plugins.availableDetails.yankedWithReason': 'Removida: {reason}',
  'plugins.availableDetails.versionDeprecatedSuffix': ' (obsoleto)',
  'plugins.availableDetails.versionYankedSuffix': ' (removido)',
  'plugins.availableDetails.ref': 'Ref',
  // Locked to English in every locale by tests/i18n/locales.test.ts: it names
  // the manifest's integrity hash field, not the concept.
  'plugins.availableDetails.integrity': 'Integrity',
  'plugins.availableDetails.permissions': 'Permissões',
  'plugins.availableDetails.capabilitySummary': 'Resumo de recursos',
  'plugins.actions.copyInstallCommand': 'Copiar comando de instalação',
  'plugins.actions.copyPluginId': 'Copiar ID do plugin',
  'plugins.actions.openSourceGithub': 'Abrir fonte no GitHub',
  'plugins.actions.openSource': 'Abrir fonte',
  'plugins.actions.openHomepage': 'Abrir homepage',
  'plugins.actions.openMarketplace': 'Abrir no marketplace',
  'app.brand': 'Crie3',
  'app.brandPill': 'Prévia de pesquisa',
  'app.brandSubtitle': 'por Nexu Labs',
  'app.welcomeLoading': 'Carregando área de trabalho…',
  'settings.welcomeKicker': '',
  'settings.welcomeTitle': 'Boas-vindas ao Crie3',
  'settings.welcomeSubtitle': '',
  'settings.onboardingCreateTitle': 'Comece com um briefing',
  'settings.onboardingCreateBody': 'Descreva o site, app, apresentação, imagem ou vídeo que você quer. O Crie3 vai criar um projeto e manter o trabalho editável.',
  'settings.onboardingMemoryTitle': 'Salvar contexto de trabalho',
  'settings.onboardingMemoryBody': 'Adicione preferências, informações do projeto e regras recorrentes para que conversas futuras assumam o contexto certo.',
  'settings.onboardingMemoryCalloutTitle': 'Salvo na sua Memória',
  'settings.onboardingMemoryCalloutBody': 'Estas respostas formam a base do seu perfil de Memória. O Crie3 reutiliza isso em cada tarefa — e continua aprendendo conforme você trabalha.',
  'settings.onboardingMemoryBenefitIntent': 'Entende o que você quer a partir de um pedido curto',
  'settings.onboardingMemoryBenefitFewerQuestions': 'Pula perguntas de configuração repetidas',
  'settings.onboardingMemoryBenefitPersonalized': 'Adapta os resultados ao seu papel, público e gosto',
  'settings.onboardingSystemsTitle': 'Traga seu design system',
  'settings.onboardingSystemsBody': 'Escolha ou crie um sistema de marca para que o trabalho gerado siga as cores, a tipografia e a linguagem real do produto.',
  'settings.onboardingExecutionTitle': 'Escolha como a geração funciona',
  'settings.onboardingExecutionBody': 'CLI oficial com configuração em um clique e padrões prontos para uso. Use uma única chave para escolher entre vários modelos com preços melhores.',
  'settings.onboardingAmrCloudBenefitOfficial': 'Recomendado oficialmente',
  'settings.onboardingAmrCloudBenefitReady': 'Nada para instalar',
  'settings.onboardingAmrCloudBenefitModels': 'Compatível com Claude Opus 4.8',
  'settings.onboardingAmrCloudBenefitPricing': 'Harness SOTA',
  'settings.onboardingAmrCloudUpcomingLabel': 'Em breve',
  'settings.onboardingAmrCloudUpcomingImageVideo': 'Imagem e vídeo',
  'settings.onboardingAmrCloudUpcomingSkills': 'Skills em massa',
  'settings.onboardingAmrCloudUpcomingRouting': 'Roteamento inteligente',
  'settings.onboardingAmrModelSourceLabel': 'Crie3 Cloud',
  'settings.onboardingAmrCloudAuthorizeAction': 'Autorizar Crie3 Cloud',
  'settings.onboardingAmrCloudAuthorizedAction': 'Autorizado',
  'settings.onboardingStepConnect': 'Conectar',
  'settings.onboardingStepDesignSystem': 'Criar um sistema de design',
  'settings.onboardingStepProfile': 'Sobre você',
  'settings.onboardingStepNewsletter': 'Fique por dentro',
  'settings.onboardingNewsletterTitle': 'Fique por dentro',
  'settings.onboardingNewsletterBody': 'Receba novidades, novos templates e avisos do Crie3 por e-mail e WhatsApp. Opcional — você pode pular.',
  'settings.onboardingConnectTitle': 'Escolha um runtime',
  'settings.onboardingConnectBody': '',
  'settings.onboardingCloudTitle': 'Entrar no Crie3',
  'settings.onboardingCloudBody': 'Entre e comece a criar na hora com IA na nuvem, sem configurações complicadas.',
  'settings.onboardingCloudSignIn': 'Entrar no Crie3',
  'settings.onboardingCloudContinue': 'Continuar (conectado)',
  'settings.onboardingCloudAlternative': 'Usar uma CLI local ou sua própria chave de API',
  'settings.onboardingCloudRights': 'Todos os direitos reservados.',
  'settings.onboardingCloudOr': 'ou',
  'settings.onboardingGateTooltipNoRuntime': 'As próximas etapas rodam em IA — escolha um runtime para continuar.',
  'settings.onboardingGateTooltipAmr': 'As próximas etapas rodam em IA — faça login no Crie3 Cloud para continuar.',
  'settings.onboardingGateTooltipLocal': 'As próximas etapas rodam em IA — selecione uma CLI local disponível para continuar.',
  'settings.onboardingGateTooltipByok': 'As próximas etapas rodam em IA — adicione e teste sua chave de modelo para continuar.',
  'settings.onboardingRecommended': 'Recomendado',
  'settings.onboardingAmrCloudOfficialBadge': 'Oficial',
  'settings.onboardingLocalTitle': 'Agente de código local',
  'settings.onboardingLocalBody': 'Use um CLI instalado como Claude Code, Codex, Cursor, Gemini ou OpenCode.',
  'settings.onboardingLocalAction': 'Abrir configurações do CLI',
  'settings.onboardingCliScanHint': 'Isso costuma levar de 5 a 10 segundos.',
  'settings.onboardingByokTitle': 'Use sua própria chave',
  'settings.onboardingByokBody': 'Use as credenciais do seu próprio provedor de modelo.',
  'settings.onboardingByokAction': 'Abrir configurações de BYOK',
  'settings.onboardingDesignTitle': 'Design system',
  'settings.onboardingDesignBody': 'Gere uma vez, reutilize em todo lugar.',
  'settings.onboardingDesignIntroGenerateTitle': 'Gere a partir de trabalhos existentes',
  'settings.onboardingDesignIntroGenerateBody': 'Envie seu design system a partir do GitHub ou de repositórios de código local, arquivos do Figma, imagens e outros recursos de conteúdo.',
  'settings.onboardingDesignIntroReuseTitle': 'Reutilize em trabalhos futuros',
  'settings.onboardingDesignIntroReuseBody': 'Protótipos, slides e outros conteúdos futuros podem referenciar suas fontes, espaçamento, estilo de logo e tom de cores existentes.',
  'settings.onboardingDesignIntroSkipTitle': 'Opcional por enquanto',
  'settings.onboardingDesignIntroSkipBody': 'Pule esta etapa se quiser começar sem gerar um design system.',
  'settings.onboardingGithubTitle': 'Importar do GitHub',
  'settings.onboardingGithubBody': 'Use um repositório de frontend.',
  'settings.onboardingUploadTitle': 'Enviar arquivos locais',
  'settings.onboardingUploadBody': 'Adicione arquivos de projeto, capturas de tela, CSS, docs ou recursos.',
  'settings.onboardingPromptTitle': 'Criar a partir de uma descrição',
  'settings.onboardingPromptBody': 'Descreva o produto ou a marca.',
  'settings.onboardingProfileTitle': 'Sobre você',
  'settings.onboardingProfileBody': 'Detalhes opcionais para melhores padrões.',
  'settings.onboardingRoleLabel': 'Qual é o seu ministério ou função?',
  'settings.onboardingOrgSizeLabel': 'Tamanho da comunidade',
  'settings.onboardingWorshipTeamLabel': 'Qual o tamanho da equipe de louvor?',
  'settings.onboardingWorshipSolo': 'Só eu',
  'settings.onboardingWorshipSmall': 'Até 5 pessoas',
  'settings.onboardingWorshipMedium': 'De 6 a 15 pessoas',
  'settings.onboardingWorshipLarge': 'Mais de 15, com escalas',
  'settings.onboardingMediaTeamLabel': 'Quem cuida da mídia?',
  'settings.onboardingMediaSolo': 'Só eu',
  'settings.onboardingMediaPair': '2 ou 3 voluntários',
  'settings.onboardingMediaTeam': 'Uma equipe de 4 a 10',
  'settings.onboardingMediaDept': 'Um departamento de comunicação',
  'settings.onboardingAgencyClientsLabel': 'Quantas igrejas ou ministérios você atende?',
  'settings.onboardingAgencyFew': 'De 1 a 3',
  'settings.onboardingAgencySome': 'De 4 a 10',
  'settings.onboardingAgencyMany': 'De 11 a 25',
  'settings.onboardingAgencyLots': 'Mais de 25',
  'settings.onboardingUseCaseLabel': 'O que você mais cria?',
  'settings.onboardingSourceLabel': 'Como você ficou sabendo da gente?',
  'settings.onboardingSourceX': '💬 WhatsApp',
  'settings.onboardingSourceGithub': '🙌 Indicação de igreja / pastor',
  'settings.onboardingSourceYoutube': '▶️ YouTube',
  'settings.onboardingSourceTiktok': '🎵 TikTok',
  'settings.onboardingSourceReddit': '🎪 Evento / congresso cristão',
  'settings.onboardingSourceLinkedin': '💼 LinkedIn',
  'settings.onboardingSourceMetaSocial': '📸 Instagram / Threads / Facebook',
  'settings.onboardingSourceSearch': '🔍 Busca (Google / Bing)',
  'settings.onboardingSourceAiTool': '🤖 Ferramenta de IA (ChatGPT / Perplexity)',
  'settings.onboardingSourceFriend': '👥 Amigo ou colega',
  'settings.onboardingSourceCommunity': '💬 Discord / comunidade',
  'settings.onboardingSourceEmail': '✉️ E-mail / Newsletter',
  'settings.onboardingSourceBlog': '📝 Blog / artigo',
  'settings.onboardingSourceOther': '✨ Outro',
  'settings.onboardingSourceOtherPlaceholder': 'Diga onde (opcional)',
  'settings.onboardingSelectPlaceholder': 'Selecione uma opção',
  'settings.onboardingSelectMultiplePlaceholder': 'Selecione uma ou mais',
  'settings.onboardingOrgSolo': 'Só eu / comunicador solo',
  'settings.onboardingOrgTeam': 'Célula / igreja pequena (até 200)',
  'settings.onboardingOrgStartup': 'Em crescimento (200–1.000)',
  'settings.onboardingOrgGrowth': 'Igreja média (1.000–5.000)',
  'settings.onboardingOrgMidMarket': 'Igreja grande (5.000+)',
  'settings.onboardingOrgEnterprise': 'Rede / denominação',
  'settings.onboardingRolePm': '🙏 Pastor(a) / líder',
  'settings.onboardingRoleDesigner': '🎤 Pregador(a) / comunicador(a) digital',
  'settings.onboardingRoleEngineer': '✍️ Criador(a) de conteúdo cristão',
  'settings.onboardingRoleMarketing': '📣 Comunicação',
  'settings.onboardingRoleAgency': '⛪ Igreja / ministério',
  'settings.onboardingRoleGrowth': '🎵 Ministério de louvor',
  'settings.onboardingRoleOps': '🎬 Mídia / comunicação da igreja',
  'settings.onboardingRoleFounder': '🌍 Missionário(a) / evangelista',
  'settings.onboardingRoleStudent': '🤝 Agência / produtora cristã',
  'settings.onboardingRoleOther': '✨ Outro',
  'settings.onboardingUseProduct': '📖 Arte de versículo / devocional',
  'settings.onboardingUseDesignSystem': '📅 Divulgação de culto / evento',
  'settings.onboardingUsePrototype': '🎠 Carrossel pra Instagram',
  'settings.onboardingUseLanding': '🎬 Cortes / Reels de pregação',
  'settings.onboardingUseAds': '📢 Série / campanha de mensagens',
  'settings.onboardingUseDashboard': '📣 Avisos e comunicados',
  'settings.onboardingUseDeck': '🌐 Site / landing do ministério',
  'settings.onboardingUseMarketing': '🎵 Letra / arte de louvor',
  'settings.onboardingUseEngineering': '🖥️ Slides de projeção (culto)',
  'settings.onboardingUseAgency': '🎨 Identidade visual da marca',
  'settings.onboardingUseLandingCreator': '🎬 Reels / vídeos curtos',
  'settings.onboardingBack': 'Voltar',
  'settings.onboardingContinue': 'Continuar',
  'settings.onboardingFinish': 'Concluir configuração',
  'settings.kicker': 'Configurações',
  'settings.title': 'Modo de execução',
  'settings.subtitle': 'Escolha entre CLI local e BYOK.',
  'settings.modeAria': 'Modo de execução',
  'settings.protocolAria': 'Protocolo de API',
  'settings.modeDaemon': 'CLI local',
  'settings.modeDaemonHelp': 'Execute por uma CLI de agente de código na sua máquina',
  'settings.modeDaemonOffline': 'Daemon não está em execução',
  'settings.modeDaemonOfflineMeta': 'daemon offline',
  'settings.modeDaemonInstalledMeta': '{count} instalados',
  'settings.modeApi': 'Provedor de API',
  'settings.modeApiMeta': 'Chave própria',
  'settings.byokNoFileToolsNotice': 'O BYOK não consegue ler, gravar ou editar arquivos do projeto. Use o Local CLI quando precisar fazer alterações no código.',
  'settings.codeAgent': 'Agente de código',
  'settings.codeAgentHint': 'Detectado ao escanear seu PATH. Escolha a CLI por onde as gerações devem passar.',
  'settings.rescan': '↻ Reescanear',
  'settings.rescanTitle': 'Reescanear PATH',
  'settings.rescanRunning': 'Escaneando...',
  'settings.rescanSuccess': 'Escaneamento concluido. {count} disponiveis.',
  'settings.designSystemRenameFailed': 'Falha ao renomear. Verifique o daemon e tente novamente.',
  'settings.rescanFailed': 'Falha ao escanear. Verifique o daemon e tente novamente.',
  'settings.test': 'Testar',
  'settings.testTitle': 'Envie um pequeno prompt de teste para verificar a conexão',
  'settings.testRunning': 'Testando conexão…',
  'settings.byokReadyToTest': 'Pronto para testar',
  'settings.testCancel': 'Cancelar',
  'settings.testRetry': 'Testar novamente',
  'settings.required': 'obrigatório',
  'settings.testMissingFields': 'Preencha {fields} para testar a conexão.',
  'settings.testSuccessApi': 'Conectado. Respondeu em {ms} ms — \'{sample}\'',
  'settings.testSuccessCli': '{agentName} respondeu em {ms} ms — \'{sample}\'',
  'settings.testAuthFailed': 'Falha na autenticação. Verifique sua chave de API.',
  'settings.testForbidden': 'Acesso proibido. Verifique conta, região ou organização.',
  'settings.testNotFoundModel': 'Modelo \'{model}\' não encontrado neste endpoint.',
  'settings.testInvalidModelId': 'O id de modelo \'{model}\' é inválido. IDs personalizados devem começar com letra ou número e não conter espaços.',
  'settings.testInvalidBaseUrl': 'Base URL inválida ou inacessível.',
  'settings.testRateLimited': 'Provedor limitou o teste. Configuração parece válida.',
  'settings.testUpstream': 'Provedor retornou {status}. Tente novamente em instantes.',
  'settings.testTimeout': 'Teste expirou após {ms} ms.',
  'settings.testAgentMissing': '{agentName} não está instalado ou não está no PATH.',
  'settings.testAgentSpawn': 'Não foi possível iniciar {agentName}: {detail}.',
  'settings.testUnknown': 'Falha no teste: {detail}',
  'settings.agentInstall.install': 'Instalar',
  'settings.agentInstall.docs': 'Documentação',
  'settings.agentInstall.pathHint': 'Se você instalou uma CLI com npm ou Homebrew e ela ainda aparece como não instalada, garanta que o diretório bin da ferramenta esteja no PATH herdado pelo daemon do Crie3 (Terminal e apps GUI podem diferir no macOS). Veja QUICKSTART.md (seção "Local agent CLI and PATH").',
  'settings.agentInstall.stepOpenLinks': 'Abra Instalar ou Docs para o agente desejado.',
  'settings.agentInstall.stepAuth': 'Autentique-se na CLI do fornecedor (faça login ou adicione credenciais de API) antes de voltar ao Crie3.',
  'settings.agentInstall.stepRescan': 'Clique em Reescanear nesta seção.',
  'settings.agentInstall.stepSelect': 'Selecione o cartão do agente quando ele aparecer como instalado.',
  'settings.noAgentsDetected': 'Nenhum agente detectado ainda. Instale Claude Code, Codex, Devin for Terminal, OpenCode, Cursor Agent, Qwen ou GitHub Copilot CLI e clique em Reescanear.',
  'settings.agentInstalledGroup': 'Suas CLIs ({count})',
  'settings.agentInstallGroup': 'Disponíveis para instalar ({count})',
  'settings.agentAuthRequired': 'Autenticação necessária',
  'settings.agentAuthUnknown': 'Status de autenticação desconhecido',
  'settings.amrCloud': 'Crie3 Cloud',
  'settings.amrAuthorize': 'Autorizar',
  'settings.amrBenefitOfficial': 'Officially maintained',
  'settings.amrBenefitLowerPrice': 'Lower price',
  'settings.amrBenefitManyModels': 'Vários modelos',
  'settings.amrPromoBonus': 'Bônus limitado: +100%',
  'settings.amrSignInToContinue': 'Faça login para continuar',
  'settings.amrSignIn': 'Entrar',
  'settings.amrSignedIn': 'Conectado',
  'settings.amrWalletBalance': 'Saldo da carteira',
  'settings.amrWalletUnavailable': 'Saldo temporariamente indisponível',
  'settings.amrWalletUpdatedAt': 'Atualizado {time}',
  'settings.amrWalletCached': 'em cache',
  'settings.amrWalletRefresh': 'Atualizar',
  'settings.amrWalletRefreshTitle': 'Atualizar saldo da carteira Crie3 Cloud',
  'settings.amrNotSignedIn': 'Não conectado',
  'settings.amrSigningIn': 'Entrando…',
  'settings.amrActivationHint': 'A página de login não abriu? Toque no botão abaixo para abri-la novamente.',
  'settings.amrActivationBrowserFailed': 'Não foi possível abrir o navegador automaticamente. Abra a página de login abaixo para continuar.',
  'settings.amrActivationOpen': 'Abrir página de login',
  'settings.amrCancelSignIn': 'Cancelar login',
  'settings.amrAccountStatus': 'Status da conta Crie3 Cloud',
  'settings.amrConsole': 'Gerenciar',
  'settings.amrBalance': 'Saldo',
  'settings.amrPlan': 'Plano',
  'settings.amrUpgrade': 'Fazer upgrade',
  'settings.amrModelUpgradeHint': 'Faça upgrade para usar',
  'settings.amrLoginErrorCompact': 'Falha no login do Crie3 Cloud.',
  'settings.advanced': 'Avançado',
  'settings.amrLogin': 'Entrar',
  'settings.amrLogout': 'Sair',
  'settings.amrLoggingIn': 'Entrando…',
  'settings.amrLoggingOut': 'Saindo…',
  'settings.amrLoggedInAs': 'Conectado como {email}',
  'settings.amrLoggedInWithPlan': 'Conectado como {email} · {plan}',
  'settings.amrLoggedInPill': 'Conectado',
  'settings.amrNotLoggedIn': 'Não conectado',
  'settings.apiSection': 'API da Anthropic',
  'settings.quickFillProvider': 'Preencher provedor',
  'settings.providerPreset': 'Predefinição de gateway',
  'settings.protocolGroupProtocols': 'Protocolos',
  'settings.protocolGroupGateways': 'Gateways',
  'settings.customProvider': 'Provedor personalizado',
  'settings.apiKey': 'Chave de API',
  'settings.apiKeyGetLink': 'Obter chave ↗',
  'settings.showKey': 'Mostrar chave',
  'settings.hideKey': 'Ocultar chave',
  'settings.show': 'Mostrar',
  'settings.hide': 'Ocultar',
  'settings.model': 'Modelo',
  'settings.sidebarExpand': 'Abrir o menu de configurações',
  'settings.sidebarCollapse': 'Recolher o menu de configurações',
  'settings.sectionsNavAria': 'Seções de configurações',
  'settings.apiKeyInvalid': 'API key inválida.',
  'settings.apiKeyCleaned': 'Espaços em branco extras foram removidos da API key.',
  'settings.modelsLoadedFromAccount': '✓ {count} modelos carregados da sua conta.',
  'settings.modelsLoadedCount': '✓ {count} modelos carregados.',
  'settings.modelSourceAccount': 'Da sua conta',
  'settings.modelSourceSuggested': 'Sugerido',
  'modelCapability.standard': 'Padrão',
  'modelCapability.advanced': 'Avançado',
  'modelCapability.bestQuality': 'Melhor qualidade',
  'modelCapability.standardDescription': 'Qualidade sólida para tarefas comuns.',
  'modelCapability.advancedDescription': 'Qualidade superior para tarefas mais exigentes.',
  'modelCapability.bestQualityDescription': 'A melhor qualidade de saída para os trabalhos mais exigentes.',
  'modelCost.upToHalf': 'Custo baixo',
  'modelCost.halfToOne': 'Custo médio',
  'modelCost.oneToFour': 'Custo alto',
  'modelCost.overFour': 'Custo máximo',
  'settings.fetchModels': 'Buscar modelos',
  'settings.fetchModelsTitle': 'Buscar modelos disponíveis deste provedor',
  'settings.fetchModelsRunning': 'Buscando modelos…',
  'settings.fetchModelsMissingFields': 'Preencha {fields} para buscar modelos.',
  'settings.fetchModelsInvalidBaseUrl': 'Insira uma Base URL válida para buscar modelos.',
  'settings.fetchModelsUnsupportedAzure': 'O Azure OpenAI usa nomes de deployment, então a descoberta de modelos não está disponível aqui.',
  'settings.fetchModelsUnsupportedOllama': 'A descoberta de modelos do Ollama Cloud ainda não está disponível. Escolha ou digite um modelo.',
  'settings.fetchModelsSuccess': '{count} modelos encontrados.',
  'settings.fetchModelsEmpty': 'Nenhum modelo de texto compatível foi retornado.',
  'settings.fetchModelsUnsupported': 'A descoberta de modelos não está disponível para este protocolo.',
  'settings.fetchModelsFailed': 'Não foi possível buscar os modelos: {detail}',
  'settings.suggestedModelsHint': 'Estes são modelos sugeridos para este protocolo. Seu provedor pode oferecer suporte a modelos diferentes.',
  'settings.baseUrl': 'URL base',
  'settings.baseUrlInvalid': 'Use uma URL pública http:// ou https://.',
  'settings.baseUrlCustomize': 'Personalizar',
  'settings.baseUrlDefaultHint': 'Endpoint padrão. Normalmente não é necessário alterar.',
  'settings.azureBaseUrlPlaceholder': 'https://my-resource.openai.azure.com',
  'settings.azureBaseUrlHint': 'Encontre isto no portal do Azure → seu recurso → Endpoint.',
  'settings.azureDeploymentModel': 'Nome do deployment',
  'settings.azureCustomDeploymentName': 'Nome de deployment personalizado',
  'settings.azureDeploymentModelHint': 'No Azure OpenAI, este campo e usado como nome do deployment em /openai/deployments/<model>. Informe o nome do deployment criado no Azure.',
  'settings.azureModelFetchHint': 'Insira o nome da implantação do seu recurso do Azure. As implantações do Azure não podem ser obtidas automaticamente.',
  'settings.apiVersion': 'Versão da API',
  'settings.byokImageModel': 'Modelo de geração de imagens',
  'settings.byokVideoModel': 'Modelo de geração de vídeo',
  'settings.byokVideoI2vHint': 'Modelo de imagem para vídeo: é necessária uma imagem de referência (caso contrário, usa a imagem mais recente do projeto)',
  'settings.byokSpeechModel': 'Modelo de voz',
  'settings.byokSpeechVoice': 'Voz',
  'settings.byokModelDefaultOption': 'Padrão',
  'settings.maxTokens': 'Tokens máx. (opcional)',
  'settings.maxTokensHint': 'Limite para o comprimento da resposta. Cada modelo tem um valor padrão ajustado (visível no placeholder); deixe em branco para usá-lo ou insira um número para substituí-lo.',
  'settings.apiHint': 'As chamadas passam pelo proxy do daemon local até a Base URL definida. A chave fica armazenada apenas neste navegador e é enviada com as requisições ao provedor.',
  'settings.skipForNow': 'Pular por enquanto',
  'settings.getStarted': 'Começar',
  'settings.envConfigure': 'Modo de execução',
  'settings.agentModel': 'Agente e modelo',
  'settings.agentModelHint': 'O agente que trabalha dentro do Crie3',
  'settings.agentModelBody': 'Escolha o modelo que o agente do Crie3 usa quando você cria dentro do Crie3. Isso não muda nada no assistente conectado pelo MCP.',
  'settings.localCli': 'CLI local',
  'settings.anthropicApi': 'API da Anthropic',
  'settings.noAgentSelected': 'nenhum agente selecionado',
  'settings.language': 'Idioma',
  'settings.languageHint': 'Altere o idioma da interface. Salvo neste navegador.',
  'settings.appearance': 'Aparência',
  'settings.appearanceHint': 'Escolha claro, escuro ou seguir as configurações do sistema.',
  'settings.themeSystem': 'Sistema',
  'settings.themeLight': 'Claro',
  'settings.themeDark': 'Escuro',
  'settings.agentModelHead': 'Modelo para:',
  'settings.modelPicker': 'Modelo',
  'settings.modelSourceLive': 'Ao vivo da CLI',
  'settings.modelSourceFallback': 'Lista integrada',
  'settings.reasoningPicker': 'Esforço de raciocínio',
  'settings.modelPickerHint': 'Buscado na CLI quando ela expõe um comando `models`. "Padrão" deixa a escolha para a configuração da própria CLI; "Personalizado…" permite digitar qualquer id de modelo aceito pela CLI.',
  'settings.modelPickerLiveHint': 'Os modelos foram atualizados a partir da CLI instalada. O padrão ainda usa a configuração da CLI.',
  'settings.modelPickerLiveCatalogOnlyHint': 'Os modelos foram atualizados a partir da CLI instalada.',
  'settings.modelPickerFallbackHint': 'Mostrando padrões integrados. Clique em Reescanear para buscar modelos ao vivo da CLI.',
  'settings.cliEnvTitle': 'Avançado: proxy e caminhos personalizados',
  'settings.cliEnvHint': 'Use estes campos para sobrescrever o ambiente da CLI selecionada: API keys, base URLs de proxy, homes personalizados ou caminhos de binários fora do padrão. Sem base URL, a CLI usa seu endpoint padrão. Segredos ficam na configuração local do app e apenas a CLI selecionada os vê.',
  'settings.cliEnvClaudeConfigDir': 'Diretório de configuração do Claude Code',
  'settings.cliEnvClaudeBaseUrl': 'Base URL do proxy do Claude',
  'settings.cliEnvClaudeApiKey': 'API key da Claude CLI',
  'settings.cliEnvCodexHome': 'Home do Codex',
  'settings.cliEnvCodexBin': 'Caminho do executável do Codex',
  'settings.cliEnvCodexBaseUrl': 'Base URL do proxy Codex/OpenAI',
  'settings.cliEnvCodexApiKey': 'API key da Codex/OpenAI CLI',
  'settings.modelCustom': 'Personalizado (digite abaixo)…',
  'settings.modelCustomLabel': 'Id do modelo personalizado',
  'settings.modelCustomPlaceholder': 'ex.: anthropic/claude-sonnet-4-6',
  'settings.mediaProviders': 'Provedores de mídia',
  'settings.mediaProvidersHint': 'Chaves de API para geração de imagem, vídeo e áudio. Salvas localmente e sincronizadas com o daemon local.',
  'settings.mcpServerTitle': 'Servidor MCP',
  'settings.mcpServerHint': 'Exponha o Crie3 como servidor MCP para o seu agente de código.',
  'settings.externalMcpTitle': 'MCP externo',
  'settings.externalMcpHint': 'Adicione ferramentas MCP de serviços externos (Higgsfield, GitHub, …).',
  'settings.mediaProviderApiKey': 'Chave de API',
  'settings.mediaProviderBaseUrl': 'Base URL',
  'settings.mediaProviderConfigured': 'Configurado',
  'settings.mediaProviderUnset': 'Não configurado',
  'settings.mediaProviderClear': 'Limpar',
  'settings.mediaProviderClearConfirm': 'Remover as configurações salvas de {name}? Você precisará inseri-las novamente para usar {name}.',
  'settings.mediaProviderPlaceholder': 'Cole a API key',
  'settings.mediaProviderBaseUrlPlaceholder': 'Sobrescrever Base URL padrão',
  'settings.mediaProviderReload': 'Recarregar do daemon',
  'settings.mediaProviderReloadError': 'Não foi possível recarregar as configurações dos provedores de mídia do daemon local.',
  'settings.mediaProviderReloadSuccess': 'As configurações dos provedores de mídia foram recarregadas do daemon local.',
  'settings.mediaProviderLoadError': 'Não foi possível carregar as configurações dos provedores de mídia do daemon local. Usando por enquanto as configurações salvas no navegador.',
  'settings.mediaProviderComingSoonHint': 'Rastreamos estes para o roteiro; o daemon ainda não fornece um cliente, então não há nada para configurar.',
  'settings.privacy': 'Privacidade',
  'settings.privacyHint': 'Quais dados são compartilhados com a equipe do Crie3',
  'settings.privacyConsentKicker': 'Ajude-nos a melhorar o Crie3',
  'settings.privacyConsentLead': 'Compartilhar dados de uso nos ajuda a entender como o Crie3 funciona em fluxos de trabalho reais, para melhorarmos as partes que mais impactam sua experiência.',
  'settings.privacyConsentFooter': 'Você pode alterar essas opções a qualquer momento em Configurações → Privacidade.',
  'settings.privacyConsentShare': 'Compartilhar',
  'settings.privacyConsentDecline': 'Não compartilhar',
  'settings.privacyConsentAccept': 'Entendi',
  'settings.privacyConsentBannerFooter': 'O compartilhamento de dados está ativado por padrão. Você pode desativá-lo a qualquer momento em Configurações → Privacidade.',
  'settings.privacyConsentPolicyLink': "Ver os controles de privacidade",
  'settings.privacyMetrics': 'Métricas anônimas',
  'settings.privacyMetricsHint': 'Quantas criações você fez, quanto cada uma consumiu do seu plano, quantos erros aconteceram e quanto tempo levaram.',
  'settings.privacyContent': 'Conteúdo das conversas',
  'settings.privacyContentHint': 'Depois de remover senhas e outras informações sensíveis, usamos o que você escreveu, as respostas do assistente, o que as ferramentas receberam e devolveram e o restante da conversa necessário para conferir a qualidade.',
  'settings.privacyConsentContentExcluded': 'Não é compartilhado por esta escolha. O conteúdo das conversas fica desligado até você ligá-lo em Configurações → Privacidade.',
  'settings.privacyInstallationId': 'ID anônimo',
  'settings.privacyOptedOut': 'optou por não participar',
  'settings.privacyDataDeletion': 'Excluir meus dados',
  'settings.privacyDataDeletionHint': 'Rotaciona seu ID anônimo e interrompe os envios. Os rastros existentes expiram conforme nossa política de retenção.',
  'settings.legal': 'Termos',
  'settings.legalHint': 'Termos de uso e política de privacidade',
  'settings.plans': 'Planos',
  'settings.plansHint': 'Preços e limites da assinatura',
  'settings.billing': 'Assinatura',
  'settings.billingHint': 'Seu plano e a forma de pagamento',
  'legal.tabTerms': 'Termos de Uso',
  'legal.tabPrivacy': 'Política de Privacidade',
  'legal.badgeDefault': 'Modelo padrão',
  'legal.defaultNotice': 'Modelo padrão — preencha os campos entre colchetes e submeta à revisão antes de publicar.',
  'legal.updatedAt': 'Atualizado em {date}',
  'legal.reset': 'Restaurar o modelo padrão',
  'legal.resetConfirm': 'Restaurar o modelo padrão? O texto atual será perdido.',
  'legal.exportPdf': 'Exportar PDF',
  'legal.exportDocx': 'Exportar DOCX',
  'legal.exporting': 'Exportando…',
  'legal.readOnly': 'Somente leitura. Apenas o operador desta instalação pode editar estes documentos.',
  'legal.titleLabel': 'Título',
  'legal.bodyLabel': 'Conteúdo (Markdown)',
  'legal.bodyHint': 'Use # para títulos e - para listas. O mesmo texto vai para a tela, o PDF e o DOCX.',
  'legal.loadError': 'Não foi possível carregar os documentos.',
  'legal.saveError': 'Não foi possível salvar o documento.',
  'legal.exportError': 'Não foi possível exportar o documento.',
  'legal.saved': 'Documento salvo.',
  'legal.bodyRequired': 'O conteúdo não pode ficar vazio.',
  'settings.briefing': 'Minha marca',
  'settings.briefingHint': 'Ficha da marca usada nas peças e na IA',
  'briefing.intro': 'Esses dados preenchem as peças automaticamente (endereço, redes, pessoas) em vez de você digitar tudo de novo a cada vez.',
  'briefing.loadError': 'Não foi possível carregar a ficha.',
  'briefing.saveError': 'Não foi possível salvar a ficha.',
  'briefing.logoUploadError': 'Não foi possível enviar o logo.',
  'briefing.saved': 'Salvo.',
  'briefing.saving': 'Salvando…',
  'briefing.save': 'Salvar',
  'briefing.nameLabel': 'Nome',
  'briefing.cityLabel': 'Cidade',
  'briefing.addressLabel': 'Endereço',
  'briefing.serviceTimesLabel': 'Horários fixos',
  'briefing.servicesLabel': 'Agenda da semana',
  'briefing.servicesHint': 'Dia e hora de cada compromisso fixo (culto, ensaio, live).',
  'briefing.serviceDay': 'Dia',
  'briefing.serviceTime': 'Hora',
  'briefing.serviceNamePlaceholder': 'Nome (opcional), ex.: Culto da família, Ensaio',
  'briefing.serviceAdd': 'Adicionar horário',
  'briefing.serviceRemove': 'Remover horário',
  'briefing.serviceIncomplete': 'Preencha a hora de cada linha ou remova a linha.',
  'briefing.timezoneLabel': 'Fuso horário',
  'briefing.timezone.saoPaulo': 'Horário de Brasília (UTC−3)',
  'briefing.timezone.manaus': 'Manaus, Cuiabá, Campo Grande (UTC−4)',
  'briefing.timezone.rioBranco': 'Acre (UTC−5)',
  'briefing.timezone.noronha': 'Fernando de Noronha (UTC−2)',
  'briefing.socialHandlesLabel': 'Redes sociais',
  'briefing.contactsLabel': 'Contatos',
  'briefing.contactWhatsapp': 'WhatsApp',
  'briefing.contactPhone': 'Telefone',
  'briefing.contactEmail': 'E-mail',
  'briefing.contactSite': 'Site',
  'briefing.customFieldsLabel': 'Campos livres',
  'briefing.customFieldsHint': 'Para o que é só deste cliente, como denominação ou onde ouvir.',
  'briefing.customFieldLabelPlaceholder': 'Rótulo',
  'briefing.customFieldValuePlaceholder': 'Valor',
  'briefing.customFieldAdd': 'Adicionar campo',
  'briefing.customFieldRemove': 'Remover',
  'clients.listHeading': 'Clientes',
  'clients.listHint': 'Cada cliente tem a própria ficha, design system e Instagram.',
  'clients.limitUsage': '{used} de {limit} clientes do seu plano.',
  'clients.limitReached': 'Para adicionar mais clientes, mude de plano em Assinatura.',
  'clients.new': 'Novo cliente',
  'clients.namePlaceholder': 'Nome do cliente',
  'clients.create': 'Criar',
  'clients.default': 'Principal',
  'clients.open': 'Abrir',
  'clients.back': 'Todos os clientes',
  'clients.nameLabel': 'Nome do cliente',
  'clients.typeLabel': 'Tipo',
  'clients.type.igreja': 'Igreja',
  'clients.type.ministerio': 'Ministério',
  'clients.type.pregador': 'Pregador',
  'clients.type.cantor_banda': 'Cantor ou banda',
  'clients.type.criador': 'Criador de conteúdo',
  'clients.type.evento': 'Evento',
  'clients.type.agencia': 'Agência',
  'clients.type.outro': 'Outro',
  'clients.designSystemLabel': 'Design system',
  'clients.designSystemDefault': 'Padrão da conta',
  'clients.instagramLabel': 'Instagram',
  'clients.instagramNone': 'Nenhum',
  'clients.save': 'Salvar cliente',
  'clients.saved': 'Cliente salvo.',
  'clients.loadError': 'Não foi possível carregar os clientes.',
  'clients.saveError': 'Não foi possível salvar o cliente.',
  'clients.nameTaken': 'Já existe um cliente com este nome.',
  'clients.instagramTaken': 'Este Instagram já é de outro cliente.',
  'clients.inviteButton': 'Convidar para conectar',
  'clients.inviteHint': 'Envie este link ao cliente. Ele vale 7 dias e uma conexão; um link novo substitui este.',
  'clients.inviteExpires': 'Vale até {date}',
  'clients.inviteCopy': 'Copiar link',
  'clients.inviteCopied': 'Link copiado.',
  'clients.inviteNew': 'Gerar link novo',
  'clients.instagramConnect': 'Conectar Instagram',
  'clients.instagramConnectHint': 'Abre o Instagram para você autorizar; a conta fica neste cliente.',
  'clients.instagramConnected': 'Instagram conectado a este cliente.',
  'clients.instagramConnectError': 'Não foi possível conectar o Instagram. Tente de novo.',
  'clients.instagramConnectTaken': 'Esse Instagram já está em outro cliente.',
  'clients.instagramConnectSame': 'O Instagram aberto neste navegador é o @{username}, que já está em outro cliente. Saia dele no instagram.com (ou use uma janela anônima), entre com o Instagram deste cliente e tente de novo.',
  'clients.instagramConnectBrowserHint': 'Vai conectar o Instagram que estiver aberto neste navegador. Se for o de outro cliente, saia dele no instagram.com antes.',
  'clients.instagramReconnect': 'Reconectar Instagram',
  'clients.instagramStatusConnected': 'Conectado: {handle}, desde {date}',
  'clients.instagramStatusReconnect': '{handle} precisa ser autorizado de novo; até lá os posts para ele vão falhar.',
  'clients.instagramStatusMissing': 'O Instagram deste cliente não está mais conectado. Conecte de novo.',
  'clients.instagramStatusNone': 'Nenhum Instagram conectado a este cliente ainda.',
  'clients.instagramBadgeConnected': 'Instagram conectado',
  'clients.instagramBadgeReconnect': 'Reconectar Instagram',
  'clients.inviteRevoke': 'Revogar link',
  'clients.inviteError': 'Não foi possível gerar o link de convite.',
  'invite.title': 'Conectar Instagram',
  'invite.body': '{inviter} convidou {client} para conectar o Instagram ao Crie3 e agendar os posts.',
  'invite.bodyNoInviter': '{client} foi convidado a conectar o Instagram ao Crie3 e agendar os posts.',
  'invite.whoSent': 'quem enviou o convite',
  'invite.connect': 'Conectar Instagram',
  'invite.privacy': 'Você autoriza no próprio Instagram. O Crie3 nunca vê a sua senha.',
  'invite.connected': 'Pronto! O Instagram @{username} está conectado a {client}.',
  'invite.connectedNoName': 'Pronto! O Instagram está conectado a {client}.',
  'invite.expired': 'Este link venceu. Fale com {inviter} e peça um link novo.',
  'invite.revoked': 'Este link não vale mais. Fale com {inviter} e peça um link novo.',
  'invite.notFound': 'Este link não existe. Confira se ele foi copiado inteiro.',
  'invite.loading': 'Carregando…',
  'invite.loadError': 'Não foi possível abrir o convite. Tente de novo.',
  'invite.errorDenied': 'A autorização foi cancelada no Instagram. Você pode tentar de novo.',
  'invite.errorTaken': 'Este Instagram já está conectado a outro cliente ou conta. Use outro Instagram ou fale com {inviter}.',
  'invite.errorSameInstagram': 'O Instagram aberto neste navegador é o @{username}, que já está conectado em outro lugar. Saia dele no instagram.com (ou use uma janela anônima), entre com o seu Instagram e tente de novo.',
  'invite.browserHint': 'Vai conectar o Instagram que estiver aberto neste navegador. Confira se é o seu antes de continuar.',
  'invite.errorGeneric': 'Não foi possível conectar. Tente de novo.',
  'clients.archive': 'Arquivar',
  'clients.archiveConfirm': 'Arquivar {name}? Os projetos continuam, e o Instagram fica livre para outro cliente.',
  'clients.delete': 'Excluir cliente',
  'clients.deleteTitle': 'Excluir {name}?',
  'clients.deleteBody': 'Isso não tem volta. O Instagram do cliente é desconectado do Crie3 e os links de convite abertos deixam de valer. Para só esconder o cliente, use Arquivar.',
  'clients.deleteProjectsQuestion': 'E os projetos deste cliente?',
  'clients.deleteMove': 'Mover os projetos para {main}',
  'clients.deleteDrop': 'Excluir os projetos junto',
  'clients.deleteConfirm': 'Excluir de vez',
  'clients.deleteScheduled': '{name} tem {count} post(s) aprovado(s) ou agendado(s). Cancele no Calendário antes de excluir.',
  'clients.deleteError': 'Não foi possível excluir. Nada foi apagado; tente de novo.',
  'clients.profileHeading': 'Ficha',
  'clients.layoutsHeading': 'Padrões salvos',
  'clients.layoutsEmpty': 'Nenhum padrão ainda. Ao aprovar um post no Calendário, o Crie3 pergunta se você quer salvá-lo como padrão deste cliente.',
  'clients.layoutUse': 'Usar',
  'clients.layoutDelete': 'Apagar',
  'clients.layoutDeleteConfirm': 'Apagar o padrão "{name}"?',
  'clients.layoutError': 'Não deu certo. Tente de novo.',
  'briefing.pastorsLabel': 'Pessoas que aparecem nas peças',
  'briefing.pastorNamePlaceholder': 'Nome',
  'briefing.pastorRolePlaceholder': 'Papel',
  'briefing.pastorRemove': 'Remover',
  'briefing.pastorAdd': 'Adicionar',
  'briefing.missionLabel': 'Descrição',
  'briefing.audienceLabel': 'Público',
  'briefing.bibleVersionLabel': 'Versão bíblica',
  'briefing.voiceAdjectivesLabel': 'Voz — adjetivos',
  'briefing.voiceUseLabel': 'Voz — usar',
  'briefing.voiceAvoidLabel': 'Voz — evitar',
  'briefing.commaHint': 'separe por vírgula',
  'briefing.voiceSheet.heading': 'Ficha de voz',
  'briefing.voiceSheet.hint': 'O que a marca realmente escreve. As peças seguem essas frases e nunca usam uma palavra proibida.',
  'briefing.voiceSheet.realPhrases': 'Frases reais (uma por linha)',
  'briefing.voiceSheet.greetings': 'Saudações que usa',
  'briefing.voiceSheet.forbidden': 'Palavras proibidas',
  'briefing.voiceSheet.register': 'Registro',
  'briefing.voiceSheet.registerUnset': 'A confirmar',
  'briefing.voiceSheet.registerOption.sobrio': 'Sóbrio',
  'briefing.voiceSheet.registerOption.caloroso': 'Caloroso',
  'briefing.voiceSheet.registerOption.fervoroso': 'Fervoroso',
  'briefing.voiceSheet.hashtagsFixed': 'Hashtags fixas (3 a 5)',
  'briefing.voiceSheet.hashtagBrand': 'Hashtag da marca',
  'briefing.doctrine.heading': 'Calibração doutrinária',
  'briefing.doctrine.hint': 'Um ponto deixado "A confirmar" nunca é suposto numa peça.',
  'briefing.doctrine.family': 'Família doutrinária',
  'briefing.doctrine.giftsTongues': 'Dons do Espírito / línguas',
  'briefing.doctrine.faithHealing': 'Cura pela fé',
  'briefing.doctrine.prosperity': 'Teologia da prosperidade',
  'briefing.doctrine.eternalSecurity': 'Segurança eterna',
  'briefing.doctrine.predestination': 'Predestinação',
  'briefing.doctrine.womenInMinistry': 'Mulher no ministério',
  'briefing.doctrine.stance.afirma': 'Afirma',
  'briefing.doctrine.stance.neutro': 'Neutro',
  'briefing.doctrine.stance.nega': 'Nega',
  'briefing.doctrine.stance.aConfirmar': 'A confirmar',
  'briefing.decisions.label': 'Decisões aprovadas',
  'briefing.decisions.hint': 'O que foi aprovado ao vivo. As próximas peças partem daqui.',
  'briefing.decisions.empty': 'Nada registrado ainda.',
  'briefing.decisions.remove': 'Remover decisão',
  'briefing.decisions.kind.voz': 'Voz',
  'briefing.decisions.kind.visual': 'Visual',
  'briefing.spacePhotos.label': 'Fotos do espaço',
  'briefing.spacePhotos.hint': 'Fotos reais do templo, do altar ou da fachada. Só foto com qualidade boa pode ser o destaque de uma peça.',
  'briefing.spacePhotos.add': 'Adicionar foto',
  'briefing.spacePhotos.descriptionPlaceholder': 'O que ela mostra',
  'briefing.spacePhotos.quality': 'Qualidade',
  'briefing.spacePhotos.quality.boa': 'Boa',
  'briefing.spacePhotos.quality.mediana': 'Mediana',
  'briefing.spacePhotos.remove': 'Remover foto',
  'briefing.spacePhotos.uploadError': 'Não foi possível enviar a foto. Use JPEG, PNG ou WebP de até 12 MB.',
  'briefing.spacePhotos.saveError': 'Não foi possível atualizar a foto.',
  'briefing.colorsLabel': 'Cores da marca',
  'briefing.fontsLabel': 'Fontes da marca',
  'briefing.logoLightLabel': 'Logo claro',
  'briefing.logoDarkLabel': 'Logo escuro',
  'briefing.logoLightHint': 'Para usar sobre fundos claros',
  'briefing.logoDarkHint': 'Para usar sobre fundos escuros',
  'briefing.logoEmpty': 'Nenhum logo enviado',
  'briefing.logoUnavailable': 'Não foi possível mostrar este logo. Recarregue a página.',
  'briefing.logoChoose': 'Escolher imagem',
  'briefing.logoUploading': 'Enviando…',
  'briefing.fillWithAi': 'Preencher com o agente do Crie3',
  'briefing.fillWithAiHint': 'Responda algumas perguntas e a IA preenche os campos. O que você responder substitui o que já está aqui; o histórico guarda a versão anterior.',
  'briefing.fillWithAiCost': 'Esta conversa usa os créditos de IA do seu plano: cada resposta conta um pouco. Criar artes pelo assistente conectado (MCP) não gasta nada.',
  'briefing.interviewDone': 'Pronto! A ficha foi atualizada com as suas respostas.',
  'briefing.interviewClose': 'Fechar entrevista',
  'briefing.interviewError': 'Não foi possível continuar a entrevista agora. Feche e preencha os campos à mão, ou tente de novo mais tarde.',
  'briefing.interviewErrorQuota': 'Sua conta já usou todo o limite de IA deste mês. Feche e preencha os campos à mão; a entrevista volta a funcionar no mês que vem.',
  'briefing.interviewErrorNotConfigured': 'A entrevista com IA não está disponível nesta instalação. Feche e preencha os campos à mão.',
  'briefing.historyLabel': 'Histórico de alterações',
  'briefing.historySource.ui': 'pelo app',
  'briefing.historySource.cli': 'pela CLI',
  'briefing.historySource.api': 'pela API',
  'briefing.historySource.onboarding': 'pela entrevista com IA',
  'briefing.unsavedChanges': 'Alterações não salvas',
  'settings.about': 'Sobre',
  'settings.aboutHint': 'Versão e detalhes de execução',
  'settings.appVersion': 'Versão',
  'settings.appChannel': 'Canal',
  'settings.appRuntime': 'Runtime',
  'settings.appPlatform': 'Plataforma',
  'settings.appArchitecture': 'Arquitetura',
  'settings.runtimePackaged': 'App empacotado',
  'settings.runtimeDevelopment': 'Desenvolvimento',
  'settings.versionUnavailable': 'Os detalhes de versão ficam indisponíveis enquanto o daemon está offline.',
  "settings.allowSilentUpdates": "Permitir atualizações silenciosas",
  "settings.allowSilentUpdatesDesc": "Aplica sozinho, ao abrir, as atualizações já baixadas. As que precisam de instalador continuam perguntando antes.",
  'settings.installLatest': 'Instalar a versão mais recente',
  'settings.alreadyLatest': 'Você já está na versão mais recente',
  'settings.updateCheck': 'Verificar atualizações',
  'settings.updateNow': 'Atualizar agora',
  'settings.updateRecheck': 'Verificar novamente',
  'settings.updateRetry': 'Tentar novamente',
  'settings.updateViewReleases': 'Notas da versão',
  'settings.updateActionFailed': 'Não foi possível concluir a ação de atualização.',
  'settings.updateQuitFailed': 'O instalador foi aberto, mas o Crie3 não conseguiu sair automaticamente.',
  'settings.updateStatusNotChecked': 'Ainda não verificado',
  'settings.updateStatusDevelopment': 'Builds de desenvolvimento não aceitam atualizações no app.',
  'settings.updateStatusUnsupported': 'Este ambiente não aceita atualizações no app.',
  'settings.updateStatusChecking': 'Verificando atualizações...',
  'settings.updateStatusUpToDate': 'Você já está na versão mais recente.',
  'settings.updateStatusAvailable': 'Nova versão {version} encontrada. Preparando download.',
  'settings.updateStatusAvailableUnknown': 'Nova versão encontrada. Preparando download.',
  'settings.updateStatusDownloading': 'Baixando atualização...',
  'settings.updateStatusDownloadingPercent': 'Baixando atualização {percent}%.',
  'settings.updateStatusReady': 'Versão {version} pronta para instalar.',
  'settings.updateStatusReadyUnknown': 'Atualização pronta para instalar.',
  'settings.updateStatusInstalling': 'Instalando atualização...',
  'settings.updateStatusFailed': 'Falha ao verificar. Tente novamente.',
  'settings.mcpTitle': 'Servidor MCP',
  'settings.mcpHint': 'Permita que agentes de programação (Cursor, Claude Code, VS Code…) leiam seus projetos do Crie3 diretamente.',
  'settings.mcpDaemonError': 'Não foi possível alcançar o daemon local para resolver os caminhos de instalação ({error}). Verifique se o Crie3 está em execução e reabra este painel.',
  'settings.mcpBuildDaemon': 'Compile o daemon primeiro.',
  'settings.mcpNodeMissing': 'O binário do Node está ausente.',
  'settings.mcpBuildHint': 'apps/daemon/dist/cli.js está ausente. Execute `pnpm --filter @open-design/daemon build` e atualize.',
  'settings.mcpMethodCli': 'Comando da CLI',
  'settings.mcpInstructionCli': 'Execute isto no seu terminal.',
  'settings.mcpMethodToml': 'Configuração TOML',
  'settings.mcpInstructionCodex': 'Anexe esta tabela a {path}. A mesma configuração é compartilhada entre a Codex CLI e a extensão de IDE do Codex.',
  'settings.mcpMethodOneClick': 'Instalação com um clique',
  'settings.mcpInstructionCursor': 'Clique em "Install in Cursor" para instalar com um diálogo de aprovação, ou mescle este JSON em {path}.',
  'settings.mcpDeeplinkInstallCursor': 'Instalar no Cursor',
  'settings.mcpMethodJson': 'Configuração JSON',
  'settings.mcpInstructionCopilot': 'Abra a Command Palette ({shortcut}), execute "MCP: Open User Configuration" e mescle este JSON. O Copilot Chat precisa estar em modo Agent para que as ferramentas apareçam.',
  'settings.mcpInstructionAntigravity': 'No Antigravity: menu "..." do painel do Agent → MCP Servers → Manage MCP Servers → View raw config. Mescle este JSON.',
  'settings.mcpInstructionZed': 'Abra as Zed Settings ({shortcut}) e mescle isto no objeto de nível superior. O Zed usa "context_servers", não "mcpServers".',
  'settings.mcpInstructionWindsurf': 'Abra {path} (ou use o ícone de MCPs no Cascade → Configure) e mescle:',
  'settings.mcpCopyAria': 'Copiar trecho de configuração do MCP',
  'settings.mcpResolvingFailed': '# a resolução de caminhos falhou, veja o erro acima',
  'settings.mcpLoadingPaths': '# carregando caminhos de instalação do daemon local…',
  'settings.mcpCopied': 'Copiado',
  'settings.mcpCopy': 'Copiar',
  'settings.mcpCursorApproval': 'O Cursor exibe um diálogo de aprovação antes de gravar a configuração.',
  'settings.mcpCodexOneClickInstall': 'Instalar no Codex',
  'settings.mcpCodexOneClickUninstall': 'Remover do Codex',
  'settings.mcpCodexOneClickUnavailable': 'Codex CLI não encontrado no PATH — instale o Codex ou cole o trecho manualmente.',
  'settings.mcpCodexInstallSuccess': 'Instalado. Reinicie o Codex para carregar o novo servidor.',
  'settings.mcpCodexUninstallSuccess': 'Removido do Codex.',
  'settings.mcpCodexBusy': 'Trabalhando…',
  'settings.mcpCodexInstallError': 'A operação falhou: {error}',
  'settings.mcpRestartNote': 'Reinicie seu cliente para detectar o novo servidor.',
  'settings.mcpRestartDetail': 'A maioria dos editores só carrega servidores MCP na inicialização. No Cursor / VS Code / Antigravity / Windsurf você pode executar `Developer: Reload Window` na command palette em vez de um reinício completo. Zed e Claude Code exigem fechar e reabrir.',
  'settings.mcpCapabilitiesTitle': 'O que dá para pedir por lá',
  'settings.mcpCapabilityRead': 'Ler ou pesquisar qualquer arquivo em um projeto (HTML, JSX, CSS, JSON, SVG, Markdown).',
  'settings.mcpCapabilityPull': 'Trazer o design inteiro de uma só vez: o arquivo principal mais todos os estilos, componentes e fontes que ele usa.',
  'settings.mcpCapabilityDefault': 'Usar por padrão o projeto e o arquivo que você tem aberto no Crie3, para que você possa dizer "crie isto no meu app" sem precisar repetir qual design.',
  'settings.mcpRemoteHeading': 'Conecte seu assistente de código',
  'settings.mcpRemoteIntro': 'Conecte o claude.ai, o ChatGPT ou um assistente de código a esta conta pela internet.',
  'settings.mcpRemoteAddressLabel': 'Endereço',
  'settings.mcpRemoteKeyHeading': 'Chave de acesso',
  'settings.mcpRemoteKeyNone': 'Nenhuma chave criada ainda. Crie uma para o seu assistente entrar.',
  'settings.mcpRemoteKeyCreated': 'Chave criada em {date}.',
  'settings.mcpRemoteGenerate': 'Criar chave',
  'settings.mcpRemoteRegenerate': 'Criar uma nova chave',
  'settings.mcpRemoteRegenerateNote': 'Criar uma nova chave faz a anterior parar de funcionar na hora.',
  'settings.mcpRemoteRevoke': 'Revogar chave',
  'settings.mcpRemoteRevoked': 'A chave foi revogada. Quem ainda estava usando ela foi desconectado.',
  'settings.mcpRemoteBusy': 'Um momento…',
  'settings.mcpRemoteKeyLabel': 'Sua nova chave',
  'settings.mcpRemoteKeyOnce': 'Copie esta chave agora — ela aparece uma única vez e não dá para recuperar depois.',
  'settings.mcpRemoteSnippetHeading': 'Pronto para colar',
  'settings.mcpRemoteSnippetNote': 'Cole isto nas configurações do seu assistente. Se você já fechou a chave, troque o trecho indicado pela sua.',
  'settings.mcpRemoteScopeNote': 'A chave e os apps conectados podem ler seus projetos e iniciar novos trabalhos, inclusive pedir ao agente do Crie3 que ajuste peças. Não podem apagar projetos nem publicar posts sem a sua aprovação.',
  'settings.mcpRemoteError': 'Algo deu errado: {error}',
  'settings.mcpRemoteKeyPlaceholder': 'SUA-CHAVE-DE-ACESSO',
  'settings.mcpRemoteOAuthHint': 'No claude.ai, no ChatGPT ou no Claude Code, adicione este endereço como conector personalizado (servidor MCP remoto). O Crie3 pede seu e-mail e senha na hora de conectar.',
  'settings.mcpRemoteKeyForOthers': 'Para assistentes sem suporte a login, ou para scripts, crie uma chave e envie no cabeçalho Authorization.',
  'settings.mcpConnectionsHeading': 'Apps conectados',
  'settings.mcpConnectionsEmpty': 'Nenhum app se conectou pelo login ainda.',
  'settings.mcpConnectionsSince': 'Conectado em {date}',
  'settings.mcpConnectionsLastUsed': 'último uso em {date}',
  'settings.mcpConnectionsDisconnect': 'Desconectar',
  'settings.mcpConnectionsDisconnected': '{name} foi desconectado. Ele para de funcionar na próxima chamada.',
  'settings.mcpConnectionsNote': 'Trocar a senha não desconecta estes apps. Desconecte aqui os que você não usa mais.',
  'settings.mcpRunningNote': 'O Crie3 precisa estar aberto para que os pedidos feitos de fora funcionem. Se você abriu o Claude ou o ChatGPT antes do Crie3, feche e abra de novo para que ele encontre o Crie3.',
  'entry.tabDesigns': 'Designs',
  'entry.tabTemplates': 'Modelos',
  'entry.tabDesignSystems': 'Sistemas de design',
  'entry.tabConnectors': 'Conectores',
  'entry.openSettingsTitle': 'Configurações',
  'entry.openSettingsAria': 'Abrir configurações',
  'entry.discordLabel': 'Entrar no Discord',
  'entry.discordOnlineLabel': '{count} online',
  'entry.followThreadsLabel': 'Siga o Crie3 no Threads',
  'entry.youtubeLabel': 'Crie3 no YouTube',
  'entry.followLinkedinLabel': 'Siga a Crie3 no LinkedIn',
  'entry.followXiaohongshuLabel': 'Siga a Crie3 no Xiaohongshu',
  'entry.resizeAria': 'Redimensionar barra lateral',
  'entry.loadingWorkspace': 'Carregando área de trabalho…',
  'entry.useEverywhereTitle': 'Usar em qualquer lugar',
  'entry.useEverywhereAria': 'Abrir o guia “Usar em qualquer lugar” (CLI, MCP, HTTP, Skills)',
  'entry.workspaceTeamsLabel': 'Teams',
  'entry.workspaceTeamsTitle': 'Crie3 para equipes — conte o que a sua equipe precisa',
  'entry.workspaceTeamsAria': 'Abrir a página do Crie3 para equipes',
  'entry.navExpand': 'Expandir barra lateral',
  'entry.navCollapse': 'Recolher barra lateral',
  'entry.navNewProject': 'Novo projeto',
  'entry.navHome': 'Início',
  'entry.navProjects': 'Projetos',
  'entry.navCalendar': 'Calendário',
  'entry.navImages': 'Imagens',
  'entry.navReferences': "Referências",
  'references.title': "Referências",
  'references.subtitle': "Posts que já deram certo nas redes, lidos e destrinchados para recriar na marca do cliente. No claude.ai, mande o link e peça para destrinchar o post: o Crie3 lê e guarda sozinho.",
  'references.client': "Cliente",
  'references.target': "Link do post, @perfil ou #hashtag do Instagram",
  'references.targetPlaceholder': "https://www.instagram.com/p/…",
  'references.read': "Ler",
  'references.reading': "Lendo… pode levar até 1 minuto.",
  'references.usedToday': "{used} de {limit} leituras hoje",
  'references.level.muito_acima': "Muito acima da média ({ratio}x)",
  'references.level.validado': "Validado ({ratio}x)",
  'references.level.na_media': "Na média do perfil",
  'references.level.abaixo': "Abaixo da média do perfil",
  'references.level.none': "Sem régua (poucos posts para comparar)",
  'references.metrics': "{likes} curtidas · {comments} comentários",
  'references.plays': "{plays} reproduções",
  'references.type.imagem': "Imagem",
  'references.type.carrossel': "Carrossel",
  'references.type.reel': "Reel",
  'references.format.feed': "Feed",
  'references.format.story': "Story",
  'references.saveTitle': "Destrinchar e guardar",
  'references.save': "Guardar",
  'references.field.kind': "Tipo de peça",
  'references.field.kindPlaceholder': "versículo, convite, carrossel…",
  'references.field.format': "Formato",
  'references.field.hook': "Gancho: o que prende na primeira tela",
  'references.field.structure': "Estrutura, tela a tela",
  'references.field.visual': "Linguagem visual",
  'references.field.whyItWorked': "Por que funcionou",
  'references.field.tags': "Etiquetas (separadas por vírgula)",
  'references.field.howToAdapt': "Como adaptar para este cliente",
  'references.saved': "Guardadas",
  'references.empty': "Nenhuma referência guardada para este cliente.",
  'references.status.guardada': "Guardada",
  'references.status.usada': "Usada numa peça",
  'references.status.aprovada': "Virou post aprovado",
  'references.open': "Ver no Instagram",
  'references.delete': "Apagar",
  'references.confirmDelete': "Confirmar",
  'references.error.target': "Mande um link de post, reel ou perfil do Instagram, um @perfil ou uma #hashtag.",
  'references.error.disabled': "A leitura de referências não está ligada neste Crie3.",
  'references.error.limit': "O limite de leituras de hoje acabou. Amanhã ele volta.",
  'references.error.notFound': "Não achei esse post, ou o perfil é privado.",
  'references.error.provider': "O leitor de referências está sem crédito ou com a chave recusada. Avise o responsável pelo Crie3.",
  'references.error.timeout': "A leitura demorou demais. Tente de novo daqui a pouco.",
  'references.error.generic': "Não deu para ler agora. Tente de novo.",
  'references.error.save': "Não deu para guardar. Preencha tipo, formato, gancho, estrutura e por que funcionou.",
  'references.error.load': "Não deu para carregar as referências. Recarregue a página.",
  'references.error.delete': "Não deu para apagar esta referência. Tente de novo.",
  'references.autoBreaking': "Destrinchando com a IA…",
  'references.autoFailed': "Não deu para destrinchar sozinho. Preencha os campos à mão ou tente de novo.",
  'references.autoAgain': "Destrinchar de novo com a IA",
  'images.title': 'Imagens',
  'images.subtitle': 'Gere imagens e fundos para as peças. Não usa o crédito de IA do Crie3; cada imagem conta no limite do dia, o mesmo do claude.ai.',
  'images.prompt': 'Descreva a imagem',
  'images.promptPlaceholder': 'Ex.: luz da manhã entrando por um vitral, tons quentes',
  'images.kind': 'Tipo',
  'images.kind.imagem': 'Imagem',
  'images.kind.fundo': 'Fundo para texto',
  'images.format': 'Formato',
  'images.format.feed': 'Feed (4:5)',
  'images.format.quadrado': 'Quadrado (1:1)',
  'images.format.story': 'Story (9:16)',
  'images.format.paisagem': 'Paisagem (16:9)',
  'images.quality': 'Qualidade',
  'images.quality.rapida': 'Rápida',
  'images.quality.foto': 'Foto realista',
  'images.references': 'Referências (até {n})',
  'images.referencesHint': 'Escolha uma foto ou o logo para editar ou seguir o estilo.',
  'images.ref.logoLight': 'Logo (fundo claro)',
  'images.ref.logoDark': 'Logo (fundo escuro)',
  'images.ref.spacePhoto': 'Foto do espaço',
  'images.ref.generated': 'Imagem gerada',
  'images.generate': 'Gerar imagem',
  'images.generating': 'Gerando… pode levar até 2 minutos.',
  'images.usedToday': '{used} de {limit} imagens hoje',
  'images.empty': 'Nenhuma imagem gerada ainda.',
  'images.disabled': 'A geração de imagens não está ligada neste Crie3.',
  'images.download': 'Baixar',
  'images.copyLink': 'Copiar link',
  'images.linkCopied': 'Link copiado',
  'images.useAsReference': 'Usar como referência',
  'images.delete': 'Apagar',
  'images.confirmDelete': 'Confirmar',
  'images.error.limit': 'O limite de imagens de hoje acabou. Amanhã ele volta.',
  'images.error.reference': 'Uma referência não serve: use foto PNG, JPEG ou WebP de até 10 MB (logo em SVG não serve).',
  'images.error.plan': 'O plano da conta não cobre mais imagens agora.',
  'images.error.provider': 'O gerador de imagens está sem crédito ou com a chave recusada. Avise o responsável pelo Crie3.',
  'images.error.generic': 'Não deu para gerar esta imagem agora. Tente de novo descrevendo de outro jeito.',
  'images.error.load': 'Não deu para carregar as imagens. Recarregue a página.',
  'images.dialogTitle': 'Gerar imagem para este projeto',
  'images.savedToProject': 'Imagem salva em {path}',
  'designFiles.generateImage': 'Gerar imagem',
  'images.error.copy': 'A imagem foi gerada, mas não entrou no projeto. Ela está na aba Imagens.',
  'images.error.delete': 'Não deu para apagar esta imagem. Tente de novo.',
  'images.orUseExisting': 'Ou use uma imagem já gerada',
  'images.useInProject': 'Usar neste projeto',
  'entry.navClients': 'Clientes',
  'calendar.title': 'Calendário',
  'calendar.intro': 'Todos os posts agendados. Aprove, remarque ou cancele antes de sair.',
  'calendar.week': 'Semana',
  'calendar.client': 'Cliente',
  'calendar.allClients': 'Todos os clientes',
  'calendar.month': 'Mês',
  'calendar.previous': 'Anterior',
  'calendar.next': 'Próximo',
  'calendar.today': 'Hoje',
  'calendar.loadError': 'Não foi possível carregar o calendário.',
  'calendar.empty': 'Nada agendado neste período.',
  'calendar.more': '+{n} mais',
  'calendar.state.draft': 'Para aprovar',
  'calendar.state.approved': 'Aprovado',
  'calendar.state.queued': 'Agendado',
  'calendar.state.publishing': 'Publicando',
  'calendar.state.handed_off': 'Pronto para você postar',
  'calendar.state.published': 'Publicado',
  'calendar.state.failed': 'Falhou',
  'calendar.state.canceled': 'Cancelado',
  'calendar.origin.user': 'Criado por você',
  'calendar.origin.mcp': 'Rascunho feito no seu assistente de IA',
  'calendar.origin.weekly': 'Gerado pelo Crie3',
  'calendar.approve': 'Aprovar',
  'calendar.approveTiktokHint': 'Posts do TikTok são aprovados na tela de publicação, onde o TikTok pede escolhas extras.',
  'calendar.reschedule': 'Remarcar',
  'calendar.rescheduleLabel': 'Nova data e hora',
  'calendar.unapprove': 'Voltar para rascunho',
  'calendar.cancel': 'Cancelar post',
  'calendar.cancelReason': 'Motivo (opcional)',
  'calendar.close': 'Fechar',
  'calendar.actionError': 'Não deu certo. Recarregue o calendário e tente de novo.',
  'calendar.layoutOffer': 'Salvar o layout deste post como padrão do cliente, para reusar nos próximos?',
  'calendar.layoutNameLabel': 'Nome do padrão',
  'calendar.layoutSave': 'Salvar como padrão',
  'calendar.layoutDismiss': 'Agora não',
  'calendar.layoutSaved': 'Salvo nos padrões do cliente. Ele aparece na ficha do cliente e para o assistente no claude.ai.',
  'calendar.layoutError': 'Não deu para salvar o padrão deste post.',
  'calendar.scheduledFor': 'Agendado para {when}',
  'calendar.chipAutomatic': 'automático',
  'calendar.automaticNotice': 'Publicação automática: sai em {when}. Cancele aqui se não quiser que saia.',
  'calendar.viewOnInstagram': 'Ver no Instagram',
  'calendar.slideOf': 'Tela {n} de {total}',
  'calendar.previousSlide': 'Tela anterior',
  'calendar.nextSlide': 'Próxima tela',
  'calendar.failure.zernioDisconnected': 'A conta do Instagram foi desconectada, então o post não saiu. Reconecte o Instagram e agende de novo.',
  'calendar.failure.zernioPostFailed': 'O Instagram não publicou este post. Confira a peça (formato e tamanho) e agende de novo.',
  'calendar.reconnectInstagram': 'Reconecte o Instagram: @{account} foi desconectado, e os posts agendados para ele não vão sair até conectar de novo.',
  'calendar.reconnectAction': 'Reconectar',
  'social.health.needsReconnect': 'precisa reconectar',
  'social.automations.title': 'Palavra-chave → mensagem',
  'social.automations.hint': 'Quando alguém comentar uma destas palavras em qualquer post do Instagram, recebe a sua mensagem no direct.',
  'social.automations.empty': 'Nenhuma resposta automática ainda.',
  'social.automations.offline': 'A Zernio não respondeu; mostrando a cópia salva.',
  'social.automations.keywords': 'Palavras-chave (separadas por vírgula)',
  'social.automations.keywordsPlaceholder': 'culto, horário',
  'social.automations.message': 'Mensagem enviada no direct',
  'social.automations.reply': 'Resposta pública no comentário (opcional)',
  'social.automations.account': 'Qual Instagram',
  'social.automations.create': 'Criar pausada',
  'social.automations.on': 'Ligada',
  'social.automations.paused': 'Pausada',
  'social.automations.sent': '{count} mensagens enviadas',
  'social.automations.turnOn': 'Ligar',
  'social.automations.turnOff': 'Pausar',
  'social.automations.delete': 'Apagar',
  'social.automations.confirmOn': 'Ligar a resposta para "{keywords}"? A partir de agora, todo mundo que comentar essas palavras recebe esta mensagem no direct.',
  'social.automations.failed': 'Não foi possível salvar a resposta automática. Tente de novo.',
  'social.automations.needsInstagram': 'Conecte primeiro o Instagram da igreja.',
  'calendar.policy.AUTOMATIC_MODE_OFF': 'Voltou a rascunho: o modo automático foi desligado. Aprove se ainda quiser publicar.',
  'calendar.policy.MISSED_SLOT': 'Voltou a rascunho: perdeu o horário. Escolha um novo horário e aprove de novo.',
  'calendar.policy.NOT_ENOUGH_NOTICE': 'Voltou a rascunho: uma publicação automática precisa ficar 24 horas no calendário antes de sair.',
  'calendar.policy.NOT_ELIGIBLE_FOR_AUTOMATION': 'Precisa da sua aprovação: só os convites semanais gerados pelo Crie3 saem automaticamente.',
  'publishing.title': 'Modo de publicação',
  'publishing.manual': 'Manual: cada publicação espera a sua aprovação.',
  'publishing.scopeHint': 'Só os convites da semana da Minha marca saem sozinhos. Os posts dos outros clientes esperam a sua aprovação.',
  'publishing.automatic': 'Automático em {account}: os convites da semana saem sozinhos, cada um visível aqui por 24 horas antes.',
  'publishing.optedInBy': 'Ativado por {who} em {when}.',
  'publishing.paused': 'Pausado: nada é publicado nem gerado até você retomar.',
  'publishing.turnOn': 'Ativar modo automático',
  'publishing.turnOff': 'Voltar ao manual',
  'publishing.pause': 'Pausar tudo',
  'publishing.resume': 'Retomar',
  'publishing.error': 'Não deu certo. Tente de novo.',
  'publishing.optInTitle': 'Publicação automática',
  'publishing.optInTerms': 'Com a publicação automática ativa, o Crie3 gera toda semana um convite para cada culto cadastrado em "Minha marca" e o publica sem nova aprovação, no horário mostrado no calendário. Cada um fica aqui, com a opção de cancelar, por pelo menos 24 horas antes de sair. Você pode pausar tudo ou voltar ao manual a qualquer momento.\n\nConteúdo gerado por inteligência artificial pode conter erros. Ao ativar, você assume a responsabilidade pelo que for publicado em nome da igreja e se compromete a acompanhar o calendário. Rascunhos de assistentes externos continuam precisando da sua aprovação.',
  'publishing.termsLink': 'Ler os Termos de Uso (seção 12)',
  'publishing.optInAccount': 'Conta do Instagram',
  'publishing.optInNoAccount': 'Conecte uma conta do Instagram nas Configurações primeiro.',
  'publishing.optInAccept': 'Li e aceito a seção 12 dos Termos de Uso.',
  'publishing.optInConfirm': 'Ativar',
  'publishing.optInTermsChanged': 'Os Termos mudaram enquanto esta janela estava aberta. Leia de novo e confirme.',
  'weekly.title': 'Convites da semana',
  'weekly.empty': 'Cadastre os cultos em "Minha marca" e o Crie3 cria um convite por culto toda semana.',
  'weekly.scopeHint': 'Só para a Minha marca, a partir dos cultos da ficha dela.',
  'weekly.runNow': 'Gerar agora',
  'weekly.runNowStarted': 'Gerando. Os convites aparecem no calendário conforme ficam prontos.',
  'weekly.nextRun': 'Próxima geração: {when}',
  'weekly.status.pending': 'Aguardando',
  'weekly.status.generating': 'Gerando',
  'weekly.status.scheduled': 'Agendado',
  'weekly.status.draft': 'Para aprovar',
  'weekly.status.not_generated': 'Não gerado',
  'weekly.error': 'Não foi possível carregar os convites da semana.',
  'weekly.offHint': 'Desligada. Ao ligar, o Crie3 cria toda semana um convite por culto — cada convite usa gerações do seu plano.',
  'weekly.turnOn': 'Ligar',
  'weekly.turnOff': 'Desligar',
  'entry.navTasks': 'Automações',
  'entry.navPlugins': 'Plugins',
  'entry.navDesignSystems': 'Design systems',
  'entry.navBrands': 'Kit de marca',
  'entry.navIntegrations': 'Integrações',
  'workspaceTabs.project': 'Projeto',
  'workspaceTabs.pluginDetails': 'Detalhes do plugin',
  'workspaceTabs.marketplace': 'Marketplace',
  'homeHero.title': 'O que você vai projetar hoje?',
  'homeHero.startWithTemplate': 'Começar com um modelo…',
  'homeHero.startBlankProject': '…ou começar um projeto em branco',
  'homeHero.templatePicker.label': 'Formato',
  'homeHero.templatePicker.searchPlaceholder': 'Buscar formatos',
  'homeHero.templatePicker.projectTypes': 'Tipos de peça',
  'homeHero.templatesScrollHint': 'Role para cima para explorar mais modelos',
  'homeHero.templatesCollapse': 'Recolher modelos',
  'homeHero.subtitlePrefix': 'Design com IA para igrejas e comunicadores cristãos.',
  'homeHero.placeholder': 'Descreva o que você quer gerar…',
  'homeHero.placeholderActive': 'Edite a consulta de exemplo ou escreva a sua própria…',
  'homeHero.carousel.hint': 'Anexe um arquivo, vincule seu design system ou descreva o que você quer criar',
  'homeHero.carousel.onePageBrief': 'Fazer a agenda da semana da igreja',
  'homeHero.carousel.notesToDeck': 'Transformar minhas anotações da pregação em slides',
  'homeHero.carousel.signupFlow': 'Fazer uma página de inscrição para o retiro',
  'homeHero.carousel.improveBrief': 'Melhorar o texto do anúncio do batismo',
  'homeHero.carousel.loadingAnimation': 'Criar uma contagem regressiva para o início do culto',
  'homeHero.carousel.teamUpdateSlides': 'Criar slides com a letra da música para o telão',
  'homeHero.carousel.ordersDashboard': 'Fazer uma página para acompanhar a campanha de doação',
  'homeHero.carousel.productDetail': 'Montar a arte da nova série de mensagens',
  'homeHero.carousel.caseStudy': 'Escrever o roteiro do devocional da semana',
  'homeHero.carousel.landingIntro': 'Criar um convite para o culto de jovens de sexta, 20h',
  'homeHero.carousel.pitchDeck': 'Criar slides para apresentar o projeto de missões',
  'homeHero.carousel.appIdea': 'Descrever um app de devocional diário para a igreja',
  'homeHero.carousel.landingLayout': 'Esboçar um card de versículo para o feed',
  'homeHero.skills': 'Skills',
  'homeHero.addMenu': 'Adicionar contexto',
  'homeHero.addPlugin': 'Adicionar plugin',
  'homeHero.addConnectors': 'Adicionar conectores',
  'homeHero.addMcp': 'Adicionar servidor MCP',
  'homeHero.noPlugins': 'Nenhum plugin instalado',
  'homeHero.noMcp': 'Nenhum servidor MCP',
  'homeHero.noConnectors': 'Nenhum conector conectado',
  'homeHero.applying': 'Aplicando…',
  'homeHero.pluginTitle': 'Plugin: {title}',
  'homeHero.pluginPrefix': 'Plugin: {title}',
  'homeHero.skillPrefix': 'Skill: {title}',
  'homeHero.removePlugin': 'Remover plugin',
  'homeHero.removePluginAria': 'Remover plugin {title}',
  'homeHero.clearActivePlugin': 'Limpar plugin ativo',
  'homeHero.clearActiveSkill': 'Limpar skill ativa',
  'homeHero.contextItemsResolved': '{n} itens de contexto resolvidos',
  'homeHero.removeFile': 'Remover arquivo',
  'homeHero.contextSearchResults': 'Resultados da busca de contexto',
  'homeHero.contextSurfaces': 'Superfícies de contexto',
  'homeHero.loadingContext': 'Carregando contexto…',
  'homeHero.noResults': 'Nenhum resultado para "{query}".',
  'homeHero.searchPrompt': 'Busque arquivos, plugins, skills, servidores MCP e conectores.',
  'homeHero.parameters': '{n} parâmetros',
  'homeHero.details': 'Detalhes',
  'homeHero.toRun': 'para executar',
  'homeHero.forNewLine': 'para nova linha',
  'homeHero.run': 'Executar',
  'homeHero.typeSomethingToRun': 'Digite algo para executar',
  'homeHero.promptExamples': 'Exemplos',
  'homeHero.footer.designSystem': 'Estilo',
  'homeHero.footer.autoDesignSystem': 'Automático',
  'homeHero.footer.autoDesignSystemSummary': 'Escolhe sozinho o design system e o estilo visual que mais combinam com o que você pediu.',
  'homeHero.footer.ratio': 'Proporção',
  'homeHero.footer.duration': 'Duração',
  'homeHero.footer.resolution': 'Resolução',
  'homeHero.footer.speakerNotes': 'Notas',
  'homeHero.footer.noSpeakerNotes': 'Sem notas',
  'homeHero.footer.availableCount': '{n} disponíveis',
  'homeHero.footer.noMatches': 'Nenhuma correspondência',
  'homeHero.moreShortcuts': 'Mais',
  'homeHero.railAria': 'Escolha uma categoria de projeto ou atalho inicial',
  'homeHero.subTypeAria': 'Escolha um subtipo',
  'homeHero.subTypeMore': 'Mais',
  'homeHero.confirmReplaceTitle': 'Substituir o que você escreveu?',
  'homeHero.confirmReplaceBody': 'Usar {title} substituirá o texto que está atualmente no campo de entrada.',
  'homeHero.confirmReplace': 'Substituir',
  'homeHero.chip.prototype': 'Protótipo',
  'homeHero.chip.webClone': 'Clone de site',
  'homeHero.chip.liveArtifact': 'Artefato ao vivo',
  'homeHero.chip.deck': 'Apresentação de slides',
  'homeHero.chip.image': 'Imagem',
  'homeHero.chip.video': 'Vídeo',
  'homeHero.chip.hyperframes': 'Animações',
  'homeHero.chip.webgl': 'Experiência WebGL',
  'homeHero.chip.webglDesc': 'Shaders, 3D e visuais GPU generativos',
  'homeHero.chip.worker': 'Visualizador Worker',
  'homeHero.chip.workerDesc': 'Sims fora da thread, partículas e data viz',
  'homeHero.chip.audio': 'Áudio',
  'homeHero.chip.createBrandKit': 'Criar kit de marca',
  'homeHero.chip.createPlugin': 'Criar plugin',
  'homeHero.chip.figma': 'Do Figma',
  'homeHero.chip.folder': 'De uma pasta',
  'homeHero.chip.template': 'De um modelo',
  'homeHero.chip.liveArtifactHint': 'Crie um artefato interativo em HTML/CSS/JS que você pode visualizar ao vivo.',
  'homeHero.chip.hyperframesHint': 'Crie animações baseadas em HTML: legendas, visuais reativos ao áudio, transições de cena.',
  'homeHero.chip.createBrandKitHint': 'Extraia um kit de marca de um site e aplique-o em qualquer chat.',
  'homeHero.chip.createPluginHint': 'Crie um plugin reutilizável do Crie3 e adicione-o aos Meus plugins.',
  'homeHero.chip.figmaHint': 'Migre um frame do Figma para o design system ativo.',
  'homeHero.chip.folderHint': 'Importe uma pasta local existente e continue editando.',
  'homeHero.chip.templateHint': 'Comece a partir de um modelo incluído.',
  'homeHero.chip.wireframe': 'Wireframe',
  'homeHero.chip.mobile': 'App mobile',
  'homeHero.chip.document': 'Documento',
  'homeHero.chip.prototypeDesc': 'Mockups interativos de app',
  'homeHero.chip.webCloneDesc': 'Reprodução de site a partir da fonte',
  'homeHero.chip.wireframeDesc': 'Telas e fluxos lo-fi',
  'homeHero.chip.mobileDesc': 'Telas iOS e Android',
  'homeHero.chip.deckDesc': 'Slides para o telão do culto',
  'homeHero.chip.documentDesc': 'Currículos, relatórios e PDFs',
  'homeHero.chip.imageDesc': 'Post, story e card de versículo',
  'homeHero.chip.videoDesc': 'Cortes da pregação e reels',
  'homeHero.chip.audioDesc': 'Vinhetas e locuções',
  'homeHero.chip.hyperframesDesc': 'Motion graphics e loops',
  'homeHero.chip.liveArtifactDesc': 'Dashboards ao vivo com dados',
  'homeHero.chip.createBrandKitDesc': 'Monte a identidade visual da igreja',
  'homeHero.chip.prototypeNext': 'Abre um chat que cria um protótipo web clicável de alta fidelidade que você refina a cada rodada.',
  'homeHero.chip.webCloneNext': 'Abre um chat que pede uma URL alvo, reconstrói o site e audita o clone.',
  'homeHero.chip.wireframeNext': 'Abre um chat que esboça telas e fluxos lo-fi para validar a estrutura primeiro.',
  'homeHero.chip.mobileNext': 'Abre um chat que monta telas mobile para iOS e Android.',
  'homeHero.chip.deckNext': 'Abre um chat que cria uma apresentação de slides para você apresentar e exportar.',
  'homeHero.chip.documentNext': 'Abre um chat que redige um documento caprichado — currículo, relatório ou PDF.',
  'homeHero.chip.imageNext': 'Abre um chat que gera imagens fiéis à marca para você iterar.',
  'homeHero.chip.videoNext': 'Abre um chat que produz um vídeo curto para você refinar.',
  'homeHero.chip.audioNext': 'Abre um chat que cria narração, música ou efeitos sonoros.',
  'homeHero.chip.webClonePromptSeed': 'URL do site para clonar: ',
  'homeWorkingDir.trigger': 'Selecionar diretório de trabalho',
  'homeWorkingDir.pick': 'Escolher pasta',
  'homeWorkingDir.replace': 'Alterar diretório de trabalho',
  'homeWorkingDir.recent': 'Pastas recentes',
  'homeWorkingDir.recentEmpty': 'Nenhuma pasta recente',
  'homeWorkingDir.clear': 'Remover diretório de trabalho',
  'homeWorkingDir.hint': 'Deixe o agente ler esta pasta local (não importada nos Design Files)',
  'homeWorkingDir.missing': 'Esta pasta de trabalho não existe mais — escolha outra',
  'homeWorkingDir.applyFailed': 'Não foi possível definir o diretório de trabalho — a pasta pode não existir mais',
  'workingDirPicker.title': 'Pasta',
  'workingDirPicker.homeTitle': 'Salvo no armazenamento local — clique para escolher uma pasta',
  'workingDirPicker.processing': 'Processando…',
  'workingDirPicker.select': 'Armazenamento local',
  'workingDirPicker.clearAria': 'Limpar diretório de trabalho',
  'workingDirPicker.replaceFailed': 'Não foi possível substituir o diretório de trabalho',
  'workingDirPicker.unavailable': 'O seletor de pastas não está disponível nesta versão. Execute o app desktop para escolher uma pasta.',
  'workingDirPicker.openUnavailable': 'Abra este projeto no app desktop para mostrar a pasta.',
  'workingDirPicker.openFailed': 'Não foi possível mostrar esta pasta',
  'workingDirPicker.showInFileManager': 'Mostrar no gerenciador de arquivos',
  'workingDirPicker.replace': 'Escolher pasta…',
  'workingDirPicker.recent': 'Diretórios recentes',
  'workingDirPicker.defaultLabel': 'Armazenamento local',
  'handoff.toTarget': 'Transferir para {target}',
  'handoff.openInTarget': 'Abrir em {target}',
  'handoff.openAction': 'Abrir',
  'handoff.menuTitle': 'Abrir em qual editor?',
  'handoff.action': 'Transferir',
  'handoff.fallbackTitle': 'Nenhum editor encontrado no $PATH - abre em {target}',
  'handoff.chooseTargetAria': 'Escolher destino da transferência',
  'handoff.optionsAria': 'Opções de transferência',
  'handoff.editorSection': 'Abrir com editor',
  'handoff.cliSection': 'Copiar para CLI',
  'handoff.clickOpen': 'Clique para abrir',
  'handoff.framework': 'Framework de código',
  'handoff.framework.react': 'React',
  'handoff.framework.vue': 'Vue.js',
  'handoff.framework.svelte': 'Svelte',
  'handoff.framework.solid': 'SolidJS',
  'handoff.framework.next': 'Next.js',
  'handoff.framework.vanilla': 'JS',
  'handoff.frameworkPrompt.react': 'React',
  'handoff.frameworkPrompt.vue': 'Vue.js',
  'handoff.frameworkPrompt.svelte': 'Svelte',
  'handoff.frameworkPrompt.solid': 'SolidJS',
  'handoff.frameworkPrompt.next': 'Next.js / React',
  'handoff.frameworkPrompt.vanilla': 'JavaScript puro, HTML e CSS',
  'handoff.amrWebsite': 'Abrir site da Crie3 Cloud',
  'handoff.copyPrompt': 'Copiar o pedido',
  'handoff.copyPromptForTarget': 'Copiar o pedido para {target}',
  'handoff.copied': 'Copiado',
  'handoff.projectPathUnavailable': 'O caminho do projeto ainda está carregando. Tente novamente em instantes.',
  'handoff.copyFailed': 'A gravação na área de transferência foi bloqueada. Tente novamente em instantes.',
  'handoff.promptIntro': 'Continuar a partir desta pasta de projeto local do Crie3:',
  'handoff.promptTarget': 'Destino',
  'handoff.promptCli': 'CLI',
  'handoff.promptStepsLead': 'Você está assumindo no {cli}. Por favor:',
  'handoff.promptReadFiles': 'Entre ou leia este diretório primeiro. Priorize DESIGN.md, README, HTML/CSS/JS existentes, assets e package.json, se houver.',
  'handoff.promptKeepDesign': 'Preserve o design visual, layout, interações e assets atuais. Não pare em um plano.',
  'handoff.promptProduceCode': 'Gere ou modifique código {framework} real e executável. Se o projeto já tiver uma stack mais clara, aponte o conflito e mantenha o resultado executável.',
  'handoff.promptVerify': 'Finalize me informando os comandos de execução, prévia e verificação.',
  'handoff.promptCommandHint': 'Para começar a partir do diretório do projeto, use:',
  'handoff.promptProject': 'Projeto',
  'handoff.promptProjectId': 'ID do projeto',
  'handoff.notInstalled': 'Não instalado',
  'handoff.notDetectedTitle': '{target} - não detectado no $PATH',
  'designSystemPicker.select': 'Escolher design system',
  'designSystemPicker.loading': 'Carregando design systems…',
  'designSystemPicker.searchPlaceholder': 'Pesquisar design systems (título / categoria / resumo)',
  'designSystemPicker.searchCompactPlaceholder': 'Pesquisar design systems',
  'designSystemPicker.noneTitle': 'Nenhum design system',
  'designSystemPicker.noneSummary': 'Deixe o modelo escolher livremente',
  'designSystemPicker.empty': 'Nenhum design system correspondente',
  'designSystemPicker.openPreview': 'Abrir prévia',
  'designSystemPicker.loadingPreview': 'Carregando pré-visualização…',
  'designSystemPicker.noPreview': 'Nenhuma página de prévia. Abra os Design Systems para ver a prévia completa.',
  'designSystemPicker.previewHint': 'Passe o cursor sobre um design system para visualizá-lo',
  'designSystemPicker.fullscreenAria': 'Prévia em tela cheia de {title}',
  'designSystemPicker.closeFullscreen': 'Fechar pré-visualização em tela cheia',
  'designSystemPicker.closeEsc': 'Fechar (Esc)',
  'designSystemPicker.previewFrameTitle': 'Pré-visualização de {title}',
  'designSystemPicker.fullscreenFrameTitle': 'Pré-visualização de {title} em tela cheia',
  'recentProjects.title': 'Projetos recentes',
  'recentProjects.viewAll': 'Ver tudo',
  'recentProjects.empty': 'Nenhum projeto ainda — escreva o que você quer criar para começar.',
  'pluginsHome.title': 'Comunidade',
  'pluginsHome.subtitle': 'Fluxos de trabalho do Crie3 prontos para usar, já incluídos aqui. Escolha um para começar com um pedido pronto ou veja a lista completa.',
  'pluginsHome.browseRegistry': 'Navegar no registro',
  'pluginsHome.count': '{filtered} de {total}',
  'pluginsHome.loadingCatalog': 'Carregando catálogo…',
  'pluginsHome.emptyCatalog': 'O catálogo está vazio. Os plugins integrados vêm com o Crie3 e devem aparecer aqui automaticamente — tente reiniciar o daemon se isso persistir.',
  'pluginsHome.emptyFiltered': 'Nenhum plugin corresponde aos filtros atuais.',
  'pluginsHome.clearFilters': 'Limpar filtros',
  'pluginsHome.modeAria': 'Modo de plugin',
  'pluginsHome.featured': 'Salvo',
  'pluginsHome.totalInCatalog': '{n} no catálogo',
  'pluginsHome.categoryFilterAria': 'Filtro de categoria',
  'pluginsHome.subcategoryFilterAria': 'Filtro de subcategoria de {label}',
  'pluginsHome.allCategory': 'Todos: {label}',
  'pluginsHome.searchPlaceholder': 'Pesquisar plugins…',
  'pluginsHome.searchAria': 'Pesquisar plugins',
  'pluginsHome.clearSearch': 'Limpar pesquisa',
  'pluginsHome.sortAria': 'Ordem de classificação',
  'pluginsHome.sortHot': 'Em alta',
  'pluginsHome.sortNewest': 'Mais recentes',
  'pluginsHome.facet.import': 'Importar',
  'pluginsHome.facet.create': 'Criar',
  'pluginsHome.facet.export': 'Exportar',
  'pluginsHome.facet.share': 'Compartilhar',
  'pluginsHome.facet.deploy': 'Implantar',
  'pluginsHome.facet.refine': 'Refinar',
  'pluginsHome.facet.extend': 'Estender',
  'pluginsHome.facet.figma': 'Figma',
  'pluginsHome.facet.github': 'GitHub',
  'pluginsHome.facet.codeFolder': 'Código / pasta',
  'pluginsHome.facet.url': 'URL',
  'pluginsHome.facet.screenshot': 'Captura de tela',
  'pluginsHome.facet.pdf': 'PDF',
  'pluginsHome.facet.pptx': 'PPTX',
  'pluginsHome.facet.framer': 'Framer',
  'pluginsHome.facet.webflow': 'Webflow',
  'pluginsHome.facet.slides': 'Slides',
  'pluginsHome.facet.publicLink': 'Link público',
  'pluginsHome.facet.githubPr': 'PR do GitHub',
  'pluginsHome.facet.githubGist': 'Gist do GitHub',
  'pluginsHome.subfacet.business-dashboards': 'Dashboards',
  'pluginsHome.subfacet.app-prototypes': 'Apps',
  'pluginsHome.subfacet.landing-marketing': 'Landing / marketing',
  'pluginsHome.subfacet.developer-tools': 'Ferramentas dev',
  'pluginsHome.subfacet.docs-reports': 'Docs / relatórios',
  'pluginsHome.subfacet.brand-design': 'Marca / design',
  'pluginsHome.subfacet.pitch-business': 'Pitch / negócios',
  'pluginsHome.subfacet.course-training': 'Cursos / treinamento',
  'pluginsHome.subfacet.reports-briefings': 'Relatórios / briefings',
  'pluginsHome.subfacet.product-sales': 'Produto / vendas',
  'pluginsHome.subfacet.engineering-talks': 'Talks técnicas',
  'pluginsHome.subfacet.creative-decks': 'Decks criativos',
  'pluginsHome.subfacet.ui-product-mockups': 'UI / mockups',
  'pluginsHome.subfacet.brand-visuals': 'Marca / logo',
  'pluginsHome.subfacet.storyboards-motion-refs': 'Storyboards',
  'pluginsHome.subfacet.social-content': 'Social / conteúdo',
  'pluginsHome.subfacet.avatar-portrait': 'Avatar / retrato',
  'pluginsHome.subfacet.illustration-style': 'Ilustração / estilo',
  'pluginsHome.subfacet.motion-effects': 'Motion / efeitos',
  'pluginsHome.subfacet.social-short-form': 'Social / formato curto',
  'pluginsHome.subfacet.marketing-product': 'Marketing / produto',
  'pluginsHome.subfacet.data-explainers': 'Dados / explicativos',
  'pluginsHome.subfacet.cinematic-story': 'Cinemático / narrativa',
  'pluginsHome.commercialCategory.student-coursework': 'Trabalhos acadêmicos',
  'pluginsHome.commercialCategory.corporate-strategy': 'Estratégia corporativa',
  'pluginsHome.commercialCategory.professional-training': 'Treinamento profissional',
  'pluginsHome.commercialCategory.b2b-sales': 'Vendas B2B',
  'pluginsHome.commercialCategory.academic-research': 'Pesquisa acadêmica',
  'pluginsHome.commercialCategory.marketing-gtm': 'Marketing e GTM',
  'pluginsHome.commercialCategory.data-finance': 'Dados e finanças',
  'pluginsHome.commercialCategory.fundraising-pitch': 'Pitch de captação',
  'pluginsHome.commercialCategory.government-policy': 'Governo e políticas',
  'pluginsHome.commercialCategory.product-management': 'Gestão de produto',
  'pluginsHome.commercialCategory.consulting': 'Consultoria',
  'pluginsHome.commercialCategory.career': 'Carreira',
  'pluginsHome.commercialCategory.ai-literacy': 'Alfabetização em IA',
  'pluginsHome.commercialCategory.life': 'Vida e história',
  'pluginsHome.commercialCategory.design-craft': 'Ofício de design',
  'pluginsView.lede': 'Navegue pelos fluxos de trabalho instalados, descubra entradas do registro, gerencie fontes e prepare plugins para distribuição em equipe.',
  'pluginsView.importPlugin': 'Importar plugin',
  'pluginsView.agentContext': 'Contexto do Agent',
  'pluginsView.summaryAria': 'Resumo do plugin',
  'pluginsView.areasAria': 'Áreas do plugin',
  'pluginsView.loading': 'Carregando plugins…',
  'pluginsView.tab.installed': 'Instalado',
  'pluginsView.tab.available': 'Disponível',
  'pluginsView.tab.sources': 'Fontes',
  'pluginsView.tab.team': 'Equipe',
  'pluginsView.tabHint.installed': 'Seus plugins',
  'pluginsView.tabHint.available': 'De fontes',
  'pluginsView.tabHint.sources': 'Catálogos',
  'pluginsView.tabHint.team': 'Empresarial',
  'pluginsView.installedTitle': 'Plugins instalados',
  'pluginsView.installedSubtitle': 'Plugins que você importou ou instalou a partir de fontes do marketplace.',
  'pluginsView.installedEmpty': 'Nenhum plugin de usuário instalado ainda. Use Criar / Importar ou instale uma entrada Disponível.',
  'pluginsView.availableTitle': 'Disponível em fontes',
  'pluginsView.availableSubtitle': 'Entradas de catálogo descobertas a partir dos marketplaces configurados.',
  'pluginsView.availableFiltersAria': 'Filtros de plugins disponíveis',
  'pluginsView.searchAvailableAria': 'Pesquisar plugins disponíveis',
  'pluginsView.searchAvailablePlaceholder': 'Pesquisar plugins disponíveis',
  'pluginsView.clearAvailableSearch': 'Limpar pesquisa de plugins disponíveis',
  'pluginsView.source': 'Origem',
  'pluginsView.availableEmptyInstalled': 'Nenhuma entrada disponível ainda. As entradas de catálogo instaladas são removidas de Disponíveis; desinstale uma para torná-la disponível novamente.',
  'pluginsView.availableEmptyFiltered': 'Nenhuma entrada disponível corresponde aos seus filtros.',
  'pluginsView.availableEmptyNoSources': 'Nenhuma entrada disponível ainda. Adicione uma origem na aba Origens.',
  'pluginsView.installing': 'Instalando…',
  'pluginsView.install': 'Instalar',
  'pluginsView.sourcesTitle': 'Origens de registro',
  'pluginsView.sourcesSubtitle': 'Catálogos de marketplace que alimentam as entradas de plugins Disponíveis.',
  'pluginsView.sourceUrl': 'URL da origem',
  'pluginsView.defaultTrust': 'Confiança padrão',
  'pluginsView.trust.restricted': 'Restrito',
  'pluginsView.trust.trusted': 'Confiável',
  'pluginsView.trust.official': 'Oficial',
  'pluginsView.adding': 'Adicionando…',
  'pluginsView.addSource': 'Adicionar origem',
  'pluginsView.sourcesEmpty': 'Nenhuma origem de registro configurada ainda.',
  'pluginsView.pluginsCount': '{n} plugins',
  'pluginsView.catalogVersion': 'catálogo v{version}',
  'pluginsView.trustFor': 'Confiança para {name}',
  'pluginsView.refreshing': 'Atualizando…',
  'pluginsView.removing': 'Removendo…',
  'pluginsView.teamTitle': 'Marketplaces privados de equipe',
  'pluginsView.teamBody': 'Esta área é reservada para catálogos corporativos e de equipe, políticas de confiança privadas e controles compartilhados do ciclo de vida de plugins.',
  'pluginCard.details': 'Detalhes',
  'pluginCard.use': 'Usar',
  'pluginCard.useWithQuery': 'Usar com consulta',
  'pluginCard.applying': 'Aplicando…',
  'pluginCard.duplicate': 'Remixar',
  'pluginCard.duplicating': 'Remixando…',
  'pluginCard.duplicateFailed': 'Nao foi possivel remixar este template.',
  'pluginCard.saved': 'Salvo',
  'pluginCard.publish': 'Publicar',
  'pluginCard.contribute': 'Contribuir',
  'pluginCard.starting': 'Iniciando…',
  'pluginCard.detailsAria': 'Ver detalhes de {title}',
  'pluginCard.chooseUseAria': 'Escolha como usar {title}',
  'pluginCard.useOptionsAria': 'Opções de uso para {title}',
  'pluginCard.duplicateAria': 'Remixar {title} como um novo projeto',
  'pluginCard.saveAria': 'Salvar {title}',
  'pluginCard.savedAria': '{title} está salvo',
  'pluginCard.shareAria': 'Compartilhar {title}',
  'pluginCard.publishAria': 'Publicar {title} como um repositório do GitHub',
  'pluginCard.publishTitle': 'Publicar plugin como um repositório do GitHub',
  'pluginCard.contributeAria': 'Contribuir com {title} para o Crie3',
  'pluginCard.contributeTitle': 'Contribuir com plugin para o Crie3 por meio de um pull request',
  'skillPluginCandidate.createForMe': 'Criar plugin/modelo',
  'skillPluginCandidate.contributeToMain': 'Contribuir para o open-design',
  'skillPluginCandidate.repoDescription': 'Este repositório parece que poderia funcionar como um plugin.',
  'integrations.kicker': 'Integração',
  'integrations.lede': 'Conecte sistemas externos, traga ferramentas MCP para o Crie3 e use o Crie3 a partir de outros aplicativos, scripts e automações.',
  'integrations.agentReady': 'Pronto para conectar',
  'integrations.areasAria': 'Áreas de integração',
  'integrations.tabLabel.mcp': 'MCP',
  'integrations.tabLabel.skills': 'Skills',
  'integrations.tabHint.mcp': 'Ferramentas externas',
  'integrations.tabHint.connectors': 'Contas e APIs',
  'integrations.tabHint.useEverywhere': 'CLI, HTTP, MCP',
  'integrations.skillsTitle': 'Integrações de Skills',
  'integrations.skillsBody': 'O gerenciamento de integração em nível de Skill está sendo migrado de outro branch. Esta aba está reservada para que MCP, Connectors e a futura configuração de Skills fiquem na mesma rota de Integração.',
  'mcpClient.title': 'Servidores MCP externos',
  'mcpClient.subtitle': 'Ferramentas de outros serviços que o Crie3 pode usar.',
  'mcpClient.addServer': 'Adicionar servidor',
  'mcpClient.emptyTitle': 'Nenhum servidor MCP configurado.',
  'mcpClient.emptyBody': 'Clique em "Adicionar servidor" para começar — escolha um modelo (Higgsfield OpenClaw, Pollinations, Allyson, Imagician, EdgeOne Pages, GitHub, Filesystem…) ou configure um servidor stdio / HTTP personalizado.',
  'mcpClient.saveChanges': 'Salvar alterações',
  'mcpClient.storedAt': 'Armazenado em',
  'mcpClient.daemonError': 'Não foi possível acessar o daemon local. Verifique se o Crie3 está em execução e reabra este painel.',
  'mcpClient.saveFailed': 'Falha ao salvar. Verifique se o daemon está em execução e tente novamente.',
  'useEverywhere.modalAria': 'Use o Crie3 em qualquer lugar',
  'useEverywhere.modalTitle': 'Use o Crie3 em qualquer lugar',
  'useEverywhere.modalSubtitle': 'Use o Crie3 em qualquer IDE, agent ou script — CLI, HTTP, MCP e Skills. Use “Copiar guia para um agent” e cole no Claude Code, Codex, Cursor, openclaw ou hermes para configurar tudo.',
  'useEverywhere.closeAria': 'Fechar uso em todos os lugares',
  'useEverywhere.closeTitle': 'Fechar (Esc)',
  'useEverywhere.tabsAria': 'Superfícies de integração',
  'useEverywhere.footStrong': 'Transferência com um clique.',
  'useEverywhere.footBody': 'Copia um guia estruturado em markdown sobre o qual seu agent pode agir imediatamente — instalar, verificar e usar.',
  'useEverywhere.configureMcp': 'Configurar servidor MCP',
  'useEverywhere.copyGuide': 'Copiar guia para um agent',
  'useEverywhere.copy': 'Copiar',
  'useEverywhere.copied': 'Copiado',
  'useEverywhere.copyFailed': 'Falha ao copiar',
  'useEverywhere.copySnippetAria': 'Copiar trecho: {label}',
  'useEverywhere.section.overview.tab': 'Visão geral',
  'useEverywhere.section.overview.heading': 'O Crie3 funciona onde quer que seu agent funcione',
  'useEverywhere.section.overview.intro': 'O Crie3 é mais do que uma janela — é um daemon local privilegiado (`od`) mais um registro de Skills + Design Systems + Atoms. Quando ele estiver rodando na sua máquina, qualquer code agent (Claude Code, Codex, Cursor, OpenCode/openclaw, Hermes, seu próprio script) pode acionar gerações, inspecionar projetos e produzir artefatos de design por meio de quatro superfícies intercambiáveis.',
  'useEverywhere.section.overview.bullet1': 'CLI — `od <command>` para scripts headless, CI e automação de shell.',
  'useEverywhere.section.overview.bullet2': 'Servidor MCP — conecta o Crie3 como um servidor Model Context Protocol para que qualquer agent compatível com MCP possa listar skills, executar cenários e ler artefatos.',
  'useEverywhere.section.overview.bullet3': 'API HTTP — endpoints REST + SSE em `http://127.0.0.1:7456/api/*`; a mesma superfície que a UI web usa.',
  'useEverywhere.section.overview.bullet4': 'Skills — pacotes `SKILL.md` plug-and-play (compatíveis com Claude) que qualquer agent já no seu PATH pode invocar sem o Crie3.',
  'useEverywhere.section.overview.bullet5': 'Artefatos padrão — inicialize projetos HTML reais a partir de Skills, plugins padrão integrados e exemplos de plugins da comunidade antes de o daemon iniciar.',
  'useEverywhere.section.overview.snippet1': 'Inicie o daemon (e a UI web) localmente',
  'useEverywhere.section.overview.snippet2': 'Confirme que está acessível',
  'useEverywhere.section.overview.snippet3': 'Ingira artefatos padrão antes do boot',
  'useEverywhere.section.overview.footer': 'Por padrão, o daemon escreve em `./.od/` (local do projeto). Defina `OD_DATA_DIR=~/.open-design` para compartilhar dados entre projetos.',
  'useEverywhere.section.cli.tab': 'CLI · od',
  'useEverywhere.section.cli.heading': 'Controle o Crie3 a partir de qualquer shell',
  'useEverywhere.section.cli.intro': 'O bin `od` acompanha o daemon e é o mesmo binário usado pelo Claude Code / Codex quando executam uma geração. A maioria dos subcomandos são clientes leves que fazem POST para o daemon local, então funcionam da mesma forma, seja você o tenha iniciado via `pnpm tools-dev` ou como um app empacotado.',
  'useEverywhere.section.cli.bullet1': '`od` (sem argumentos) — inicia o daemon e abre a UI web.',
  'useEverywhere.section.cli.bullet2': '`od media generate ...` — produz bytes de imagem / vídeo / áudio por meio do protocolo de mídia unificado.',
  'useEverywhere.section.cli.bullet3': '`od run ...` — inicia a execução de um projeto a partir de um prompt + skill.',
  'useEverywhere.section.cli.bullet4': '`od plugin install <source>` / `od plugin apply <id>` — instala e aplica plugins da comunidade.',
  'useEverywhere.section.cli.bullet5': '`od skills list` / `od design-systems list` — inspeciona o que está disponível localmente.',
  'useEverywhere.section.cli.bullet6': '`od status` / `od doctor` — verifica a integridade do daemon e detecta CLIs de agent no seu PATH.',
  'useEverywhere.section.cli.snippet1': 'Gerar uma imagem (delega ao provedor de mídia configurado)',
  'useEverywhere.section.cli.snippet2': 'Execute um plugin de cenário em modo headless e transmita eventos como linhas JSON',
  'useEverywhere.section.cli.snippet3': 'Liste skills e design systems disponíveis localmente',
  'useEverywhere.section.cli.snippet4': 'Verifique os artefatos seeded pela CLI',
  'useEverywhere.section.cli.snippet5': 'Verificar ambiente + agents detectados (Claude, Codex, Cursor, …)',
  'useEverywhere.section.cli.footer': 'Todos os subcomandos aceitam `--daemon-url http://127.0.0.1:<port>` para direcionar a um daemon específico em execução — útil ao rodar uma segunda instância em sandbox para testes.',
  'useEverywhere.section.mcp.tab': 'Servidor MCP',
  'useEverywhere.section.mcp.heading': 'Exponha o Crie3 como um servidor MCP para qualquer agent de codificação',
  'useEverywhere.section.mcp.intro': 'O Crie3 vem com um servidor Model Context Protocol (`od mcp`) que permite que qualquer cliente compatível com MCP — Cursor, Claude Code, Antigravity, VS Code Copilot Chat, openclaw, hermes — descubra as ferramentas do Crie3 (listar skills, renderizar pré-visualizações, gerar mídia, executar plugins) sem usar o shell manualmente. O daemon publica um trecho de instalação pronto para colar via `GET /api/mcp/install-info` para cada cliente principal.',
  'useEverywhere.section.mcp.bullet1': 'Transporte stdio — sem porta extra, o cliente executa `od mcp` diretamente.',
  'useEverywhere.section.mcp.bullet2': 'Descobre automaticamente a URL do daemon ativo via o socket de status IPC local quando iniciado como sidecar.',
  'useEverywhere.section.mcp.bullet3': 'Recorre a `--daemon-url http://127.0.0.1:<port>` em instalações simples, para que o processo MCP sempre encontre um daemon em execução.',
  'useEverywhere.section.mcp.bullet4': 'Fixa `OD_DATA_DIR` para que o processo MCP gerado escreva no mesmo lugar que o daemon já usa (evita EPERM em bundles de app empacotados no macOS).',
  'useEverywhere.section.mcp.snippet1': 'Configuração genérica de cliente MCP (funciona no Cursor, Claude Code, Codex, …)',
  'useEverywhere.section.mcp.snippet2': 'Ou: peça ao daemon o trecho personalizado para sua instalação',
  'useEverywhere.section.mcp.snippet3': 'Variante MCP de artefatos ao vivo (ler e atualizar dashboards)',
  'useEverywhere.section.mcp.footer': 'No app Crie3, abra Configurações → Integrações para copiar um comando de instalação específico do cliente (Cursor, Claude Code, Antigravity, VS Code) em vez de editar JSON manualmente.',
  'useEverywhere.section.http.tab': 'API HTTP',
  'useEverywhere.section.http.heading': 'A mesma superfície REST + SSE que a UI web usa',
  'useEverywhere.section.http.intro': 'O daemon local serve uma API HTTP em `http://127.0.0.1:7456` (porta configurável). Todo endpoint que a UI web chama também está disponível para seus scripts. Endpoints de streaming (turnos de chat, execuções de projeto) emitem Server-Sent Events com os tipos de contrato em `@open-design/contracts`.',
  'useEverywhere.section.http.bullet1': '`GET /api/health` — disponibilidade do daemon.',
  'useEverywhere.section.http.bullet2': '`GET /api/skills` e `GET /api/design-systems` — registros disponíveis.',
  'useEverywhere.section.http.bullet3': '`GET /api/projects` e `POST /api/projects` — lista e cria projetos (POST retorna o projeto + a primeira conversa).',
  'useEverywhere.section.http.bullet4': '`GET /api/projects/:id/chat` — stream SSE de eventos do agent para uma conversa.',
  'useEverywhere.section.http.bullet5': '`POST /api/plugins/:id/apply` — vincula um plugin instalado e obtém sua consulta de exemplo renderizada + entradas.',
  'useEverywhere.section.http.bullet6': '`GET /api/agents` — CLIs de code agent detectadas no seu PATH.',
  'useEverywhere.section.http.snippet1': 'Liste as skills instaladas (o agent as usará como templates)',
  'useEverywhere.section.http.snippet2': 'Crie um projeto a partir de um prompt (fluxo completo no servidor)',
  'useEverywhere.section.http.snippet3': 'Transmita um turno de chat (SSE — cada linha é compatível com JSON-Lines)',
  'useEverywhere.section.http.footer': 'Tipos TypeScript puros para cada requisição/resposta ficam em `@open-design/contracts` — importe-os no seu script para autocompletar completo sem configurar um gerador.',
  'useEverywhere.section.skills.tab': 'Skills e headless',
  'useEverywhere.section.skills.heading': 'Skills plug-and-play para qualquer agent — mesmo sem o Crie3 em execução',
  'useEverywhere.section.skills.intro': 'Uma Skill é um diretório com um `SKILL.md` compatível com Claude (front-matter YAML + corpo). O Crie3 estende o formato com o namespace `od:` (`mode`, `preview`, `design_system`, `inputs`, …) para que o mesmo artefato possa ser usado tanto dentro do Crie3 quanto por um agent comum como Claude Code, Codex, openclaw ou hermes. A descoberta segue uma cadeia de precedência para que os projetos possam sobrescrever suas próprias skills.',
  'useEverywhere.section.skills.bullet1': 'Descoberta: `./.claude/skills/` → `./skills/` → `~/.claude/skills/` (o projeto prevalece).',
  'useEverywhere.section.skills.bullet2': 'Crie um symlink de uma skill em múltiplos projetos para compartilhá-la sem copiar.',
  'useEverywhere.section.skills.bullet3': 'Cada skill pode declarar connectors, atoms, requisitos de design system e um exemplo de saída `preview` para a galeria.',
  'useEverywhere.section.skills.bullet4': 'Headless: um agent com `od` no seu PATH pode chamar `od skills list` e depois executar qualquer skill; o daemon é opcional para fluxos somente leitura.',
  'useEverywhere.section.skills.bullet5': '`pnpm seed:test-projects` exercita o mesmo formato de artefato com exemplos de plugins padrão e exemplos de plugins da comunidade, e depois armazena os projetos `index.html` resultantes como dados de teste reutilizáveis.',
  'useEverywhere.section.skills.snippet1': 'SKILL.md mínimo (front matter compatível com Claude + extras do Crie3)',
  'useEverywhere.section.skills.snippet2': 'Crie um symlink de uma skill compartilhada em um projeto (estilo cc-switch)',
  'useEverywhere.section.skills.snippet3': 'Headless: liste as skills que o daemon vê agora',
  'useEverywhere.section.skills.snippet4': 'Bundle de fixtures de artefatos headless',
  'useEverywhere.section.skills.footer': 'Spec: `docs/skills-protocol.md` e `docs/agent-adapters.md` cobrem toda a superfície de adapters (Claude Code, Codex, Cursor, agents compatíveis com MCP, fallback de API BYOK) e as estratégias de injeção de skill por adapter.',
  'tasks.kicker': 'Central de automações',
  'tasks.comingSoon': 'Em breve',
  'tasks.lede': 'As automações transformam prompts em trabalho durável: o Orbit as executa, as routines as mantêm, os schedules decidem quando elas disparam e os artefatos ao vivo mostram o que mudou.',
  'tasks.newAutomation': 'Nova automação',
  'tasks.previewNote': 'Apenas superfície de pré-visualização. As configurações do Orbit já estão disponíveis hoje; routines, schedules e a integração de artefatos ao vivo chegarão à medida que os branches do backend forem mesclados.',
  'tasks.primitivesAria': 'Primitivas de automação',
  'tasks.primitive.orbit.title': 'Orbit',
  'tasks.primitive.orbit.body': 'Um ambiente que fica de pé para trabalhos longos ou que se repetem.',
  'tasks.primitive.orbit.enabled': 'Resumo diário ativado',
  'tasks.primitive.orbit.manualOnly': 'Apenas manual',
  'tasks.primitive.routines.title': 'Rotinas',
  'tasks.primitive.routines.body': 'Definições de tarefas duráveis que sobrevivem após o fim de um único chat.',
  'tasks.primitive.routines.meta': 'Shell do produto pronto',
  'tasks.primitive.schedules.title': 'Agendamentos',
  'tasks.primitive.schedules.body': 'Gatilhos de tempo ou evento que decidem quando uma routine deve ser executada.',
  'tasks.primitive.schedules.meta': 'Branch pendente',
  'tasks.primitive.liveArtifacts.title': 'Artefatos ao vivo',
  'tasks.primitive.liveArtifacts.body': 'Relatórios e notas que continuam se atualizando enquanto o trabalho corre.',
  'tasks.primitive.liveArtifacts.meta': 'Pré-visualizar modelo',
  'tasks.listAria': 'Lista de automações',
  'tasks.routinesAndRuns': '{n} rotinas e execuções',
  'tasks.filtersAria': 'Filtros de automação',
  'tasks.filter.scheduled': 'Agendado',
  'tasks.filter.running': 'Em execução',
  'tasks.filter.done': 'Concluído',
  'tasks.configurationAria': 'Configuração da automação',
  'tasks.slot.trigger': 'Gatilho',
  'tasks.slot.pattern': 'Padrão',
  'tasks.slot.runtime': 'Tempo de execução',
  'tasks.slot.output': 'Saída',
  'tasks.liveArtifact': 'Artefato ao vivo',
  'tasks.viewProgress': 'Ver progresso',
  'tasks.pause': 'Pausar',
  'tasks.runNow': 'Executar agora',
  'tasks.openArtifact': 'Abrir artefato',
  'tasks.status.dailyAt': 'Diário · {time}',
  'tasks.status.pausedManual': 'Pausado · apenas manual',
  'tasks.sample.orbit.title': 'Resumo do conector Orbit Daily',
  'tasks.sample.orbit.metaEnabled': 'O resumo do conector está agendado',
  'tasks.sample.orbit.metaDisabled': 'Abra as configurações do Orbit para ativar',
  'tasks.sample.orbit.previewEnabled': 'orbit_daily.html · artefato ao vivo',
  'tasks.sample.orbit.previewDisabled': 'Nenhuma execução agendada',
  'tasks.sample.orbit.triggerEnabled': 'Agendamento · diariamente às {time}',
  'tasks.sample.orbit.triggerDisabled': 'Manual · executar sob demanda',
  'tasks.sample.orbit.pattern': 'Rotina · resumo de conectores',
  'tasks.sample.orbit.runtime': 'Orbit · agendado pelo daemon',
  'tasks.sample.orbit.output': 'Artefato ao vivo · relatório atualizável',
  'tasks.sample.orbit.artifactMetaEnabled': 'Atualiza após cada execução',
  'tasks.sample.orbit.artifactMetaDisabled': 'Aguardando agendamento',
  'tasks.sample.orbit.body1': '# Resumo de atividades do Orbit Daily',
  'tasks.sample.orbit.body2': 'Conectores verificados · sucessos, ignorados e falhas',
  'tasks.sample.orbit.body3': 'Os destaques se tornam um artefato ao vivo atualizável.',
  'tasks.sample.mcp.title': 'Pesquisa de alternativas ao MCP',
  'tasks.sample.mcp.status': 'Em execução na orbit · 2h 14min',
  'tasks.sample.mcp.meta': '14 / 30 fontes processadas',
  'tasks.sample.mcp.preview': 'research_notes.md · ao vivo',
  'tasks.sample.mcp.trigger': 'Manual · execução única',
  'tasks.sample.mcp.pattern': 'Prompt de pesquisa aprofundada',
  'tasks.sample.mcp.runtime': 'Remoto · persistente',
  'tasks.sample.mcp.output': 'Relatório ao vivo · atualização automática',
  'tasks.sample.mcp.artifactMeta': 'Atualizado há 12s',
  'tasks.sample.mcp.body1': '# Alternativas ao MCP - conclusões preliminares',
  'tasks.sample.mcp.body2': '14 fontes revisadas · 3 candidatos pré-selecionados',
  'tasks.sample.mcp.body3': '## Lista de finalistas',
  'tasks.sample.mcp.body4': '- Esquemas de chamada de ferramentas via JSON-RPC...',
  'tasks.sample.mcp.body5': '- Protocolos baseados em gRPC...',
  'tasks.sample.weekly.title': 'Resumo semanal da equipe',
  'tasks.sample.weekly.status': 'Próxima: seg 9:00',
  'tasks.sample.weekly.meta': 'Atualiza o documento semanal da equipe',
  'tasks.sample.weekly.preview': 'team_weekly.md · próximo artefato',
  'tasks.sample.weekly.trigger': 'Agendamento · semanal',
  'tasks.sample.weekly.pattern': 'Rotina · resumo da equipe',
  'tasks.sample.weekly.runtime': 'Remoto · recorrente',
  'tasks.sample.weekly.output': 'Artefato ao vivo · markdown',
  'tasks.sample.weekly.artifactMeta': 'Última atualização há 4d',
  'tasks.sample.weekly.body1': '# Semanal da equipe',
  'tasks.sample.weekly.body2': '## Em andamento',
  'tasks.sample.weekly.body3': '- Rodada de integração do sistema de design',
  'tasks.sample.weekly.body4': '- Revisão de qualidade dos conectores',
  'tasks.sample.weekly.body5': '## Riscos',
  'tasks.sample.pr.title': 'Lembrete de revisão de PR',
  'tasks.sample.pr.status': 'Em novo PR · disparado há 23min',
  'tasks.sample.pr.meta': 'Envia DM no Slack',
  'tasks.sample.pr.preview': 'A última entrega foi bem-sucedida',
  'tasks.sample.pr.trigger': 'Evento · novo PR',
  'tasks.sample.pr.pattern': 'Rotina · notificação',
  'tasks.sample.pr.runtime': 'Local · execução rápida',
  'tasks.sample.pr.output': 'Mensagem · DM no Slack',
  'tasks.sample.pr.artifactMeta': 'Disparado pela última vez há 23m',
  'tasks.sample.pr.body1': 'PR #184 aberto para revisão',
  'tasks.sample.pr.body2': 'Revisores correspondentes: design-platform, web-runtime',
  'tasks.sample.pr.body3': 'Entrega: DM no Slack enviada',
  'tasks.sample.meeting.title': 'Preparação pré-reunião',
  'tasks.sample.meeting.status': 'Amanhã · 10:00',
  'tasks.sample.meeting.meta': 'Execução única · envia resumo',
  'tasks.sample.meeting.preview': 'meeting_brief.md · na fila',
  'tasks.sample.meeting.trigger': 'Agendamento · execução única',
  'tasks.sample.meeting.pattern': 'Prompt de briefing',
  'tasks.sample.meeting.runtime': 'Remoto · limitado',
  'tasks.sample.meeting.output': 'Artefato + mensagem',
  'tasks.sample.meeting.artifactMeta': 'Na fila para geração',
  'tasks.sample.meeting.body1': '# Briefing da reunião',
  'tasks.sample.meeting.body2': 'Fonte da pauta: evento do calendário + documentos vinculados',
  'tasks.sample.meeting.body3': 'A saída incluirá decisões, bloqueios e perguntas.',
  'tasks.sample.candidate.title': 'Acompanhamento de candidatos',
  'tasks.sample.candidate.status': 'Falhou · requer atenção',
  'tasks.sample.candidate.meta': 'Autenticação expirada',
  'tasks.sample.candidate.preview': 'Reconecte o Greenhouse para retomar',
  'tasks.sample.candidate.trigger': 'Agendamento · diário',
  'tasks.sample.candidate.pattern': 'Rotina · sincronização de candidatos',
  'tasks.sample.candidate.runtime': 'Remoto · recorrente',
  'tasks.sample.candidate.output': 'Artefato ao vivo · tabela',
  'tasks.sample.candidate.artifactMeta': 'Pausado até a autenticação ser restaurada',
  'tasks.sample.candidate.body1': '# Pipeline de candidatos',
  'tasks.sample.candidate.body2': 'Última sincronização bem-sucedida: 2d atrás',
  'tasks.sample.candidate.body3': 'Ação necessária: reconecte a conta de origem.',
  'routines.title': 'Automações',
  'routines.subtitle': 'Automações agendadas que rodam sem supervisão.',
  'routines.newAutomation': 'Nova automação',
  'routines.loading': 'Carregando…',
  'routines.empty': 'Nenhuma automação ainda.',
  'routines.emptyHint': 'Clique em Nova automação para agendar uma execução sem acompanhamento.',
  'routines.runHistoryLoading': 'Carregando execuções…',
  'routines.runHistoryEmpty': 'Nenhuma execução ainda.',
  'routines.fieldName': 'Nome',
  'routines.fieldNamePlaceholder': 'Briefing matinal',
  'routines.fieldPrompt': 'Pedido',
  'routines.fieldPromptPlaceholder': 'Buscar a atividade de ontem no GitHub + Linear e resumir o que mudou.',
  'routines.fieldSchedule': 'Agendamento',
  'routines.fieldMinute': 'Minuto de cada hora',
  'routines.fieldTime': 'Horário',
  'routines.fieldTimezone': 'Fuso horário',
  'routines.fieldsetProject': 'Projeto',
  'routines.kind.hourly': 'De hora em hora',
  'routines.kind.daily': 'Diariamente',
  'routines.kind.weekdays': 'Dias úteis',
  'routines.kind.weekly': 'Semanalmente',
  'routines.weekday.short.0': 'Dom',
  'routines.weekday.short.1': 'Seg',
  'routines.weekday.short.2': 'Ter',
  'routines.weekday.short.3': 'Qua',
  'routines.weekday.short.4': 'Qui',
  'routines.weekday.short.5': 'Sex',
  'routines.weekday.short.6': 'Sáb',
  'routines.weekday.long.0': 'Domingo',
  'routines.weekday.long.1': 'Segunda-feira',
  'routines.weekday.long.2': 'Terça-feira',
  'routines.weekday.long.3': 'Quarta-feira',
  'routines.weekday.long.4': 'Quinta-feira',
  'routines.weekday.long.5': 'Sexta-feira',
  'routines.weekday.long.6': 'Sábado',
  'routines.timeAm': 'AM',
  'routines.timePm': 'PM',
  'routines.describe.hourly': 'Roda a cada hora aos :{minute}',
  'routines.describe.daily': 'Roda diariamente às {time} {tz}',
  'routines.describe.weekdays': 'Executa de seg. a sex. às {time} {tz}',
  'routines.describe.weekly': 'Roda toda {day} às {time} {tz}',
  'routines.modeCreate': 'Criar um novo projeto a cada execução',
  'routines.modeCreateHint': 'Um espaço novo e separado a cada disparo.',
  'routines.modeReuse': 'Reutilizar um projeto existente',
  'routines.modeReuseHint': 'Cada execução fica como uma nova conversa dentro do projeto.',
  'routines.pickProject': '— Escolha um projeto —',
  'routines.targetReuse': '→ {project}',
  'routines.targetCreate': '→ novo projeto a cada execução',
  'routines.tagPaused': 'pausado',
  'routines.metaNext': 'próxima: {when}',
  'routines.metaLast': 'última:',
  'routines.triggerManual': 'manual',
  'routines.triggerScheduled': 'agendada',
  'routines.openProject': 'Abrir projeto',
  'routines.openProjectTitle': 'Abra o projeto em que esta execução gravou',
  'routines.runNow': 'Executar agora',
  'routines.edit': 'Editar',
  'routines.pause': 'Pausar',
  'routines.resume': 'Retomar',
  'routines.history': 'Histórico',
  'routines.hideHistory': 'Ocultar histórico',
  'routines.delete': 'Excluir',
  'routines.deleteTitle': 'Excluir esta automação',
  'routines.cancel': 'Cancelar',
  'routines.save': 'Salvar',
  'routines.saving': 'Salvando…',
  'routines.create': 'Criar',
  'routines.creating': 'Criando…',
  'routines.status.queued': 'na fila',
  'routines.status.running': 'em execução',
  'routines.status.succeeded': 'concluído',
  'routines.status.failed': 'falhou',
  'routines.status.canceled': 'cancelado',
  'routines.confirmDelete': 'Excluir esta automação? As execuções anteriores e seus projetos serão mantidos.',
  'routines.errorPickProject': 'Escolha um projeto para reutilizar ou alterne para “Criar novo a cada execução”',
  'routines.errorAgentEmptyOutput': 'A execução terminou sem produzir nada. O modelo ou o provedor pode ter devolvido uma resposta vazia — confira os registros da execução.',
  'entry.helpAria': 'Ajuda',
  'entry.helpMenuAria': 'Menu de ajuda',
  'entry.helpGetHelp': 'Obter ajuda no GitHub',
  'entry.helpSubmitFeature': 'Sugerir um recurso',
  'entry.helpWhatsNew': 'Novidades',
  'entry.helpDownloadDesktop': 'Baixar app para desktop',
  'entry.githubStarLabel': 'Favoritar',
  'entry.githubStarTitle': 'Clique para nos dar uma estrela no GitHub',
  'entry.githubStarAria': 'Dar uma estrela ao Crie3 no GitHub',
  'entry.tabImageTemplates': 'Modelos de imagem',
  'entry.tabVideoTemplates': 'Modelos de vídeo',
  'promptTemplates.searchPlaceholder': 'Buscar templates…',
  'promptTemplates.countLabel': '{n} resultados',
  'promptTemplates.emptyImage': 'Nenhum modelo de pedido de imagem instalado.',
  'promptTemplates.emptyVideo': 'Nenhum modelo de pedido de vídeo instalado.',
  'promptTemplates.emptyNoMatch': 'Nenhum template corresponde à busca.',
  'promptTemplates.attributionFooter': 'Adaptado de bibliotecas públicas de modelos. Cada card aponta para o autor original.',
  'promptTemplates.openPreviewTitle': 'Abrir o pedido e a prévia',
  'promptTemplates.sourcePrefix': 'Fonte:',
  'promptTemplates.fetchError': 'Não foi possível carregar o corpo deste template.',
  'promptTemplates.promptLabel': 'Texto do pedido',
  'promptTemplates.copyPrompt': 'Copiar o pedido',
  'promptTemplates.copyDone': 'Copiado!',
  'promptTemplates.modelHint': 'Modelo sugerido: {model}',
  'promptTemplates.openSource': 'Ver original',
  'promptTemplates.openFullscreen': 'Abrir prévia em tela cheia',
  'promptTemplates.closeFullscreen': 'Fechar prévia em tela cheia',
  'promptTemplates.allSources': 'Todas as fontes',
  'promptTemplates.sourceFilterAria': 'Filtrar por fonte',
  'promptTemplates.retry': 'Tentar novamente',
  'connectors.title': 'Conectores',
  'connectors.subtitle': 'Fontes locais e futuras que podem alimentar artefatos live.',
  'connectors.account': 'Conta',
  'connectors.noAccount': 'Não conectado',
  'connectors.tools': 'Ferramentas',
  'connectors.connect': 'Conectar',
  'connectors.disconnect': 'Desconectar',
  'connectors.authorizationPending': 'Aguardando autorização...',
  'connectors.authorizationPendingHint': 'Conclua a autorização na janela aberta.',
  'connectors.cancelAuthorization': 'Cancelar',
  'connectors.configure': 'Configurar',
  'connectors.unavailable': 'Indisponível',
  'connectors.phaseStubTitle': 'As APIs de conectores chegam na Phase 3; esta é uma superfície de prévia.',
  'connectors.statusAvailable': 'Disponível',
  'connectors.statusConnected': 'Conectado',
  'connectors.statusError': 'Erro',
  'connectors.statusDisabled': 'Desativado',
  'connectors.gateTitle': 'Adicione sua chave de API do Composio para continuar',
  'connectors.gateBody': 'Cole sua chave acima e clique em Salvar chave para carregar as integrações disponíveis.',
  'connectors.aboutLabel': 'Sobre',
  'connectors.detailsLabel': 'Detalhes',
  'connectors.statusLabel': 'Status',
  'connectors.category.aiAgents': 'Agentes de IA',
  'connectors.category.aiInfrastructure': 'Infraestrutura de IA',
  'connectors.category.accounting': 'Contabilidade',
  'connectors.category.admin': 'Administração',
  'connectors.category.advertising': 'Publicidade',
  'connectors.category.analytics': 'Análises',
  'connectors.category.automation': 'Automação',
  'connectors.category.cms': 'CMS',
  'connectors.category.crm': 'CRM',
  'connectors.category.calendar': 'Calendário',
  'connectors.category.commerce': 'Comércio',
  'connectors.category.communication': 'Comunicação',
  'connectors.category.contacts': 'Contatos',
  'connectors.category.dataPlatform': 'Plataforma de dados',
  'connectors.category.database': 'Banco de dados',
  'connectors.category.design': 'Design',
  'connectors.category.developer': 'Ferramentas de desenvolvedor',
  'connectors.category.documentation': 'Documentação',
  'connectors.category.erp': 'ERP',
  'connectors.category.education': 'Educação',
  'connectors.category.email': 'E-mail',
  'connectors.category.events': 'Eventos',
  'connectors.category.fieldService': 'Serviço de campo',
  'connectors.category.finance': 'Finanças',
  'connectors.category.fitness': 'Fitness',
  'connectors.category.forms': 'Formulários',
  'connectors.category.gaming': 'Jogos',
  'connectors.category.hr': 'RH',
  'connectors.category.hospitality': 'Hospitalidade',
  'connectors.category.itsm': 'ITSM',
  'connectors.category.integration': 'Integração',
  'connectors.category.localization': 'Localização',
  'connectors.category.logistics': 'Logística',
  'connectors.category.maps': 'Mapas',
  'connectors.category.marketing': 'Marketing',
  'connectors.category.media': 'Mídia',
  'connectors.category.meetings': 'Reuniões',
  'connectors.category.nonprofit': 'Sem fins lucrativos',
  'connectors.category.observability': 'Observabilidade',
  'connectors.category.payments': 'Pagamentos',
  'connectors.category.personal': 'Pessoal',
  'connectors.category.presentations': 'Apresentações',
  'connectors.category.procurement': 'Compras',
  'connectors.category.product': 'Produto',
  'connectors.category.productivity': 'Produtividade',
  'connectors.category.projectManagement': 'Gerenciamento de projetos',
  'connectors.category.recruiting': 'Recrutamento',
  'connectors.category.research': 'Pesquisa',
  'connectors.category.salesIntelligence': 'Inteligência de vendas',
  'connectors.category.scheduling': 'Agendamento',
  'connectors.category.search': 'Busca',
  'connectors.category.security': 'Segurança',
  'connectors.category.signing': 'Assinatura',
  'connectors.category.social': 'Social',
  'connectors.category.spreadsheets': 'Planilhas',
  'connectors.category.storage': 'Armazenamento',
  'connectors.category.support': 'Suporte',
  'connectors.category.surveys': 'Pesquisas',
  'connectors.category.tasks': 'Tarefas',
  'connectors.category.timeTracking': 'Controle de tempo',
  'connectors.category.video': 'Vídeo',
  'connectors.category.whiteboard': 'Quadro branco',
  'connectors.categoryLabel': 'Categoria',
  'connectors.providerLabel': 'Provedor',
  'connectors.toolsSection': 'Ferramentas',
  'connectors.toolsLoading': 'Carregando ferramentas…',
  'connectors.noToolsAvailable': 'Nenhuma ferramenta disponível ainda. Conecte-se para descobrir o que esta integração oferece.',
  'connectors.toolDetailsUnavailable': 'Os detalhes das ferramentas estão indisponíveis, mas este conector informa {n} ferramentas.',
  'connectors.loadMoreTools': 'Carregar mais ferramentas',
  'connectors.openDetailsAria': 'Abrir detalhes de {name}',
  'connectors.toolsBadgeNone': 'Sem ferramentas',
  'connectors.toolsBadgeOne': '{n} ferramenta',
  'connectors.toolsBadgeMany': '{n} ferramentas',
  'connectors.searchPlaceholder': 'Buscar conectores…',
  'connectors.searchAriaLabel': 'Buscar conectores por nome, provedor ou ferramenta',
  'connectors.searchClear': 'Limpar busca',
  'connectors.emptyNoMatchTitle': 'Nenhum conector corresponde a “{query}”',
  'connectors.emptyNoMatchBody': 'Tente outra palavra-chave ou limpe a busca para ver o catálogo completo.',
  'connectors.emptyNoMatchAction': 'Limpar busca',
  'newproj.tabPrototype': 'Protótipo',
  'newproj.tabLiveArtifact': 'Novo artefato live',
  'newproj.tabDeck': 'Apresentação',
  'newproj.tabTemplate': 'A partir de template',
  'newproj.tabMedia': 'Mídia',
  'newproj.tabOther': 'Outro',
  'newproj.tabPost': 'Post',
  'newproj.titlePrototype': 'Novo protótipo',
  'newproj.clientLabel': 'Cliente',
  'newproj.titleLiveArtifact': 'Novo artefato live',
  'newproj.titleDeck': 'Nova apresentação',
  'newproj.titleTemplate': 'Começar de um template',
  'newproj.titleImage': 'Nova imagem',
  'newproj.titleVideo': 'Novo vídeo',
  'newproj.titleAudio': 'Novo áudio',
  'newproj.titleMedia': 'Nova mídia',
  'newproj.titleOther': 'Novo projeto',
  'newproj.titlePost': 'Novo post',
  'newproj.namePlaceholder': 'Nome do projeto',
  'newproj.fidelityLabel': 'Fidelidade',
  'newproj.fidelityWireframe': 'Wireframe',
  'newproj.fidelityHigh': 'Alta fidelidade',
  'newproj.toggleSpeakerNotes': 'Usar notas do apresentador',
  'newproj.toggleSpeakerNotesHint': 'Menos texto nos slides — deixe os pontos de fala nas notas.',
  'newproj.toggleAnimations': 'Incluir animações',
  'newproj.toggleAnimationsHint': 'Adicionar movimento (entrada, hover, transições) sobre o template.',
  'newproj.targetPlatformsLabel': 'Plataformas de destino',
  'newproj.targetPlatformsHint': 'Escolha uma ou mais. A web responsiva cobre apenas breakpoints de navegador; adicione app iOS, Android, tablet ou desktop para variantes nativas multiplataforma.',
  'newproj.platform.responsive.label': 'Web responsiva',
  'newproj.platform.responsive.hint': 'Uma experiência web adaptada para navegadores de desktop, tablet e celular',
  'newproj.platform.webDesktop.label': 'Web desktop',
  'newproj.platform.webDesktop.hint': 'Produto ou página de destino voltado para navegador',
  'newproj.platform.mobileIos.label': 'App iOS',
  'newproj.platform.mobileIos.hint': 'Frames de iPhone e regras de interação do iOS',
  'newproj.platform.mobileAndroid.label': 'App Android',
  'newproj.platform.mobileAndroid.hint': 'Frames de Pixel e regras de interação do Material',
  'newproj.platform.tablet.label': 'App de tablet',
  'newproj.platform.tablet.hint': 'Experiência de tablet em estilo nativo com visualizações divididas',
  'newproj.platform.desktopApp.label': 'App de desktop',
  'newproj.platform.desktopApp.hint': 'Interface de app macOS/Windows',
  'newproj.surfaceOptionsLabel': 'Superfícies complementares',
  'newproj.includeLandingPage': 'Incluir página de destino',
  'newproj.includeLandingPageHint': 'Adicione uma página de marketing responsiva para anúncios, listas de espera, campanhas de lançamento, downloads de app ou explicação do produto.',
  'newproj.includeOsWidgets': 'Incluir widgets do SO',
  'newproj.includeOsWidgetsHint': 'Adicione widgets nativos da plataforma para tela inicial, tela de bloqueio ou acesso rápido em apps de celular/tablet.',
  'newproj.includeOsWidgetsDisabledHint': 'Disponível quando um app iOS, Android ou de tablet é selecionado como plataforma de destino.',
  'newproj.templateLabel': 'Modelo',
  'newproj.noTemplatesTitle': 'Ainda não há templates',
  'newproj.noTemplatesBody': 'Abra qualquer projeto e use o menu Compartilhar no visualizador de arquivos para convertê-lo em template. Os templates aparecem aqui.',
  'newproj.savedTemplate': 'Template salvo',
  'newproj.fileSingular': 'arquivo',
  'newproj.filePlural': 'arquivos',
  'newproj.create': 'Criar',
  'newproj.locationLabel': 'Salvar em',
  'newproj.locationDefault': 'Projetos Crie3',
  'newproj.locationExternalBase': 'Base externa',
  'newproj.createLiveArtifact': 'Criar artefato live',
  'newproj.createFromTemplate': 'Criar a partir do template',
  'newproj.createDisabledTitle': 'Salve primeiro um projeto como template (menu Compartilhar dentro de qualquer projeto).',
  'newproj.importClaudeZip': 'Importar ZIP do Claude Design',
  'newproj.importClaudeZipTitle': 'Importar uma exportação .zip do Claude Design',
  'newproj.importingClaudeZip': 'Importando…',
  'newproj.openFolder': 'Abrir pasta',
  'newproj.openingFolder': 'Abrindo…',
  'newproj.importFailed': 'Falha ao importar',
  'newproj.importFailedWithReason': 'Falha ao importar: {reason}',
  'newproj.folderPickerUnavailable': 'Não foi possível abrir o seletor de pastas. Atualize o Crie3 e tente de novo.',
  'newproj.privacyFooter': 'Por padrão, só você pode ver seu projeto.',
  'newproj.designSystem': 'Sistema de design',
  'newproj.dsNoneFreeform': 'Nenhum — livre',
  'newproj.dsNoneSubtitleEmpty': 'Sem cores e fontes definidas, escolha sua própria paleta',
  'newproj.dsNoneSubtitleSelected': 'Não usar cores e fontes definidas. O assistente escolhe a própria paleta.',
  'newproj.dsCategoryFallback': 'Sistema de design',
  'newproj.dsSearch': 'Buscar sistemas de design…',
  'newproj.dsModeAria': 'Modo de seleção',
  'newproj.dsModeSingle': 'Único',
  'newproj.dsModeMulti': 'Múltiplo',
  'newproj.dsNoneTitle': 'Nenhum — livre',
  'newproj.dsNoneSub': 'Não usar cores e fontes definidas. O assistente escolhe a própria paleta.',
  'newproj.dsEmpty': 'Nenhum sistema de design corresponde a “{query}”.',
  'newproj.dsFootSingular': 'é apenas inspiração.',
  'newproj.dsFootPlural': 'são apenas inspiração.',
  'newproj.dsFootClear': 'Limpar',
  'newproj.dsBadgeDefault': 'PADRÃO',
  'newproj.dsPrimaryFallback': 'Principal',
  'newproj.surfaceImage': 'Imagem',
  'newproj.surfaceVideo': 'Vídeo',
  'newproj.surfaceAudio': 'Áudio',
  'newproj.modelLabel': 'Modelo',
  'newproj.modelSearch': 'Buscar modelos…',
  'newproj.modelEmpty': 'Nenhum modelo corresponde.',
  'newproj.modelRecommended': 'Recomendado',
  'newproj.modelMissingTitle': 'Escolher um modelo',
  'newproj.modelMissingSub': 'Escolha um modelo para esta superfície.',
  'newproj.aspectLabel': 'Proporção',
  'newproj.videoLengthLabel': 'Duração',
  'newproj.videoLengthSeconds': '{n}s',
  'newproj.audioKindLabel': 'Tipo de áudio',
  'newproj.audioKindMusic': 'Música',
  'newproj.audioKindSpeech': 'Voz / TTS',
  'newproj.audioKindSfx': 'Efeito sonoro',
  'newproj.audioDurationLabel': 'Duração',
  'newproj.audioDurationSeconds': '{n}s',
  'newproj.voiceLabel': 'Voz',
  'newproj.voicePlaceholder': 'Voice id do provedor, opcional',
  'newproj.connectorsLabel': 'Conectores',
  'newproj.connectorsHint': 'Fontes de dados que este artefato pode consultar.',
  'newproj.connectorsEmptyTitle': 'Nenhum conector configurado',
  'newproj.connectorsEmptyBody': 'Conecte uma fonte de dados para que o artefato live use dados reais em vez de placeholders.',
  'newproj.connectorsEmptyCta': 'Configurar conectores →',
  'newproj.connectorsLoading': 'Carregando conectores…',
  'newproj.connectorsCountOne': '{n} conectado',
  'newproj.connectorsCountMany': '{n} conectados',
  'newproj.connectorsManage': 'Gerenciar',
  'newproj.promptTemplateLabel': 'Modelo de referência',
  'newproj.promptTemplateNoneTitle': 'Nenhum — escreva o seu',
  'newproj.promptTemplateNoneSub': 'Pule a galeria e descreva o próprio briefing',
  'newproj.promptTemplateRefSub': 'Modelo de referência',
  'newproj.promptTemplateSearch': 'Buscar modelos…',
  'newproj.promptTemplateEmpty': 'Nenhum modelo instalado para este formato ainda.',
  'newproj.promptTemplateBodyLabel': 'Pedido (você pode ajustar)',
  'newproj.promptTemplateOptimizeHint': 'Edite o que quiser — suas alterações entram no briefing do agente.',
  'newproj.promptTemplateBodyEmpty': 'Corpo vazio — o agente não receberá nenhuma referência de modelo.',
  'newproj.deleteTemplateTitle': 'Excluir template',
  'newproj.deleteTemplateConfirm': 'Excluir "{name}"? Esta ação não pode ser desfeita.',
  'newproj.deleteTemplateConfirmCta': 'Excluir template',
  'newproj.deleteTemplateError': 'Não foi possível excluir este template. Tente novamente.',
  'designs.subRecent': 'Recentes',
  'designs.subYours': 'Seus designs',
  'designs.filterAria': 'Filtrar projetos',
  'designs.searchPlaceholder': 'Buscar…',
  'designs.emptyNoProjects': 'Ainda não há projetos.',
  'designs.emptyNoMatch': 'Nenhum projeto corresponde à sua busca.',
  'designs.deleteTitle': 'Excluir projeto',
  'designs.deleteConfirm': 'Excluir "{name}"?',
  'designs.cardFreeform': 'livre',
  'designs.badgeLive': 'Ao vivo',
  'designs.liveArtifactBadgesAria': 'Marcadores de artefato live',
  'designs.liveCount': '{n} ao vivo',
  'designs.statusLive': 'Artefato live',
  'designs.statusArchived': 'Arquivado',
  'designs.statusError': 'Erro',
  'designs.statusRefreshing': 'Atualizando…',
  'designs.statusRefreshFailed': 'Falha ao atualizar',
  'designs.statusRefreshed': 'Atualizado',
  'designs.status.notStarted': 'Não iniciado',
  'designs.status.queued': 'Na fila',
  'designs.status.running': 'Em execução',
  'designs.status.awaitingInput': 'Aguardando resposta',
  'designs.status.incomplete': 'Incompleto',
  'designs.status.succeeded': 'Concluído',
  'designs.status.published': 'Publicado',
  'designs.status.failed': 'Falhou',
  'designs.status.canceled': 'Cancelado',
  'designs.viewToggleAria': 'Modo de visualização',
  'designs.viewGrid': 'Visualização em grade',
  'designs.viewKanban': 'Visualização em quadro',
  'designs.kanbanEmptyColumn': 'Sem designs',
  'designs.deleteAria': 'Excluir projeto {name}',
  'designs.menuMore': 'Mais ações',
  'designs.menuRename': 'Renomear',
  'designs.menuDuplicate': 'Duplicar projeto',
  'designs.menuDelete': 'Excluir',
  'designs.renamePrompt': 'Novo nome para "{name}"',
  'designs.selectMode': 'Selecionar',
  'designs.cancelSelect': 'Cancelar',
  'designs.deleteSelected': 'Excluir selecionados',
  'designs.selectedCount': '{n} selecionado(s)',
  'designs.deleteSelectedConfirm': 'Excluir {n} projeto(s)?',
  'designs.deleteSelectedSuccess': '{n} projeto(s) excluído(s) com sucesso.',
  'designs.deleteSelectedPartial': '{deleted} projeto(s) excluído(s); {failed} falharam.',
  'designs.tagPrototype': 'Protótipo',
  'designs.tagLiveArtifact': 'Artefato ao vivo',
  'designs.tagSlide': 'Slide',
  'designs.tagMedia': 'Mídia',
  'designs.renameTitle': 'Renomear projeto',
  'designs.renameSave': 'OK',
  'designs.renameCancel': 'Cancelar',
  'examples.typeLabel': 'Tipo',
  'examples.surfaceLabel': 'Superfície',
  'examples.surfaceWeb': 'Web',
  'examples.surfaceImage': 'Imagem',
  'examples.surfaceVideo': 'Vídeo',
  'examples.surfaceAudio': 'Áudio',
  'examples.scenarioLabel': 'Cenário',
  'examples.modeAll': 'Todos',
  'examples.modePrototypeDesktop': 'Protótipos · Desktop',
  'examples.modePrototypeMobile': 'Protótipos · Mobile',
  'examples.modeDeck': 'Slides',
  'examples.modeDocument': 'Docs e templates',
  'examples.modeOrbit': 'Orbit',
  'examples.modeLive': 'Ao vivo',
  'examples.scenarioGeneral': 'Geral',
  'examples.scenarioEngineering': 'Engenharia',
  'examples.scenarioProduct': 'Produto',
  'examples.scenarioDesign': 'Design',
  'examples.scenarioMarketing': 'Marketing',
  'examples.scenarioSales': 'Vendas',
  'examples.scenarioFinance': 'Finanças',
  'examples.scenarioHr': 'RH',
  'examples.scenarioOperations': 'Operações',
  'examples.scenarioSupport': 'Suporte',
  'examples.scenarioLegal': 'Jurídico',
  'examples.scenarioEducation': 'Educação',
  'examples.scenarioPersonal': 'Pessoal',
  'examples.searchPlaceholder': 'Buscar exemplos…',
  'examples.searchAria': 'Buscar exemplos por nome',
  'examples.emptyNoSkills': 'Nenhuma skill disponível. O daemon está em execução?',
  'examples.emptyNoMatch': 'Nenhum exemplo corresponde a esses filtros.',
  'examples.openPreview': '⤢ Abrir prévia',
  'examples.loadingPreview': 'Carregando prévia…',
  'examples.hoverPreview': 'Passe o cursor para ver a prévia',
  'examples.usePrompt': 'Usar este pedido',
  'examples.previewModalTitle': 'Abrir prévia completa (modal)',
  'examples.shareTitle': 'Compartilhar este exemplo',
  'examples.shareLoadFirst': 'Passe o cursor para carregar a prévia primeiro',
  'examples.unavailablePlaceholder': 'Sem prévia {kind} incluída — abra para saber mais',
  'examples.shareUnavailable': 'Sem prévia {kind} incluída para compartilhar',
  'examples.shareMenu': 'Compartilhar ▾',
  'examples.exportPdfAllSlides': 'Exportar como PDF (todos os slides)',
  'examples.exportPptxLocked': 'Exportar como PPTX… (abra o template primeiro)',
  'examples.tagSlideDeck': 'Apresentação',
  'examples.tagTemplate': 'Modelo',
  'examples.tagDesignSystem': 'Sistema de design',
  'examples.tagMobilePrototype': 'Protótipo mobile',
  'examples.tagDesktopPrototype': 'Protótipo desktop',
  'examples.tagImage': 'Imagem',
  'examples.tagVideo': 'Vídeo',
  'examples.tagAudio': 'Áudio',
  'examples.previewLabel': 'Prévia',
  'ds.surfaceLabel': 'Superfície',
  'ds.surfaceWeb': 'Web',
  'ds.surfaceImage': 'Imagem',
  'ds.surfaceVideo': 'Vídeo',
  'ds.surfaceAudio': 'Áudio',
  'ds.searchPlaceholder': 'Buscar sistemas de design…',
  'ds.emptyNoMatch': 'Nenhum sistema de design corresponde à sua busca.',
  'ds.badgeDefault': 'PADRÃO',
  'ds.preview': 'Prévia',
  'ds.previewTitle': 'Prévia do sistema de design',
  'ds.categoryAll': 'Todos',
  'ds.categoryUncategorized': 'Sem categoria',
  'ds.showcase': 'Vitrine',
  'ds.tokens': 'Cores e fontes',
  'ds.specToggle': 'DESIGN.md',
  'ds.specLoading': 'Carregando DESIGN.md…',
  'avatar.title': 'Conta e configurações',
  'avatar.localCli': 'CLI local',
  'avatar.anthropicApi': 'API da Anthropic',
  'avatar.useLocal': 'Usar CLI local',
  'avatar.useApi': 'Usar API · chave própria',
  'avatar.codeAgent': 'Agente de código',
  'avatar.rescan': 'Reescanear PATH',
  'avatar.amrConsole': 'Conta Crie3 Cloud',
  'avatar.amrConsoleMeta': 'Saldo e recarga',
  'avatar.settings': 'Configurações',
  'avatar.backToProjects': 'Voltar aos projetos',
  'avatar.metaActive': 'ativo',
  'avatar.metaOffline': 'offline',
  'avatar.metaSelected': 'selecionado',
  'avatar.noAgentSelected': 'nenhum agente selecionado',
  'avatar.modelSection': 'Modelo',
  'avatar.modelLabel': 'Modelo',
  'avatar.reasoningLabel': 'Raciocínio',
  'avatar.customSuffix': '(personalizado)',
  'socialShare.openDesignSection': 'Compartilhar Crie3',
  'socialShare.openDesignTitle': 'Crie3 no GitHub',
  'socialShare.openDesignText': 'Crie3 é um espaço de trabalho de código aberto para criar, editar, implantar e entregar artefatos de design.',
  'socialShare.openDesignCopyText': '{text}\n{url}',
  'socialShare.projectSection': 'COMPARTILHAMENTO SOCIAL',
  'socialShare.publishPageTitle': 'Publicar página de compartilhamento',
  'socialShare.publishPageSubtitle': 'Publique esta prévia para que ela possa ser compartilhada nas plataformas sociais.',
  'socialShare.projectTitle': '{title} · Crie3',
  'socialShare.projectText': 'Feito com Crie3: {title}. Veja o artefato implantado e dê uma estrela no repositório: {repo}',
  'socialShare.projectCopyText': 'Feito com Crie3: {title}\n{url}\nRepositório do Crie3: {repo}',
  'socialShare.deployFirst': 'Publique e compartilhe…',
  'socialShare.copied': 'Copiado',
  'socialShare.platform.x': 'X',
  'socialShare.platform.linkedin': 'LinkedIn',
  'socialShare.platform.facebook': 'Facebook',
  'socialShare.platform.reddit': 'Reddit',
  'socialShare.platform.telegram': 'Telegram',
  'socialShare.platform.whatsapp': 'WhatsApp',
  'socialShare.platform.weibo': 'Weibo',
  'socialShare.platform.line': 'LINE',
  'socialShare.platform.instagram': 'Instagram',
  'socialShare.platform.xiaohongshu': 'Xiaohongshu',
  'inlineSwitcher.chipTitle': 'Trocar CLI / modelo',
  'inlineSwitcher.chipCli': 'CLI local',
  'inlineSwitcher.chipByok': 'Chave própria',
  'inlineSwitcher.modelDefault': 'padrão',
  'inlineSwitcher.noAgent': 'sem agente',
  'inlineSwitcher.modeLabel': 'Modo',
  'inlineSwitcher.agentLabel': 'Agente',
  'inlineSwitcher.providerLabel': 'Provedor',
  'inlineSwitcher.modelLabel': 'Modelo',
  'inlineSwitcher.useCli': 'Usar CLI local',
  'inlineSwitcher.useByok': 'Usar a minha chave de API',
  'inlineSwitcher.daemonOffline': 'Daemon offline — abrir configurações',
  'inlineSwitcher.noAgentsDetected': 'Nenhum CLI detectado no PATH',
  'inlineSwitcher.openSettingsForModel': 'Configure o provedor em Configurações',
  'inlineSwitcher.missingApiKey': 'Chave de API ausente — abra Configurações.',
  'inlineSwitcher.openFullSettings': 'Abrir configurações de execução',
  'inlineSwitcher.customSuffix': '(personalizado)',
  'project.backToProjects': 'Voltar aos projetos',
  'project.brandReadyTitle': 'O design system {name} está pronto',
  'project.brandReadyTitleGeneric': 'Seu design system está pronto',
  'project.brandReadyCta': 'Visualizar em Design systems',
  'project.brandReadyDismiss': 'Dispensar',
  'project.brandReadyRefineHint': 'A extração automática pode deixar passar detalhes. Refine antes de usar este sistema em larga escala.',
  'project.brandReadyAiOptimize': 'Otimizar com IA',
  'project.brandReadyEditManually': 'Editar manualmente',
  'project.brandReadyPreviewOpened': 'Prévia do sistema de design aberta.',
  'project.metaFreeform': 'livre',
  'project.typePrototype': 'Protótipo',
  'project.typeDeck': 'Slides',
  'project.typeTemplate': 'Modelo',
  'project.typeImage': 'Imagem',
  'project.typeVideo': 'Vídeo',
  'project.typeAudio': 'Áudio',
  'project.customInstructions': 'Instruções do projeto',
  'project.customInstructionsPlaceholder': 'Instruções para este projeto (injetadas em cada mensagem)…',
  'project.resizeChatPanel': 'Redimensionar painel de chat',
  'project.instructionsActive': 'Ativo — incluído em cada mensagem',
  'project.missing': 'Este projeto foi excluído ou não existe mais.',
  'chat.tabChat': 'Chat',
  'chat.tabComments': 'Comentários',
  'chat.commentsSoon': 'Comentários — em breve',
  'chat.comments.attached': 'Anexado ao chat',
  'chat.comments.emptyAttached': 'Nenhum comentário anexado.',
  'chat.comments.saved': 'Comentários salvos',
  'chat.comments.emptySaved': 'Nenhum comentário salvo.',
  'chat.comments.add': 'Adicionar',
  'chat.comments.addAll': 'Adicionar todos',
  'chat.comments.remove': 'Remover',
  'chat.comments.placeholder': 'Comente neste elemento…',
  'chat.comments.addSend': 'Adicionar e enviar',
  'chat.comments.updateSend': 'Atualizar e enviar',
  'chat.comments.removeAttachment': 'Remover anexo de comentário',
  'chat.comments.removeAttachmentAria': 'Remover anexo de comentário de {name}',
  'chat.comments.comment': 'Comentar',
  'chat.comments.sendToChat': 'Enviar para o chat',
  'chat.comments.sending': 'Enviando…',
  'chat.comments.edit': 'Editar',
  'chat.comments.select': 'Selecionar',
  'chat.comments.selectAll': 'Selecionar tudo',
  'chat.comments.deselect': 'Desmarcar',
  'chat.comments.nSelected': '{n} selecionados',
  'chat.comments.pin': 'Fixar',
  'chat.comments.addNote': 'Adicionar nota',
  'chat.comments.savedToast': 'Comentário salvo',
  'chat.comments.pinSavedToast': 'Fixado salvo',
  'chat.comments.pinAtCoords': 'em {x}, {y}',
  'chat.comments.capturedItems': '{n} itens capturados',
  'chat.comments.clear': 'Limpar',
  'chat.comments.targetImage': 'Imagem',
  'chat.comments.targetControl': 'Controle',
  'chat.comments.targetLink': 'Link',
  'chat.comments.targetText': 'Texto',
  'chat.comments.targetSection': 'Seção',
  'chat.comments.targetPage': 'Página',
  'chat.comments.targetArea': 'Área',
  'chat.annotationNotePlaceholder': 'Adicionar uma nota para esta marcação',
  'chat.annotationAttachImage': 'Anexar imagem',
  'chat.annotationAttachedImages': 'Imagens anexadas',
  'chat.annotationAttachedRemove': 'Remover última imagem',
  'chat.annotationAddToInput': 'Adicionar à entrada',
  'chat.annotationAddingToInput': 'Adicionando...',
  'chat.annotationQueue': 'Fila',
  'chat.annotationQueueing': 'Enfileirando...',
  'chat.annotationSubmitOptions': 'Opções de envio',
  'chat.annotationSending': 'Enviando...',
  'chat.annotationSendDisabledReason': 'Uma tarefa está em execução no momento',
  'chat.annotationPreviewMissing': 'Não foi possível capturar a prévia. Tente novamente.',
  'chat.annotationPreviewMissingInk': 'Não foi possível capturar a prévia. Tente novamente para evitar enviar apenas o traçado.',
  'chat.annotationSentWithoutScreenshot': 'Não foi possível capturar a pré-visualização. A anotação foi enviada sem captura de tela.',
  'chat.annotationTimeout': 'O envio da anotação expirou. Tente novamente.',
  'chat.annotationFailed': 'Falha ao enviar a anotação. Tente novamente.',
  'chat.annotationProjectCreateFailed': 'Não foi possível criar um projeto, então a anotação não foi enviada.',
  'chat.annotationUploadFailed': 'Falha ao enviar o anexo. Tente novamente.',
  'chat.conversationsTitle': 'Conversas',
  'chat.conversationsAria': 'Histórico de conversas',
  'chat.newConversation': 'Nova conversa',
  'chat.newConversationsTitle': 'Nova conversa',
  'chat.conversationsHeading': 'Conversas',
  'chat.new': 'Nova',
  'chat.emptyConversations': 'Ainda não há conversas.',
  'chat.deleteConversation': 'Excluir conversa',
  'chat.renameConversationLabel': 'Renomear "{title}"',
  'chat.deleteConversationConfirm': 'Excluir "{title}"? Isso remove as mensagens.',
  'chat.untitledConversation': 'Conversa sem título',
  'chat.forkedConversationTitle': 'Fork de {title}',
  'chat.forkConversationFailed': 'Não foi possível bifurcar esta conversa.',
  'chat.startTitle': 'Comece uma conversa',
  'chat.startHint': 'Descreva o que você quer gerar ou comece por um destes exemplos:',
  'chat.brandBrowserAssistDesktopOnly': 'O assistente de navegador precisa do app desktop para que o Crie3 possa ler a página aberta no navegador.',
  'chat.brandBrowserAssistReadFailed': 'Não foi possível ler a página do navegador. Verifique se o site da marca está aberto e totalmente carregado.',
  'chat.brandBrowserAssistMessage': 'Crie3 needs browser assist to finish this brand extraction. Use the card below to open Browser, then click More, choose Download Page, wait for the success message, and use the left Next Step card to continue extraction.',
  'chat.brandBrowserLocalSnapshotMissing': 'Nenhum snapshot de página salvo está disponível para esta URL.',
  'chat.brandBrowserLocalSnapshotReadFailed': 'Não foi possível ler o snapshot da página salvo.',
  'chat.brandBrowserSnapshotSaveFailed': 'Não foi possível salvar um snapshot da página a partir do navegador.',
  'chat.brandBrowserAssistDownloadGuideTitle': 'Navegador aberto',
  'chat.brandBrowserAssistDownloadGuideDetails': 'Step 1: Browser is open. Step 2: click More, then Download Page. Step 3: wait for the saved snapshot success message. Step 4: return to the left Next Step card and click Continue extraction to continue the programmatic extraction.',
  'brandEnrichment.title': "Otimização com IA",
  'brandEnrichment.body': "O Crie3 executará uma extração mais profunda em segundo plano, aplicará automaticamente as skills certas de design system e atualizará este sistema no lugar. Isso pode levar de 10 a 20 minutos; você pode continuar trabalhando.",
  'brandEnrichment.cta': "Otimizar com IA",
  'brandEnrichment.busy': "Iniciando otimização com IA...",
  'brandExtractionTranscript.sourceDesignMd': 'DESIGN.md colado',
  'brandExtractionTranscript.user': 'Extraia um sistema de design de {source}.',
  'brandExtractionTranscript.doneTitle': 'A extração programática de {name} terminou.',
  'brandExtractionTranscript.doneBody': 'Criei e registrei o sistema de design {designSystemId} a partir de {source}. Ele já está pronto para pré-visualização e pode ser usado em novos designs.',
  'brandExtractionTranscript.next': 'Em seguida, você pode executar o AI Optimize para uma extração mais profunda ou criar um novo design com este sistema.',
  'chat.fillInputTitle': 'Clique para preencher o campo',
  'chat.jumpToLatest': 'Ir para a mais recente',
  'chat.scrollToLatest': 'Rolar para a mais recente',
  'chat.you': 'Você',
  'chat.openFile': 'Abrir {name}',
  'chat.copyPrompt': 'Copiar o pedido',
  'chat.copyErrorDiagnostic': 'Copiar diagnóstico do erro',
  'chat.copyDone': 'Copiado!',
  'chat.formAnswersTitle': 'Suas respostas',
  'chat.formAnswerSkipped': 'pulada',
  'chat.readingToggle': 'Ficha medida da imagem',
  'chat.readingDark': 'escura',
  'chat.readingMedium': 'média',
  'chat.readingLight': 'clara',
  'chat.readingPortrait': 'retrato',
  'chat.readingLandscape': 'paisagem',
  'chat.readingSquare': 'quadrada',
  'chat.readingCopyColor': 'Copiar cor',
  'chat.readingText': 'Texto lido',
  'chat.readingPaletteUnavailable': 'Paleta indisponível',
  'chat.readingFailed': 'Não foi possível ler esta imagem.',
  'chat.inspect.noEditableTargets': 'This page has no editable elements yet.',
  'chat.inspect.noCommentTargets': 'This page has no commentable elements yet.',
  'chat.inspect.editHint': 'Click an element in the canvas to edit its styles.',
  'chat.inspect.commentHint': 'Click an element in the canvas to add a comment.',
  'chat.composerPlaceholder': 'Descreva o que você quer gerar…',
  'chat.activeFileEditingLabel': 'Editando',
  'chat.activeFilePlaceholder': 'Peça ao Crie3 para alterar {file}...',
  'chat.designArtifactsShowMore': 'Mostrar mais {count} arquivos de design',
  'chat.mode.chat.label': 'Perguntar',
  'chat.mode.chat.title': 'Modo Ask',
  'chat.mode.chat.summary': 'Para respostas rápidas, ajustes, planejamento e conversa sem presumir que um artefato de design precisa ser criado.',
  'chat.mode.chat.solves': 'Use para esclarecer ideias, melhorar o que você vai pedir, comparar opções ou perguntar sobre um trabalho já feito.',
  'chat.mode.chat.query1': 'Resuma este rascunho e aponte as lacunas.',
  'chat.mode.chat.query2': 'Ajude-me a decidir a melhor estrutura para esta landing page.',
  'chat.mode.chat.query3': 'Revise este design e sugira melhorias concretas.',
  'chat.mode.plan.label': 'Plano',
  'chat.mode.plan.title': 'Modo plano',
  'chat.mode.plan.summary': 'Cria primeiro um documento de plano editável e, depois que você revisa, passa para o modo Design.',
  'chat.mode.plan.solves': 'Use para PRDs, roteiros de slides, briefings de protótipo, wireframes, storyboards e qualquer pedido amplo que precise de confirmação antes da geração.',
  'chat.mode.plan.query1': 'Crie primeiro um roteiro de PPT slide a slide.',
  'chat.mode.plan.query2': 'Rascunhe um PRD antes de gerar o protótipo.',
  'chat.mode.plan.query3': 'Transforme esta ideia em um plano de design editável.',
  'chat.mode.design.label': 'Design',
  'chat.mode.design.title': 'Modo Design',
  'chat.mode.design.summary': 'Cria artes, slides e vídeos a partir do seu pedido: páginas, posts, apresentações, imagens, áudio e arquivos do projeto.',
  'chat.mode.design.solves': 'Use quando quiser que o Crie3 crie ou altere arquivos de verdade — a arte pronta, não só a conversa. Pode levar alguns minutos.',
  'chat.mode.design.query1': 'Crie uma página de inscrição para o retiro e um convite animado a partir deste pedido.',
  'chat.mode.design.query2': 'Crie um deck para investidores com 10 slides e notas de apresentação.',
  'chat.mode.design.query3': 'Gere conceitos de imagem, vídeo e áudio para esta campanha.',
  'chat.mode.cardBestFor': 'Ideal para',
  'chat.mode.cardTry': 'Experimente pedir',
  'chat.mode.cardCost': 'Consumo típico',
  'chat.mode.chat.cost': 'Baixo',
  'chat.mode.chat.costNote': 'Apenas uma conversa — nada é gerado, então consome o mínimo.',
  'chat.mode.plan.cost': 'Padrão',
  'chat.mode.plan.costNote': 'Cria primeiro um documento de plano editável antes de qualquer geração.',
  'chat.mode.design.cost': 'Alto',
  'chat.mode.design.costNote': 'Gera arquivos e mídia multimodal, então uma execução pode consumir mais.',
  'chat.composerHint': '⌘/Ctrl + Enter para enviar · inclua objetivo, conteúdo, estilo e formato',
  'chat.cliSettingsTitle': 'Configurações de CLI e modelo',
  'chat.cliSettingsAria': 'Abrir configurações de CLI e modelo',
  'chat.attachTitle': 'Anexar arquivos (ou colar / arrastar)',
  'chat.addContextTitle': 'Adicionar contexto',
  'chat.attachAria': 'Anexar arquivos',
  'chat.importTitle': 'Importar fontes (em breve)',
  'chat.importLabel': 'Importar',
  'chat.importComingSoon': 'Em breve',
  'chat.importSoon': 'Em breve',
  'chat.importFig': 'Enviar arquivo .fig',
  'chat.importGitHub': 'Conectar GitHub',
  'chat.importWeb': 'Capturar elemento web',
  'chat.importFolder': 'Vincular pasta de código',
  'chat.importSkills': 'Skills e sistemas de design',
  'chat.importProject': 'Referenciar outro projeto',
  'chat.importDesignSystemHeader': 'Escolher um design system',
  'chat.importDesignSystemBack': 'Voltar',
  'chat.importDesignSystemSearch': 'Pesquisar design systems…',
  'chat.importDesignSystemEmpty': 'Nenhum design system corresponde a "{query}"',
  'chat.importDesignSystemNone': 'Nenhum — livre',
  'chat.importDesignSystemNoneSub': 'Não vincular a um sistema desta vez',
  'chat.importDesignSystemActive': 'Ativo',
  'chat.importDesignSystemSwitched': 'Design system alterado para {title}',
  'chat.importDesignSystemFailed': 'Não foi possível mudar o design system. Tente novamente.',
  'chat.importDesignSystemLoadFailed': 'Não foi possível carregar os sistemas de design.',
  'browserUse.title': 'Inspiração',
  'browserUse.summary': '{count} ações na web, priorizando extração de ativos, linguagem de design, movimento, verificações visuais e estrutura de componentes.',
  'browserUse.searchAria': 'Buscar inspiração',
  'browserUse.searchPlaceholder': 'Buscar capturas de tela, fontes, cores, a11y...',
  'browserUse.empty': 'Nenhuma inspiração correspondente',
  'browserUse.unavailable': 'A inspiração não está disponível aqui',
  'browserUse.added': 'Adicionado ao compositor',
  // Design Browser
  'designBrowser.aria': 'Navegador de Design',
  'designBrowser.goBack': 'Voltar',
  'designBrowser.goForward': 'Avançar',
  'designBrowser.reload': 'Recarregar',

  'designBrowser.stopLoading': 'Parar carregamento',
  'designBrowser.viewportAria': 'Viewport do navegador',
  'designBrowser.addressPlaceholder': 'Digite a URL ou pesquise...',
  'designBrowser.addressAria': 'Endereço do navegador',
  'designBrowser.suggestion.reference': 'Referência',
  'designBrowser.suggestion.history': 'Histórico',
  'designBrowser.menu.copyScreenshot': 'Copiar captura de tela',
  'designBrowser.menu.hardReload': 'Recarregar do zero',
  'designBrowser.menu.copyUrl': 'Copiar URL',
  'designBrowser.menu.openInBrowser': 'Abrir no navegador',
  'designBrowser.menu.savePageBrief': 'Salvar briefing da página',
  'designBrowser.menu.clearBrowsingHistory': 'Limpar histórico de navegação',
  'designBrowser.menu.clearCookies': 'Limpar cookies',
  'designBrowser.menu.clearAllData': 'Limpar todos os dados',
  'designBrowser.status.openHttpUrlFirst': 'Abra uma URL http primeiro',
  'designBrowser.status.openPageBeforeScreenshot': 'Abra uma página antes de tirar a captura de tela',
  'designBrowser.status.screenshotCopied': 'Captura de tela copiada para a área de transferência',
  'designBrowser.status.openPageBeforeBrief': 'Abra uma página antes de salvar um briefing',
  'designBrowser.status.openPageBeforeTools': 'Abra uma página antes de usar as ferramentas do navegador',
  'designBrowser.status.clickElementToComment': 'Clique em um elemento para comentar',
  'designBrowser.status.clickElementToTune': 'Clique em um elemento para ajustar',
  'designBrowser.status.noElementSelected': 'Nenhum elemento do navegador selecionado',
  'designBrowser.status.addBrowserComment': 'Adicionar um comentário do navegador',
  'designBrowser.status.tuneElementThenSaveHtml': 'Ajuste o elemento e salve o HTML',
  'designBrowser.status.tuneLiveOnly': 'O ajuste só funciona ao vivo em páginas fora do projeto',
  'designBrowser.status.pickerFailed': 'Falha no seletor de elementos do navegador',
  'designBrowser.status.applyStyleFailed': 'Não foi possível aplicar o estilo na página do navegador',
  'designBrowser.status.editTextFailed': 'Não foi possível editar o texto na página do navegador',
  'designBrowser.status.onlyProjectHtmlCanSave': 'Apenas páginas HTML locais do projeto podem ser salvas',
  'designBrowser.status.htmlSaved': 'Alterações de HTML salvas',
  'designBrowser.status.htmlSaveFailed': 'Falha ao salvar o HTML',
  'designBrowser.status.commentSavingUnavailable': 'O salvamento de comentários está indisponível',
  'designBrowser.status.commentSaved': 'Comentário do navegador salvo',
  'designBrowser.status.commentSendingUnavailable': 'O envio de comentários está indisponível',
  'designBrowser.comments.aria': 'Comentários do navegador',
  'designBrowser.comments.openFor': 'Abrir comentário do navegador para {label}',
  'designBrowser.comment.dialog': 'Comentário do navegador',
  'designBrowser.comment.elementFallback': 'Elemento do navegador',
  'designBrowser.comment.close': 'Fechar comentário do navegador',
  'designBrowser.comment.noteAria': 'Nota do comentário do navegador',
  'designBrowser.comment.placeholder': 'Descreva a mudança ou o problema...',
  'designBrowser.comment.addNote': 'Adicionar nota',
  'designBrowser.comment.saveComment': 'Salvar comentário',
  'designBrowser.comment.sending': 'Enviando...',
  'designBrowser.comment.sendToChat': 'Enviar para o chat',
  'designBrowser.inspect.editTitle': 'Editar elemento HTML',
  'designBrowser.inspect.tuneTitle': 'Ajustar elemento do navegador',
  'designBrowser.inspect.closeTune': 'Fechar ajuste do navegador',
  'designBrowser.inspect.colors': 'Cores',
  'designBrowser.inspect.text': 'Texto',
  'designBrowser.inspect.fill': 'Preenchimento',
  'designBrowser.inspect.type': 'Tipo',
  'designBrowser.inspect.size': 'Tamanho',
  'designBrowser.inspect.weight': 'Peso',
  'designBrowser.inspect.spacing': 'Espaçamento',
  'designBrowser.inspect.pad': 'Espaço',
  'designBrowser.inspect.radius': 'Raio',
  'designBrowser.inspect.content': 'Conteúdo',
  'designBrowser.inspect.elementText': 'Texto do elemento',
  'designBrowser.inspect.saving': 'Salvando...',
  'designBrowser.inspect.saveHtml': 'Salvar HTML',
  'designBrowser.inspect.liveOnly': 'Somente ao vivo',
  'designBrowser.reference.kicker': 'Navegador do Crie3',
  'designBrowser.reference.title': 'Quadro de referências',
  'designBrowser.reference.subtitle': 'Um conjunto selecionado de referências de inspiração, UI de produtos reais, motion, cor, tipografia, assets e design systems. Abra uma para navegar ao vivo enquanto reúne a linguagem de design do próximo artefato.',
  'designBrowser.reference.categoryAria': 'Categoria de referência',
  'designBrowser.reference.searchPlaceholder': 'Buscar referências...',
  'designBrowser.reference.searchAria': 'Buscar referências',
  'designBrowser.reference.clearSearch': 'Limpar busca',
  'designBrowser.reference.noMatches': 'Nenhuma referência corresponde a “{query}”.',
  'designBrowser.reference.clearFilters': 'Limpar filtros',
  'designBrowser.reference.open': 'Abrir',
  'designBrowser.reference.group.inspiration': 'Inspiração',
  'designBrowser.reference.group.interfaces': 'Interfaces reais',
  'designBrowser.reference.group.motion': 'Motion',
  'designBrowser.reference.group.color': 'Cor',
  'designBrowser.reference.group.type': 'Tipografia',
  'designBrowser.reference.group.icons': 'Ícones',
  'designBrowser.reference.group.illustration': 'Ilustração',
  'designBrowser.reference.group.photography': 'Fotografia',
  'designBrowser.reference.group.3d': '3D e gráficos',
  'designBrowser.reference.group.mockups': 'Mockups',
  'designBrowser.reference.group.systems': 'Design Systems',
  'designBrowser.reference.group.components': 'Componentes',
  'designBrowser.reference.group.guidelines': 'Diretrizes e acessibilidade',
  'designBrowser.reference.group.tools': 'Ferramentas e recursos',
  'designBrowser.reference.site.dribbble.detail': 'Shots de design e inspiração de UI.',
  'designBrowser.reference.site.behance.detail': 'Portfólios criativos e estudos de caso.',
  'designBrowser.reference.site.awwwards.detail': 'Design de sites premiado.',
  'designBrowser.reference.site.godly.detail': 'Web design moderno selecionado.',
  'designBrowser.reference.site.land_book.detail': 'Galeria e padrões de landing pages.',
  'designBrowser.reference.site.mobbin.detail': 'Telas reais de apps e padrões de UI.',
  'designBrowser.reference.site.screenlane.detail': 'Padrões de UI mais recentes de apps.',
  'designBrowser.reference.site.pageflows.detail': 'Fluxos de usuário e onboarding de produtos reais.',
  'designBrowser.reference.site.uisources.detail': 'Padrões de interação dos melhores apps.',
  'designBrowser.reference.site.collectui.detail': 'Coleção diária de UI por categoria.',
  'designBrowser.reference.site.gsap.detail': 'Motor de animação de produção e exemplos.',
  'designBrowser.reference.site.animations.detail': 'Padrões de animação e exemplos de interação.',
  'designBrowser.reference.site.transitions.detail': 'Padrões de transição para interfaces modernas.',
  'designBrowser.reference.site.motionsites.detail': 'Referências sofisticadas de motion e interação.',
  'designBrowser.reference.site.motion.detail': 'Inspiração de animação em scroll e timeline.',
  'designBrowser.reference.site.animography.detail': 'Tipografia animada e lettering cinético.',
  'designBrowser.reference.site.reactbits.detail': 'Referência de animação de texto em React para tipografia cinética brilhante.',
  'designBrowser.reference.site.coolors.detail': 'Gerador rápido de paletas de cores.',
  'designBrowser.reference.site.colorhunt.detail': 'Paletas de cores selecionadas.',
  'designBrowser.reference.site.realtimecolors.detail': 'Veja a prévia de paletas em uma UI real.',
  'designBrowser.reference.site.color_adobe.detail': 'Roda de cores e regras de harmonia.',
  'designBrowser.reference.site.happyhues.detail': 'Paletas mostradas em contexto real.',
  'designBrowser.reference.site.fonts_google.detail': 'Biblioteca de fontes open-source.',
  'designBrowser.reference.site.fontshare.detail': 'Fontes de qualidade gratuitas para uso comercial.',
  'designBrowser.reference.site.typewolf.detail': 'Fontes em uso e orientação de combinações.',
  'designBrowser.reference.site.fontpair.detail': 'Sugestões de combinações de fontes.',
  'designBrowser.reference.site.fontsinuse.detail': 'Tipografia em design do mundo real.',
  'designBrowser.reference.site.thesvg.detail': 'Assets em SVG e referências vetoriais.',
  'designBrowser.reference.site.svglogos.detail': 'Logos SVG limpos para mocks de produto e marca.',
  'designBrowser.reference.site.icons_lobehub.detail': 'Ícones de produtos e marcas de IA para interfaces.',
  'designBrowser.reference.site.icon_sets_iconify.detail': 'Mais de 200 mil ícones open-source em um só lugar.',
  'designBrowser.reference.site.lucide.detail': 'Conjunto de ícones aberto, limpo e consistente.',
  'designBrowser.reference.site.heroicons.detail': 'Ícones SVG feitos com Tailwind.',
  'designBrowser.reference.site.svgrepo.detail': 'Vetores e ícones SVG gratuitos.',
  'designBrowser.reference.site.storyset.detail': 'Ilustrações vetoriais personalizáveis.',
  'designBrowser.reference.site.undraw.detail': 'Ilustrações open-source com licença MIT.',
  'designBrowser.reference.site.blush.detail': 'Ilustrações para combinar e misturar.',
  'designBrowser.reference.site.lummi.detail': 'Visuais gerados por IA gratuitos.',
  'designBrowser.reference.site.whirrls.detail': 'Referências de imagens desenhadas à mão.',
  'designBrowser.reference.site.worldindots.detail': 'Referências de mapas de pontos e visualização de dados.',
  'designBrowser.reference.site.unsplash.detail': 'Fotos gratuitas em alta resolução.',
  'designBrowser.reference.site.pexels.detail': 'Fotos e vídeos de stock gratuitos.',
  'designBrowser.reference.site.pixabay.detail': 'Imagens e mídia livres de royalties.',
  'designBrowser.reference.site.cosmos.detail': 'Descoberta visual e moodboards.',
  'designBrowser.reference.site.spline.detail': 'Design 3D no navegador.',
  'designBrowser.reference.site.threejs.detail': 'Referências e demos 3D em WebGL.',
  'designBrowser.reference.site.womp.detail': 'Criação 3D fácil no navegador.',
  'designBrowser.reference.site.pixcap.detail': 'Ícones, mockups e cenas em 3D.',
  'designBrowser.reference.site.shots.detail': 'Mockups de dispositivos e navegadores.',
  'designBrowser.reference.site.mockuuups.detail': 'Mockups de dispositivos com arrastar e soltar.',
  'designBrowser.reference.site.angle.detail': 'Biblioteca de mockups 3D de dispositivos.',
  'designBrowser.reference.site.rotato.detail': 'Mockups de produtos 3D animados.',
  'designBrowser.reference.site.impeccable.detail': 'Referências de estilo e interface de alta qualidade.',
  'designBrowser.reference.site.styles_refero.detail': 'Referências de estilo de design e sistemas visuais.',
  'designBrowser.reference.site.brandfetch.detail': 'Assets de marca, logos e identidade.',
  'designBrowser.reference.site.designsystemsrepo.detail': 'Galeria de design systems públicos.',
  'designBrowser.reference.site.startups.detail': 'Referências dos melhores produtos e marcas de startups.',
  'designBrowser.reference.site.base_ui.detail': 'Primitivos acessíveis sem estilo para sistemas personalizados.',
  'designBrowser.reference.site.ui_shadcn.detail': 'Componentes React combináveis construídos sobre Radix e Tailwind.',
  'designBrowser.reference.site.heroui.detail': 'Biblioteca de componentes React moderna e design system.',
  'designBrowser.reference.site.radix_ui.detail': 'Primitivos de UI acessíveis de baixo nível.',
  'designBrowser.reference.site.react_spectrum_adobe.detail': 'Primitivos de comportamento acessíveis da Adobe.',
  'designBrowser.reference.site.headlessui.detail': 'Componentes acessíveis sem estilo para projetos Tailwind.',
  'designBrowser.reference.site.mui.detail': 'Ecossistema de componentes React baseado em Material.',
  'designBrowser.reference.site.mantine.detail': 'Componentes e hooks React completos.',
  'designBrowser.reference.site.chakra_ui.detail': 'Componentes React acessíveis, com cores e espaçamentos do tema.',
  'designBrowser.reference.site.ant.detail': 'Sistema de componentes e padrões para empresas.',
  'designBrowser.reference.site.ark_ui.detail': 'Componentes headless para frameworks modernos.',
  'designBrowser.reference.site.daisyui.detail': 'Classes de componentes e temas do Tailwind CSS.',
  'designBrowser.reference.site.developer_apple.detail': 'Diretrizes de design das plataformas Apple.',
  'designBrowser.reference.site.m3_material.detail': 'Material Design 3 do Google.',
  'designBrowser.reference.site.lawsofux.detail': 'Princípios e heurísticas de UX.',
  'designBrowser.reference.site.webaim.detail': 'Verificador de contraste de cores.',
  'designBrowser.reference.site.a11yproject.detail': 'Checklist e padrões de acessibilidade.',
  'designBrowser.reference.site.toolfolio.detail': 'Ferramentas, recursos e coleções de design.',
  'designBrowser.reference.site.getdesign.detail': 'Recursos de design selecionados.',
  'designBrowser.reference.site.tasteskill.detail': 'Referências de treino e crítica de bom gosto em design.',
  'designBrowser.reference.site.uigoodies.detail': 'Recursos de design escolhidos a dedo.',
  'designBrowser.reference.site.sidebar.detail': 'Cinco links de design, todos os dias.',
  'designBrowser.reference.site.github.detail': 'Implementação de referência para fluxos com navegador embutido.',
  'browserUse.category.assets': 'Extração de ativos',
  'browserUse.category.tokens': 'Linguagem de design',
  'browserUse.category.motion': 'Movimento',
  'browserUse.category.visual': 'Verificações visuais',
  'browserUse.category.structure': 'Componentes',
  'browserUse.category.project': 'Execução do projeto',
  'browserUse.category.general': 'Geral',
  'browserUse.input.none': 'Sem entrada',
  'browserUse.input.assetKind': 'kind: images | svgs | media | fonts, limit=200',
  'browserUse.input.optionalSelector': 'Seletor opcional',
  'browserUse.input.requirementSelector': 'Requisito, seletor opcional',
  'browserUse.input.selectorOptional': 'Seletor opcional',
  'browserUse.input.scaleOne': 'scale=1',
  'browserUse.input.selectorScaleTwo': 'Seletor, scale=2',
  'browserUse.input.gridOverlay': '12 colunas, máx. 1200, espaçamento 24',
  'browserUse.input.bodySelector': 'selector=\'body\'',
  'browserUse.input.navigate': 'URL, domínio ou termos de busca',
  'browserUse.input.selector': 'Seletor',
  'browserUse.input.selectorText': 'Seletor e texto',
  'browserUse.input.scroll': 'Pixels, topo, base ou página',
  'browserUse.input.terminalRun': 'Comando, tempo limite 120s',
  'browserUse.input.command': 'Comando',
  'browserUse.input.maxChars': 'maxChars=8000',
  'browserUse.input.custom': '{input}',
  'browserUse.action.extract_logo.output': 'Melhores candidatos a logo do cabeçalho, navegação, nomes de classe, posição, imagem OG e fallback de favicon.',
  'browserUse.action.list_images.output': 'Todas as imagens de img, srcset, source e de fundo CSS com dimensões e texto alternativo.',
  'browserUse.action.download_assets.output': 'Pasta de ativos baixados mais _manifest.json com suporte a referer e cookie.',
  'browserUse.action.extract_svgs.output': 'SVGs inline e arquivos .svg vinculados salvos como arquivos SVG individuais.',
  'browserUse.action.optimize_svgs.output': 'Arquivos SVG otimizados mais a taxa de compressão.',
  'browserUse.action.extract_colors.output': 'Paleta ponderada mais variáveis de cor CSS :root como palette.json e palette.html.',
  'browserUse.action.extract_fonts.output': 'Principais famílias de fontes, tamanhos, pesos e regras @font-face como typography.json.',
  'browserUse.action.extract_design_tokens.output': 'Raio, sombra, espaçamento e variáveis CSS como tokens.json.',
  'browserUse.action.extract_type_scale.output': 'Escala tipográfica de título, corpo e botão com tamanho, peso, altura de linha e proporções.',
  'browserUse.action.extract_buttons.output': 'Biblioteca de estilos de botão sem duplicatas como buttons.html e buttons.json.',
  'browserUse.action.extract_grid_system.output': 'Containers grid e flex, direção, espaçamentos, colunas e larguras máximas como layout.json.',
  'browserUse.action.extract_breakpoints.output': 'Breakpoints de media query responsivos como breakpoints.json.',
  'browserUse.action.extract_gradients.output': 'Gradientes CSS como gradients.css, gradients.json e HTML de visualização.',
  'browserUse.action.extract_shadows.output': 'Sombras de caixa, sombras de texto e drop shadows como shadows.json mais visualização.',
  'browserUse.action.extract_easings.output': 'Funções de easing de transição e animação como easings.json.',
  'browserUse.action.export_tokens.output': 'tokens.css, tokens.scss, tailwind.theme.js e style-dictionary.tokens.json.',
  'browserUse.action.extract_animations.output': '@keyframes, regras de transition e transform, bibliotecas de movimento detectadas, motion.css e motion.json.',
  'browserUse.action.validate_view.output': 'Caminhos das capturas de tela mais problemas visuais e de layout estruturados.',
  'browserUse.action.audit_layout.output': 'Defeitos de layout incluindo overflow, limites, sobreposição e texto cortado como audit.json.',
  'browserUse.action.audit_accessibility.output': 'Problemas de acessibilidade com seletores, rótulos, roles, foco, contraste e capturas de tela quando úteis.',
  'browserUse.action.responsive_screenshots.output': 'Capturas de tela em mobile 390, tablet 834 e desktop 1440.',
  'browserUse.action.screenshot_full.output': 'Captura de tela da página inteira além da viewport.',
  'browserUse.action.screenshot_element.output': 'Captura de tela de um único elemento em 2x por padrão.',
  'browserUse.action.screenshot_with_grid.output': 'Captura de tela com sobreposição do grid de layout.',
  'browserUse.action.screenshot_dark_mode.output': 'Captura de tela com prefers-color-scheme: dark.',
  'browserUse.action.generate_styleguide.output': 'Guia de estilo de uma página com cores, escala tipográfica, raio e sombras.',
  'browserUse.action.extract_html.output': 'HTML limpo e autossuficiente, sem script, noscript ou atributos de evento inline.',
  'browserUse.action.extract_component_inventory.output': 'Padrões de componentes repetidos, seletores, contagens e capturas de tela.',
  'browserUse.action.extract_copy.output': 'Títulos, CTAs, texto de corpo e descrições como copy.md e copy.json.',
  'browserUse.action.extract_nav.output': 'Navegação principal e links de rodapé como sitemap.md e nav.json.',
  'browserUse.action.extract_forms.output': 'Campos de formulário, rótulos, dicas de validação e ações de envio como forms.json.',
  'browserUse.action.run_project.output': 'URL do servidor de desenvolvimento detectada e aberta na aba Browser.',
  'browserUse.action.detect_project.output': 'Framework, gerenciador de pacotes, comando de instalação, comando de desenvolvimento e porta.',
  'browserUse.action.page_info.output': 'URL, título, descrição, imagem OG, cor do tema, favicon e viewport.',
  'browserUse.action.snapshot.output': 'Até 120 elementos interativos e de texto visíveis com tag, rótulo, href e coordenadas.',
  'browserUse.action.navigate.output': 'Abrir a página e retornar page_info.',
  'browserUse.action.click.output': 'Clicar no primeiro elemento correspondente após rolá-lo para a área visível.',
  'browserUse.action.type_text.output': 'Preencher um campo e disparar eventos input e change.',
  'browserUse.action.scroll.output': 'Posição de rolagem atual e máxima.',
  'browserUse.action.extract_og_metadata.output': 'Título meta, descrição, URL canônica, cards OG/Twitter, imagem social e cor do tema.',
  'browserUse.action.terminal_run.output': 'stdout, stderr e código de saída.',
  'browserUse.action.terminal_run_background.output': 'ID da tarefa em segundo plano e saída recente.',
  'browserUse.action.terminal_read.output': 'Saída recente do terminal compartilhado.',
  'chat.designToolbox.title': 'Caixa de ferramentas de design',
  'chat.designToolbox.tooltip': 'Caixa de ferramentas de design',
  'chat.designToolbox.aria': 'Abrir caixa de ferramentas de design',
  'chat.designToolbox.searchPlaceholder': 'Buscar skills / MCP / plugins / connectors / arquivos de design...',
  'chat.designToolbox.searchAria': 'Buscar recursos da caixa de ferramentas de design',
  'chat.designToolbox.followupSection': 'Acompanhamento',
  'chat.designToolbox.resourcesSection': 'Recursos globais',
  'chat.designToolbox.selected': 'Selecionado',
  'chat.designToolbox.noResources': 'Nenhum recurso encontrado para "{query}".',
  'chat.designToolbox.badge.video': 'Vídeo',
  'chat.designToolbox.badge.image': 'Imagem',
  'chat.designToolbox.badge.motion': 'Movimento',
  'chat.designToolbox.badge.polish': 'Refinamento',
  'chat.designToolbox.action.auto-match.title': 'Combinar próximo passo',
  'chat.designToolbox.action.auto-match.badge': 'Combinar',
  'chat.designToolbox.action.auto-match.description': 'Defina primeiro o nível de exigência estética, depois combine skills, MCP, plugins, connectors e arquivos.',
  'chat.designToolbox.action.asset-search.title': 'Encontrar imagens / referências',
  'chat.designToolbox.action.asset-search.badge': 'Assets',
  'chat.designToolbox.action.asset-search.description': 'Busque imagens utilizáveis, screenshots de referência, moodboards e candidatos de fonte para o design atual.',
  'chat.designToolbox.action.icon-workflow.title': 'Encontrar / substituir ícones',
  'chat.designToolbox.action.icon-workflow.badge': 'Ícones',
  'chat.designToolbox.action.icon-workflow.description': 'Encontre, gere ou troque iconografia, SVGs, ícones Lucide e símbolos visuais com um estilo consistente.',
  'chat.designToolbox.action.image-replace.title': 'Substituir imagens da página',
  'chat.designToolbox.action.image-replace.badge': 'Trocar',
  'chat.designToolbox.action.image-replace.description': 'Avalie as imagens atuais e substitua imagens fracas de hero, seção, fundo ou card por assets melhores.',
  'chat.designToolbox.action.reference-extract.title': 'Extrair referências visuais',
  'chat.designToolbox.action.reference-extract.badge': 'Refs',
  'chat.designToolbox.action.reference-extract.description': 'Analise um screenshot ou site de referência quanto a paleta, tipografia, postura de layout, motion e direção de assets.',
  'chat.designToolbox.action.motion.title': 'Adicionar animação / movimento',
  'chat.designToolbox.action.motion.badge': 'Movimento',
  'chat.designToolbox.action.motion.description': 'Adicione movimento de entrada, de rolagem, de transição de estado e de microinteração ao HTML ou elemento de página atual.',
  'chat.designToolbox.action.motion-polish.title': 'Refinar movimento',
  'chat.designToolbox.action.motion-polish.badge': 'Tempo',
  'chat.designToolbox.action.motion-polish.description': 'Revise tempo, easing, desempenho e fallbacks de reduced-motion para o movimento existente.',
  'chat.designToolbox.action.transition-motion.title': 'Criar transições',
  'chat.designToolbox.action.transition-motion.badge': 'Transição',
  'chat.designToolbox.action.transition-motion.description': 'Crie transições de página, cena, carregamento e estado com timing contido e fallbacks para movimento reduzido.',
  'chat.designToolbox.action.threejs-scene.title': 'Cena 3D / Three.js',
  'chat.designToolbox.action.threejs-scene.badge': '3D',
  'chat.designToolbox.action.threejs-scene.description': 'Adicione ou planeje visuais interativos com Three.js, Spline, Vanta, partículas, WebGL, mapas ou no estilo deck.gl.',
  'chat.designToolbox.action.anti-ai-polish.title': 'Remover cara de IA',
  'chat.designToolbox.action.anti-ai-polish.badge': 'Estética',
  'chat.designToolbox.action.anti-ai-polish.description': 'Remova cara de template, gradientes de IA, pilhas de cards baratas e texto vago.',
  'chat.designToolbox.action.visual-polish.title': 'Refinamento de design / pronto para publicar',
  'chat.designToolbox.action.visual-polish.badge': 'Refinar',
  'chat.designToolbox.action.visual-polish.description': 'Audite a hierarquia visual, tipografia, espaçamento, comportamento responsivo, acessibilidade e qualidade de entrega.',
  'chat.designToolbox.action.image-gen.title': 'Gerar imagens / referências visuais',
  'chat.designToolbox.action.image-gen.badge': 'Imagem',
  'chat.designToolbox.action.image-gen.description': 'Gere referências de seção, assets, ícones, imagens para redes sociais ou um moodboard para a página atual.',
  'chat.designToolbox.action.chart-gen.title': 'Gerar gráficos / diagramas',
  'chat.designToolbox.action.chart-gen.badge': 'Gráficos',
  'chat.designToolbox.action.chart-gen.description': 'Gere ECharts, React Flow, diagramas, dashboards, mapas de relacionamento ou recursos de visualização de dados.',
  'chat.designToolbox.action.logo-gen.title': 'Gerar logo / identidade',
  'chat.designToolbox.action.logo-gen.badge': 'Logo',
  'chat.designToolbox.action.logo-gen.description': 'Crie caminhos de logo, versões escritas, combinações, símbolos e orientações de identidade para a marca atual.',
  'chat.designToolbox.action.plan-outline.title': 'Gerar estrutura de PPT a partir de uma ideia',
  'chat.designToolbox.action.plan-outline.badge': 'Plano',
  'chat.designToolbox.action.plan-outline.description': 'Transforme uma ideia inicial em uma estrutura de deck em Markdown editável antes de criar os slides.',
  'chat.designToolbox.action.video-gen.title': 'Gerar vídeo / roteiro de animação',
  'chat.designToolbox.action.video-gen.badge': 'Vídeo',
  'chat.designToolbox.action.video-gen.description': 'Transforme o design em um vídeo curto, um roteiro de cenas ou um pedido pronto para gerar.',
  'chat.designToolbox.kind.skill': 'Skill',
  'chat.designToolbox.kind.plugin': 'Plugin',
  'chat.designToolbox.kind.mcp': 'MCP',
  'chat.designToolbox.kind.mcpTemplate': 'Modelo de MCP',
  'chat.designToolbox.kind.connector': 'Conector',
  'chat.designToolbox.kind.designFile': 'Arquivo de design',
  'chat.designToolbox.context.browser': 'Navegador',
  'chat.designToolbox.context.designFiles': 'Arquivos de design',
  'chat.designToolbox.context.designSystem': 'Design system',
  'chat.designToolbox.context.folder': 'Pasta',
  'chat.designToolbox.context.terminal': 'Terminal',
  'chat.designToolbox.context.sideChat': 'Chat lateral',
  'chat.designToolbox.context.liveArtifact': 'Artefato ao vivo',
  'chat.designToolbox.context.file': 'Arquivo',
  'chat.designToolbox.prompt.contextGeneric': 'Alvo atual: o arquivo HTML / arquivo de design / elemento web aberto no momento.',
  'chat.designToolbox.prompt.contextSpecific': 'Alvo atual: {kind} · {label}.',
  'chat.designToolbox.prompt.preserveDraft': 'Preserve a intenção que já está no compositor: {draft}',
  'chat.designToolbox.prompt.selectedSkill': 'Skill selecionada: {skill}. Use-a como o fluxo de trabalho principal neste turno.',
  'chat.designToolbox.prompt.noSkill': 'Se nenhuma skill específica corresponder, primeiro escolha a melhor combinação entre skills, MCP, plugins, conectores e arquivos de design disponíveis.',
  'chat.designToolbox.prompt.autoMatchIntro': 'Atue como o orquestrador Diretor de Criação e conclua um fluxo de trabalho de design:',
  'chat.designToolbox.prompt.autoMatchStep1': '1. Primeiro, defina o que significa um “design bonito”: público, objetivo de negócio, identidade da marca, referências de estilo, densidade de informação, padrões de cor/tipografia/movimento/recursos e padrões de IA/templates a evitar.',
  'chat.designToolbox.prompt.autoMatchStep2': '2. Pesquise e faça a correspondência com todo o índice de recursos acima. Não use apenas as recomendações da caixa de ferramentas de design; combine skills, MCP, plugins, conectores e arquivos de design quando for útil.',
  'chat.designToolbox.prompt.autoMatchStep3': '3. Se o objetivo ou o nível estético ainda estiver indefinido, me oriente com um question-form estruturado, inclua padrões recomendados e deixe cada pergunta de escolha finita editável com um campo de resposta personalizada. Se estiver claro o suficiente, execute o próximo passo diretamente.',
  'chat.designToolbox.prompt.autoMatchStep4': '4. Conclua o fluxo nesta ordem: diagnóstico -> direção de estilo -> seleção de recursos -> edição/geração concreta -> verificação. Em cada etapa, explique por que esses recursos foram escolhidos e o que precisa ser confirmado em seguida.',
  'chat.designToolbox.prompt.assetSearch': 'Encontre os melhores recursos de imagem/referência para o design atual. Busque em arquivos disponíveis, conectores, MCPs, capturas do navegador e ferramentas de geração. Retorne candidatos concretos com notas de uso, ressalvas de licenciamento/fonte quando relevante, e um pedido de geração alternativo caso não exista nenhum recurso utilizável.',
  'chat.designToolbox.prompt.iconWorkflow': 'Melhore o sistema de ícones do design atual: encontre ícones faltando, substitua ícones fracos, mantenha traço, preenchimento, raio e peso consistentes, prefira bibliotecas de ícones existentes quando disponíveis e escreva pedidos de SVG/ícone apenas quando um ícone de biblioteca for insuficiente.',
  'chat.designToolbox.prompt.imageReplace': 'Audite cada espaço de imagem visível no design atual, identifique imagens fracas ou provisórias e, em seguida, substitua ou especifique imagens melhores para topo, seções, fundo, cards e redes sociais. Preserve o layout e forneça escolhas exatas de arquivo, pedido e fonte.',
  'chat.designToolbox.prompt.referenceExtract': 'Use a imagem/site/arquivo de design de referência atual como entrada visual. Extraia paleta, escala tipográfica, ritmo de layout, postura dos componentes, indicações de movimento e estilo dos recursos, e então aplique essas descobertas ao design atual sem copiar recursos de marca protegidos de forma literal.',
  'chat.designToolbox.prompt.motion': 'Adicione movimento de alta qualidade ao HTML / elemento de página atual: escolha os 1 a 2 momentos mais úteis de entrada, scroll, transição de estado, transição, movimento de ícone no estilo Rive/Lottie ou micro-interação GSAP/Motion. Mantenha contido, prefira transform / opacity e inclua fallbacks de prefers-reduced-motion.',
  'chat.designToolbox.prompt.planOutline': 'Crie ou atualize um documento de planejamento em Markdown para uma estrutura de PPT/deck a partir desta ideia. Ainda não gere o deck final. Inclua títulos slide a slide, objetivos, tópicos de conteúdo, direção visual, dados/recursos necessários e questões em aberto. Salve como arquivo `.md` em Design Files e me diga qual arquivo revisar.',
  'chat.designToolbox.prompt.motionPolish': 'Revise e refine o tempo, a suavização, o desempenho e a acessibilidade das animações existentes. Remova animações abruptas, baratas ou que prejudicam a legibilidade; use uma linha do tempo mais refinada quando necessário.',
  'chat.designToolbox.prompt.transitionMotion': 'Projete transições de alta qualidade para o design atual: mudanças de página/cena, pontes de carregamento, mudanças de estado e passagens entre seções. Use GSAP/Motion/CSS quando apropriado, mantenha o desempenho e inclua comportamento de reduced-motion.',
  'chat.designToolbox.prompt.threejsScene': 'Planeje ou implemente um visual Three.js/WebGL focado para o design atual. Considere Three.js, cenas no estilo Spline, fundos Vanta, sistemas de partículas, camadas de dados Mapbox/deck.gl ou efeitos de portal no navegador, mas mantenha a cena útil e verifique se ela renderiza.',
  'chat.designToolbox.prompt.antiAiPolish': 'Faça uma passagem de refinamento anti-cara-de-IA: remova layouts genéricos, gradientes/brilhos baratos, pilhas de cards sem sentido e textos vagos. Preserve a informação e faça com que pareça que um designer de verdade a entregou.',
  'chat.designToolbox.prompt.visualPolish': 'Refine este design até deixá-lo pronto para publicação: verifique hierarquia, tipografia, espaçamento, comportamento responsivo, estados de botões, estados vazios/de carregamento/de erro e acessibilidade; corrija diretamente os problemas mais importantes.',
  'chat.designToolbox.prompt.imageGen': 'Crie o próximo plano de imagens para este design: referências de seção, imagens de topo, ilustrações, ícones, imagens para redes sociais ou um painel de inspiração. Primeiro decida que tipo de imagem está faltando e, em seguida, escreva pedidos de geração prontos para executar e o plano de arquivos.',
  'chat.designToolbox.prompt.chartGen': 'Gere o gráfico, diagrama ou visualização de dados certo para o design atual. Escolha entre ECharts, React Flow, diagramas SVG/CSS, gráficos de radar, mapas de relacionamento, dashboards ou visualizações deck.gl/mapa com base nos dados e no objetivo do usuário.',
  'chat.designToolbox.prompt.logoGen': 'Crie direções de logo e identidade para a marca atual. Produza múltiplos caminhos para versão escrita, símbolo, combinação, paleta, regras de uso e pedidos de geração; garanta que o resultado seja original e utilizável no artefato atual.',
  'chat.designToolbox.prompt.videoGen': 'Direcione este design para vídeo: crie um roteiro de vídeo curto, uma sequência de cenas ou um pedido pronto para gerar. Prefira fazer com que o conteúdo da página existente vire as cenas naturalmente.',
  'chat.designToolbox.prompt.useSkill': 'Use {skill} no design atual.',
  'chat.designToolbox.prompt.skillInstruction': 'Primeiro decida o melhor objetivo de continuidade e, em seguida, conclua uma passagem concreta. Se depender de assets externos ou APIs, forneça um fallback executável ou indique o que preciso fornecer.',
  'chat.designToolbox.prompt.selectedResource': 'Recurso selecionado: {kind} · {title} ({id}).',
  'chat.designToolbox.prompt.resourceDescription': 'Descrição do recurso: {description}',
  'chat.designToolbox.prompt.pluginResource': 'Use este plugin como o contexto principal para o fluxo de design atual. Se ele expuser inputs ou GenUI, oriente-me a escolher quando necessário; se não se adequar ao alvo, escolha um recurso global melhor e explique por quê.',
  'chat.designToolbox.prompt.mcpResource': 'Prefira esta capacidade de MCP para a próxima etapa do design. Quando forem necessários assets externos, captura web, geração de imagem/vídeo ou dados, primeiro decida se ela é capaz de realizar a tarefa e, em seguida, forneça um plano executável.',
  'chat.designToolbox.prompt.mcpTemplateResource': 'Este MCP é um modelo configurável. Se for a ferramenta mais útil para esta etapa do design, oriente a configuração primeiro; se houver uma alternativa já configurada, continue com essa alternativa.',
  'chat.designToolbox.prompt.connectorResource': 'Use este conector quando forem necessários dados reais, assets, conteúdo de conta ou acesso a fluxo de trabalho externo. Antes de usá-lo, explique o que será lido ou gravado e peça confirmação quando apropriado.',
  'chat.designToolbox.prompt.fileResource': 'Use este arquivo de design como o alvo de design atual ou asset de referência e conclua a próxima etapa a partir dele. Se for necessário comparar outros arquivos, continue pesquisando em todos os arquivos de design.',
  'chat.designToolbox.prompt.resourceIndex': 'Índice de recursos globais: skills({skills}), plugins({plugins}), MCP({mcpEnabled} ativados / {mcpTemplates} modelos), conectores({connectors} conectados), arquivos de design({files}).',
  'chat.designToolbox.prompt.searchableSkills': 'Skills pesquisáveis',
  'chat.designToolbox.prompt.searchablePlugins': 'Plugins pesquisáveis',
  'chat.designToolbox.prompt.availableMcp': 'MCP disponíveis',
  'chat.designToolbox.prompt.connectedConnectors': 'Conectores conectados',
  'chat.designToolbox.prompt.referenceDesignFiles': 'Arquivos de design de referência',
  'chat.designToolbox.prompt.mcpTemplateName': 'Modelo {name}',
  'chat.designToolbox.prompt.processRule': 'Regra de fluxo de trabalho: defina primeiro o objetivo estético e as restrições, depois busque e combine recursos; quando for necessária a escolha do usuário, gere um question-form estruturado com respostas personalizadas editáveis e continue após a confirmação.',
  'chat.designToolbox.prompt.moreSuffix': ', +{count} mais',
  'chat.designToolbox.prompt.compactLine': '{label}: {values}{suffix}.',
  'chat.mentionTabsAria': 'Superfícies de menção',
  'chat.mentionTabAll': 'Todos',
  'chat.mentionTabTabs': 'Abas',
  'chat.mentionTabPlugins': 'Plugins',
  'chat.mentionTabSkills': 'Skills',
  'chat.mentionTabMcp': 'MCP',
  'chat.mentionTabConnectors': 'Conectores',
  'chat.mentionTabFiles': 'Arquivos de design',
  'chat.mentionNoResults': 'Nenhum resultado para “{query}”.',
  'chat.mentionSearchPrompt': 'Pesquisar arquivos de design, abas, plugins, skills, servidores MCP e conectores.',
  'chat.mentionSectionTabs': 'Abas',
  'chat.mentionSectionPlugins': 'Plugins',
  'chat.mentionSectionSkills': 'Skills',
  'chat.mentionSectionMcp': 'MCP',
  'chat.mentionSectionConnectors': 'Conectores',
  'chat.mentionSectionFiles': 'Arquivos de design',
  'chat.mentionActiveSkill': 'Ativo',
  'chat.mentionUseMcpTitle': 'Usar {name}',
  'chat.mentionUseConnectorTitle': 'Usar {name}',
  'chat.mentionPluginOfficial': 'Oficial',
  'chat.mentionPluginMine': 'Meu plugin',
  'chat.linkedFolderRemoveAria': 'Remover pasta vinculada {path}',
  'chat.linkedFolderNotFound': 'A pasta não existe',
  'chat.linkedFolderAlready': 'Esta pasta já está vinculada',
  'chat.linkedFolderPickError': 'Não foi possível abrir o seletor de pasta',
  'chat.queuedHeader': 'Na fila',
  'chat.queuedToSend': 'para enviar',
  'chat.queuedEditQueuedTaskAria': 'Editar tarefa na fila',
  'chat.queuedSave': 'Salvar',
  'chat.queuedCancel': 'Cancelar',
  'chat.queuedReorder': 'Arraste para reordenar',
  'chat.queuedEdit': 'Editar',
  'chat.queuedMore': 'mais na fila',
  'chat.queuedFollowUpFallback': 'Acompanhamento na fila',
  'chat.send': 'Enviar',
  'chat.stop': 'Parar',
  'chat.removeAria': 'Remover {name}',
  'chat.contextKind.current': 'Atual',
  'chat.contextKind.browser': 'Navegador',
  'chat.contextKind.designFiles': 'Arquivos de design',
  'chat.contextKind.designSystem': 'Design system',
  'chat.contextKind.folder': 'Pasta',
  'chat.contextKind.project': 'Projeto',
  'chat.contextKind.localCode': 'Código local',
  'chat.contextKind.terminal': 'Terminal',
  'chat.contextKind.sideChat': 'Conversa lateral',
  'chat.contextKind.liveArtifact': 'Peça ao vivo',
  'chat.contextKind.file': 'Arquivo',
  'chat.starterPreacher1Title': "Capa de série de mensagens",
  'chat.starterPreacher1Tag': "Série",
  'chat.starterPreacher1Prompt': "Uma capa para uma série de mensagens de 4 semanas — título da série em tipografia grande e memorável, subtítulo com a promessa da série, e uma faixa discreta com as datas. Formato 1080×1350, com uma versão adicional em 1920×1080 para projeção. Deixe o título legível em miniatura e reserve espaço para o logo da igreja.",
  'chat.starterPreacher2Title': "Card de citação da pregação",
  'chat.starterPreacher2Tag': "Citação",
  'chat.starterPreacher2Prompt': "Um card de feed com a frase mais forte da mensagem — a citação ocupando a maior parte da arte, atribuição discreta abaixo, referência bíblica quando houver. Formato 1080×1350, contraste alto, uma única ideia por arte, sem elementos que disputem com o texto.",
  'chat.starterPreacher3Title': "Carrossel do ponto principal",
  'chat.starterPreacher3Tag': "Social",
  'chat.starterPreacher3Prompt': "Um carrossel de 5 slides desdobrando o ponto principal da mensagem — capa com a tensão que a mensagem resolve, três slides de desenvolvimento com uma ideia cada, e um slide final com a aplicação para a semana. Formato 1080×1350, texto curto por slide, ritmo de leitura no celular.",
  'chat.starterPreacher4Title': "Corte vertical da pregação",
  'chat.starterPreacher4Tag': "Reels",
  'chat.starterPreacher4Prompt': "Um roteiro de corte vertical de 45 segundos a partir de um trecho da pregação — gancho nos primeiros 3 segundos, o trecho central, e um fecho com convite. Inclua sugestão de legenda na tela, marcação de onde entra o corte e a chamada final. Formato 1080×1920, área central segura.",
  'chat.starterWorship1Title': "Slides de letra",
  'chat.starterWorship1Tag': "Letra",
  'chat.starterWorship1Prompt': "Slides de letra para projeção — uma estrofe por tela, fonte grande e alto contraste, sem hifenização e sem cortar frase no meio da tela. Formato 1920×1080, fundo escuro com texto claro, dimensionado para ser lido do fundo do salão.",
  'chat.starterWorship2Title': "Card do repertório",
  'chat.starterWorship2Tag': "Repertório",
  'chat.starterWorship2Prompt': "Um card com o repertório do domingo — lista das músicas na ordem, com tom de cada uma, e o nome de quem ministra. Formato 1080×1350, hierarquia clara entre música e tom, legível numa olhada rápida no celular.",
  'chat.starterWorship3Title': "Story de ensaio",
  'chat.starterWorship3Tag': "Ensaio",
  'chat.starterWorship3Prompt': "Uma sequência de 2 stories verticais avisando o ensaio — o primeiro com dia, horário e local em destaque, o segundo com o que cada pessoa precisa levar. Formato 1080×1920, texto grande, área central segura para não cortar em nenhum aparelho.",
  'chat.starterWorship4Title': "Capa de playlist",
  'chat.starterWorship4Tag': "Playlist",
  'chat.starterWorship4Prompt': "Uma capa quadrada para a playlist de louvor do mês — nome da playlist em tipografia forte, tratamento visual que funcione reduzido a um ícone pequeno, e espaço para o nome do ministério. Formato 1080×1080, legível em 100×100 pixels.",
  'chat.starterMedia1Title': "Capa de vídeo do YouTube",
  'chat.starterMedia1Tag': "Thumbnail",
  'chat.starterMedia1Prompt': "Uma capa para vídeo do YouTube — no máximo quatro palavras em tipografia muito grande, contraste alto, e espaço à direita para um recorte de pessoa. Formato 1280×720, com o texto ainda legível na largura de um celular na lista de recomendados.",
  'chat.starterMedia2Title': "Carrossel de conteúdo",
  'chat.starterMedia2Tag': "Carrossel",
  'chat.starterMedia2Prompt': "Um carrossel de 7 slides sobre um tema — capa com a promessa clara, cinco slides de desenvolvimento com uma ideia por slide, e um slide final de chamada para seguir ou salvar. Formato 1080×1350, hierarquia consistente entre os slides, texto que se lê sem aumentar o zoom.",
  'chat.starterMedia3Title': "Capa de podcast",
  'chat.starterMedia3Tag': "Podcast",
  'chat.starterMedia3Prompt': "Uma capa de podcast — nome do programa em destaque, subtítulo curto explicando o assunto, e um tratamento visual que se mantenha reconhecível reduzido. Formato 3000×3000, com checagem de legibilidade em 55×55 pixels, que é o tamanho real nos aplicativos.",
  'chat.starterMedia4Title': "Corte vertical",
  'chat.starterMedia4Tag': "Reels",
  'chat.starterMedia4Prompt': "Um roteiro de corte vertical de 30 segundos a partir de um conteúdo mais longo — gancho de 3 segundos, o miolo com uma única ideia, e fecho com chamada. Inclua as legendas na tela e onde entram os cortes. Formato 1080×1920, área central segura.",
  'chat.starterImage1Title': 'Fundo para versículo',
  'chat.starterImage1Tag': 'Arte bíblica',
  'chat.starterImage1Prompt': 'Uma imagem de fundo para card de versículo: céu de amanhecer em tons quentes (âmbar, rosa suave, azul profundo no topo), nuvens esparsas e suaves, luz subindo do canto inferior esquerdo. Composição limpa com os dois terços superiores livres para receber o texto do versículo depois. Sem texto na imagem, sem pessoas, granulação sutil de filme, formato retrato 1080×1350.',
  'chat.starterImage2Title': 'Capa de série de mensagens',
  'chat.starterImage2Tag': 'Série',
  'chat.starterImage2Prompt': 'Um fundo de capa minimalista para uma série de mensagens: fundo verde-profundo texturizado, um único objeto simbólico — uma lâmpada de óleo com chama pequena — à direita do centro, luz lateral suave e dramática, sombra longa e delicada, bastante espaço negativo à esquerda para o título da série entrar depois. Sem texto, sem pessoas, corte quadrado.',
  'chat.starterImage3Title': 'Ilustração de célula',
  'chat.starterImage3Tag': 'Ilustração',
  'chat.starterImage3Prompt': 'Uma ilustração vetorial flat de um pequeno grupo reunido numa sala aconchegante — cinco pessoas de idades diferentes em círculo, luz quente de abajur, uma Bíblia aberta na mesa de centro. Paleta contida de 5 cores (creme, terracota, verde profundo, âmbar, quase-preto), sem gradientes, traços finos de acento, sombras suaves só sob os móveis.',
  'chat.starterVideoShot1Title': 'Manhã de culto',
  'chat.starterVideoShot1Tag': 'Cinemático',
  'chat.starterVideoShot1Prompt': 'Um plano cinemático de 5 segundos: luz da manhã atravessando os vitrais de uma igreja vazia, poeira flutuando nos feixes, câmera em avanço lento pelo corredor central em direção ao altar. Sem pessoas, sem texto na tela, quente e silencioso.',
  'chat.starterVideoShot2Title': 'Mãos em oração',
  'chat.starterVideoShot2Tag': 'Clima',
  'chat.starterVideoShot2Prompt': 'Um close de 6 segundos de mãos marcadas pelo tempo entrelaçadas em oração na luz dourada do fim de tarde, profundidade de campo rasa, dolly-in suave, luz lateral quente com partículas de poeira no ar. Sem diálogo, ambiência quieta, movimento contido.',
  'chat.starterVideoShot3Title': 'Louvor em contraluz',
  'chat.starterVideoShot3Tag': 'Loop',
  'chat.starterVideoShot3Prompt': 'Um plano de 5 segundos pensado para loop no telão: silhuetas de mãos levantadas contra um contraluz suave âmbar-e-azul com leve névoa, movimento lento e sutil, nenhum rosto em foco, sem texto na tela. Energia calma e reverente.',
  'chat.starterVideoFrames1Title': 'Título da série',
  'chat.starterVideoFrames1Tag': 'HTML-in-canvas',
  'chat.starterVideoFrames1Prompt': 'Monte uma composição de 5 segundos com o título da série de mensagens em tipografia display sobre um fundo escuro e limpo. Anime uma lente redonda atravessando o título da esquerda para a direita, com refração de vidro sutil distorcendo as letras por onde passa. Use animação em HTML sobre canvas — capture o texto da página e rode o efeito da lente por cima. O título é CSS puro; o vidro é uma camada WebGL.',
  'chat.starterVideoFrames2Title': 'Versículo digitado',
  'chat.starterVideoFrames2Tag': 'Overlay',
  'chat.starterVideoFrames2Prompt': 'Monte uma composição em que a linha de um versículo se digita sozinha sobre um canvas escuro — tipografia serifada, um brilho suave crescendo conforme as palavras aparecem, scanlines discretas e uma vinheta leve aplicadas sobre o DOM vivo via html-in-canvas. O texto do versículo continua CSS de verdade, nítido sob o passe de shader. Termine segurando a linha completa por dois tempos.',
  'chat.starterVideoFrames3Title': 'Contagem pré-culto',
  'chat.starterVideoFrames3Tag': 'Contagem',
  'chat.starterVideoFrames3Prompt': 'Construa uma contagem regressiva pré-culto de 6 segundos: numerais grandes contando de 5 a 1 num canvas escuro, cada transição com um glitch curto e limpo — separação de canais RGB, um stutter breve, e um reset nítido. Capture os numerais via html-in-canvas para o tipo continuar nítido sob o passe de glitch, e termine num momento calmo de “bem-vindo” em tela cheia.',
  'chat.starterAudio1Title': 'Boas-vindas ao culto',
  'chat.starterAudio1Tag': 'Voz',
  'chat.starterAudio1Prompt': 'Uma locução calorosa de 30 segundos para a abertura do culto — sem pressa, tom de sorriso, uma pausa entre as frases. Roteiro: \'Que bom ter você aqui. Esta hora é separada — respira fundo, aquieta o coração. Bem-vindo à casa.\'',
  'chat.starterAudio2Title': 'Devocional narrado',
  'chat.starterAudio2Tag': 'Voz',
  'chat.starterAudio2Prompt': 'Uma leitura devocional calma de 45 segundos, grave e cadenciada, com respiração entre as frases e qualidade intimista de microfone próximo. Roteiro: \'O Senhor é o meu pastor; nada me faltará. Deitar-me faz em verdes pastos, guia-me mansamente a águas tranquilas. Refrigera a minha alma.\'',
  'chat.starterAudio3Title': 'Chamada de evento',
  'chat.starterAudio3Tag': 'Voz',
  'chat.starterAudio3Prompt': 'Um convite animado de 20 segundos para redes sociais — vibrante, cheio de energia, sem soar vendedor. Roteiro: \'É neste fim de semana. Uma noite de louvor, palavra e comunhão — e o seu lugar está esperando. As inscrições estão abertas. Traga alguém que precisa.\'',
  'ds.loadingSystem': 'Carregando o design system...',
  'ds.openingWorkspace': 'Abrindo o espaço de trabalho...',
  'dsCreate.figmaUrlInvalid': 'Informe a URL de um arquivo do Figma (https://figma.com/file/… ou /design/…).',
  'dsCreate.extractionAlreadyStarting': 'A extração já está começando. Aguarde a solicitação atual terminar.',
  'dsCreate.prepareProjectFailed': 'Não foi possível preparar o projeto do design system.',
  'dsCreate.confirmTitle': 'O Crie3 vai extrair o seu design system.',
  'dsCreate.confirmBody': 'Você vai cair num projeto que se preenche ao vivo — logo, paleta, tipografia, imagens — enquanto a sua marca é medida. Mantenha a aba aberta.',
  'dsCreate.startingExtraction': 'Iniciando a extração...',
  'dsCreate.extractDesignSystem': 'Extrair design system',
  'dsCreate.addingSourceMaterial': 'Adicionando material de origem...',
  'common.fileSystemReadError': 'Não foi possível ler um ou mais arquivos ou pastas soltos. Verifique se ainda existem e tente de novo.',
  'dsCreate.browseFolder': 'Escolher pasta',
  'dsCreate.dropZoneSelections': 'Seleções de {label}',
  'dsCreate.assetEmptyFile': '(arquivo vazio)',
  'dsCreate.assetNoPreview': 'Sem pré-visualização para este tipo de arquivo.',
  'dsCreate.assetDropAria': 'Adicionar arquivos — arraste e solte, cole, ou clique para escolher',
  'dsCreate.assetDropTitle': 'Arraste e solte, cole, ou ',
  'dsCreate.assetDropBrowse': 'escolha',
  'dsCreate.assetDropHint': 'Imagens, fontes, logos, PDF, slides, HTML — até 12 MB cada',
  'dsCreate.assetStagedAria': 'Arquivos preparados',
  'dsCreate.assetRemoveAria': 'Remover {name}',
  'dsCreate.assetClosePreview': 'Fechar pré-visualização',
  'dsCreate.heroShowcasePalette': 'Paleta',
  'dsCreate.heroShowcaseTypeScale': 'Escala tipográfica',
  'dsCreate.heroShowcaseComponents': 'Componentes',
  'dsCreate.heroShowcaseBtnPrimary': 'Primário',
  'dsCreate.heroShowcaseBtnGhost': 'Ghost',
  'dsFonts.missingAddFiles': 'Adicionar arquivos de fonte da marca',
  'dsFonts.missingKeepSubstitutes': 'Manter substitutas',
  'workspace.uploadErrorDismiss': 'Dispensar',
  'chat.searchConversations': 'Buscar conversas',
  'chat.noConversationsMatch': 'Nenhuma conversa corresponde.',
  'chat.chipKindDesignSystem': 'Design System',
  'workspace.searchTabsPlaceholder': 'Buscar abas',
  'workspace.noTabsFound': 'Nenhuma aba encontrada',
  'newproj.modalTitle': 'Novo projeto',
  'newproj.closeEsc': 'Fechar (Esc)',
  'newproj.creating': 'Criando projeto…',
  'newproj.scrollTabsLeft': 'Rolar tipos de projeto para a esquerda',
  'newproj.scrollTabsRight': 'Rolar tipos de projeto para a direita',
  'newproj.targetPlatforms': 'Plataformas de destino',
  'newproj.pickPlatform': 'Escolha uma plataforma',
  'home.blankProjectFailed': 'Não foi possível criar um projeto em branco. Verifique se o daemon está acessível.',
  'home.templatePickerUnavailable': 'O seletor de modelos não está disponível neste shell.',
  'home.referenceFolderMissing': 'Uma pasta de referência selecionada não está mais disponível. Remova-a ou selecione de novo antes de iniciar.',
  'home.startRunFailed': 'Não foi possível iniciar a execução. Verifique se o daemon está acessível e tente de novo.',
  'figmaImport.notFigFile': 'Isso não é um arquivo .fig. Exporte o seu arquivo do Figma como .fig (File → Save local copy) e solte aqui.',
  'figmaImport.noProject': 'Não foi possível abrir um projeto para importar.',
  'figmaImport.invalidUrl': 'Informe a URL de um arquivo do Figma (https://figma.com/file/… ou /design/…).',
  'figmaImport.tabUploadFig': 'Enviar .fig',
  'figmaImport.tabUrl': 'URL do Figma',
  'workspace.sideChatNeedsAgent': 'O Side Chat precisa de um agente local. Escolha um na barra superior.',
  'workspace.sideChatPickAgent': 'Escolha primeiro um agente local (barra superior).',
  'automations.validationTitle': 'Dê um título a esta automação.',
  'automations.validationPrompt': 'Adicione um prompt para a conversa agendada.',
  'settings.noMatchingModels': 'Nenhum modelo corresponde',
  'manualEdit.resetElement': 'Restaurar elemento',
  'assistant.designSystemLocked': 'Design system ativo selecionado. A direção visual já está travada.',
  'designFiles.pluginFolders': 'Pastas de plugin',
  'preview.printFailed': 'A impressão falhou. Tente Exportar PDF de novo ou use a versão do navegador.',
  'preview.popupBlocked': 'Pop-up bloqueado! Clique no ícone de pop-up bloqueado na barra de endereço (ou no menu do navegador), escolha "Sempre permitir pop-ups" para este site e tente Exportar PDF de novo.',
  'pluginsHome.filtersAria': 'Filtros de plugins',
  'pluginsHome.savedToast': '{title} salvo.',
  'pluginsHome.saveFailedToast': 'Não foi possível salvar este plugin neste navegador.',
  'settings.skillUserImported': 'Skill importada pelo usuário',
  'settings.skillDescriptionPlaceholder': 'O que esta skill faz? Quando o agente deve usá-la?',
  'settings.skillDetailUnavailable': 'O daemon não retornou o detalhe completo da skill. Tente de novo antes de usá-la.',
  'settings.skillExamplePrompt': 'Exemplo de pedido',
  'entry.navPrimaryAria': 'Principal',
  'chat.pluginsMyPlugins': 'Meus plugins',
  'chat.pluginsSearchPlaceholder': 'Buscar plugins…',
  'chat.skillsSearchPlaceholder': 'Buscar skills…',
  'chat.example1Title': "Carrossel de versículo",
  'chat.example1Tag': "Social",
  'chat.example1Prompt': "Um carrossel de 6 slides para o Instagram a partir de um versículo — capa com a frase mais forte em tipografia grande, dois slides abrindo o contexto, um slide de aplicação prática para a semana, um slide com uma oração curta e um slide final com o nome da igreja e convite para salvar. Formato 1080×1350, texto legível no celular, paleta da marca, sem poluição visual.",
  'chat.example2Title': "Slides de culto",
  'chat.example2Tag': "Projeção",
  'chat.example2Prompt': "Slides de projeção para o culto de domingo — capa com o tema da mensagem, slides de letra de louvor com uma estrofe por tela em fonte grande, slides de versículo com a referência destacada, slide de avisos e slide de encerramento. Formato 1920×1080, fundo escuro com texto claro, dimensionado para ser lido do fundo do salão.",
  'chat.example3Title': "Card de evento da igreja",
  'chat.example3Tag': "Evento",
  'chat.example3Prompt': "Um card de divulgação para o feed sobre um evento da igreja — nome do evento em destaque, data, horário e local com hierarquia clara, uma linha de chamada convidativa e o logo no rodapé. Formato 1080×1350, com o essencial ainda legível na miniatura e espaço para uma foto de fundo com sobreposição escura.",
  'home.recommendation.eyebrow': 'Recomendado para você',
  'home.recommendation.primaryCta': 'Começar a criar',
  'home.recommendation.change': 'Tentar outro',
  'home.recommendation.browseAll': 'Todos os tipos',
  'home.recommendation.defaultProjectName': 'Novo projeto',
  'home.recommendation.startFailed': 'Não foi possível iniciar a criação. Tente novamente.',
  'studio.firstArtifactHint.title': 'Seu primeiro design está pronto',
  'studio.firstArtifactHint.body': 'Experimente editar e anotar diretamente — exporte ou compartilhe quando estiver satisfeito.',
  'studio.firstArtifactHint.dismiss': 'Entendi',
  'home.starter.product_ui_prototype.title': 'Comece com um protótipo de produto editável',
  'home.starter.product_ui_prototype.desc': 'Com base no seu objetivo, comece com uma interface clicável que você pode refinar.',
  'home.starter.product_ui_prototype.firstPrompt': 'Projete um protótipo de produto editável para [seu produto] com as telas principais e um fluxo principal claro.',
  'home.starter.product_ui_component.title': 'Comece a partir de um componente reutilizável',
  'home.starter.product_ui_component.desc': 'Crie um componente primeiro e depois combine-o em telas completas.',
  'home.starter.product_ui_component.firstPrompt': 'Projete um componente [nome do componente] reutilizável com seus principais estados e variantes.',
  'home.starter.product_ui_lowfi.title': 'Comece com um protótipo de baixa fidelidade',
  'home.starter.product_ui_lowfi.desc': 'Esboce a estrutura primeiro e depois aumente a fidelidade.',
  'home.starter.product_ui_lowfi.firstPrompt': 'Crie um wireframe de baixa fidelidade das telas principais para [seu produto].',
  'home.starter.marketing_landing.title': 'Comece com uma landing page',
  'home.starter.marketing_landing.desc': 'Transforme sua campanha em uma landing page pronta para publicar.',
  'home.starter.marketing_landing.firstPrompt': 'Projete uma landing page para [seu produto] com um hero, benefícios principais e uma chamada para ação clara.',
  'home.starter.marketing_multivariant.title': 'Comece com várias variantes de landing page',
  'home.starter.marketing_multivariant.desc': 'Gere algumas versões para comparar antes de decidir.',
  'home.starter.marketing_multivariant.firstPrompt': 'Crie 3 variantes de landing page para [seu produto] com mensagens de hero diferentes para comparar.',
  'home.starter.internal_dashboard.title': 'Comece com um painel interno',
  'home.starter.internal_dashboard.desc': 'Comece a partir de um layout de painel para o seu fluxo de trabalho.',
  'home.starter.internal_dashboard.firstPrompt': 'Projete um painel interno mostrando [métricas principais] com filtros e uma tabela de dados.',
  'home.starter.internal_report.title': 'Comece com um relatório',
  'home.starter.internal_report.desc': 'Descreva os dados e campos que você quer ver.',
  'home.starter.internal_report.firstPrompt': 'Crie uma página de relatório resumindo [descreva os dados, campos e métricas que interessam a você].',
  'home.starter.ministry_versiculo.title': 'Comece por uma arte de versículo',
  'home.starter.ministry_versiculo.desc': 'Um card com o texto grande e legível, nas cores da sua identidade.',
  'home.starter.ministry_versiculo.firstPrompt': 'Crie um card de versículo para o feed com [referência do versículo], texto grande e legível, no formato 1080×1080.',
  'home.starter.ministry_evento.title': 'Comece pela divulgação de um evento',
  'home.starter.ministry_evento.desc': 'A arte do convite com data, horário e local em destaque.',
  'home.starter.ministry_evento.firstPrompt': 'Crie a arte de divulgação de [nome do evento] com data, horário, endereço e o logo, no formato 1080×1080.',
  'home.starter.ministry_carrossel.title': 'Comece por um carrossel',
  'home.starter.ministry_carrossel.desc': 'Uma sequência de telas que abre com o gancho e fecha com o convite.',
  'home.starter.ministry_carrossel.firstPrompt': 'Crie um carrossel de 5 telas sobre [tema], abrindo com um gancho e fechando com um convite claro.',
  'home.starter.creator_reels.title': 'Comece por um Reels',
  'home.starter.creator_reels.desc': 'Um vídeo curto no formato vertical, com o gancho nos primeiros segundos e legenda na tela.',
  'home.starter.creator_reels.firstPrompt': 'Crie um Reels vertical de 30 segundos sobre [tema], com um gancho nos primeiros 3 segundos e legenda na tela.',
  'home.starter.ministry_reels.title': 'Comece por um corte de pregação',
  'home.starter.ministry_reels.desc': 'Um trecho curto no formato vertical, com legenda na tela.',
  'home.starter.ministry_reels.firstPrompt': 'Crie um corte vertical de 30 segundos com [o trecho da pregação], legenda na tela e o nome do pregador.',
  'home.starter.ministry_louvor.title': 'Comece por uma arte de louvor',
  'home.starter.ministry_louvor.desc': 'A letra que a igreja está cantando, no formato do feed.',
  'home.starter.ministry_louvor.firstPrompt': 'Crie uma arte com um trecho da letra de [música], em alto contraste e boa leitura no celular.',
  'home.starter.ministry_serie.title': 'Comece pela capa de uma série',
  'home.starter.ministry_serie.desc': 'A identidade da campanha, pronta para render as peças seguintes.',
  'home.starter.ministry_serie.firstPrompt': 'Crie a capa da série [nome da série] com espaço para o título, o subtítulo e o período em que ela acontece.',
  'home.starter.ministry_avisos.title': 'Comece pelos avisos da semana',
  'home.starter.ministry_avisos.desc': 'A agenda em uma peça só, legível de longe.',
  'home.starter.ministry_avisos.firstPrompt': 'Crie a arte de avisos da semana com [os avisos], cada um com dia, horário e local.',
  'home.starter.ministry_site.title': 'Comece pelo site do ministério',
  'home.starter.ministry_site.desc': 'Uma página com o essencial: quem é, onde fica e como participar.',
  'home.starter.ministry_site.firstPrompt': 'Crie uma página para [nome do ministério] com apresentação, horários, endereço e um jeito de entrar em contato.',
  'home.starter.ministry_projecao.title': 'Comece pelos slides do culto',
  'home.starter.ministry_projecao.desc': 'Telas de alto contraste, pensadas para o telão.',
  'home.starter.ministry_projecao.firstPrompt': 'Crie os slides de projeção para o culto de [dia] com [o versículo ou a letra], uma ideia por tela e alto contraste.',
  'home.starter.ministry_identidade.title': 'Comece pela identidade visual',
  'home.starter.ministry_identidade.desc': 'Cores, tipografia e logo reunidos para todas as peças seguintes.',
  'home.starter.ministry_identidade.firstPrompt': 'Monte a identidade visual de [nome do ministério] com paleta de cores, tipografia e uso do logo.',
  'home.starter.general_menu.title': 'Comece com seu primeiro projeto',
  'home.starter.general_menu.desc': 'Descreva o que você quer e geraremos uma primeira versão editável.',
  'home.starter.general_menu.firstPrompt': 'Crie uma primeira versão editável de [descreva o que você quer criar].',
  'chat.example4Title': "Story de convite",
  'chat.example4Tag': "Stories",
  'chat.example4Prompt': "Uma sequência de 3 stories verticais convidando para o culto — o primeiro com a pergunta que prende, o segundo com o tema e o horário, o terceiro com o endereço e um lembrete para chamar alguém. Formato 1080×1920, área central segura para não cortar em nenhum aparelho, texto grande e um único ponto de foco por tela.",
  'preview.usePlugin': 'Usar plugin',
  'preview.usePluginOnly': 'Usar sem o texto de exemplo',
  'preview.usePluginOnlyDesc': 'Use a estrutura do plugin sem carregar o texto de exemplo',
  'preview.replicateContent': 'Usar',
  'preview.replicateContentDesc': 'Use o texto de exemplo para recriar a prévia',
  'preview.duplicateTemplate': 'Remixar',
  'preview.duplicateTemplateDesc': 'Remixe este exemplo em um novo projeto editavel',
  'preview.shareMenu': 'Compartilhar',
  'preview.exportMenu': 'Exportar',
  'preview.shareTemplateBadge': 'Modelo',
  'preview.shareToX': 'X / Twitter',
  'preview.shareToReddit': 'Reddit',
  'preview.shareToFacebook': 'Facebook',
  'preview.shareToLinkedIn': 'LinkedIn',
  'preview.shareToInstagram': 'Instagram',
  'preview.shareToXiaohongshu': '小红书',
  'preview.copyTemplateLink': 'Copiar link do modelo',
  'preview.copyShareText': 'Copiar texto de compartilhamento',
  'preview.shareSocialGroup': 'Compartilhar nas redes sociais',
  'preview.shareCopyGroup': 'Copiar',
  'preview.shareExportGroup': 'Exportar arquivos',
  'preview.shareCopied': 'Copiado',
  'preview.shareCopyFailed': 'Falha ao copiar',
  'preview.shareTextDefault': 'Modelo do Crie3: {title}',
  'preview.openInNewTab': 'Abrir em nova aba',
  'preview.exit': '⤓ Sair',
  'preview.fullscreen': '⤢ Tela cheia',
  'preview.closeTitle': 'Fechar (Esc)',
  'preview.loading': 'Carregando {label}…',
  'preview.errorTitle': 'Não foi possível carregar este exemplo.',
  'preview.errorBody': 'A obtenção do HTML do exemplo falhou. Verifique se o Crie3 está em execução e tente novamente.',
  'preview.retry': 'Tentar novamente',
  'preview.unavailableTitle': 'Nenhuma prévia incluída para {noun}.',
  'preview.unavailableBody': 'Envie o pedido na conversa para gerar um resultado {kind}.',
  'preview.nounSkill': 'esta skill',
  'preview.nounPlugin': 'este plugin',
  'preview.nounTemplate': 'este modelo',
  'preview.showSidebar': 'Mostrar {label}',
  'preview.hideSidebar': 'Ocultar {label}',
  'misc.savedTemplate': 'Template salvo',
  'misc.primary': 'Principal',
  'misc.designSystem': 'Sistema de design',
  'workspace.designFiles': 'Arquivos de design',
  'workspace.focusMode': 'Focar na área de trabalho',
  'workspace.showChat': 'Mostrar chat',
  'workspace.hideChat': "Ocultar conversa",
  'workspace.closeTab': 'Fechar aba',
  'workspace.deleteFileConfirm': 'Excluir "{name}" da pasta do projeto?',
  'workspace.deleteSelectedFilesConfirm': 'Excluir {n} arquivo(s) selecionado(s) da pasta do projeto?',
  'workspace.deleteSelectedFilesPartial': 'Falha ao excluir {n} arquivo(s).',
  'workspace.openFromDesignFiles': 'Abra um arquivo em',
  'workspace.designFilesLink': 'Arquivos de design',
  'workspace.loadingSketch': 'Carregando esboço…',
  'workspace.newTab': 'Nova aba',
  'workspace.tabsBarAria': 'Abas do Crie3',
  'workspace.openTabsAria': 'Abas abertas',
  'workspace.searchFilesPlaceholder': 'Pesquisar arquivos…',
  'workspace.openTabs': 'Abrir abas',
  'workspace.openFile': 'Abrir um arquivo',
  'workspace.noFilesMatch': 'Nenhum arquivo corresponde',
  'workspace.allFiles': 'Todos',
  'workspace.createNew': 'Criar novo',
  'workspace.tabOpen': 'Aberto',
  'workspace.sideChatContextBanner': 'Contexto da conversa atual integrado',
  'workspace.sideChatDefaultTitle': 'Chat lateral',
  'workspace.newTerminal': 'Novo terminal',
  'workspace.newTerminalDescription': 'Abrir um shell no diretório do projeto em uma nova aba',
  'workspace.newBrowser': 'Novo navegador',
  'workspace.newBrowserDescription': 'Abrir uma aba de navegador integrada para sites de referência e tarefas',
  'workspace.newSketchDescription': 'Rascunhe layouts e notas rápidas como contexto de design para o agente',
  'workspace.terminalStarting': 'Iniciando terminal…',
  'workspace.terminalStartingDescription': 'Preparando o shell do projeto. Normalmente leva alguns segundos.',
  'workspace.terminalSessionEnded': 'Sessão encerrada',
  'workspace.terminalReconnecting': 'Reconectando…',
  'workspace.terminalStartFailed': 'Não foi possível iniciar a sessão de terminal',
  'workspace.terminalRestart': 'Reiniciar',
  'workspace.browserTab': 'Navegador',
  'workspace.browserTabNumbered': 'Navegador {n}',
  'workspace.uploadFailed': 'Não foi possível enviar {count} arquivo(s){detail}.',
  'workspace.uploadFailedDetail': 'Não foi possível enviar {count} arquivo(s) ({detail}).',
  'workspace.uploadPartialFailed': 'Enviamos {uploaded} arquivo(s), mas {failed} falhou(aram){detail}.',
  'workspace.renamePendingSketchConflict': 'Já existe um rascunho não salvo chamado "{name}" aberto. Salve ou feche esse rascunho antes de renomear.',
  'memory.storagePathCopy': 'Pasta onde a memória fica salva — clique para copiar',
  'memory.advanced': 'Avançado',
  'memory.advancedHint': 'Veja ou edite o índice de memória por baixo dos panos.',
  'memory.flowOnboarding': 'Boas-vindas',
  'memory.flowBrandContext': 'Contexto da marca',
  'memory.flowChatSignals': 'Pistas das conversas',
  'memory.howCopy': 'A memória é montada sozinha: a partir do seu perfil, das informações do projeto e da marca, dos apps conectados e dos fatos úteis que aparecem nas conversas. A lista salva abaixo é onde você revisa tudo; o resto fica quieto até você abrir Adicionar ou Avançado.',
  'memory.areasAria': 'Áreas da memória',
  'memory.addManually': 'Adicionar à mão',
  'memory.addManuallyCaption': 'Escreva um fato ou uma preferência',
  'memory.addManuallyHint': 'Você mesmo adiciona fatos, preferências ou informações do projeto. O comportamento fixo do assistente fica em Instruções / Regras.',
  'memory.importFromApps': 'Importar de apps',
  'memory.importFromAppsCaption': 'Ler os apps conectados',
  'memory.importFromAppsHint': 'Escolha os apps de onde tirar preferências de design, informações do projeto e referências visuais. Nada é lido até você selecionar um app.',
  'memory.loading': 'Carregando',
  'memory.connectedCount': '{count} conectados',
  'memory.manage': 'Gerenciar',
  'memory.chooseSources': 'Escolha as fontes',
  'memory.chooseSourcesHint': 'Primeiro selecione os apps conectados. O Crie3 só lê os apps que você escolher.',
  'memory.selectedCount': '{count} selecionados',
  'memory.connectorListAria': 'Apps conectados à memória',
  'memory.connectorReadTools': '{count} ferramentas de leitura',
  'memory.connectorCheckingStatus': 'Verificando a conexão…',
  'memory.connectorAuthPending': 'Conclua a autorização no navegador e volte para cá',
  'memory.connectorNotConnected': 'Conecte este app antes de buscar informações',
  'memory.connectorUseForExtraction': 'Usar {name} para alimentar a memória',
  'memory.selected': 'Selecionado',
  'memory.select': 'Selecionar',
  'memory.connectAria': 'Conectar {name}',
  'memory.reconnectAria': 'Reconectar {name}',
  'memory.checking': 'Verificando',
  'memory.waiting': 'Aguardando',
  'memory.connecting': 'Conectando',
  'memory.reconnect': 'Reconectar',
  'memory.connect': 'Conectar',
  'memory.selectedOfConnectedOne': 'Selecionados: {selected} de {total} app conectado.',
  'memory.selectedOfConnectedOther': 'Selecionados: {selected} de {total} apps conectados.',
  'memory.scanningApps': 'Lendo os apps',
  'memory.selectAppsToScan': 'Selecione os apps para ler',
  'memory.scanSelectedApps': 'Ler os apps selecionados',
  'memory.suggestedMemories': 'Memórias sugeridas',
  'memory.suggestedMemoriesHint': 'Revise as memórias ligadas a design antes de salvar.',
  'memory.suggestionSourceFallback': 'Apps conectados',
  'memory.saving': 'Salvando',
  'memory.saveSelected': 'Salvar selecionadas',
  'memory.discard': 'Descartar',
  'memory.diagnosticsAria': 'Status de leitura dos apps conectados',
  'memory.lastScan': 'Última leitura',
  'memory.bytesRead': '{size} lidos',
  'memory.noData': 'Sem dados',
  'memory.recentScans': 'Leituras recentes',
  'memory.runHistoryAria': 'Histórico de leituras dos apps conectados',
  'memory.attemptRead': 'Leu {name}',
  'memory.attemptFailed': 'Não foi possível ler {name}',
  'memory.attemptSkipped': 'Pulou {name}',
  'memory.savedMemory': 'Memória salva',
  'memory.savedMemoryHint': 'Fatos, preferências e informações do projeto já salvos e disponíveis nas próximas conversas.',
  'memory.savedCount': '{count} salvas',
  'memory.extractionCountOne': '{count} extração',
  'memory.extractionCountOther': '{count} extrações',
  'memory.emptyHintBefore': 'Conte um fato para o assistente no chat — por exemplo,',
  'memory.emptyHintExample': 'prefiro o tema escuro',
  'memory.emptyHintAfter': '— e ele será salvo aqui automaticamente.',
  'memory.memoryTree': 'Árvore da memória',
  'memory.memoryTreeHint': 'Visão técnica das mesmas memórias salvas. Na maioria dos casos, a lista de memória salva acima já basta.',
  'memory.nodeCountOne': '{count} item',
  'memory.nodeCountOther': '{count} itens',
  'designFiles.title': 'Arquivos de design',
  'designFiles.upload': 'Enviar arquivos',
  'designFiles.pasteText': 'Colar como arquivo de texto',
  'designFiles.newSketch': 'Novo esboço',
  'designFiles.empty': 'As criações aparecerão aqui',
  'designFiles.refresh': 'Atualizar',
  'designFiles.delete': 'Excluir',
  'designFiles.searchPlaceholder': 'Buscar arquivos…',
  'designFiles.up': 'Subir',
  'designFiles.back': 'Voltar',
  'designFiles.crumbs': 'projeto',
  'designFiles.rowMenu': 'Menu da linha',
  'designFiles.openInTab': 'Abrir em aba',
  'designFiles.download': 'Baixar',
  'designFiles.downloadSelected': 'Baixar {n} selecionados como ZIP',
  'designFiles.deleteSelected': 'Excluir {n}',
  'designFiles.clearSelection': 'Limpar seleção',
  'designFiles.selectPage': 'Selecionar tudo na página',
  'designFiles.selectAll': 'Selecionar tudo',
  'designFiles.dropTitle': '⤓ Solte arquivos aqui',
  'designFiles.dropDesc': 'Imagens, docs, referências ou pastas — o agente usará tudo como contexto.',
  'designFiles.dropLabel': 'Solte os arquivos aqui',
  'designFiles.upload.title': 'Enviar arquivos',
  'designFiles.paste.title': 'Criar documento',
  'designFiles.upload.label': 'Enviar',
  'designFiles.paste.label': 'Criar documento',
  'designFiles.documentTemplate.titleFallback': 'Documento',
  'designFiles.documentTemplate.goalHeading': 'Objetivo',
  'designFiles.documentTemplate.goalBody': 'Descreva o que o Crie3 deve gerar, editar ou decidir a partir deste documento.',
  'designFiles.documentTemplate.capabilitiesHeading': 'Como usar este documento',
  'designFiles.documentTemplate.capabilityMarkdown': 'Use qualquer formato Markdown: títulos, tabelas, checklists, links, citações, blocos de código e imagens.',
  'designFiles.documentTemplate.capabilityAgent': 'O agente do Crie3 pode ler, editar e usar este arquivo como contexto do projeto.',
  'designFiles.documentTemplate.capabilityImages': 'Cole imagens ou arraste arquivos de imagem para o editor; imagens enviadas são inseridas no cursor.',
  'designFiles.documentTemplate.scenarioHeading': 'Guia de cenários',
  'designFiles.documentTemplate.scenario.prototype': 'Para protótipos, descreva o objetivo do produto, usuários-alvo, fluxos, telas, módulos, estados de interação, tamanhos de tela e as definições visuais como cor, tipografia, espaçamento, arredondamento e movimento.',
  'designFiles.documentTemplate.scenario.wireframe': 'Para wireframes, descreva o fluxo do usuário, a lista de telas, a hierarquia de layout, os blocos de conteúdo, as restrições de baixa fidelidade e as perguntas que a estrutura deve responder antes do design visual.',
  'designFiles.documentTemplate.scenario.mobile': 'Para apps de celular, liste as plataformas-alvo, telas, modelo de navegação, gestos, padrões nativos, tamanhos de aparelho, estados e as definições visuais do aplicativo.',
  'designFiles.documentTemplate.scenario.slideDeck': 'Para slides, escreva uma estrutura de PPT paginada: uma seção por slide com título, propósito, mensagem principal, evidências, direção visual, notas do apresentador e necessidades de exportação.',
  'designFiles.documentTemplate.scenario.document': 'Para documentos, defina o público, o tom, a estrutura de seções, o material de origem, citações ou dados, expectativas de layout e requisitos de PDF/exportação.',
  'designFiles.documentTemplate.scenario.image': 'Para imagens, especifique o assunto, a proporção, a composição, o estilo visual, as cores e fontes da marca, os arquivos de referência e o que deve ser evitado.',
  'designFiles.documentTemplate.scenario.video': 'Para vídeo, esboce um storyboard com cenas, tempo, legendas, movimento, recursos, notas de áudio e formato de saída.',
  'designFiles.documentTemplate.scenario.hyperframes': 'Para animações, descreva a peça de movimento em HTML: cenas, linha do tempo, legendas, momentos reativos ao áudio, transições e requisitos de captura/exportação.',
  'designFiles.documentTemplate.scenario.audio': 'Para áudio, defina a direção de voz ou música, duração, clima, roteiro ou copy, ritmo, notas de pronúncia e uso final.',
  'designFiles.documentTemplate.scenario.liveArtifact': 'Para artefatos ao vivo, descreva as fontes de dados, a cadência de atualização, os widgets, filtros, interações, estados de vazio/carregamento/erro e quaisquer alertas ou automações.',
  'designFiles.documentTemplate.scenario.designSystem': 'Para design systems, liste os objetivos da marca, as definições visuais, tipografia, cor, espaçamento, componentes, recursos, referências e regras a seguir ou evitar.',
  'designFiles.documentTemplate.scenario.default': 'Descreva o público, o entregável, o conteúdo necessário, as referências, as restrições e como deve ser o resultado pronto.',
  'designFiles.documentTemplate.nextHeading': 'Próximo passo',
  'designFiles.documentTemplate.nextBody': 'Revise e edite este documento e depois peça ao Crie3 para gerar, revisar ou operar a partir dele.',

  'designFiles.projectMenu': 'Ações do projeto',
  'designFiles.createDesignSystemFromProject': 'Criar design system a partir deste projeto',
  'designFiles.duplicateProject': 'Duplicar projeto',

  'designFiles.previewOpen': 'Abrir',
  'designFiles.previewClose': 'Fechar prévia',
  'designFiles.modified': 'Modificado {time} · {size}',
  'designFiles.weeksAgo': 'há {n} sem',
  'designFiles.groupBy': 'Agrupar por',
  'designFiles.groupByKind': 'Tipo',
  'designFiles.groupByModified': 'Modificado',
  'designFiles.filterBy': 'Filtrar por tipo',
  'designFiles.filterClear': 'Limpar',
  'designFiles.filterCount': '{n} tipos',
  'designFiles.expandGroup': 'Expandir',
  'designFiles.collapseGroup': 'Recolher',
  'designFiles.sectionPages': 'Páginas',
  'designFiles.sectionScripts': 'Scripts',
  'designFiles.sectionImages': 'Imagens',
  'designFiles.sectionSketches': 'Esboços',
  'designFiles.sectionLiveArtifacts': 'Artefatos live',
  'designFiles.sectionOther': 'Outros',
  'designFiles.modifiedToday': 'Hoje',
  'designFiles.modifiedYesterday': 'Ontem',
  'designFiles.modifiedPrevious7Days': 'Últimos 7 dias',
  'designFiles.modifiedPrevious30Days': 'Últimos 30 dias',
  'designFiles.modifiedOlder': 'Mais antigos',
  'designFiles.showMore': 'Mostrar +{n} mais',
  'designFiles.kindHtml': 'Página HTML',
  'designFiles.kindImage': 'Imagem',
  'designFiles.kindSketch': 'Esboço',
  'designFiles.kindText': 'Texto',
  'designFiles.kindCode': 'Script',
  'designFiles.kindPdf': 'PDF',
  'designFiles.kindDocument': 'Documento',
  'designFiles.kindPresentation': 'Apresentação',
  'designFiles.kindSpreadsheet': 'Planilha',
  'designFiles.kindLiveArtifact': 'Artefato live',
  'designFiles.kindBinary': 'Binário',
  'designFiles.kindFolder': 'Pasta',
  'designFiles.folderCount': '{n} arquivos',
  'designFiles.newFolderTitle': 'Nova pasta',
  'designFiles.newFolderLabel': 'Nome da pasta',
  'designFiles.moveTitle': 'Mover para a pasta',
  'designFiles.moveLabel': 'Pasta de destino',
  'designFiles.moveRoot': 'Raiz do projeto',
  'designFiles.moveNewFolder': 'Nova pasta…',
  'designFiles.move': 'Mover',
  'designFiles.copyPath': 'Copiar caminho',
  'designFiles.copiedPath': 'Caminho copiado',
  'designFiles.copyLocalPath': 'Copiar caminho do arquivo local',
  'designFiles.copiedLocalPath': 'Caminho do arquivo local copiado',
  'designFiles.deleteFolderConfirm': 'Excluir a pasta "{name}" e todo o seu conteúdo?',
  'designFiles.folderCreated': 'Pasta "{name}" criada',
  'designFiles.folderDeleted': 'Pasta "{name}" excluída',
  'designFiles.filesMoved': '{n} movido(s) para {dest}',
  'designFiles.colName': 'Nome',
  'designFiles.colKind': 'Tipo',
  'designFiles.colModified': 'Modificado',
  'designFiles.perPage': 'Mostrar',
  'designFiles.all': 'Todos',
  'designFiles.prev': 'Anterior',
  'designFiles.next': 'Próximo',
  'designFiles.jumpToPage': 'Ir para a página',
  'designFiles.pageInfo': '{start}–{end} de {total}',
  'designFiles.sectionFolders': 'Pastas',
  'designFiles.sectionStylesheets': 'Folhas de estilo',
  'designFiles.sectionDocuments': 'Documentos',
  'designFiles.kindStylesheet': 'Folha de estilo',
  'designFiles.modifiedExt': 'Modificado em {time} · {size} · {ext}',
  'designFiles.usefulInfoLabel': 'Informações úteis',
  'designFiles.usefulInfoTip': 'Clique duas vezes em qualquer arquivo para abri-lo em uma aba completa.',
  'designFiles.usefulInfoTip2': 'Digite @ no chat para referenciar um arquivo como contexto.',
  'designFiles.usefulInfoTip4': 'Escolha um design system para manter o resultado alinhado à marca.',
  'designFiles.usefulInfoTip5': 'Sem ideias? Experimente um template de plugin na Comunidade, na página inicial.',
  'designFiles.usefulInfoTip9': 'Arraste imagens, documentos ou pastas inteiras para este painel — o agente usará tudo como contexto.',
  'designFiles.usefulInfoTip10': 'Clique em «Novo rascunho», desenhe um layout e deixe o agente gerá-lo.',
  'designFiles.usefulInfoTip11': 'Selecione qualquer elemento na prévia para comentar — o agente fará ajustes pontuais.',
  'designFiles.usefulInfoTip12': 'Não gostou do resultado? Marcar o elemento é mais rápido que descrever de novo.',
  'designFiles.usefulInfoTip13': 'Exporte qualquer design como PDF, imagem ou HTML independente em um clique.',
  'designFiles.usefulInfoTip14': 'Gostou de um projeto? Salve-o como template pelo menu Compartilhar.',
  'designFiles.usefulInfoTip15': 'Depois de publicar, gere cartões para compartilhar nas redes na hora.',
  'quickSwitcher.placeholder': 'Abrir arquivo…',
  'quickSwitcher.empty': 'Nenhum arquivo neste projeto',
  'quickSwitcher.noMatches': 'Sem resultados',
  'quickSwitcher.navigate': 'navegar',
  'quickSwitcher.open': 'abrir',
  'quickSwitcher.close': 'fechar',
  'pasteDialog.title': 'Colar texto',
  'pasteDialog.hint': 'Salvo na pasta do projeto. Escolha qualquer nome.',
  'pasteDialog.fileNameLabel': 'Nome do arquivo',
  'pasteDialog.namePlaceholder': 'notas.txt',
  'pasteDialog.contentLabel': 'Conteúdo',
  'pasteDialog.contentPlaceholder': 'Cole qualquer coisa…',
  'pasteDialog.save': 'Salvar',
  'pasteDialog.cancel': 'Cancelar',
  'sketch.save': 'Salvar esboço',
  'sketch.cancel': 'Cancelar',
  'sketch.saving': 'Salvando…',
  'sketch.saved': 'Salvo',
  'sketch.tooltipMainMenu': 'Menu principal: salvar, exportar, ajuda e ajustes da tela',
  'sketch.tooltipLock': 'Mantenha a ferramenta de desenho atual ativa para uso repetido',
  'sketch.tooltipHand': 'Desloque o canvas sem selecionar objetos',
  'sketch.tooltipSelection': 'Selecione, mova, redimensione ou edite objetos no canvas',
  'sketch.tooltipRectangle': 'Desenhe um retângulo ou área de card',
  'sketch.tooltipDiamond': 'Desenhe um losango para decisões ou estruturas de ramificação',
  'sketch.tooltipEllipse': 'Desenhe um círculo ou elipse',
  'sketch.tooltipArrow': 'Desenhe um conector direcional ou seta de fluxo',
  'sketch.tooltipLine': 'Desenhe uma linha divisória reta ou de conexão',
  'sketch.tooltipFreedraw': 'Desenhe linhas à mão livre no canvas',
  'sketch.tooltipText': 'Adicione texto editável ao canvas',
  'sketch.tooltipImage': 'Insira uma imagem no canvas',
  'sketch.tooltipEraser': 'Apague objetos do canvas',
  'sketch.tooltipFrame': 'Crie um frame para agrupar uma região do canvas',
  'sketch.tooltipEmbeddable': 'O Web Embed só suporta links https:// ou http:// válidos',
  'sketch.tooltipLaser': 'Aponte para o conteúdo do canvas temporariamente sem alterá-lo',
  'sketch.tooltipMoreTools': 'Abra ferramentas adicionais como frame, web embed e ponteiro laser',
  'sketch.tooltipDirty': 'Alterações não salvas',
  'sketch.tooltipClean': 'Salvo',
  'fileViewer.empty': 'Selecione um arquivo para visualizar.',
  'fileViewer.loading': 'Carregando…',
  'fileViewer.exportPptx': 'Exportar como PPTX',
  'fileViewer.openInNewTab': 'Abrir em nova aba',
  'fileViewer.copyPath': 'Copiar caminho',
  'fileViewer.copied': 'Copiado!',
  'fileViewer.share': 'Compartilhar',
  'fileViewer.binaryMeta': 'Binário · {size}',
  'fileViewer.binaryNote': 'Arquivo binário ({size} bytes). Baixe ou abra do disco para inspecionar.',
  'fileViewer.pdfMeta': 'PDF · {size}',
  'fileViewer.documentMeta': 'Documento',
  'fileViewer.presentationMeta': 'Apresentação',
  'fileViewer.spreadsheetMeta': 'Planilha',
  'fileViewer.previewUnavailable': 'Prévia indisponível. Baixe ou abra o arquivo para inspecionar.',
  'fileViewer.download': 'Baixar',
  'fileViewer.open': 'Abrir',
  'fileViewer.imageMeta': 'Imagem · {size}',
  'fileViewer.reactMeta': 'Componente React · {size}',
  'fileViewer.sketchMeta': 'Esboço · {size}',
  'fileViewer.markdownStreamingMeta': 'Prévia em streaming…',
  'fileViewer.markdownErrorMeta': 'A prévia pode estar incompleta (erro de geração).',
  'fileViewer.markdownStreamingStatus': 'Streaming… mostrando markdown parcial.',
  'fileViewer.markdownErrorStatus': 'Erro de geração. Mostrando o último conteúdo disponível.',
  'fileViewer.markdownSaving': 'Salvando...',
  'fileViewer.markdownSaveFailed': 'Falha ao salvar',
  'fileViewer.markdownSaved': 'Salvo',
  'fileViewer.markdownAutoSaved': 'Salvo automaticamente · {time}',
  'fileViewer.markdownAutoSaveHint': 'Salvamento automático ativado',
  'fileViewer.markdownViewMode': 'Modo de visualização Markdown',
  'fileViewer.split': 'Dividido',
  'fileViewer.markdownEditor': 'Editor Markdown',
  'fileViewer.markdownEditorPlaceholder': 'Digite notas, requisitos ou instruções para este documento...',
  'fileViewer.markdownPreview': 'Prévia Markdown',
  'fileViewer.videoMeta': 'Vídeo · {size}',
  'fileViewer.audioMeta': 'Áudio · {size}',
  'fileViewer.reload': 'Recarregar',
  'fileViewer.reloadDisk': 'Recarregar do disco',
  'fileViewer.copy': 'Copiar',
  'fileViewer.copyTitle': 'Copiar conteúdo do arquivo',
  'fileViewer.saveDisabled': 'Salvar (visualizador somente leitura)',
  'fileViewer.save': 'Salvar',
  'fileViewer.preview': 'Prévia',
  'fileViewer.source': 'Código-fonte',
  'fileViewer.tweaks': 'Ajustes',
  'fileViewer.tweaksUnavailable': 'Sem painel de ajustes neste artefato',
  'fileViewer.jsxModuleTitle': 'Sem visualização independente',
  'fileViewer.jsxModuleBody': 'Este arquivo é um módulo de componente carregado por outra página.',
  'fileViewer.jsxModuleCta': 'Abra a página que o renderiza:',
  'fileViewer.comment': 'Comentar',
  'fileViewer.edit': 'Editar',
  'fileViewer.draw': 'Desenhar',
  'fileViewer.mark': 'Marcar',
  'fileViewer.markTool': 'Ferramenta de marcação',
  'fileViewer.boxSelect': 'Selecionar área',
  'fileViewer.textTool': 'Texto',
  'fileViewer.textAnnotationRemove': 'Remover texto',
  'fileViewer.screenshot': 'Captura de tela',
  'fileViewer.versions.entry': 'Versões',
  'fileViewer.versions.title': 'Versões',
  'fileViewer.versions.countOne': '1 versão',
  'fileViewer.versions.countMany': '{count} versões',
  'fileViewer.versions.current': 'Atual',
  'fileViewer.versions.sourceAi': 'Edição por IA',
  'fileViewer.versions.sourceManual': 'Edição manual',
  'fileViewer.versions.sourceRestore': 'Restaurado',
  'fileViewer.versions.restoredFrom': 'Restaurado da v{version}',
  'fileViewer.versions.versionLabel': 'Versão {version}',
  'fileViewer.versions.listAria': 'Versões do arquivo',
  'fileViewer.versions.loading': 'Carregando versões...',
  'fileViewer.versions.empty': 'Ainda não há versões.',
  'fileViewer.versions.loadFailed': 'Não foi possível carregar as versões.',
  'fileViewer.versions.previewFailed': 'Não foi possível carregar a prévia desta versão.',
  'fileViewer.versions.previewLoading': 'Carregando prévia da versão...',
  'fileViewer.versions.noPrompt': 'Nenhum pedido registrado',
  'fileViewer.versions.noPromptBody': 'Nenhum pedido foi registrado para esta versão.',
  'fileViewer.versions.promptTitle': 'Pedido',
  'fileViewer.versions.copyPrompt': 'Copiar o pedido',
  'fileViewer.versions.fullscreen': 'Prévia em tela cheia',
  'fileViewer.versions.open': 'Abrir prévia',
  'fileViewer.versions.currentHelp': 'Esta já é a versão atual.',
  'fileViewer.versions.restoreHelp': 'Ao alternar, este HTML será restaurado como uma nova versão atual.',
  'fileViewer.versions.restore': 'Alternar para esta versão',
  'fileViewer.versions.restoreConfirmTitle': 'Mudar para esta versão?',
  'fileViewer.versions.restoreConfirmCta': 'Mudar',
  'fileViewer.versions.restoring': 'Alternando...',
  'fileViewer.versions.restoreFailed': 'Não foi possível alternar para esta versão.',
  'fileViewer.versions.restoreSuccess': 'Alternado para esta versão.',
  'manualEdit.layers': 'Camadas',
  'manualEdit.editableCount': '{count} editáveis',
  'manualEdit.hiddenBadge': 'Oculto',
  'manualEdit.title': 'Editor manual',
  'manualEdit.fallbackTitle': 'Editar',
  'manualEdit.movePanel': 'Mover painel de edição',
  'manualEdit.editParams': 'Editar parâmetros',
  'manualEdit.closePanel': 'Fechar painel de edição',
  'manualEdit.selectLayer': 'Selecione uma camada',
  'manualEdit.empty': 'Clique em um elemento na pré-visualização ou escolha uma camada.',
  'manualEdit.noEditableLayers': 'Nenhuma camada editável encontrada.',
  'manualEdit.noClass': 'sem classe',
  'manualEdit.tabsAria': 'Abas de edição manual',
  'manualEdit.tabContent': 'Conteúdo',
  'manualEdit.tabStyle': 'Estilo',
  'manualEdit.tabAttributes': 'Atributos',
  'manualEdit.tabHtml': 'Html',
  'manualEdit.tabSource': 'Código-fonte',
  'manualEdit.attributesJson': 'JSON de atributos',
  'manualEdit.selectedHtml': 'HTML do elemento selecionado',
  'manualEdit.fullSource': 'Código-fonte completo do artefato',
  'manualEdit.applyContent': 'Aplicar conteúdo',
  'manualEdit.applyStyle': 'Aplicar estilo',
  'manualEdit.applyAttributes': 'Aplicar atributos',
  'manualEdit.applyHtml': 'Aplicar HTML',
  'manualEdit.applySource': 'Aplicar código-fonte',
  'manualEdit.invalidAttributes': 'JSON de atributos inválido.',
  'manualEdit.changes': 'Alterações',
  'manualEdit.undo': 'Desfazer',
  'manualEdit.redo': 'Refazer',
  'manualEdit.noChanges': 'Nenhuma edição manual ainda.',
  'manualEdit.imageUrl': 'URL da imagem',
  'manualEdit.altText': 'Texto alternativo',
  'manualEdit.label': 'Rótulo',
  'manualEdit.text': 'Texto',
  'manualEdit.href': 'Href',
  'manualEdit.textColor': 'Cor do texto',
  'manualEdit.background': 'Plano de fundo',
  'manualEdit.fontSize': 'Tamanho da fonte',
  'manualEdit.weight': 'Espessura',
  'manualEdit.align': 'Alinhamento',
  'manualEdit.padding': 'Espaçamento interno',
  'manualEdit.margin': 'Margem',
  'manualEdit.radius': 'Arredondamento',
  'manualEdit.border': 'Borda',
  'manualEdit.width': 'Largura',
  'manualEdit.minHeight': 'Altura mínima',
  'manualEdit.deleteElement': 'Excluir elemento',
  'manualEdit.deleteElementConfirm': 'Excluir o elemento selecionado? Isso pode ser revertido com Desfazer.',
  'manualEdit.uploadImage': 'Enviar imagem',
  'manualEdit.uploadingImage': 'Enviando imagem…',
  'manualEdit.uploadImageFailed': 'Não foi possível enviar a imagem.',
  'manualEdit.focusSlides': 'Focar nos slides',
  'manualEdit.showPanels': 'Mostrar painéis',
  'manualEdit.sectionContent': 'CONTEÚDO',
  'manualEdit.sectionImage': 'IMAGEM',
  'manualEdit.sectionPage': 'PÁGINA',
  'manualEdit.sectionTypography': 'TEXTO',
  'manualEdit.sectionSize': 'TAMANHO',
  'manualEdit.sectionLayout': 'LAYOUT',
  'manualEdit.sectionBox': 'CAIXA',
  'manualEdit.font': 'Fonte',
  'manualEdit.size': 'Tamanho',
  'manualEdit.color': 'Cor',
  'manualEdit.line': 'Linha',
  'manualEdit.tracking': 'Letras',
  'manualEdit.height': 'Altura',
  'manualEdit.gap': 'Espaço',
  'manualEdit.direction': 'Direção',
  'manualEdit.justify': 'Distribuir',
  'manualEdit.fill': 'Fundo',
  'manualEdit.opacity': 'Opacidade',
  'manualEdit.borderStyle': 'Estilo',
  'manualEdit.baseSize': 'Tamanho base',
  'manualEdit.pageStylesUnavailable': 'Os estilos da página só funcionam em documentos HTML completos.',
  'manualEdit.targetContainer': 'Bloco',
  'manualEdit.targetImage': 'Imagem',
  'manualEdit.targetLink': 'Link',
  'manualEdit.targetText': 'Texto',
  'manualEdit.pickColor': 'Escolher {label}',
  'manualEdit.decrease': 'Diminuir {label}',
  'manualEdit.increase': 'Aumentar {label}',
  'fileViewer.zoomOut': 'Diminuir zoom',
  'fileViewer.zoomIn': 'Aumentar zoom',
  'fileViewer.resetZoom': 'Redefinir zoom',
  'fileViewer.viewportAria': 'Viewport de pré-visualização',
  'fileViewer.viewportDesktop': 'Desktop',
  'fileViewer.viewportDesktopTitle': 'Pré-visualização em desktop de largura total',
  'fileViewer.viewportTablet': 'Tablet',
  'fileViewer.viewportTabletTitle': 'Visualização em tablet a 820 × 1180 (referência moderna em retrato)',
  'fileViewer.viewportMobile': 'Celular',
  'fileViewer.viewportMobileTitle': 'Visualização em celular a 390 × 844',
  'fileViewer.reloadAria': 'Recarregar',
  'fileViewer.previousSlide': 'Slide anterior',
  'fileViewer.nextSlide': 'Próximo slide',
  'fileViewer.slideNavAria': 'Navegação de slides',
  'fileViewer.speakerNotes': 'Notas do apresentador',
  'fileViewer.speakerNotesSlide': 'Slide {current} / {total}',
  'fileViewer.speakerNotesEmpty': 'Sem notas do apresentador para este slide.',
  'fileViewer.speakerNotesEdit': 'Editar',
  'fileViewer.speakerNotesSave': 'Salvar notas',
  'fileViewer.speakerNotesSaving': 'Salvando…',
  'fileViewer.speakerNotesSaved': 'Salvo',
  'fileViewer.speakerNotesSaveFailed': 'Não foi possível salvar as notas do apresentador.',
  'fileViewer.speakerNotesPlaceholder': 'Adicione notas do apresentador para este slide…',
  'fileViewer.presenterReset': 'Redefinir',
  'fileViewer.present': 'Apresentar',
  'fileViewer.presentInTab': 'Nesta aba',
  'fileViewer.presentFullscreen': 'Tela cheia',
  'fileViewer.presentNewTab': 'Nova aba',
  'fileViewer.exitPresentation': 'Sair da apresentação',
  'fileViewer.shareLabel': 'Compartilhar',
  'fileViewer.shareMenuShareLink': 'COMPARTILHAR',
  'fileViewer.shareMenuPublishOnline': 'PUBLICAR ONLINE',
  'fileViewer.shareMenuDownload': 'BAIXAR',
  'fileViewer.shareMenuPresentation': 'Apresentação',
  'fileViewer.shareMenuSourceFiles': 'Arquivos-fonte',
  'fileViewer.shareMenuSave': 'SALVAR',
  'fileViewer.copyShareLink': 'Copiar link de compartilhamento',
  'fileViewer.openSharePage': 'Abrir página compartilhada',
  'fileViewer.shareLinkRequiresDeploy': 'Publique online primeiro para obter um link',
  'fileViewer.shareLinkPublishGuide': 'Publique online acima para habilitar o compartilhamento ↑',
  'fileViewer.shareAfterGenerationComplete': 'Compartilhamento disponível após a geração',
  'fileViewer.copyProviderLink': 'Copiar link do {provider}',
  'fileViewer.copyCloudflareLink': 'Copiar link do Cloudflare',
  'fileViewer.screenshotCopying': 'Copiando captura de tela...',
  'fileViewer.screenshotCopied': 'Captura de tela copiada para a área de transferência',
  'fileViewer.screenshotClipboardDenied': 'O navegador bloqueou o acesso à área de transferência',
  'fileViewer.screenshotPreviewLoading': 'A pré-visualização ainda está carregando. Tente novamente em instantes.',
  'fileViewer.screenshotCaptureFailed': 'Não foi possível capturar a pré-visualização. Tente novamente.',
  'fileViewer.exportPdf': 'Exportar como PDF',
  'fileViewer.exportPdfAllSlides': 'Exportar como PDF (todos os slides)',
  'fileViewer.exportPptxBusy': 'Aguarde o turno atual terminar.',
  'fileViewer.exportPptxHint': 'Envie uma solicitação ao agente para converter este design em PPTX.',
  'fileViewer.exportPptxNa': 'Exportação PPTX não está disponível aqui.',
  'fileViewer.exportZip': 'Baixar como .zip',
  'fileViewer.exportHtml': 'Exportar como HTML independente',
  'fileViewer.exportMd': 'Exportar como Markdown',
  'fileViewer.exportImage': 'Exportar como imagem',
  'fileViewer.exportVideo': 'Vídeo MP4',
  'fileViewer.exportVideoOneCard': 'O vídeo é gravado de uma tela só. Este carrossel tem várias, e o Instagram aceita um vídeo por post.',
  'fileViewer.exportVideoNotAnimated': 'Nada se mexe nesta peça, então não há vídeo para gravar. Baixe como imagem.',
  'fileViewer.exportVideoFailed': 'Não foi possível gerar o vídeo. Tente de novo.',
  'fileViewer.exportVideoBusy': 'Outras peças estão sendo geradas agora. Espere um pouco e tente de novo.',
  'fileViewer.exportPptxImages': 'Exportar como PPTX (imagens)',
  'fileViewer.exportPptxEditable': 'Exportar como PPTX (editável)',
  'fileViewer.exportPptxEditableHint': 'Formas e texto editáveis nativos (não pixel-perfect)',
  'fileViewer.exportPptxModalSubtitle': 'Escolha como exportar e depois baixe.',
  'fileViewer.exportPptxScreenshot': 'PPTX por captura de tela',
  'fileViewer.exportPptxScreenshotHint': 'Uma imagem por slide — pixel-perfect, mas não editável.',
  'fileViewer.exportPptxConfirm': 'Exportar',
  'fileViewer.exportPptxRecommended': 'Recomendado',
  'fileViewer.exportingProgress': 'Exportando…',
  'fileViewer.exportSlideProgress': 'Exportando slide {current}/{total}…',
  'fileViewer.exportingElapsed': 'Exportando… {seconds}s',
  'fileViewer.exportSlideEta': 'Slide {current}/{total} · ~{seconds}s restantes',
  'fileViewer.exportFailed': 'Falha na exportação. Tente novamente.',
  'fileViewer.exportDone': 'Exportação concluída',
  'fileViewer.exportImageFailed': 'Não foi possível gerar a imagem desta peça. Tente de novo ou baixe em PDF.',
  'fileViewer.exportImageDegraded': 'Baixamos uma versão reduzida: sem a foto que você anexou e no tamanho da tela, não no da peça. Tente de novo — se repetir, avise que a gente investiga.',
  'fileViewer.exportImageModalSubtitle': 'Escolha um formato e baixe a prévia atual como imagem.',
  'fileViewer.exportImageFormatLabel': 'Formato',
  'fileViewer.exportImageSaving': 'Salvando imagem…',
  'fileViewer.exportImageSaved': 'Imagem salva',
  'fileViewer.exportImageDownloadStarted': 'Download iniciado',
  'fileViewer.exportImageDownloadDetails': '{filename} está nos downloads do navegador se a janela Salvar como não apareceu.',
  'fileViewer.exportJsx': 'Exportar como JSX',
  'fileViewer.exportReactHtml': 'Exportar prévia como HTML',
  'fileViewer.exportStarted': 'Exportação iniciada',
  'fileViewer.saveAsTemplate': 'Salvar como template…',
  'fileViewer.savingTemplate': 'Salvando template…',
  'fileViewer.savedTemplate': 'Salvo como "{name}"',
  'fileViewer.savedTemplateFail': 'Não foi possível salvar o template — tente novamente.',
  'fileViewer.templateNamePrompt': 'Nome do template',
  'fileViewer.templateNameDefault': 'Template sem título',
  'fileViewer.templateDescPrompt': 'Descrição curta (opcional — o que torna este template útil?)',
  'liveArtifact.refresh.button': 'Atualizar',
  'liveArtifact.refresh.buttonTitle': 'Atualizar este artefato ao vivo',
  'liveArtifact.refresh.loadingTitle': 'Carregando artefato ao vivo…',
  'liveArtifact.refresh.noSourceTitle': 'Ainda não há fonte de atualização somente leitura aprovada.',
  'liveArtifact.refresh.running': 'Atualizando…',
  'liveArtifact.refresh.runningMessage': 'Atualizando dados e prévia. Isso pode levar um momento.',
  'liveArtifact.refresh.runningAction': 'A prévia anterior continua visível até a atualização ter sucesso.',
  'liveArtifact.refresh.successOne': 'Atualização concluída. Dados atualizados.',
  'liveArtifact.refresh.successMany': 'Atualização concluída. Dados atualizados.',
  'liveArtifact.refresh.successAction': 'A prévia foi recarregada com os dados confirmados mais recentes.',
  'liveArtifact.refresh.previousFailure': 'Atualização anterior falhou: {message}',
  'liveArtifact.refresh.failureAction': 'Revise o histórico de atualização, corrija a fonte ou permissão e tente novamente.',
  'liveArtifact.refresh.networkFailure': 'A solicitação de atualização falhou. Verifique sua conexão e tente novamente.',
  'liveArtifact.refresh.genericFailure': 'Atualização falhou.',
  'liveArtifact.refresh.statusNever': 'Não atualizável',
  'liveArtifact.refresh.statusReady': 'Pronto para atualizar',
  'liveArtifact.refresh.statusSucceeded': 'Atualizado',
  'liveArtifact.refresh.statusFailed': 'Atualização falhou',
  'liveArtifact.refresh.statusRunning': 'Atualizando',
  'liveArtifact.refresh.statusRunningDescription': 'Uma execução de atualização está em andamento no momento.',
  'liveArtifact.refresh.statusSucceededDescription': 'A última atualização foi concluída com sucesso.',
  'liveArtifact.refresh.statusFailedDescription': 'A última tentativa de atualização não foi concluída com sucesso.',
  'liveArtifact.refresh.statusReadyDescription': 'Fontes atualizáveis estão configuradas, mas nenhuma execução está em andamento.',
  'liveArtifact.refresh.statusNeverDescription': 'Este artefato ao vivo ainda não tem fonte de atualização.',
  'liveArtifact.refresh.eventStarted': 'Iniciada',
  'liveArtifact.refresh.eventSucceeded': 'Bem-sucedida',
  'liveArtifact.refresh.eventFailed': 'Falhou',
  'liveArtifact.refresh.eventStartedDetail': 'Atualização iniciada…',
  'liveArtifact.refresh.sourcesUpdatedOne': '{n} fonte atualizada',
  'liveArtifact.refresh.sourcesUpdatedMany': '{n} fontes atualizadas',
  'liveArtifact.refresh.timelineEmpty': 'Ainda não há atividade de atualização nesta sessão. Acione Atualizar para registrar uma linha do tempo ou aguarde execuções automáticas.',
  'liveArtifact.refresh.heroLastRefreshedLabel': 'Última atualização',
  'liveArtifact.refresh.heroLastRefreshedNever': 'Nunca',
  'liveArtifact.refresh.justNow': 'agora mesmo',
  'liveArtifact.refresh.factCreated': 'Criado',
  'liveArtifact.refresh.factLastUpdated': 'Última atualização',
  'liveArtifact.refresh.factUnknown': 'Desconhecido',
  'liveArtifact.refresh.persistedTitle': 'Histórico de atualizações persistido',
  'liveArtifact.refresh.persistedHint': 'Entradas carregadas de refreshes.jsonl',
  'liveArtifact.refresh.persistedEmpty': 'Ainda não há histórico de atualizações persistido.',
  'liveArtifact.refresh.persistedStatusSucceeded': 'bem-sucedida',
  'liveArtifact.refresh.persistedStatusRunning': 'em execução',
  'liveArtifact.refresh.persistedStatusFailed': 'falhou',
  'liveArtifact.refresh.persistedStatusCancelled': 'cancelada',
  'liveArtifact.refresh.persistedStatusSkipped': 'ignorada',
  'liveArtifact.refresh.sessionTitle': 'Atividade da sessão',
  'liveArtifact.refresh.sessionHint': 'Eventos observados enquanto esta aba está aberta',
  'liveArtifact.refresh.docSourceTitle': 'Fonte do documento',
  'liveArtifact.refresh.docSourceHint': 'Fonte configurada',
  'liveArtifact.refresh.docSourceType': 'Tipo',
  'liveArtifact.refresh.docSourceTool': 'Ferramenta',
  'liveArtifact.refresh.docSourceConnector': 'Conector',
  'liveArtifact.refresh.debugSummary': 'Metadados avançados de depuração',
  'liveArtifact.refresh.debugNote': 'Pode incluir IDs de conectores, nomes de arquivos, metadados de fonte e caminhos internos de artefatos.',
  'liveArtifact.viewer.tabPreview': 'Prévia',
  'liveArtifact.viewer.tabCode': 'Código',
  'liveArtifact.viewer.tabData': 'Dados',
  'liveArtifact.viewer.tabRefreshHistory': 'Histórico de atualização',
  'liveArtifact.viewer.dataEmpty': 'Nenhum cache data.json disponível.',
  'liveArtifact.viewer.code.templateHeading': 'HTML do modelo',
  'liveArtifact.viewer.code.renderedHeading': 'HTML renderizado',
  'liveArtifact.viewer.code.templateHelp': 'O modelo editável usado com data.json para gerar a prévia.',
  'liveArtifact.viewer.code.renderedHelp': 'O index.html gerado atualmente carregado pela Prévia.',
  'liveArtifact.viewer.code.variantAria': 'Variante de código',
  'liveArtifact.viewer.code.variantTemplate': 'Modelo',
  'liveArtifact.viewer.code.variantRendered': 'Renderizado',
  'liveArtifact.viewer.code.loading': 'Carregando código…',
  'liveArtifact.viewer.code.unavailable': 'O código ainda não está disponível.',
  'liveArtifact.viewer.code.empty': 'Este arquivo de código está vazio.',
  'fileViewer.deployToVercel': 'Implantar na Vercel',
  'fileViewer.redeployToVercel': 'Implantar novamente',
  'fileViewer.deployingToVercel': 'Implantando na Vercel…',
  'fileViewer.deployProviderLabel': 'Provedor',
  'fileViewer.vercelProvider': 'Vercel',
  'fileViewer.cloudflarePagesProvider': 'Cloudflare Pages',
  'fileViewer.deployToProvider': 'Implantar em {provider}',
  'fileViewer.redeployToProvider': 'Implantar novamente em {provider}',
  'fileViewer.deployingToProvider': 'Implantando em {provider}…',
  'fileViewer.preparingPublicLink': 'Preparando link público…',
  'fileViewer.copyDeployLink': 'Copiar link',
  'fileViewer.deployModalTitle': 'Implantar',
  'fileViewer.deployModalSubtitle': 'Use a conta do provedor selecionado para implantar esta prévia HTML.',
  'fileViewer.vercelToken': 'Chave de acesso da Vercel',
  'fileViewer.vercelTokenGetLink': 'Obter a chave na Vercel',
  'fileViewer.vercelTokenPlaceholder': 'Cole aqui a sua chave da Vercel',
  'fileViewer.vercelTokenReuseHint': 'A chave já salva será usada. Digite uma nova para substituí-la.',
  'fileViewer.vercelTokenRequired': 'Antes, informe e salve uma chave de acesso da Vercel.',
  'fileViewer.cloudflareApiToken': 'Chave de acesso da Cloudflare',
  'fileViewer.cloudflareApiTokenGetLink': 'Obter a chave de acesso',
  'fileViewer.cloudflareApiTokenPlaceholder': 'Cole aqui a sua chave da Cloudflare',
  'fileViewer.cloudflareApiTokenReuseHint': 'A chave da Cloudflare já salva será usada. Digite uma nova para substituí-la.',
  'fileViewer.cloudflareApiTokenRequired': 'Antes, informe e salve uma chave de acesso da Cloudflare.',
  'fileViewer.cloudflareApiTokenScopeHint': 'Ao criar a chave, marque Pages Edit; domínios próprios também precisam de Zone Read e DNS Edit.',
  'fileViewer.vercelTeamId': 'ID da equipe',
  'fileViewer.vercelTeamSlug': 'Slug da equipe',
  'fileViewer.cloudflareAccountId': 'ID da conta',
  'fileViewer.cloudflareAccountIdHint': 'Encontre o ID da conta no painel da Cloudflare.',
  'fileViewer.cloudflareAccountIdRequired': 'Insira e salve primeiro um Cloudflare Account ID.',
  'fileViewer.cloudflareZoneLabel': 'Domínio',
  'fileViewer.cloudflareZonePlaceholder': 'Salve as configurações do Cloudflare para carregar os domínios',
  'fileViewer.cloudflareZoneRequired': 'Selecione primeiro um domínio do Cloudflare.',
  'fileViewer.cloudflareZonesLoading': 'Carregando domínios da Cloudflare…',
  'fileViewer.cloudflareZonesRefresh': 'Atualizar domínios',
  'fileViewer.cloudflareZonesLoadFailed': 'Não foi possível carregar os domínios do Cloudflare.',
  'fileViewer.cloudflareZonesEmpty': 'Nenhum domínio completo ativo do Cloudflare foi encontrado para esta conta.',
  'fileViewer.cloudflareDomainPrefixLabel': 'Prefixo de subdomínio',
  'fileViewer.cloudflareDomainPrefixPlaceholder': 'demo',
  'fileViewer.cloudflareDomainPrefixInvalid': 'Use apenas um rótulo DNS: letras minúsculas, números e hífens.',
  'fileViewer.cloudflareHostnamePreview': 'Prévia do domínio personalizado: {hostname}',
  'fileViewer.cloudflareCustomDomainHint': 'Opcional: vincule um domínio personalizado. Se deixar em branco, um link pages.dev ainda será criado.',
  'fileViewer.cloudflarePagesDevLinkLabel': 'URL do pages.dev',
  'fileViewer.cloudflareCustomDomainLinkLabel': 'Domínio personalizado',
  'fileViewer.optional': 'Opcional',
  'fileViewer.vercelPreviewOnly': 'As implantações são apenas Preview por enquanto.',
  'fileViewer.cloudflarePagesPreviewHint': 'Cloudflare Pages usa Direct Upload.',
  'fileViewer.savingConfig': 'Salvando…',
  'fileViewer.deployConfigSaveFailed': 'Não foi possível salvar as configurações da Vercel.',
  'fileViewer.deployFailed': 'Falha na implantação. Verifique as configurações da Vercel e tente novamente.',
  'fileViewer.deployProviderConfigSaveFailed': 'Não foi possível salvar as configurações de {provider}.',
  'fileViewer.deployProviderFailed': 'A implantação em {provider} falhou. Verifique as configurações e tente novamente.',
  'fileViewer.deployResultLabel': 'URL implantada',
  'fileViewer.deployLinkReady': 'Pronto',
  'fileViewer.deploySuccessToast': 'Implantação enviada com sucesso',
  'fileViewer.deploySuccessToastDetails': '{provider} · {url}',
  'fileViewer.deployLinkPreparingLabel': 'Link público pendente',
  'fileViewer.deployLinkDelayed': 'Seu site foi implantado. O provedor ainda está preparando o link público.',
  'fileViewer.deployLinkFailed': 'Falha no domínio personalizado',
  'fileViewer.deployLinkProtectedLabel': 'Proteção da implantação ativada',
  'fileViewer.deployLinkProtected': 'O site foi implantado, mas este link de prévia exige autenticação. Desative Deployment Protection ou use um domínio personalizado.',
  'fileViewer.retryLink': 'Tentar novamente agora',
  'questionForm.submit': 'Enviar',
  'questionForm.skip': 'Pular',
  'questionForm.locked': 'Respondido',
  'conv.switch': 'Trocar conversa',
  'conv.label': 'Conversa',
  'conv.heading': 'Conversas',
  'conv.new': '+ Nova',
  'conv.empty': 'Ainda não há conversas.',
  'conv.untitled': 'Conversa sem título',
  'conv.renameTooltip': 'Clique duas vezes para renomear',
  'conv.delete': 'Excluir conversa',
  'conv.deleteConfirm': 'Excluir "{title}"? Isso remove as mensagens.',
  'agentPicker.label': 'Agente',
  'agentPicker.modeChoose': 'Escolha o modo de execução',
  'agentPicker.localCli': 'CLI local',
  'agentPicker.daemonOff': 'daemon desligado',
  'agentPicker.byok': 'API · chave própria',
  'agentPicker.selectAgent': 'Selecione uma CLI de agente de código detectada',
  'agentPicker.noAgents': 'nenhum agente no PATH',
  'agentPicker.notInstalled': 'não instalado',
  'agentPicker.rescan': 'Reescanear agentes no PATH local',
  'tool.openInTab': 'Abrir {name} em uma aba',
  'tool.open': 'abrir',
  'tool.todos': 'Tarefas',
  'tool.todosExpand': 'Mostrar tarefas',
  'tool.todosCollapse': 'Ocultar tarefas',
  'tool.todosDone': 'Concluído',
  'tool.todosDismiss': 'Fechar lista de tarefas',
  'tool.write': 'Escrever',
  'tool.edit': 'Editar',
  'tool.read': 'Ler',
  'tool.delete': 'Excluir',
  'tool.bash': 'Bash',
  'tool.glob': 'Glob',
  'tool.grep': 'Grep',
  'tool.fetch': 'Buscar',
  'tool.search': 'Pesquisar',
  'tool.lines': '{n} linhas',
  'tool.changeSingular': 'alteração',
  'tool.changePlural': 'alterações',
  'tool.in': 'em {path}',
  'tool.hide': 'ocultar',
  'tool.output': 'saída',
  'tool.running': 'executando…',
  'tool.error': 'erro',
  'tool.done': 'concluído',
  'assistant.role': 'Assistente',
  'assistant.workingLabel': 'Trabalhando',
  'assistant.doneLabel': 'Concluído',
  'assistant.copyMarkdown': 'Copiar Markdown da resposta',
  'assistant.forkConversation': 'Bifurcar daqui',
  'assistant.forkingConversation': 'Bifurcando…',
  'assistant.shareToOpenDesign': 'Upstream PR',
  'assistant.shareToOpenDesignBusy': 'Preparando pacote…',
  'assistant.feedbackPrompt': 'Feedback',
  'assistant.feedbackPositive': 'Útil',
  'assistant.feedbackNegative': 'Não útil',
  'assistant.feedbackReasonTitle': 'Diga-nos o motivo',
  'assistant.feedbackReasonPositiveMatched': 'Entendeu meu pedido',
  'assistant.feedbackReasonPositiveVisual': 'Ficou bom',
  'assistant.feedbackReasonPositiveUseful': 'Estrutura útil',
  'assistant.feedbackReasonPositiveEasy': 'Fácil de continuar editando',
  'assistant.feedbackReasonPositiveDesignSystem': 'Seguiu o design system',
  'assistant.feedbackReasonNegativeMissed': 'Não atendeu ao meu pedido',
  'assistant.feedbackReasonNegativeVisual': 'A qualidade visual precisa melhorar',
  'assistant.feedbackReasonNegativeIncomplete': 'Saída incompleta',
  'assistant.feedbackReasonNegativeHard': 'Difícil de usar',
  'assistant.feedbackReasonNegativeDesignSystem': 'Não seguiu o design system',
  'assistant.feedbackReasonOther': 'Outro',
  'assistant.feedbackReasonPlaceholder': 'Adicione uma nota curta...',
  'assistant.feedbackReasonSubmit': 'Enviar',
  'assistant.emptyResponseLabel': 'Sem saída',
  'assistant.emptyResponseMessage': 'O provedor encerrou a solicitação sem retornar texto ou artefato. Tente outro modelo ou provedor, verifique a cota ou tente novamente.',
  'assistant.unfinishedLabel': 'Interrompido com trabalho pendente',
  'assistant.unfinishedSummary': '{n} tarefa(s) restante(s)',
  'assistant.unfinishedMore': '+{n} mais',
  'assistant.continueRemaining': 'Continuar tarefas restantes',
  'chat.resumeRunCta': 'Continuar a execução',
  'assistant.outTokens': '{n} saída',
  'assistant.producedFiles': 'Arquivos deste turno',
  'assistant.openFile': 'Abrir',
  'assistant.downloadFile': 'Baixar',
  'nextStep.title': 'Próximo passo',
  'nextStep.more': 'Mais',
  'nextStep.share': 'Compartilhar',
  'nextStep.download': 'Baixar',
  'nextStep.createDesignSystemTitle': 'Criar design system',
  'nextStep.createDesignSystemBody': 'Duplique este projeto num espaço de design system e comece uma passagem da IA a partir de todos os arquivos e referências atuais.',
  'nextStep.createDesignSystemBusy': 'Criando design system...',
  'nextStep.contribute': 'Contribuir',
  'nextStep.planGenerateTitle': 'Gerar a partir do documento',
  'nextStep.planGenerateBody': 'Use o plano aprovado em Markdown como fonte da verdade para a próxima execução de design.',
  'nextStep.planImproveTitle': 'Melhorar documento',
  'nextStep.planImproveBody': 'Refine o documento de plano atual antes de gerar o artefato final.',
  'nextStep.planGeneratePrompt': 'Use `{file}` como fonte da verdade. Leia o documento primeiro, preserve suas decisões e então gere o artefato de design final que corresponda a ele. Se for uma estrutura de slides, gere o deck; se for um plano de PRD/protótipo, gere o protótipo ou wireframes; se for um storyboard/briefing criativo, gere o artefato visual/de mídia correspondente. Antes de gerar, aponte quaisquer TODOs bloqueantes ou contradições que você não consiga resolver.',
  'nextStep.planImprovePrompt': 'Leia `{file}` e melhore-o no lugar como um documento de plano editável. Refine o escopo, preencha seções fracas, adicione verificações de aceitação faltantes e mantenha TODO/questões em aberto onde ainda for necessária a entrada do usuário. Ainda não gere o artefato de design final.',
  'nextStep.planImproveArtifactTitle': 'Melhorar artefato',
  'nextStep.planImproveArtifactBody': 'Continue iterando o artefato gerado em vez de voltar ao planejamento.',
  'nextStep.planImproveArtifactPrompt': 'Melhore `{artifact}` no lugar. Mantenha o artefato funcional existente e faça as melhorias de maior impacto em produto, visual, interação e conteúdo. Preserve o comportamento que já funciona e depois resuma os arquivos alterados e quaisquer riscos remanescentes.',
  'nextStep.planMergeTitle': 'Alinhar documento e artefato',
  'nextStep.planMergeBody': 'Reconcilie o plano e o artefato gerado para que avancem juntos.',
  'nextStep.planMergePrompt': 'Leia `{document}` e `{artifact}` juntos. Trate o documento como a intenção e o artefato como a implementação atual. Reconcilie-os: atualize o artefato para corresponder às decisões confirmadas, atualize o documento apenas onde estiver desatualizado e mantenha TODO/questões em aberto explícitos para tudo que ainda não estiver resolvido. Preserve o comportamento funcional existente e resuma o que mudou em ambos os arquivos.',

  'nextStep.projectContinueTitle': 'Continuar trabalhando',
  'nextStep.projectGenerateArtifactTitle': 'Gerar artefato',
  'nextStep.designSystemAiRefineTitle': 'Refinar design system com IA',
  'nextStep.designSystemAuditKitTitle': 'Revisar cores, fontes e kit',

  'nextStep.brandAiOptimizeTitle': 'Refinar design system extraído',
  'nextStep.brandAiOptimizeBody': 'Inicia uma revisão automática que consome créditos do seu plano, relê a fonte da marca e atualiza este design system aqui mesmo.',
  'nextStep.brandCreateDesignTitle': 'Criar com este design system',
  'nextStep.brandCreateDesignBody': 'Comece um novo design usando as cores, tipografia, assets e orientações do sistema extraídos.',
  'nextStep.brandCreateDesignPrompt': 'Criar um novo design com o design system {designSystem}.',

  'nextStep.brandContinueExtractionTitle': 'Continuar extração',
  'nextStep.brandContinueExtractionBody': 'Depois que a aba Browser passar por qualquer verificação, leia-a e continue preenchendo o kit salvo.',
  'nextStep.brandContinueExtractionBusy': 'Continuando extração...',
  'nextStep.brandContinueAiExtractionTitle': 'Continuar com agente',
  'nextStep.brandContinueAiExtractionProgrammaticBody': 'Use o agente selecionado para extrair do rascunho salvo caso a passagem programática ainda não consiga concluir.',
  'nextStep.brandContinueAiExtractionAiBody': 'Retome o agente selecionado a partir do esboço de marca atual e finalize o mesmo design system.',
  'nextStep.brandContinueAiExtractionBusy': 'Continuando com agente...',
  'nextStep.createDesignBusy': 'Criando design...',
  'assistant.thinking': 'Pensando',
  'assistant.thought': 'Pensou',
  'assistant.thoughtFor': 'Pensou por {s}s',
  'assistant.systemReminder': 'Lembrete do sistema',
  'assistant.possiblePromptInjection': 'Possível tentativa de enganar o assistente',
  'assistant.waitingFirstOutput': 'Aguardando primeira saída',
  'assistant.statusBootingAgent': 'Iniciando agente',
  'assistant.statusPreparing': 'Preparando...',
  'assistant.statusStarting': 'Iniciando',
  'assistant.statusRequesting': 'Enviando solicitação',
  'assistant.statusThinking': 'Pensando',
  'assistant.statusStreaming': 'Transmitindo',
  'assistant.slowHint': 'Está demorando mais que o normal. O formulário geralmente aparece em 5–10 s — você pode Parar e reformular.',
  'assistant.verbEditing': 'Editando',
  'assistant.verbWriting': 'Escrevendo',
  'assistant.verbReading': 'Lendo',
  'assistant.verbSearching': 'Pesquisando',
  'assistant.verbRunning': 'Executando',
  'assistant.verbTodos': 'Tarefas',
  'assistant.verbFetching': 'Buscando',
  'assistant.verbCalling': 'Chamando',
  'qf.answered': 'respondido',
  'qf.choose': 'Escolha…',
  'qf.customLabel': 'Resposta personalizada',
  'qf.customPlaceholder': 'Digite sua própria resposta...',
  'qf.otherOption': 'Outro',
  'qf.required': 'obrigatório',
  'qf.lockedSubmitted': 'Respostas enviadas — o agente usará isso pelo resto da sessão.',
  'qf.lockedPrev': 'Este formulário é de um turno anterior.',
  'qf.hint': 'Escolha o que se encaixa. Pule campos opcionais se não se importar — o agente usará padrões sensatos.',
  'qf.submitDefault': 'Enviar respostas',
  'qf.submitDisabledTitle': 'Preencha os campos obrigatórios primeiro',
  'qf.submitTitle': 'Enviar respostas',
  'qf.cardSelected': 'selecionado',
  'qf.cardRefs': 'Refs:',
  'qf.cardSampleText': 'A rápida raposa marrom · 0123',
  'questions.tabLabel': 'Perguntas',
  'questions.banner': 'Posso fazer algumas perguntas rápidas?',
  'questions.bannerAnswered': 'Perguntas respondidas',
  'questions.continue': 'Continuar',
  'questions.generating': 'Gerando perguntas…',
  'questions.skipAll': 'Pular tudo',
  'questions.autoSkipHint': 'Continua automaticamente quando o cronômetro termina',
  'questions.submitting': 'Enviando…',
  'sketch.toolSelect': 'Selecionar (sem ação)',
  'sketch.toolPen': 'Caneta',
  'sketch.toolText': 'Texto',
  'sketch.toolRect': 'Retângulo',
  'sketch.toolArrow': 'Seta',
  'sketch.toolEraser': 'Borracha',
  'sketch.color': 'Cor',
  'sketch.strokeSize': 'Espessura do traço',
  'sketch.undo': 'Desfazer',
  'sketch.clear': 'Limpar',
  'sketch.close': 'Fechar',
  'sketch.closeConfirm': 'Fechar o esboço e descartar as alterações não salvas?',
  'sketch.textPrompt': 'Texto:',
  'sketch.textModalTitle': 'Adicionar texto',
  'critiqueTheater.userFacingName': 'Revisão de design',
  'critiqueTheater.roleDesigner': 'Designer',
  'critiqueTheater.roleCritic': 'Crítico',
  'critiqueTheater.roleBrand': 'Marca',
  'critiqueTheater.roleA11y': 'Acessibilidade',
  'critiqueTheater.roleCopy': 'Texto',
  'critiqueTheater.roundLabel': 'Rodada {n} de {m}',
  'critiqueTheater.mustFix': '{n} correção obrigatória',
  'critiqueTheater.composite': 'Composto',
  'critiqueTheater.threshold': 'Limite',
  'critiqueTheater.consensus': 'Consenso',
  'critiqueTheater.interrupt': 'Interromper',
  'critiqueTheater.interrupting': 'Interrompendo…',
  'critiqueTheater.interrupted': 'Interrompido',
  'critiqueTheater.degradedHeading': 'Painel offline nesta execução',
  'critiqueTheater.degradedReasonMalformed': 'Saída do painel malformada (o parser rejeitou o bloco).',
  'critiqueTheater.degradedReasonOversize': 'A saída do painel excedeu o limite seguro de bytes.',
  'critiqueTheater.degradedReasonAdapter': 'O adaptador {adapter} não suportou o protocolo Critique.',
  'critiqueTheater.degradedReasonProtocol': 'O adaptador {adapter} enviou uma versão de protocolo não suportada.',
  'critiqueTheater.degradedReasonMissingArtifact': 'A execução terminou sem um artefato final.',
  'critiqueTheater.replay': 'Reproduzir',
  'critiqueTheater.replaySpeed': 'Velocidade de reprodução',
  'critiqueTheater.readOnly': 'Somente leitura',
  'critiqueTheater.shippedSummary': 'Entregue na rodada {round} · composto {composite}',
  'critiqueTheater.interruptedSummary': 'Interrompido na rodada {round} · melhor composto {composite}',
  'critiqueTheater.shippedBadge': 'Publicado',
  'critiqueTheater.belowThresholdBadge': 'Abaixo do limite',
  'critiqueTheater.timedOutBadge': 'Tempo esgotado',
  'critiqueTheater.failedHeading': 'Falha na execução',
  'critiqueTheater.failedReasonCliExit': 'A ferramenta de linha de comando terminou com erro antes de o painel concluir.',
  'critiqueTheater.failedReasonPerRoundTimeout': 'Uma rodada excedeu seu limite de tempo.',
  'critiqueTheater.failedReasonTotalTimeout': 'A execução completa excedeu seu limite total de tempo.',
  'critiqueTheater.failedReasonOrchestrator': 'Erro interno do orquestrador.',
  'critiqueTheater.transcriptEmpty': 'Ainda não há transcrição para reproduzir. Execute uma crítica para gravar uma.',
  'critiqueTheater.transcriptLoading': 'Carregando transcrição…',
  'critiqueTheater.transcriptError': 'Não foi possível carregar a transcrição: {error}',
  'critiqueTheater.replaySpeedPaused': 'Pausado',
  'critiqueTheater.replaySpeedInstant': 'Instantâneo',
  'critiqueTheater.replaySpeedLive': 'Ao vivo',
  'critiqueTheater.replaySpeedFast': 'Rápido',
  'critiqueTheater.settingsNav': 'Revisão de design',
  'critiqueTheater.settingsNavHint': 'Revisão de design com cinco pareceres para as suas criações',
  'critiqueTheater.settingsEnabledLabel': 'Mostrar a revisão de design durante as criações',
  'critiqueTheater.settingsEnabledDescription': 'Quando ativado, uma revisão com cinco pareceres aparece junto das criações e avalia a arte antes da publicação. Você pode interromper a qualquer momento.',
  'critiqueTheater.settingsEnabledProjectHint': 'Salvo para este projeto. Novas criações neste projeto passam pela revisão de design no servidor.',
  'critiqueTheater.settingsEnabledNoProjectHint': 'Abra um projeto para persistir isso no servidor. Até lá, isso altera apenas a preferência no navegador.',
  'pet.title': 'Bichinhos',
  'pet.subtitle': 'Adote um companheirinho que flutua sobre o seu workspace.',
  'pet.navTitle': 'Bichinhos',
  'pet.navHint': 'Adote ou personalize',
  'pet.tabBuiltIn': 'Inclusos',
  'pet.tabBuiltInHint': 'Companheiros incluídos no Crie3 — escolha um e adote.',
  'pet.builtInEmpty': 'Os pets integrados não estão disponíveis agora. Atualize a aba Comunidade quando o daemon voltar.',
  'pet.tabCustom': 'Personalizado',
  'pet.tabCustomHint': 'Defina nome, glifo, cor ou envie um sprite.',
  'pet.tabCommunity': 'Comunidade',
  'pet.tabCommunityHint': 'Bichinhos chocados pelo Codex — adote ou gere um novo com IA.',
  'pet.tabsAria': 'Fonte do bichinho',
  'pet.adopt': 'Adotar',
  'pet.adoptedBadge': 'Adotado',
  'pet.adoptCallout': 'Adote um bichinho',
  'pet.changePet': 'Trocar bichinho',
  'pet.wake': 'Acordar',
  'pet.tuck': 'Esconder',
  'pet.wakeTitle': 'Acordar o bichinho — mostrar o overlay.',
  'pet.tuckTitle': 'Esconder o bichinho — ocultar o overlay.',
  'pet.settingsTitle': 'Abrir configurações do bichinho',
  'pet.useCustom': 'Usar meu bichinho',
  'pet.customTitle': 'Crie o seu',
  'pet.customHint': 'Escolha nome, símbolo e cor de destaque — o overlay atualiza ao vivo.',
  'pet.customGreetingPlaceholder': 'Diga oi pelo seu bichinho…',
  'pet.fieldName': 'Nome',
  'pet.fieldGlyph': 'Símbolo',
  'pet.fieldGlyphHint': 'Um único emoji funciona melhor (por ex. 🐝, 🦄, 🐢).',
  'pet.fieldGreeting': 'Saudação',
  'pet.fieldAccent': 'Cor de destaque',
  'pet.fieldAccentCustom': 'Cor personalizada',
  'pet.fieldAccentDefault': 'Cor de destaque padrão',
  'pet.overlayAria': 'Companheiro',
  'pet.spriteAria': '{name} — arraste para mover, clique para conversar',
  'pet.spriteTitle': 'Olá de {name}! Clique para conversar.',
  'pet.taskSummarySingle': '{count} tarefa do agent em execução.',
  'pet.taskSummaryMultiple': '{count} tarefas do agent em execução em {projects} projetos.',
  'pet.taskSummaryRecentSingle': '{count} tarefa do agent concluída recentemente.',
  'pet.taskSummaryRecentMultiple': '{count} tarefas de agent concluídas recentemente.',
  'pet.taskListAria': 'Tarefas de agent ativas',
  'pet.taskOpenProject': 'Abrir {project}',
  'pet.taskGroup.running': 'Em execução',
  'pet.taskGroup.queued': 'Aguardando',
  'pet.taskGroup.recent': 'Concluídas recentemente',
  'pet.idleQuote.leonardo.text': 'Aprender nunca esgota a mente.',
  'pet.idleQuote.leonardo.author': 'Leonardo da Vinci',
  'pet.idleQuote.michelangelo.text': 'Vi o anjo no mármore e esculpi até libertá-lo.',
  'pet.idleQuote.michelangelo.author': 'Michelangelo',
  'pet.idleQuote.bernini.text': 'Há dois recursos que podem ajudar o escultor: a luz e a sombra.',
  'pet.idleQuote.bernini.author': 'Gian Lorenzo Bernini',
  'pet.idleQuote.raphael.text': 'Quando se está pintando, não se pensa.',
  'pet.idleQuote.raphael.author': 'Rafael',
  'pet.idleQuote.caravaggio.text': 'Todas as obras, não importa o quê ou por quem pintadas, não passam de bagatelas e ninharias infantis, a menos que sejam feitas e pintadas a partir da vida.',
  'pet.idleQuote.caravaggio.author': 'Caravaggio',
  'pet.idleQuote.rodin.text': 'O essencial é se comover, amar, esperar, tremer, viver.',
  'pet.idleQuote.rodin.author': 'Auguste Rodin',
  'pet.composerTitle': 'Bichinhos — acordar, esconder ou escolher',
  'pet.composerMenuTitle': 'Bichinhos',
  'pet.composerMenuHint': 'dica: digite /pet para alternar',
  'pet.composerOpenSettings': 'Gerenciar pets',
  'pet.welcomeTeaserTitle': 'Adote um bichinho',
  'pet.welcomeTeaserBody': 'Um companheirinho que flutua pelo workspace.',
  'pet.welcomeTeaserCta': 'Escolher',
  'pet.imageUpload': 'Enviar sprite',
  'pet.imageReplace': 'Substituir sprite',
  'pet.imageRemove': 'Usar emoji',
  'pet.imageHintIdle': 'PNG, JPG, WebP, GIF ou SVG. Spritesheet? Envie uma faixa horizontal e ajuste o número de frames.',
  'pet.imageHintActive': 'Mostrando seu sprite. Defina frames > 1 para animar um spritesheet horizontal.',
  'pet.fieldFrames': 'Frames',
  'pet.fieldFramesHint': '1 = estático. > 1 = spritesheet horizontal.',
  'pet.fieldFps': 'Velocidade (fps)',
  'pet.fieldFpsHint': 'Velocidade da animação dos frames.',
  'pet.atlasImport': 'Importar sprite do Codex',
  'pet.atlasImportTitle': 'Importe um atlas hatch-pet 8x9 / 192x208 (PNG ou WebP).',
  'pet.atlasPickerTitle': 'Escolha uma linha de animação',
  'pet.atlasPickerHint': 'Os pets do Codex trazem 9 linhas de animação. Por padrão mantemos o atlas inteiro para que o pet troque de linha ao passar o mouse, conforme a direção do arrasto e após longa ociosidade. Você também pode fixar uma única linha.',
  'pet.atlasCancel': 'Descartar atlas',
  'pet.atlasAdopt': 'Fixar nesta linha',
  'pet.atlasAdoptFull': 'Usar atlas inteiro (animado)',
  'pet.atlasAdoptFullTitle': 'Mantém todas as linhas para o pet reagir a hover, direção do arrasto e ociosidade longa.',
  'pet.atlasAdoptRowTitle': 'Corta apenas a linha destacada em uma tira de loop único.',
  'pet.atlasActiveHint': 'Atlas animado ativo — o pet escolhe a linha com base na sua interação (hover, arrasto, ociosidade).',
  'pet.atlasRow.idle': 'Parado',
  'pet.atlasRow.running-right': 'Corre à direita',
  'pet.atlasRow.running-left': 'Corre à esquerda',
  'pet.atlasRow.waving': 'Acenando',
  'pet.atlasRow.jumping': 'Pulando',
  'pet.atlasRow.failed': 'Falhou',
  'pet.atlasRow.waiting': 'Esperando',
  'pet.atlasRow.running': 'Correndo',
  'pet.atlasRow.review': 'Revisão',
  'pet.hatchTitle': 'Choque um novo pet com IA',
  'pet.hatchHint': 'Use a skill hatch-pet incluída no chat para gerar um spritesheet estilo Codex e depois importe-o aqui.',
  'pet.hatchConcept': 'Conceito do pet (opcional)',
  'pet.hatchConceptPlaceholder': 'ex.: um shiba pixel art com um suéter aconchegante',
  'pet.hatchCopy': 'Copiar prompt',
  'pet.hatchCopied': 'Copiado!',
  'pet.hatchFoot': 'Quando a skill salvar seu pet, volte aqui e clique em "Importar sprite do Codex".',
  'pet.slashPopoverAria': 'Comandos slash',
  'pet.slashPopoverTitle': 'Comandos',
  'pet.slashPopoverHint': '↑↓ navegar · enter escolher · esc fechar',
  'pet.slashPet': 'Alternar, adotar ou abrir as configurações do pet.',
  'pet.slashPetWake': 'Acordar o pet flutuante.',
  'pet.slashPetTuck': 'Guardar o pet por agora.',
  'pet.slashHatch': 'Gere um pet Codex com a skill hatch-pet.',
  'pet.slashHatchArg': '<conceito>',
  'pet.slashSearch': 'Pesquise na web pelo comando OD research.',
  'pet.slashSearchArg': '<consulta>',
  'pet.codexTitle': 'Recém-chocados',
  'pet.codexSubtitle': 'Pets empacotados pela skill hatch-pet aparecem aqui para adoção em um clique.',
  'pet.codexSubtitleWithDir': 'Verificando {dir} em busca de pacotes do hatch-pet.',
  'pet.codexEmpty': 'Ainda sem pets chocados. Digite /hatch no chat para gerar um.',
  'pet.codexLoading': 'Procurando pets chocados…',
  'pet.codexRefresh': 'Atualizar',
  'pet.codexAdopt': 'Adotar',
  'pet.codexAdopting': 'Adotando…',
  'pet.communitySync': 'Baixar pets da comunidade',
  'pet.communitySyncing': 'Baixando…',
  'pet.communitySyncTitle': 'Sincronizar os pets mais recentes do Codex Pet Share + j20 Hatchery em ~/.codex/pets/.',
  'pet.communitySyncDone': '{wrote} pets novos sincronizados ({total} no total).',
  'pet.communitySyncFailed': 'Falha na sincronização: {error}',
  'pet.codexBundled': 'Incluído',
  'pet.codexBundledTitle': 'Já vem com o Crie3 — sem download.',
  'settings.notifications': 'Notificações',
  'settings.notificationsHint': 'Som e notificação na conclusão da tarefa',
  'settings.notifyCompletionSound': 'Som de conclusão',
  'settings.notifyCompletionSoundHint': 'Toca ao terminar uma rodada. Desativado por padrão.',
  'settings.notifySuccessSound': 'Som de sucesso',
  'settings.notifyFailureSound': 'Som de falha',
  'settings.notifyDesktop': 'Notificação na área de trabalho',
  'settings.notifyDesktopHint': 'Enviada quando a janela não está em foco.',
  'settings.notifyDesktopBlocked': 'Bloqueadas pelo navegador. Habilite nas configurações do site.',
  'settings.notifyDesktopUnsupported': 'Notificações na área de trabalho indisponíveis neste ambiente.',
  'settings.notifyTest': 'Enviar teste',
  'settings.notifyTestSent': 'Notificação de teste enviada. Se nenhum banner aparecer, verifique as notificações do navegador e do sistema.',
  'settings.notifyTestFailed': 'Falha ao chamar a notificação. Verifique as notificações do navegador e do sistema.',
  'settings.notifySoundDing': 'Tilim',
  'settings.notifySoundChime': 'Carrilhão',
  'settings.notifySoundTwoToneUp': 'Dois tons crescente',
  'settings.notifySoundPluck': 'Dedilhado',
  'settings.notifySoundBuzz': 'Zumbido',
  'settings.notifySoundTwoToneDown': 'Dois tons descendente',
  'settings.notifySoundThud': 'Baque',
  'settings.skills': 'Habilidades',
  'settings.skillsHint': 'Habilidades funcionais que o agente pode invocar durante a tarefa',
  'settings.skillsNew': 'Nova habilidade',
  'settings.skillsEmpty': 'Selecione uma habilidade à esquerda ou crie uma nova.',
  'settings.skillsEdit': 'Editar',
  'settings.skillsDelete': 'Excluir',
  'settings.skillsDeleteConfirm': 'Confirmar exclusão',
  'settings.skillsName': 'Nome',
  'settings.skillsTriggers': 'Gatilhos (separados por vírgulas ou novas linhas)',
  'settings.skillsDescription': 'Descrição',
  'settings.skillsBody': 'Corpo do SKILL.md',
  'settings.skillsCreate': 'Criar',
  'settings.skillsSave': 'Salvar',
  'settings.skillsSaving': 'Salvando…',
  'settings.skillsOverrideCreate': 'Criar substituição do usuário',
  'settings.skillsOverrideSave': 'Salvar como substituição do usuário',
  'settings.skillsBuiltInOverrideWarning': 'Editar esta habilidade integrada cria uma substituição do usuário. A entrada integrada ficará oculta na lista até você excluir a substituição. Continuar?',
  'settings.skillsFiles': 'Arquivos',
  'settings.skillsNoFiles': 'Nenhum arquivo nesta pasta de habilidade.',
  'settings.skillsNameRequired': 'O nome da habilidade é obrigatório.',
  'settings.skillsBodyRequired': 'O conteúdo da habilidade é obrigatório.',
  'settings.designSystems': 'Design systems',
  'settings.designSystemsHint': 'Explore e ative os design systems disponíveis',
  'settings.designSystemsInstalled': 'Instalados',
  'settings.designSystemsAdd': 'Adicionar design system',
  'settings.designSystemsHiddenCount': '{count} ocultos da galeria inicial',
  'settings.designSystemsShowAll': 'Mostrar todos',
  'settings.designSystemsShowHidden': 'Mostrar ocultos',
  'settings.designSystemsSource': 'Origem',
  'settings.designSystemsSourceLocal': 'Local',
  'settings.designSystemsSourceGithub': 'GitHub',
  'settings.designSystemsSourceShadcn': 'shadcn',
  'settings.designSystemsShadcnReference': 'Referência do registro shadcn',
  'settings.designSystemsImportShadcn': 'Importar do shadcn',
  'settings.designSystemsStructure': 'Estrutura',
  'settings.designSystemsModeHybrid': 'Híbrido',
  'settings.designSystemsModeNormalized': 'Normalizado',
  'settings.designSystemsModeVerbatim': 'Literal',
  'settings.designSystemsCraft': 'Ofício',
  'settings.designSystemsCraftColor': 'Cor',
  'settings.designSystemsCraftAccessibility': 'Acessibilidade',
  'settings.designSystemsGithubUrl': 'URL do GitHub',
  'settings.designSystemsProjectPath': 'Caminho do projeto',
  'settings.designSystemsImportGithub': 'Importar do GitHub',
  'settings.designSystemsImportProject': 'Importar do projeto',
  'settings.designSystemsImportedStatus': '{title} importado',
  'settings.designSystemsViewImported': 'Ver design system importado',
  'settings.designSystemsCategory': 'Categoria',
  'settings.designSystemsAllCategories': 'Todas as categorias',
  'settings.designSystemsShowInHomeGallery': 'Mostrar na galeria inicial',
  'settings.projectLocations': 'Locais de projetos',
  'settings.projectLocationsHint': 'Raízes de armazenamento do workspace',
  'settings.projectLocationsDescription': 'Adicione bases de trabalho que podem conter várias pastas de projetos do Crie3. Novos projetos são salvos como uma pasta dentro da base selecionada.',
  'settings.projectLocationsSaveError': 'Não foi possível salvar os locais de projetos. Verifique se cada caminho é uma pasta acessível.',
  'settings.projectLocationsSaved': 'Locais de projetos salvos.',
  'settings.projectLocationsScanError': 'Não foi possível escanear os locais de projetos.',
  'settings.projectLocationsScanComplete': 'Escaneamento concluído: {imported} importados, {existing} já registrados.',
  'settings.projectLocationsNoFolderSelected': 'Nenhuma pasta selecionada.',
  'settings.projectLocationsDuplicate': 'Essa base de trabalho já foi adicionada.',
  'settings.projectLocationsWorkBaseMeta': 'Base de trabalho · projetos são criados aqui como subpastas',
  'settings.projectLocationsAddFolder': 'Adicionar pasta…',
  'settings.projectLocationsDefaultBadge': 'Local padrão',
  'settings.projectLocationsMakeDefault': 'Tornar padrão',
  'settings.projectLocationsDefaultSaved': 'Local padrão do projeto atualizado.',
  'settings.librarySkills': 'Habilidades',
  'settings.libraryDesignSystems': 'Sistemas de design',
  'settings.librarySearch': 'Pesquisar...',
  'settings.libraryAll': 'Todos',
  'settings.libraryPreview': 'Visualizar',
  'settings.libraryPreviewClose': 'Fechar',
  'settings.libraryLoading': 'Carregando...',
  'settings.libraryNoResults': 'Nenhum item corresponde à sua pesquisa.',
  'settings.libraryEnabled': 'Ativado',
  'settings.libraryDisabled': 'Desativado',
  'settings.connectorsNavHint': 'Conexões com sistemas externos',
  'settings.connectorsHint': 'Gerencie configurações de conectores e provedores de ferramentas para este dispositivo.',
  'settings.connectorsComposioApiKey': 'Chave de API da Composio',
  'settings.connectorsSavedTitle': 'Salva no daemon local',
  'settings.connectorsSavedWithTail': 'Salva · ••••{tail}',
  'settings.connectorsSaved': 'Salva',
  'settings.connectorsGetApiKey': 'Obter chave de API',
  'settings.connectorsReplaceKeyPlaceholder': 'Cole uma nova chave para substituir a salva',
  'settings.connectorsApiKeyPlaceholder': 'Cole a chave de API da Composio',
  'settings.connectorsClear': 'Limpar',
  'settings.connectorsClearConfirmTitle': 'Limpar a chave de API do Composio salva?',
  'settings.connectorsClearConfirmBody': 'Remover a chave desconecta todos os conectores do Composio vinculados a este workspace. Contas conectadas, autorizações OAuth e acessos a ferramentas serão removidos.',
  'settings.connectorsClearConfirmContinue': 'Continuar',
  'settings.connectorsClearFinalTitle': 'Isso vai desconectar todos os conectores',
  'settings.connectorsClearFinalBody': 'Não há como desfazer. Você precisará reconectar cada integração do zero depois de colar uma nova chave.',
  'settings.connectorsClearFinalConfirm': 'Apagar chave e desconectar',
  'settings.connectorsClearArming': 'Um instante…',
  'settings.connectorsClearCancel': 'Cancelar',
  'settings.connectorsSaveKey': 'Salvar chave',
  'settings.connectorsSaveKeyTitle': 'Enviar esta chave para o daemon local',
  'settings.connectorsKeySaving': 'Salvando…',
  'settings.connectorsKeySaved': 'Salvo ✓',
  'settings.connectorsKeyError': 'Não foi possível salvar a chave. Confirme que o daemon local está ativo e tente novamente.',
  'settings.connectorsHelpSaved': 'Sua chave desbloqueia o catálogo abaixo e permanece no daemon local. Cole uma nova chave para substituí-la ou limpe para remover.',
  'settings.connectorsHelpUnsaved': 'Alterações não salvas — clique em Salvar chave para armazenar esta credencial no daemon local e desbloquear o catálogo abaixo.',
  'settings.connectorsHelpEmpty': 'Adicione uma chave para desbloquear o catálogo abaixo. As chaves são armazenadas localmente no daemon e nunca enviadas por variáveis de ambiente.',
  'settings.connectorsLoadingSavedKey': 'Procurando uma chave salva no daemon local…',
  'settings.autosaveSaving': 'Salvando…',
  'settings.autosaveSaved': 'Todas as alterações foram salvas',
  'settings.autosaveError': 'Não foi possível salvar as alterações. O daemon local pode estar offline.',
  'settings.libraryToggleLabel': 'Alternar',
  'settings.memory': 'Memória',
  'settings.memoryHint': 'Fatos sobre a sua igreja, guardados para as próximas conversas',
  'settings.customInstructionsTitle': 'Regras globais',
  'settings.customInstructionsHint': 'Instruções fixas que o Crie3 deve seguir em todos os chats. Salve fatos, preferências e contexto do projeto como memórias.',
  'settings.customInstructionsPlaceholder': 'ex.: "Nosso nome é Igreja Batista Vida Nova. Use sempre o versículo na tradução NVI. Não use imagens de pessoas."',
  'settings.memoryDescription': 'Auto-extracted facts about you and your preferences. Saved as Markdown files and folded into every chat.',
  'settings.memoryEnabled': 'Ativada',
  'settings.memoryDisabled': 'Desativada',
  'settings.memoryEnableLabel': 'Ativar injeção de memória',
  'settings.memoryDisabledBanner': 'A memória está atualmente DESATIVADA. Os fatos existentes são preservados no disco, mas não serão incorporados a novos chats e os novos turnos não extrairão nada novo.',
  'settings.memoryNew': 'Nova memória',
  'settings.memoryEdit': 'Editar',
  'settings.memoryDelete': 'Excluir',
  'settings.memoryPreview': 'Visualizar',
  'settings.memoryEmpty': 'Nenhuma memória ainda.',
  'settings.memoryEmptyHintZh': '记住: 用户偏好深色主题',
  'settings.memoryEmptyHintEn': 'Prefiro o modo escuro',
  'settings.memoryName': 'Name',
  'settings.memoryDesc': 'One-line description',
  'settings.memoryBody': 'Memory body (Markdown supported)',
  'settings.memoryBodyHint': 'Lead with the rule itself; add Why and How to apply lines.',
  'settings.memoryStartersLabel': 'Precisa de um ponto de partida? Clique para preencher o formulário:',
  'settings.memoryStarterUserName': 'Minha igreja',
  'settings.memoryStarterUserDesc': 'Quem somos, para o Crie3 não perguntar de novo a cada conversa',
  'settings.memoryStarterUserBody': '- Igreja: Comunidade Vida Nova, bairro Santa Rita\n- Pastor: Márcio Alves\n- Cultos: domingo 19h e quarta 20h\n- Redes: @vidanovasantarita\n\nQuando aplicar: qualquer conversa — use esses dados nas peças sem precisar perguntar.',
  'settings.memoryStarterFeedbackName': 'Como gostamos das artes',
  'settings.memoryStarterFeedbackDesc': 'Letra grande, pouco texto, tom sóbrio',
  'settings.memoryStarterFeedbackBody': '- Letra: grande o bastante para ler do fundo do templo\n- Texto: no máximo uma frase por slide\n- Tom: sóbrio, sem exageros de efeito\n\nPor quê: quem lê está longe da tela, e no celular a tela é pequena.\nQuando aplicar: sempre que gerar slides, posts ou cards.',
  'settings.memoryStarterProjectName': 'Projeto atual',
  'settings.memoryStarterProjectDesc': 'Crie3 v0.5 — editor de design conduzido por chat',
  'settings.memoryStarterProjectBody': '- Objetivo: lançar o editor orientado por chat neste trimestre\n- Prioridades: renderização em streaming, multimodal local, offline-first\n- Stack: Next.js 16, daemon Express, SQLite\n\nQuando aplicar: em qualquer conversa sobre este projeto.',
  'settings.memorySaveHint': 'Não salvo automaticamente — clique em Criar / Salvar para aplicar.',
  'settings.memoryIndexSaveHint': 'As edições no índice não são salvas automaticamente — clique em Salvar índice para aplicar.',
  'settings.memoryIndexUnsaved': 'Alterações não salvas',
  'settings.memoryFlashCreated': '✓ Memória criada',
  'settings.memoryFlashSaved': '✓ Memória salva',
  'settings.memoryFlashDeleted': '✓ Memória excluída',
  'settings.memoryFlashIndexSaved': '✓ Índice salvo',
  'settings.memoryFlashPathCopied': '✓ Caminho copiado',
  'settings.memoryNameLabel': 'Título',
  'settings.memoryTypeLabel': 'Tipo',
  'settings.memoryDescLabel': 'Descrição',
  'settings.memoryBodyLabel': 'Conteúdo',
  'settings.memoryTypeUser': 'Usuário',
  'settings.memoryTypeFeedback': 'Feedback',
  'settings.memoryTypeProject': 'Projeto',
  'settings.memoryTypeReference': 'Referência',
  'artifact.odCardTaskBriefChip': 'Memória aplicada · ver briefing',
  'artifact.odCardScorecardTitle': 'Autoverificação',
  'artifact.odCardScorecardStatusPass': 'Aprovado',
  'artifact.odCardScorecardStatusPartial': 'Parcial',
  'artifact.odCardScorecardStatusFail': 'Precisa de ajustes',
  'artifact.odCardRuleKicker': 'Regra proposta',
  'artifact.odCardRuleNameLabel': 'Nome',
  'artifact.odCardRuleDescriptionLabel': 'Descrição',
  'artifact.odCardRuleAssertionLabel': 'Deve valer',
  'artifact.odCardRuleCheckLabel': 'Como verificar',
  'artifact.odCardRuleRationaleLabel': 'Por quê',
  'artifact.odCardRuleKeep': 'Manter',
  'artifact.odCardRuleEdit': 'Editar',
  'artifact.odCardRuleDone': 'Concluído',
  'artifact.odCardRuleDiscard': 'Descartar',
  'artifact.odCardRuleSaving': 'Salvando…',
  'artifact.odCardRuleSaved': 'Salvou “{name}” como regra',
  'artifact.odCardRuleError': 'Não foi possível salvar a regra. Tente novamente.',
  'artifact.odCardBrandAssistDone': 'Browser assist confirmed',
  'artifact.odCardBrandAssistKicker': 'Assistência do navegador necessária: {reason}',
  'artifact.odCardBrandAssistBody': 'Open Browser and clear any human check. Then click More, choose Download Page, wait for the saved snapshot success, and use the left Next Step card to continue extraction.',
  'artifact.odCardBrandAssistError': 'Não foi possível iniciar a assistência do navegador. Tente novamente.',
  'artifact.odCardBrandAssistWorking': 'Iniciando...',
  'artifact.odCardBrandAssistConfirm': 'Abrir assistência do navegador',
  'settings.memoryTypeProfile': 'Perfil',
  'settings.memoryTypeRule': 'Regra',
  'settings.memoryTabMemories': 'Memórias',
  'settings.memoryTabMemoriesCaption': 'Ver e gerenciar a memória salva',
  'settings.memoryTabHow': 'Como funciona',
  'settings.memoryTabHowCaption': 'Os dois loops e seus controles',
  'settings.memoryAddDisclosure': 'Adicionar ou importar memórias',
  'settings.memoryAddDisclosureHint': 'Perfil, entrada manual ou apps conectados',
  'settings.memoryProfileTab': 'Perfil de trabalho',
  'settings.memoryProfileTabCaption': 'Quem você é e seus padrões',
  'settings.memoryProfileTitle': 'Seu perfil de trabalho',
  'settings.memoryProfileHint':
    'Alguns fatos sobre você e seus padrões. A memória injeta isso antes de cada tarefa para que o agente entenda o que você quer a partir de um pedido curto.',
  'settings.memoryProfileName': 'Perfil de trabalho',
  'settings.memoryProfileDescription':
    'Função, empresa, domínio, público, gosto e padrões que o assistente deve reutilizar.',
  'settings.memoryProfileSave': 'Salvar perfil',
  'settings.memoryProfileSaving': 'Salvando…',
  'settings.memoryProfileSaved': 'Perfil salvo',
  'settings.memoryProfileRole': 'Função',
  'settings.memoryProfileRolePlaceholder': 'ex.: Founder, designer, PM',
  'settings.memoryProfileCompany': 'Empresa / Equipe',
  'settings.memoryProfileCompanyPlaceholder': 'ex.: Acme, equipe de growth',
  'settings.memoryProfileDomain': 'Domínio',
  'settings.memoryProfileDomainPlaceholder': 'ex.: B2B SaaS, fintech, devtools',
  'settings.memoryProfileAudience': 'Público principal',
  'settings.memoryProfileAudiencePlaceholder': 'ex.: executivos, engenheiros, usuários finais',
  'settings.memoryProfileAesthetic': 'Estética / gosto',
  'settings.memoryProfileAestheticPlaceholder':
    'ex.: clean e editorial, fundos claros, bastante espaço em branco',
  'settings.memoryProfileDeliverables': 'Entregáveis padrão',
  'settings.memoryProfileDeliverablesPlaceholder': 'ex.: landing pages, decks, one-pagers',
  'settings.memoryProfileLocale': 'Idioma / Região',
  'settings.memoryProfileLocalePlaceholder': 'ex.: English (US), Simplified Chinese',
  'settings.memoryProfileGoals': 'Objetivos atuais',
  'settings.memoryProfileGoalsPlaceholder':
    'ex.: lançar a nova página de preços, aumentar a conversão no fluxo de teste',
  'settings.memoryHooksTitle': 'Hooks de memória',
  'settings.memoryHooksHint':
    'Escolha quais partes da memória rodam automaticamente. O interruptor principal acima desliga todas elas.',
  'settings.memoryHooksProfileLabel': 'Usar meu perfil',
  'settings.memoryHooksProfileDesc': 'Injeta seu perfil de trabalho em cada tarefa.',
  'settings.memoryHooksRewriteLabel': 'Reescrever pedidos curtos',
  'settings.memoryHooksRewriteDesc': 'PRE: expande um pedido curto em um briefing de tarefa completo.',
  'settings.memoryHooksVerifyLabel': 'Autoverificar resultado',
  'settings.memoryHooksVerifyDesc': 'POST: verifica o resultado em relação às suas regras e mostra um placar.',
  'settings.memoryHooksExtractionLabel': 'Aprender com os chats',
  'settings.memoryHooksExtractionDesc': 'Captura fatos úteis e preferências a partir dos turnos de chat.',
  'settings.memoryIndex': 'MEMORY.md (índice)',
  'settings.memoryIndexSave': 'Salvar índice',
  'settings.memoryIndexReset': 'Redefinir',
  'settings.memoryToastChanged': 'Memória atualizada',
  'settings.memoryToastClickHint': 'Ver',
  'settings.memoryAll': 'Todas',
  'settings.memoryExtractions': 'Histórico de extração',
  'settings.memoryExtractionsHint': 'Recent LLM-backed extraction attempts. Heuristic regex extraction always runs first; LLM extraction runs in the background after each turn.',
  'settings.memoryExtractionsEmpty': 'Nenhuma extração ainda. O próximo turno do chat preencherá esta lista.',
  'settings.memoryExtractionsRefresh': 'Atualizar',
  'settings.memoryExtractionsRefreshing': 'Atualizando…',
  'settings.memoryExtractionPhaseRunning': 'Executando…',
  'settings.memoryExtractionPhaseSuccess': 'Sucesso',
  'settings.memoryExtractionPhaseSkipped': 'Ignorado',
  'settings.memoryExtractionPhaseFailed': 'Falhou',
  'settings.memoryExtractionSkipNoProvider': 'Nenhuma API key configurada para extração de memória por LLM.',
  'settings.memoryExtractionSkipDisabled': 'A memória está desativada.',
  'settings.memoryExtractionSkipEmpty': 'Mensagem do usuário vazia — nada a extrair.',
  'settings.memoryExtractionSkipNoMatch': 'Nenhum padrão regex correspondeu a esta interação.',
  'settings.memoryExtractionKindHeuristic': 'regex',
  'settings.memoryExtractionKindLlm': 'LLM',
  'settings.memoryExtractionProviderEnv': 'env',
  'settings.memoryExtractionProviderMediaConfig': 'configurações de mídia',
  'settings.memoryExtractionProviderOverride': 'configurações de memória',
  'settings.memoryExtractionProposed': 'proposto',
  'settings.memoryExtractionWritten': 'gravado',
  'settings.memoryExtractionDuration': 'em',
  'settings.memoryExtractionDelete': 'Excluir',
  'settings.memoryVerifyTitle': 'Verificações recentes',
  'settings.memoryVerifyStatusPass': 'Aprovado',
  'settings.memoryVerifyStatusFail': 'Reprovado',
  'settings.memoryVerifyStatusMissing': 'Não verificado',
  'settings.memoryVerifyRules': '{covered} de {active} regras conferidas',
  'settings.memoryVerifyUncovered': 'Regras que a rodada não tratou:',
  'settings.memoryVerifyArtifact': 'No arquivo entregue:',
  'settings.memoryVerifyRowsFailed': '{failed} de {total} verificações reprovadas',
  'settings.memoryExtractionsClear': 'Limpar',
  'settings.memoryExtractionsClearTitle': 'Limpar todo o histórico de extração',
  'settings.memoryExtractionsClearConfirm': 'Limpar todo o histórico de extração? Isso não pode ser desfeito.',
  'settings.memoryNoProviderBannerTitle': 'A extração de memória por LLM não está em execução',
  'settings.memoryNoProviderBannerBody': 'Nenhuma API key encontrada para o extrator de memória. Adicione uma chave da OpenAI em provedores de mídia, ou defina ANTHROPIC_API_KEY / OPENAI_API_KEY no ambiente, para ativar a extração baseada em LLM. A extração heurística por regex continua ativa.',
  'settings.libraryInstall': 'Instalar',
  'settings.libraryInstallGithub': 'GitHub',
  'settings.libraryInstallLocal': 'Caminho local',
  'settings.libraryInstallUrl': 'https://github.com/owner/repo',
  'settings.libraryInstallPath': '/path/to/skill-folder',
  'settings.libraryInstallButton': 'Instalar',
  'settings.libraryUninstall': 'Desinstalar',
  'settings.libraryBuiltIn': 'Integrado',
  'settings.libraryInstalled': 'Instalado',
  'notify.successTitle': 'Tarefa concluída',
  'notify.failureTitle': 'Tarefa falhou',
  'notify.successBody': 'Uma rodada foi concluída.',
  'notify.failureBody': 'A tarefa terminou com erro.',
  'updater.available': 'Atualização disponível',
  'updater.availableBody': 'Crie3 {version} está disponível. Ela será baixada antes que o instalador possa abrir.',
  'updater.checking': 'Verificando atualizações',
  'updater.download': 'Baixar atualização',
  'updater.downloading': 'Baixando atualização',
  'updater.downloadingPercent': 'Baixando atualização {percent}%',
  'updater.done': 'Concluído',
  'updater.failed': 'Falha na atualização',
  'updater.installerOpenBody': 'O instalador está aberto. O Crie3 está saindo para que você conclua a atualização.',
  'updater.installerOpened': 'Instalador aberto',
  'updater.later': 'Mais tarde',
  "updater.allowSilentUpdates": "Permitir atualizações silenciosas",
  'updater.openFailedFallback': 'Não foi possível abrir o instalador.',
  'updater.installRestart': 'Instalar e reiniciar',
  'updater.installingRestart': 'Instalando e reiniciando...',
  'updater.openInstaller': 'Instalar atualização',
  'updater.opening': 'Abrindo instalador...',
  'updater.payloadReadyGeneric': 'Uma nova atualização do Crie3 está pronta. O Crie3 vai fechar e reiniciar automaticamente.',
  'updater.payloadReadyVersion': 'O Crie3 {version} está pronto. O Crie3 vai fechar e reiniciar automaticamente.',
  'updater.quitButton': 'Sair do Crie3',
  'updater.quitFailedBody': 'O instalador está aberto, mas não foi possível sair do Crie3. Saia do Crie3 antes de substituir o app.',
  'updater.quitFailedTitle': 'Não foi possível sair',
  'updater.quitting': 'Saindo...',
  'updater.ready': 'Atualização pronta',
  'updater.readyGeneric': 'Uma nova versão está pronta. O Crie3 será fechado e abrirá o instalador.',
  'updater.readyVersion': 'Crie3 {version} está pronto. O Crie3 será fechado e abrirá o instalador.',
  'updater.upToDate': 'Você já está na versão mais recente.',
  'whatsNew.cta': 'Ver as novidades',
  'whatsNew.dismissAria': 'Fechar as novidades',
  'newsletter.label': 'E-mail (opcional)',
  'newsletter.placeholder': 'voce@email.com',
  'newsletter.phoneLabel': 'Telefone / WhatsApp (opcional)',
  'newsletter.phonePlaceholder': '(00) 00000-0000',
  'newsletter.consent': 'Aceito receber novidades e contato do Crie3 por e-mail e WhatsApp.',
  'settings.memoryModelInlineLabel': 'Modelo de memória',
  'settings.memoryModelInlineSameAsChat': 'Igual ao chat',
  'settings.memoryModelInlineSameAsChatWithModel': 'Igual ao chat ({model})',
  'settings.memoryModelInlineSameAsChatWithProvider': 'Igual ao chat ({provider})',
  'settings.memoryModelInlineHintCli': 'Optional. The memory extractor uses an env-var or media-providers API key on this provider; pinning a model here just overrides the auto-pick.',
  'settings.memoryModelInlineHintCliConstrained': 'Optional. Memory will call {provider}; needs an env-var or media-providers API key for that provider, or pick a model below to override.',
  'settings.memoryModelInlineHintByok': 'Optional. Reuses your chat API key on the same provider — picking a different (usually cheaper) model only changes the request body.',
  'settings.memoryModelInlineFlashSaved': 'Salvo',
  'settings.memoryModelInlineFlashCleared': 'Limpo',
  'settings.orbit.eyebrow': 'Automação',
  'settings.orbit.title': 'Orbit',
  'settings.orbit.navHint': 'Resumo diário de conectores',
  'settings.orbit.lede': 'Coletar atividade dos conectores em uma agenda e publicar o resultado como um live artifact atualizável.',
  'settings.orbit.statusOnTitle': 'execuções diárias agendadas estão ativadas',
  'settings.orbit.statusOffTitle': 'execuções diárias agendadas estão desativadas',
  'settings.orbit.statusActive': 'Ativo',
  'settings.orbit.statusOff': 'Desativado',
  'settings.orbit.runTitle': 'Iniciar uma execução Orbit e abrir a conversa ao vivo',
  'settings.orbit.running': 'Executando…',
  'settings.orbit.runOpen': 'Executar agora',
  'settings.orbit.dailySummaryTitle': 'Resumo diário',
  'settings.orbit.dailySummarySub': 'Executa uma vez por dia no horário local agendado.',
  'settings.orbit.on': 'Ativado',
  'settings.orbit.off': 'Desativado',
  'settings.orbit.runTimeTitle': 'Horário de execução',
  'settings.orbit.runTimeSub': 'Padrão 08:00. Salve para aplicar à agenda do daemon.',
  'settings.orbit.runTimeAria': 'Horário diário de execução Orbit',
  'settings.orbit.nextRun': 'Próxima execução',
  'settings.orbit.nextRunScheduledAfterSave': 'Agendada após salvar',
  'settings.orbit.schedule': 'Agenda',
  'settings.orbit.pausedManualOnly': 'Pausado — apenas execuções manuais',
  'settings.orbit.templateTitle': 'Modelo de pedido',
  'settings.orbit.templateMissing': 'O modelo {id} não está instalado.',
  'settings.orbit.templateMissingOption': '{id} (ausente)',
  'settings.orbit.templateMissingInstall': 'Instale uma skill Orbit para orientar o pedido.',
  'settings.orbit.templateMissingPickAnother': 'Escolha outro modelo no menu.',
  'settings.orbit.templateResetTitle': 'Redefinir para {id}',
  'settings.orbit.templateReset': 'Redefinir',
  'settings.orbit.templateHelp': 'Oriente o Orbit com uma skill — o pedido de exemplo do modelo escolhido entra em cada execução do Orbit para que os resumos sigam esse formato.',
  'settings.orbit.templateAria': 'Modelo de pedido do Orbit',
  'settings.orbit.templatesLoading': 'Carregando modelos…',
  'settings.orbit.templatesOptgroup': 'Modelos de skills Orbit',
  'settings.orbit.lastRun': 'Última execução',
  'settings.orbit.triggerManual': 'Manual',
  'settings.orbit.triggerScheduled': 'Agendada',
  'settings.orbit.meterAria': '{succeeded} bem-sucedidos, {skipped} ignorados, {failed} com falha de {checked} verificados',
  'settings.orbit.countChecked': 'Verificados',
  'settings.orbit.countSucceeded': 'Bem-sucedidos',
  'settings.orbit.countSkipped': 'Ignorados',
  'settings.orbit.countFailed': 'Falharam',
  'settings.orbit.runError': 'Não foi possível executar Orbit. Verifique se o daemon local está em execução e se os conectores estão configurados.',
  'settings.orbit.gateAriaLabel': 'Conectores são necessários para usar o Orbit',
  'settings.orbit.gateEyebrow': 'Configuração necessária',
  'settings.orbit.gateTitle': 'Conecte uma ferramenta para alimentar o Orbit',
  'settings.orbit.gateBody': 'O Orbit resume a atividade dos seus conectores. Você ainda não conectou nada — adicione ao menos uma integração para o Orbit ter o que reportar.',
  'settings.orbit.gateBodyNoKey': 'O Orbit resume a atividade dos conectores, e os conectores operam via Composio. Adicione uma chave de API do Composio em Conectores para desbloquear o catálogo e escolher sua primeira integração.',
  'settings.orbit.gateAction': 'Abrir Conectores',
  'settings.orbit.gateActionNoKey': 'Configurar Composio',
  'settings.orbit.gateLoading': 'Verificando seus conectores…',
  'settings.orbit.controlsLockedBadge': 'Bloqueado',
  'settings.orbit.controlsLockedHint': 'Conecte uma ferramenta para desbloquear a programação e o modelo do Orbit.',
  'settings.orbit.artifactKickerLive': 'artefato ao vivo',
  'settings.orbit.artifactKickerLegacy': 'Resumo legado',
  'settings.orbit.artifactTitle': 'Resumo diário de atividade Orbit',
  'settings.orbit.artifactMetaLive': 'Artefato HTML atualizável gerado da atividade dos conectores.',
  'settings.orbit.artifactMetaLegacy': 'Gerado antes de ativar o suporte a live artifact — execute Orbit novamente para publicar um.',
  'settings.orbit.copyMarkdownTitle': 'Copiar resumo Markdown para a área de transferência',
  'settings.orbit.copied': 'Copiado',
  'settings.orbit.copy': 'Copiar',
  'settings.orbit.openArtifact': 'Abrir artefato',
  'settings.orbit.sourceMarkdown': 'Markdown de origem',
  'settings.memoryModelInlineHintByokNeutral': 'A memória usa um modelo separado do chat. O padrão é o seu modelo de chat.',
  'diagnostics.exportTitle': 'Exportar diagnósticos',
  'diagnostics.exportButton': 'Exportar diagnósticos',
  'diagnostics.exportHint': 'Empacota logs recentes do app e informações do dispositivo em um zip para enviar à equipe.',
  'diagnostics.exporting': 'Exportando…',
  'diagnostics.exportSuccess': 'Diagnósticos salvos em {path}',
  'diagnostics.exportFailed': 'Falha ao exportar diagnósticos: {message}',
  'automations.eyebrow': 'Sessões de agentes agendadas',
  'automations.title': 'Automações',
  'automations.lede': 'Planeje conversas recorrentes para trabalho de projeto, resumos do Orbit e artefatos ao vivo.',
  'automations.summaryAria': 'Resumo de automações',
  'automations.metricActive': 'Ativas',
  'automations.metricPaused': 'Pausadas',
  'automations.metricTemplates': 'Modelos',
  'automations.newAutomation': 'Nova automação',
  'automations.yourAutomations': 'Suas automações',
  'automations.loading': 'Carregando',
  'automations.emptyTitle': 'Nenhuma automação ainda',
  'automations.emptyBody': 'Crie uma a partir de um modelo ou comece com um agendamento em branco.',
  'automations.targetNewEachRun': 'Novo projeto a cada execução',
  'automations.targetCreateEachRun': 'Novo projeto a cada execução',
  'automations.lastRun': 'Última execução {time}',
  'automations.openResult': 'Abrir resultado',
  'automations.run': 'Executar',
  'automations.runNowTitle': 'Executar agora e abrir a conversa',
  'automations.history': 'Histórico',
  'automations.hideHistory': 'Ocultar histórico',
  'automations.edit': 'Editar',
  'automations.pause': 'Pausar',
  'automations.resume': 'Retomar',
  'automations.deleteAria': 'Excluir automação',
  'automations.deleteTitle': 'Excluir esta automação',
  'automations.deleteConfirm': 'Excluir esta automação? As execuções anteriores e seus projetos são mantidos.',
  'automations.proposalsTitle': 'Propostas de evolução',
  'automations.proposalsSub': 'Revise a saída da automação antes que ela altere memória, skills ou design systems.',
  'automations.proposalsPending': '{n} pendentes',
  'automations.apply': 'Aplicar',
  'automations.reject': 'Rejeitar',
  'automations.proposalsDismissReason': 'Descartada em Automações',
  'automations.templatesTitle': 'Modelos',
  'automations.templatesSub': 'Orbit e artefatos ao vivo são modelos dentro do mesmo fluxo de automação.',
  'automations.templatesCount': '{filtered} de {total}',
  'automations.templateFiltersAria': 'Filtros de modelos',
  'automations.templatesEmptyTitle': 'Nenhum modelo nesta categoria ainda.',
  'automations.templatesEmptyBody': 'Experimente um filtro diferente ou comece com uma automação em branco.',
  'automations.useTemplate': 'Usar modelo',
  'automations.runHistoryLoading': 'Carregando histórico de execuções...',
  'automations.runHistoryEmpty': 'Nenhuma execução ainda.',
  'automations.runHistoryTitle': 'Histórico de execuções',
  'automations.runHistoryLatest': 'Últimas 10',
  'automations.crystallize': 'Cristalizar',
  'automations.crystallizing': 'Cristalizando',
  'automations.crystallizeTitle': 'Rascunhar propostas de skill e memória a partir desta execução',
  'automations.crystallizeFailed': 'Falha ao cristalizar: {error}',
  'automations.crystallizePartialSuccess': 'A cristalização criou propostas, mas Automações não conseguiu atualizar a lista de propostas. Revise as propostas visíveis ou tente atualizar.',
  'automations.crystallizeRefreshFailed': 'A cristalização foi concluída, mas Automações não conseguiu atualizar as propostas. Tente atualizar antes de executar novamente.',
  'automations.crystallizeNoProposals': 'A cristalização foi concluída, mas nenhuma proposta foi retornada. Tente atualizar ou verifique os detalhes da execução.',
  'automations.openConversation': 'Abrir conversa',
  'automations.runHistoryAria': 'Histórico de execuções da automação',
  'automations.proposalsAria': 'Propostas de evolução da automação',
  'automations.templatesAria': 'Modelos de automação',
  'automations.runInProgress': 'Em andamento',
  'automations.promptPlaceholder': 'Buscar a atividade de ontem no GitHub + Linear e resumir o que mudou.',
  'automations.scheduleStatusPaused': 'Pausada',
  'automations.nextRunManualOnly': 'Somente manual',
  'automations.nextRunScheduled': 'Agendada',
  'automations.nextRunAt': 'Próxima {time}',
  'automations.statusSucceeded': 'Concluída',
  'automations.statusFailed': 'Falhou',
  'automations.statusRunning': 'Em execução',
  'automations.statusQueued': 'Na fila',
  'automations.statusCanceled': 'Cancelada',
  'automations.kindOrbit': 'Orbit',
  'automations.kindLiveArtifact': 'Artefato ao vivo',
  'automations.kindAutomation': 'Automação',
  'automations.proposalTargetMemory': 'Memória',
  'automations.proposalTargetDesignSystem': 'Design system',
  'automations.proposalTargetSkill': 'Skill',
  'automations.proposalTargetTemplate': 'Modelo de automação',
  'automations.proposalActionCreate': 'Criar',
  'automations.proposalActionUpdate': 'Atualizar',
  'automations.proposalActionMerge': 'Mesclar',
  'automations.proposalActionMove': 'Mover',
  'automations.proposalActionDelete': 'Excluir',
  'automations.proposalActionPromote': 'Promover',
  'automations.filterAll': 'Todas',
  'automations.filterOrbit': 'Orbit',
  'automations.filterLiveArtifacts': 'Artefatos ao vivo',
  'automations.filterMemory': 'Memória',
  'automations.filterDesignSystems': 'Design systems',
  'automations.filterSkills': 'Skills',
  'automations.filterConnectors': 'Conectores',
  'automations.filterCompression': 'Compressão',
  'automations.filterRelease': 'Versão',
  'automations.filterQuality': 'Qualidade',
  'automations.tpl.memoryRefresh.title': 'Atualizar a memória do projeto com base no trabalho recente.',
  'automations.tpl.memoryRefresh.desc': 'Transforma decisões, preferências e feedback recorrentes em atualizações de memória reutilizáveis.',
  'automations.tpl.designSystemRefresh.title': 'Atualizar design systems a partir de artefatos entregues.',
  'automations.tpl.designSystemRefresh.desc': 'Encontra tokens, componentes e regras reutilizáveis em trabalhos de design recentes.',
  'automations.tpl.liveArtifactRegistry.title': 'Auditar artefatos ao vivo e atualizar versões desatualizadas.',
  'automations.tpl.liveArtifactRegistry.desc': 'Mantém dashboards, relatórios e previews persistentes atualizados em vez de duplicá-los.',
  'automations.tpl.orbitDashboard.title': 'Criar um dashboard de atividade de conectores.',
  'automations.tpl.orbitDashboard.desc': 'Agrega os conectores selecionados em um dashboard ao vivo no estilo Orbit.',
  'automations.tpl.releaseNotes.title': 'Rascunhar notas de versão a partir do trabalho de design entregue.',
  'automations.tpl.releaseNotes.desc': 'Conecta PRs mesclados, artefatos e mudanças voltadas ao produto em notas de versão.',
  'automations.tpl.qualityRegressionWatch.title': 'Monitorar regressões de design e implementação.',
  'automations.tpl.qualityRegressionWatch.desc': 'Compara mudanças recentes com benchmarks, traces e referências aprovadas.',
  'automations.tpl.orbitDaily.title': 'Resumo diário de conectores.',
  'automations.tpl.orbitDaily.desc': 'Atualiza um resumo de atividade de conectores em um agendamento.',
  'automations.tpl.liveStatusBoard.title': 'Manter um artefato de status ao vivo atualizado.',
  'automations.tpl.liveStatusBoard.desc': 'Atualiza um único artefato persistente em vez de criar um novo relatório a cada execução.',
  'dsManager.areaAria': 'Área de design systems',
  'dsManager.tabDesignSystem': 'Design system',
  'dsManager.tabTemplate': 'Modelo',
  'dsManager.sourceAria': 'Origem do design system',
  'dsManager.templateSourceAria': 'Origem do modelo',
  'dsManager.yourSystems': 'Seus sistemas',
  'dsManager.officialPresets': 'Presets oficiais',
  'dsManager.enterprise': 'Enterprise',
  'dsManager.yourTemplates': 'Seus modelos',
  'dsManager.yourSystemsAria': 'Seus design systems',
  'dsManager.eyebrowDesignSystems': 'Design Systems',
  'dsManager.yourSystemsHeading': 'Seus sistemas',
  'dsManager.filterAria': 'Filtrar design systems',
  'dsManager.filterAll': 'Todos',
  'dsManager.filterPublished': 'Publicados',
  'dsManager.filterDraft': 'Rascunho',
  'dsManager.createTitle': 'Criar novo design system',
  'dsManager.createBody': 'Ensine ao Crie3 sua marca, produto, código, ativos e referências de design.',
  'dsManager.createAction': 'Criar',
  'dsManager.emptyMine': 'Nenhum design system ainda. Crie um a partir do contexto real do produto, revise o rascunho e publique-o para projetos futuros.',
  'dsManager.badgeDefault': 'Padrão',
  'dsManager.rowMetaUpdated': 'Você · atualizado {date}',
  'dsManager.edit': 'Editar',
  'dsManager.openSystem': 'Abrir',
  'dsManager.editWithAgent': 'Editar com IA',
  'dsManager.downloadTitle': 'Baixar design system (.zip + SKILLS.md)',
  'dsManager.downloadAria': 'Baixar {title} como .zip',
  'dsManager.downloadFailed': 'Não foi possível baixar o design system. Tente novamente.',
  'dsManager.deleteConfirm': 'Excluir "{title}"? Isso remove o rascunho do design system deste dispositivo.',
  'dsManager.makeDefault': 'Tornar padrão',
  'dsManager.statusPublished': 'Publicado',
  'dsManager.statusDraft': 'Rascunho',
  'dsWorkspace.back': 'Voltar',
  'dsWorkspace.setDefault': 'Padrão para novas conversas',
  'dsWorkspace.setDefaultHint': 'Pré-seleciona este design system para novas conversas e novos projetos.',
  'dsWorkspace.fontsMissingTitle': 'Arquivos de fonte da marca ausentes',
  'dsWorkspace.fontsMissingBody': 'As prévias de tipografia usam fontes substitutas até que os arquivos de fonte da marca sejam adicionados.',
  'dsWorkspace.addFonts': 'Adicionar arquivos de fonte da marca',
  'dsWorkspace.stepRead': 'Ler o sistema atual',
  'dsWorkspace.stepUpdate': 'Atualizar os arquivos de design',
  'dsWorkspace.stepRefresh': 'Atualizar a revisão',
  'dsManager.openSystemAria': 'Abrir {title}',
  'dsManager.deleteSystemAria': 'Excluir {title}',
  'dsManager.presetsAria': 'Presets oficiais de design system',
  'dsManager.eyebrowLibrary': 'Biblioteca',
  'dsManager.eyebrowTemplates': 'Modelos',
  'dsManager.yourTemplatesAria': 'Seus modelos',
  'dsManager.emptyTemplates': 'Nenhum modelo ainda. Crie um a partir de qualquer projeto gerado via Compartilhar assim que a publicação de modelos for habilitada.',
  'dsManager.templateDescFallback': 'Criado a partir de um projeto',
  'dsManager.comingSoonBadge': 'Em breve',
  'dsManager.enterpriseDsTitle': 'Design systems Enterprise',
  'dsManager.enterpriseDsBody': 'Design systems compartilhados de equipe e bibliotecas de marca governadas estão chegando em breve.',
  'dsManager.enterpriseTplTitle': 'Modelos Enterprise',
  'dsManager.enterpriseTplBody': 'Modelos aprovados pela equipe e publicação em toda a organização estão chegando em breve.',
  'settings.instructionsTitle': 'Instruções / Regras',
  'settings.instructionsSubtitle': 'Comportamento fixo que o assistente deve seguir',
  'settings.instructionsNavSub': 'Comportamento fixo do assistente',
  'settings.customInstructionsDesc': 'Instruções fixas que o Crie3 segue em todas as conversas. Estas não são memórias salvas; use a Memória para fatos, preferências e contexto de projeto.',
  'mcpClient.forwardedToLabel': 'Encaminhado para:',
  'mcpClient.notForwardedToLabel': 'Não encaminhado para:',
  'mcpClient.forwardedAcpNote': 'Adaptadores ACP marcados como stdio recebem apenas servidores MCP stdio desta lista; entradas HTTP e SSE são descartadas no momento da inicialização.',
  'mcpClient.notForwardedNote': 'Para esses agentes, configure os servidores MCP no próprio arquivo de configuração do agente (ex.: ~/.codex/config.toml, ~/.gemini/settings.json); os servidores abaixo ficam sem uso silenciosamente nesse caso.',

  // Brands library + extraction
  'brand.libraryTitle': 'Kit de marca',
  'brand.librarySubtitle': 'Teach Crie3 your brand kits — extract one from a website, then apply it in any chat.',
  'brand.newBrand': 'New Brand Kit',
  'brand.searchPlaceholder': 'Search your brand kits…',
  'brand.empty': 'No brand kits yet. Extract one from a website to get started.',
  'brand.colorsCount': '{count} cores',
  'brand.extracting': 'Extraindo…',
  'brand.failed': 'Falha na extração',
  'brand.needsInput': 'Precisa de entrada',
  'brand.needsInputHint': 'Extração pausada — abra o projeto para concluir a verificação ou responder à pergunta.',
  'brand.appliedToChat': 'Usando {name}',
  'brand.previewEmpty': 'Select a brand to preview',
  'brand.viewDetails': 'Ver detalhes',
  'newBrand.title': 'New Brand',
  'newBrand.subtitle': 'Cole um site, ou escolha uma marca abaixo, e extrairemos suas cores, fontes e logo.',
  'newBrand.urlLabel': 'Site da marca',
  'newBrand.urlPlaceholder': 'suaempresa.com',
  'newBrand.extract': 'Extract brand',
  'newBrand.cancel': 'Cancelar',
  'newBrand.close': 'Fechar',
  'newBrand.stage1': 'Buscando o site e medindo seu design',
  'newBrand.stage2': 'Building a brand preview',
  'newBrand.stage3': 'Derivando e registrando o design system',
  'newBrand.measured': '{colors} cores · {fonts} fontes · {logos} logos',
  'newBrand.done': 'Brand ready',
  'brandDetail.identity': 'Identidade',
  'brandDetail.designLanguage': 'Linguagem de design',
  'brandDetail.colors': 'Cores',
  'brandDetail.fonts': 'Fontes',
  'brandDetail.tone': 'Tom',
  'brandDetail.aesthetic': 'Estética',
  'brandDetail.tagline': 'Slogan',
  'brandDetail.voice': 'Voz',
  'brandDetail.useInChat': 'Usar em novo chat',
  'brandDetail.delete': 'Delete brand',
  'brandDetail.back': 'Kit de marca',
  'brandDetail.refining': 'Refining this brand…',
  'brandDetail.notFound': 'Brand not found.',
  'brandDetail.logo': 'Logo',
  'brandDetail.typography': 'Tipografia',
  'brandDetail.palette': 'Paleta',
  'brandDetail.voiceTone': 'Voz e tom',
  'brandDetail.imageryLayout': 'Imagens e layout',
  'brandDetail.images': 'Imagens',
  'brandDetail.designSystem': 'Design system',
  'brandDetail.brandAssets': 'Brand assets',
  'brandDetail.openProject': 'Abrir projeto',
  'brandDetail.themeLight': 'Claro',
  'brandDetail.themeDark': 'Escuro',
  'brandDetail.subjects': 'Temas',
  'brandDetail.treatment': 'Tratamento',
  'brandDetail.useLabel': 'Usar',
  'brandDetail.avoidLabel': 'Evitar',
  'brandDetail.layoutPosture': 'Postura de layout',
  'brandDetail.deleteConfirm': 'Delete "{name}"? This removes the brand and its design system.',
  'brandDetail.viewMore': 'Mostrar todas as {count}',
  'brandDetail.viewLess': 'Mostrar menos',
  'settings.resetOnboarding': 'Redefinir onboarding',
  'settings.resetOnboardingDesc': 'Refaça a configuração inicial, incluindo a extração da marca.',
  'settings.resetOnboardingButton': 'Redefinir',
  'onboarding.brandTitle': 'Extract your brand kit',
  'onboarding.brandSubtitle': 'Paste a website and we\'ll turn its brand signals into a reusable brand kit for future work.',
  'onboarding.brandSkip': 'Skip for now',
  'onboarding.brandDone': 'Brand kit extracted',
  'onboarding.buildTitle': 'Crie uma vez, construa em todo lugar',
  'onboarding.buildBody': 'O Crie3 transforma sua marca em um sistema de design reutilizável — e mantém tudo o que você cria fiel à marca e consistente.',
  'onboarding.buildBenefitMemoryTitle': 'Uma memória de marca',
  'onboarding.buildBenefitMemoryBody': 'Cores, fontes, logo e tom de voz ficam guardados e entram em todas as peças.',
  'onboarding.buildBenefitAlignedTitle': 'Tudo que você cria fica alinhado',
  'onboarding.buildBenefitAlignedBody': 'Posts, carrosséis, stories e convites seguem as mesmas regras.',
  'onboarding.buildBenefitSourcesTitle': 'Comece do que você já tem',
  'onboarding.buildBenefitSourcesBody': 'Use o site, o Instagram, o logo, fotos ou fontes que você já tem.',
  'onboarding.buildPreviewLabel': 'Sistema de marca',
  'onboarding.buildStart': 'Criar um sistema de design',
  'onboarding.interview.title': 'Vamos conhecer sua igreja?',
  'onboarding.interview.body': 'Responda algumas perguntas rápidas e a IA já deixa o perfil da sua igreja pronto para usar nas peças. Pode pular e fazer depois em Configurações.',
  'onboarding.interview.placeholder': 'Digite sua resposta…',
  'onboarding.interview.send': 'Enviar',
  'onboarding.interview.skip': 'Pular por agora',
  'onboarding.interview.start': 'Responder agora',
  'onboarding.interview.sending': 'Digitando…',
  'onboarding.interview.error': 'Não foi possível continuar a entrevista agora. Você pode pular e preencher depois em Configurações → Minha marca.',
  'onboarding.interview.errorQuota': 'Sua conta já usou todo o limite de IA deste mês. Pule por agora; você pode preencher o perfil em Configurações → Minha marca.',
  'onboarding.interview.errorBusy': 'A IA está sobrecarregada agora. Tente de novo em alguns instantes.',
  'onboarding.interview.errorNotConfigured': 'A entrevista com IA não está disponível nesta instalação. Pule por agora; você pode preencher o perfil à mão em Configurações → Minha marca.',
  'onboarding.interview.retry': 'Tentar de novo',
  'onboarding.logo.title': 'Envie o logo da igreja',
  'onboarding.logo.body': 'Ele fica guardado no perfil da sua igreja e entra nas peças que o Crie3 cria. Se tiver duas versões, envie a que vai sobre fundo claro e a que vai sobre fundo escuro. Pode pular e enviar depois em Configurações → Minha marca.',
  'onboarding.interview.titleMinistry': 'Vamos conhecer seu ministério?',
  'onboarding.interview.titleWorship': 'Vamos conhecer sua banda?',
  'onboarding.interview.titleAgency': 'Vamos conhecer sua agência?',
  'onboarding.interview.bodyProfile': 'Responda algumas perguntas rápidas e a IA já deixa o seu perfil pronto para usar nas peças. Pode pular e fazer depois em Configurações.',
  'onboarding.logo.titleMinistry': 'Envie o logo do ministério',
  'onboarding.logo.titleWorship': 'Envie o logo da banda',
  'onboarding.logo.titleAgency': 'Envie o logo da agência',
  'onboarding.logo.bodyProfile': 'Ele fica guardado no seu perfil e entra nas peças que o Crie3 cria. Se tiver duas versões, envie a que vai sobre fundo claro e a que vai sobre fundo escuro. Pode pular e enviar depois em Configurações.',
  'onboarding.interview.done': 'Perfil salvo! Você já pode ajustar tudo em Configurações → Minha marca quando quiser.',
  'onboarding.interview.continue': 'Continuar',
  'onboarding.buildHome': 'Ir para o início',
  'dsCreate.heroEyebrow': "Design system",
  'dsCreate.heroTitle': "Crie um design system em minutos",
  'dsCreate.heroLede': 'Transforme o perfil da sua marca, um site ou os materiais que você já tem em uma identidade visual completa, pronta para usar nas suas artes.',
  'dsCreate.heroStepCount': '3 passos',
  'dsCreate.heroDuration': '~3 min',
  'dsCreate.heroStep1Title': 'Sua marca',
  'dsCreate.heroStep1Desc': 'Use o perfil da Minha marca, um site ou o Instagram',
  'dsCreate.heroStep2Title': 'Envie materiais',
  'dsCreate.heroStep2Desc': 'Logos, capas, fotos, fontes (opcional)',
  'dsCreate.heroStep3Title': 'Gerar',
  'dsCreate.heroStep3Desc': 'Primeiro um rascunho rápido; depois a IA refina',
  'dsCreate.heroShowcaseTitle': "Seu design system",
  'dsFonts.missingTitle': "Faltam os arquivos de fonte da marca",
  'dsFonts.missingBody': "As prévias de tipografia usam fontes web substitutas até que os arquivos da marca sejam enviados.",
  'dsCreate.referenceLabel': 'Copiar de um design system existente',
  'dsCreate.referenceLoading': 'Carregando DESIGN.md...',
  'dsCreate.referenceLoadFailed': 'Não foi possível carregar esse design system.',
  'dsCreate.heroShowGuideAria': 'Mostrar guia do design system',
  'dsCreate.heroHideGuideAria': 'Ocultar guia do design system',
  'dsCreate.heroShowGuideTitle': 'Mostrar guia',
  'dsCreate.heroHideGuideTitle': 'Ocultar guia',
  'dsCreate.heroGuide': 'Guia',
  'dsCreate.missingSourceError': 'Adicione um site, uma descrição, um arquivo ou anotações para criar o design system.',
  'dsCreate.continueToGeneration': 'Continuar para a geração',
  'dsCreate.embeddedTitle': 'Gerar a partir do seu material',
  'dsCreate.embeddedBody': 'Comece pelo site ou pelo Instagram da marca e depois junte os arquivos que já tiver.',
  'dsCreate.sourceSectionTitle': 'Comece pelo que a marca já tem',
  'dsCreate.sourceSectionBody': 'Use o site, o Instagram ou arquivos que mostrem o estilo da marca. O Crie3 cria primeiro um rascunho rápido e, depois, a IA refina dentro do projeto.',
  'dsCreate.githubWebsiteLabel': 'Site ou Instagram da marca',
  'dsCreate.add': 'Adicionar',
  'dsCreate.startFromBrand': 'Começar a partir de uma marca',
  'dsCreate.brandPickerSubtitle': 'Busque entre centenas de marcas — escolha uma e adicionamos o site dela como referência de estilo.',
  'dsCreate.brandPickerQuickPicks': 'Marcas populares — clique para adicionar',
  'dsCreate.addedSourceLinks': 'Links de origem adicionados',
  'dsCreate.openSourceLabel': 'Abrir {label}',
  'dsCreate.removeSourceLabel': 'Remover {label}',
  'dsCreate.addFiles': 'Adicionar arquivos',
  'dsCreate.describeBrand': 'Descrever marca',
  'dsCreate.optional': 'opcional',
  'dsCreate.describeBrandHelp': 'Voz da marca, introdução e contexto do produto. Usado na passagem rápida e no refinamento por IA.',
  'dsCreate.companyPlaceholder': 'Ex.: Vida Nova, Campinas. Acolhedora, jovem, foco em famílias',
  'dsCreate.pasteDesignMd': 'Colar DESIGN.md',
  'dsCreate.pasteDesignMdHelp': 'Cole um DESIGN.md para criar direto a partir das cores, fontes, justificativas e orientações de componentes.',
  'dsCreate.reference': 'Referência',
  'dsCreate.designMdViewMode': 'Modo de visualização do DESIGN.md',
  'dsCreate.advancedToggle': 'Avançado — repositório, código local, Figma',
  'dsCreate.githubRepo': 'Repo do GitHub',
  'dsCreate.localCodeLabel': 'Vincular código local',
  'dsCreate.localCodeHelper': 'Use uma pasta ou arquivos selecionados deste computador.',
  'dsCreate.localCodePrompt': 'Arraste uma pasta aqui ou navegue',
  'dsCreate.uploadFigLabel': 'Enviar .fig',
  'dsCreate.uploadFigHelper': 'Decodificado na sua máquina em cores, fontes, componentes e arquivos reais — sem conta do Figma.',
  'dsCreate.uploadFigPrompt': 'Solte o .fig aqui ou navegue',
  'dsCreate.figmaUrl': 'URL do Figma',
  'dsCreate.figmaPlaceholder': 'https://figma.com/design/… ou /file/…',
  'dsCreate.addedFigmaUrls': 'URLs do Figma adicionadas',
  'dsCreate.savedFigmaHelp': 'Salvo como uma fonte de design do Figma. O agente a usa como referência canônica; exporte um .fig acima para uma decodificação offline completa.',
  'dsCreate.notes': 'Notas',
  'dsCreate.notesPlaceholder': 'ex.: Usamos uma paleta de cores quente e terrosa com cantos arredondados. Nossa voz de marca é descontraída, mas profissional...',
  'dsCreate.back': 'Voltar',
  'dsCreate.generate': 'Gerar',
  'dsCreate.libraryPickerTitle': 'Selecionar da biblioteca',
  'dsCreate.libraryPickerConfirm': 'Adicionar aos assets',
  'dsCreate.designMdPreviewKicker': 'DESIGN SYSTEM',
  'dsCreate.designMdPreviewTitle': 'Prévia do DESIGN.md',
  'dsCreate.componentKit': 'kit de componentes',
  'dsCreate.defaultTheme': 'tema padrão',
  'dsCreate.componentKitTitle': '{name} — kit de componentes',
  'dsCreate.designMdGeneratedDescription': 'Gerado a partir das cores, fontes, justificativa e orientação de componentes do DESIGN.md colado.',
  'dsCreate.previewButtons': 'Botões',
  'dsCreate.previewButtonsHelp': 'Cinco tipos em três tamanhos.',
  'dsCreate.buttonPrimary': 'Primário',
  'dsCreate.buttonDashed': 'Tracejado',
  'dsCreate.buttonText': 'Texto',
  'dsCreate.buttonLink': 'Link',
  'dsCreate.sizeSmall': 'Pequeno',
  'dsCreate.sizeMedium': 'Médio',
  'dsCreate.sizeLarge': 'Grande',
  'dsCreate.previewTypeScale': 'Escala tipográfica',
  'dsCreate.extractedTokens': 'Cores e fontes extraídas do DESIGN.md',
  'brandPicker.heading': 'Comece com uma marca que você ama',
  'brandPicker.subtext': 'Clique em qualquer marca para extrair o kit direto do site dela.',
  'brandPicker.quickPicksLabel': 'Marcas populares — clique para extrair',
  'brandPicker.searchPlaceholder': 'Buscar marcas…',
  'brandPicker.allCategories': 'Todas',
  'brandPicker.extractAction': 'Extrair',
  'brandPicker.showMore': 'Mostrar mais',
  'brandPicker.opening': 'Iniciando a extração — abrindo {brand}…',
  'ds.kitVisualize': 'Visualizar',
  'ds.kitEdit': 'Editar',
  'ds.kitSource': 'Código',
  'ds.saveDesignMd': 'Salvar DESIGN.md',
  'ds.saving': 'Salvando…',
  'ds.copyDesignMd': 'Copiar DESIGN.md',
  'ds.editDesignMd': 'Editar DESIGN.md',
  'ds.openDesignMd': 'Abrir DESIGN.md',
  'ds.copyDesignMdModule': 'Copiar seção {module}',
  'ds.editDesignMdModule': 'Editar seção {module}',
  'ds.openDesignMdModule': 'Abrir seção {module}',
  'ds.uploadMd': 'Enviar MD',
  'ds.uploadFont': 'Adicionar arquivo de fonte',
  'ds.pasteImage': 'Colar imagem',
  'ds.refresh': 'Atualizar',
  'ds.download': 'Baixar',
  'ds.importFolder': 'Importar pasta',
  'ds.reset': 'Redefinir',
  'ds.editingDesignMdHint': 'Editar este Markdown atualiza os módulos renderizados do kit.',
  'ds.editingModuleHint': 'Apenas o módulo {module} está sendo editado.',
  'ds.manualEditModuleHint': 'Edite {module} aqui. Passe o mouse sobre esta seção para revelar os controles.',
  'ds.saveModule': 'Salvar módulo',
  'ds.uploadLogo': 'Enviar logo',
  'ds.uploadImage': 'Enviar imagem',
  'ds.uploading': 'Enviando…',
  'ds.moduleEmptyLogo': 'Ainda sem logo',
  'ds.moduleEmptyFonts': 'Nenhuma fonte capturada.',
  'ds.actionDone': 'Concluído',
  'ds.actionFailed': 'Algo deu errado. Tente novamente.',
  'ds.uploadDone': 'Enviado',
  'ds.uploadFailed': 'Falha no envio. Tente novamente.',
  'ds.deleteLogo': 'Excluir logo',
  'ds.deleteImage': 'Excluir {caption}',
  'ds.deleteProjectConfirm': 'Excluir "{title}"? Isso remove permanentemente este design system e seu projeto deste dispositivo.',
  'ds.deleteProjectAction': 'Excluir {title}',
  'ds.editColor': 'Editar {name}',
  'ds.colorLabel': 'Cor',
  'ds.hexLabel': 'Hex',
  'ds.hexValueLabel': 'Valor Hex',
  'ds.saveColor': 'Salvar cor',
  'ds.invalidHexColor': 'Insira uma cor Hex válida, como #FF6A3D.',
  'ds.colorSaveFailed': 'Não foi possível salvar esta cor.',
  'ds.colorResetFailed': 'Não foi possível redefinir esta cor.',
  'ds.designMdSectionLabel': 'Seção {module} do DESIGN.md',
  'ds.kitErrorTitle': 'Esta visualização encontrou um problema.',
  'ds.kitErrorRetry': 'Recarregar',
  'ds.shortcutsLabel': 'Atalhos do teclado',
  'ds.shortcutsHint': 'Atalhos: E editar · C copiar · U enviar · R atualizar · ⌫ excluir logo',
  'ds.moduleEmptyImages': 'Ainda sem imagens',
  'ds.noOriginalColor': 'Não há cor original disponível para esta amostra.',
  'ds.manifestReadFailed': 'Não foi possível ler _ds_manifest.json.',
  'ds.reviewCollapseSection': 'Recolher {title}',
  'ds.reviewExpandSection': 'Expandir {title}',
  'ds.reviewNeedsReview': 'Precisa de revisão',
  'ds.reviewLooksGood': 'Está bom',
  'ds.reviewActionsLabel': 'Revisão de {title}',
  'ds.reviewNeedsWorkEllipsis': 'Precisa de ajustes...',
  'ds.reviewEditFile': 'Editar {file}',
  'ds.reviewFeedbackLabel': 'Diga ao agente o que mudar',
  'ds.reviewFeedbackPlaceholder': 'ex.: aperte o espaçamento em {title}, gere esta prévia de novo...',
  'ds.reviewChangedAfterFeedback': 'Esta seção mudou após o seu feedback. Revise-a novamente antes de publicar.',
  'ds.reviewChangedDuringRun': 'Esta seção mudou durante a última execução. Revise-a antes de publicar.',
  'ds.reviewLastFeedback': 'Último feedback',
  'ds.previewGenerating': 'Gerando prévia...',
  'ds.creatingProjectTitle': 'Criando seu design system...',
  'ds.creatingProjectSubtitle': 'Mantenha esta aba aberta. Você pode voltar em alguns minutos.',
  'ds.generationProgressLabel': 'Progresso da geração do design system {progress}%',
  'ds.publishRepoRequiredTitle': 'Termine de importar seu repo do GitHub antes de publicar.',
  'ds.publishDesignSystem': 'Publicar design system',
  'ds.unpublishDesignSystem': 'Despublicar design system',
  'ds.published': 'Publicado',
  'ds.publish': 'Publicar',
  'ds.extractionRunningTitle': 'Extraindo design system',
  'ds.extractionCompleteTitle': 'Extração concluída',
  'ds.extractionRunningBody': 'O Crie3 está atualizando este sistema no lugar.',
  'ds.extractionCompleteBody': 'Todos os módulos extraídos são mostrados abaixo; seções vazias estão intencionalmente em branco.',
  'ds.publishCardPublished': 'Os novos projetos da sua equipe podem usar este design system como contexto por padrão.',
  'ds.publishCardDraft': 'Seu design system está pronto, mas seu feedback vai melhorá-lo. Publique-o quando estiver pronto para usar em projetos futuros.',
  'ds.useSystemTitle': 'Usar este sistema',
  'ds.useSystemBody': 'Comece um novo design que herda as cores, a tipografia e os componentes deste sistema — mantido na identidade da marca automaticamente.',
  'ds.createNewDesign': 'Criar novo design',
  'ds.openSourceContext': 'Abrir contexto de origem',
  'ds.manifestNeedsAttention': 'O manifesto de design precisa de atenção',
  'ds.openManifest': 'Abrir manifesto',
  'ds.workspacePreparing': 'Preparando o espaço de trabalho do design system.',
  'ds.workspaceLoadingLabel': 'O espaço de trabalho do design system está carregando',
  'ds.sectionQueued': 'Na fila',
  'ds.sectionReviewUpdatedFiles': 'Arquivos atualizados precisam de revisão',
  'ds.reviewNeedsWork': 'Precisa de ajustes',
  'ds.sectionRequiredFileMissing': 'Arquivo obrigatório ausente: {file}',
  'ds.sectionNoFilesYet': 'Nenhum arquivo ainda',
  'ds.generationSourceTitle': 'Contexto de origem',
  'ds.generationSourceDetail': 'Lendo o contexto de origem vinculado e as evidências do repositório.',
  'ds.generationGuidanceTitle': 'Orientação de marca',
  'ds.generationGuidanceDetail': 'Escrevendo a orientação e a voz do DESIGN.md.',
  'ds.generationTokensTitle': 'Cores e fontes',
  'ds.generationTokensDetail': 'Extraindo cores, tipografia e espaçamento.',
  'ds.generationPreviewsTitle': 'Cards de prévia',
  'ds.generationPreviewsDetail': 'Renderizando cards de prévia revisáveis.',
  'ds.generationUiKitTitle': 'UI kit',
  'ds.generationUiKitDetail': 'Criando componentes e padrões reutilizáveis.',
  'ds.generationAssetsTitle': 'Assets de marca',
  'ds.generationAssetsDetail': 'Coletando logos, fontes, imagens e ícones.',
  'ds.phaseQueuedTypography': 'Tipografia na fila',
  'ds.phaseQueuedTokens': 'Cores e fontes na fila',
  'ds.phaseQueuedSpacing': 'Espaçamento na fila',
  'ds.phaseQueuedUiKit': 'UI kit na fila',
  'ds.phaseQueuedAssets': 'Assets na fila',
  'ds.phaseReadingTypography': 'Lendo tipografia',
  'ds.phaseReadingTokens': 'Lendo cores e fontes',
  'ds.phaseReadingSpacing': 'Lendo espaçamento',
  'ds.phaseReadingUiKit': 'Lendo UI kit',
  'ds.phaseReadingAssets': 'Lendo assets',
  'ds.phaseWritingTypography': 'Escrevendo tipografia',
  'ds.phaseWritingTokens': 'Escrevendo cores e fontes',
  'ds.phaseWritingSpacing': 'Escrevendo espaçamento',
  'ds.phaseBuildingUiKit': 'Construindo UI kit',
  'ds.phaseUpdatingAssets': 'Atualizando assets',
  'ds.phaseNeedsAttention': 'Precisa de atenção',
  'ds.phaseUpdated': 'Atualizado',
  'ds.sectionActivityFromTodo': '{phase}: {todo}',
  'ds.sectionActivityReadFiles': 'Leu {files}',
  'ds.sectionActivityPhaseFiles': '{phase}: {files}',
  'ds.sectionRunningReadingContext': 'Lendo o contexto de {title}.',
  'ds.sectionRunningNow': '{phase} agora.',
  'ds.reviewLastReviewed': 'Última revisão {time}',
  'ds.agentFeedbackQueued': 'Feedback do agente na fila',
  'ds.agentFeedbackSent': 'Feedback do agente enviado',
  'ds.agentFeedbackSentAt': 'Feedback do agente enviado {time}',
  'ds.agentFeedbackFailedWithError': 'Falha no feedback do agente: {error}',
  'ds.agentFeedbackFailed': 'Falha no feedback do agente',
  'ds.agentFeedbackUnknown': 'Status do feedback do agente desconhecido',
  'ds.repoConnectBannerTitle': 'Conecte seu repo para puxar aspectos do seu design system',
  'ds.repoConnectCardTitle': 'Conecte seu repo',
  'ds.repoConnectPendingBody': 'Verificando sua conexão com o GitHub...',
  'ds.repoConnectPendingButton': 'Verificando o GitHub...',
  'ds.repoConnectedTitle': 'O GitHub está conectado',
  'ds.repoConnectedBody': 'Reimporte este repo para puxar seus arquivos para o seu design system.',
  'ds.repoImportButton': 'Importar repo',
  'ds.repoConnectBannerBody': 'Conecte o GitHub para que o Crie3 possa ler seu repositório e puxar cores, tipografia e componentes para este design system.',
  'ds.repoConnectCardBody': 'Puxe cores, tipografia e componentes do seu repositório para este design system.',
  'ds.repoConnectButton': 'Conectar GitHub',
  'newproj.startFromLabel': 'Começar de',
  'newproj.startBlank': 'Em branco',
  'newproj.startBlankHint': 'Começar do zero',
  'workspace.pages': 'Páginas',
  'workspace.allProjectFiles': 'Todos os arquivos do projeto',
  'workspace.newBlankPage': 'Nova página em branco',
  'workspace.noPagesYet': 'Nenhuma página ainda',
  'workspace.pageCreateFailed': 'Não foi possível criar a página.',
  'workspace.pageCreatorTitle': 'Criar página',
  'workspace.pageCreatorSearch': 'Buscar modelos',
  'workspace.pageCreatorCategoryAll': 'Todos os cenários',
  'workspace.pageCreatorEmpty': 'Nenhum tipo de página corresponde à sua busca.',
  'workspace.pageCreatorPreview': 'Pré-visualizar',
  'workspace.pageCreatorUse': 'Usar',
  'fileViewer.presentInTabDeckHint': 'Notas do apresentador em janela popup',
  'fileViewer.presentEscHint': 'Pressione Esc para sair',
  'fileViewer.presenterPause': 'Pausar',
  'fileViewer.presenterResume': 'Retomar',
  'fileViewer.presenterPrevious': 'Anterior',
  'fileViewer.presenterNext': 'Próximo',
  'questions.uploadingFiles': 'Enviando arquivos…',
  'questions.uploadNeedsProject': 'O envio de arquivos precisa de um projeto ativo.',
  'questions.uploadPartialFailed': '{uploaded} arquivo(s) enviado(s), mas {failed} falharam.',
  'questions.uploadFailed': 'Falha no envio de {failed} arquivo(s).',
  // TikTok consent screen. The Music Usage Confirmation sentence and the
  // processing notice are NOT here on purpose: they come from the server in
  // English because a human auditor reads those exact words, and translating
  // them would change the thing being checked.
  'fileViewer.publishToSocial': 'Publicar nas redes',
  'social.loading': 'Carregando suas contas…',
  'settings.socialNetworks': 'Redes sociais',
  'settings.socialNetworksHint': 'Contas conectadas e publicação',
  'social.connectionsTitle': 'Contas conectadas',
  'social.clientConnectHint': 'Para conectar o Instagram de um cliente, abra a ficha do cliente em {screen} e use “{button}”. Os botões abaixo conectam o perfil da própria conta.',
  'social.noConnections': 'Nenhuma conta conectada ainda.',
  'social.disconnect': 'Desconectar',
  'social.connectTo': 'Conectar {network}',
  'social.connectFailed': 'Não foi possível iniciar a conexão. A publicação pode ainda não estar configurada.',
  'social.appCredentialsTitle': 'Chaves do aplicativo',
  'social.appCredentialsHint': 'As chaves do aplicativo desta instalação em cada rede. Todo mundo que usa o produto publica através dele.',
  'social.publishingOn': 'A publicação está ligada.',
  'social.publishingOff': 'Publicação desligada: {reason}',
  'social.sourceEnv': 'do ambiente',
  'social.sourceStored': 'salva aqui',
  'social.sourceUnset': 'não definida',
  'social.managedByEnv': 'Definida por variável de ambiente no servidor, que tem precedência. Editar aqui não teria efeito.',
  'social.save': 'Salvar',
  'social.saving': 'Salvando…',
  'social.clear': 'Limpar',
  'social.publicBaseUrl': 'Endereço público',
  'social.publicBaseUrlHint': 'A origem pública de onde as redes baixam a imagem. Sem ela, todo post falha do outro lado.',
  'social.noAccounts': 'Nenhuma conta do TikTok conectada ainda.',
  'social.connectTikTok': 'Conectar TikTok',
  'social.notConfigured': 'Esta instalação não tem credenciais do app do TikTok, então não dá para conectar contas.',
  'social.account': 'Conta',
  'social.postingAs': 'Publicando como {name}',
  'social.preview': 'O que vai ser publicado',
  'social.titleLabel': 'Título',
  'social.captionLabel': 'Legenda',
  'social.privacyLabel': 'Quem pode ver',
  'social.privacyPlaceholder': 'Escolha o público',
  'social.privacyRequired': 'Escolha quem pode ver este post.',
  'social.disableComment': 'Desativar comentários',
  'social.commercialContent': 'Este post é conteúdo comercial',
  'social.yourBrand': 'Sua marca',
  'social.yourBrandHint': 'Marca o post como conteúdo promocional.',
  'social.brandedContent': 'Conteúdo de marca',
  'social.brandedContentHint': 'Marca o post como parceria paga.',
  'social.disclosureRequired': 'Conteúdo comercial exige pelo menos uma divulgação.',
  'social.brandedNotPrivate': 'Uma parceria paga não pode ser publicada como “só eu”.',
  'social.musicRequired': 'Aceite a Music Usage Confirmation para continuar.',
  'social.publish': 'Aprovar e agendar',
  'social.publishing': 'Enviando…',
  'social.queued': 'Aprovado. Vai ao ar no horário que você escolheu.',
  'social.cancel': 'Cancelar',
  'social.close': 'Fechar',
  'social.errorGeneric': 'Algo deu errado. Tente de novo.',
  'social.noMedia': 'Este projeto ainda nao tem imagens JPEG ou WebP para publicar.',
  'social.renderTitle': 'Imagens para o Instagram',
  'social.renderHint': 'O Instagram só aceita JPEG. Isto transforma cada card da peça numa imagem, na ordem, e guarda no projeto.',
  'social.renderAction': 'Preparar imagens',
  'social.renderBusy': 'Preparando imagens…',
  'social.renderDone': '{count} imagens prontas em {folder}.',
  'social.renderUnavailable': 'Esta instalação não consegue transformar peças em imagens.',
  'social.renderTryLater': 'Não foi possível preparar as imagens agora. Tente de novo em instantes.',
  'social.assembleTitle': 'Vídeo a partir destes slides',
  'social.assembleHint': 'Cada slide entra inteiro num quadro vertical, nunca cortado, e fica três segundos na tela. O vídeo é mudo: trilha sonora é decisão de direitos, não um padrão. Nada é publicado — o arquivo fica neste projeto.',
  'social.assembleAction': 'Montar o vídeo',
  'social.assembleBusy': 'Montando o vídeo...',
  'social.assembleDone': 'Salvo como {path} — {width}x{height}, {seconds}s, sem áudio. Nada foi publicado.',
  'social.assembleUnavailable': 'Esta instalação não tem codificador de vídeo, então não dá para montar o clipe aqui.',
  // Instagram connect funnel. The account-type question comes before any
  // redirect on purpose: Instagram cannot be reached by a personal account,
  // and Meta does not document what such an attempt returns.
  'social.connectInstagram': 'Conectar Instagram',
  'social.askAccountKind': 'Que tipo de conta do Instagram é?',
  'social.askAccountKindWhy': 'O Instagram só deixa aplicativos publicarem a partir de conta profissional. Responder agora evita um login que falha.',
  'social.accountKindProfessional': 'Criador de conteúdo ou Empresa',
  'social.accountKindPersonal': 'Pessoal',
  'social.accountKindUnsure': 'Não tenho certeza',
  'social.convertTitle': 'Antes, mude para conta de Criador',
  'social.convertWhy': 'É grátis, leva menos de um minuto e dá para voltar atrás quando quiser. Seu @, seus posts e seus seguidores continuam exatamente como estão.',
  'social.convertDone': 'Pronto — conectar agora',
  'social.convertStep1': 'Abra o app do Instagram e vá até o seu perfil.',
  'social.convertStep2': 'Toque no menu e depois em Configurações e privacidade.',
  'social.convertStep3': 'Toque em Tipo de conta e ferramentas e depois em Mudar para conta profissional.',
  'social.convertStep4': 'Escolha Criador de conteúdo (ou Empresa), selecione uma categoria e conclua.',
  'social.convertStep5': 'Volte aqui e conecte de novo.',
  // Assisted delivery. A different promise from automatic publishing, and
  // the copy says so wherever it appears — selling one plan that silently
  // delivers both behaviours is what produces refunds.
  'social.assistedLabel': 'Eu mesmo publico',
  'social.assistedHint': 'No horário marcado você recebe a peça e a legenda prontas e publica em dois toques. Não é publicação automática.',
  'social.queuedAssisted': 'Agendado. No horário que você escolheu, a peça e a legenda chegam prontas para publicar.',
  // The list where an assisted piece actually arrives.
  'social.waitingForYou': 'Pronto para você publicar',
  'social.openApp': 'Abrir o app',
  'social.iPosted': 'Publiquei',
  // Reaching the two paths that had no entry point.
  'social.connectFacebook': 'Conectar uma Página do Facebook',
  'social.assistedOffer': 'Sem conta profissional? Dá para agendar mesmo assim.',
  'social.whereWillYouPost': 'Onde você vai publicar?',
  // ISSUE-026 — dicas curtas no lugar dos prompts de ação que a rotação do
  // placeholder mostrava para a igreja.
  'chat.composerHintPiece1': 'Peça uma arte para o culto de domingo',
  'chat.composerHintPiece2': 'Troque a cor, a foto ou o versículo',
  'chat.composerHintPiece3': 'Peça uma versão para os stories',
  'chat.composerHintImage1': 'Descreva a imagem que você quer para o post',
  'chat.composerHintImage2': 'Peça a mesma imagem em outra cor',
  'chat.composerHintVideo1': 'Descreva o vídeo curto do convite',
  'chat.composerHintVideo2': 'Peça uma versão mais curta para os stories',
  'chat.composerHintAudio1': 'Diga o que anunciar, e em que voz',
  'chat.composerHintAudio2': 'Peça uma leitura mais calma e mais devagar',
  'chat.composerHintDesignSystem1': 'Peça para melhorar as cores e as fontes da igreja',
  'chat.composerHintDesignSystem2': 'Pergunte o que ainda falta aqui',
  'chat.composerHintPlan1': 'Peça para transformar este plano nas peças',
  'chat.composerHintPlan2': 'Peça para melhorar o plano antes',
  // ISSUE-014 — as partes da linha "o que você mandou" na transcrição.
  'dsCreate.sourceLabelDesignMd': 'DESIGN.md colado',
  'dsCreate.sourceLabelFile': '1 arquivo',
  'dsCreate.sourceLabelFiles': '{count} arquivos',
  'dsCreate.sourceLabelFolder': '1 pasta',
  'dsCreate.sourceLabelFolders': '{count} pastas',
  'dsCreate.sourceLabelLink': '1 link',
  'dsCreate.sourceLabelLinks': '{count} links',
  'dsCreate.sourceLabelDescription': 'descrição',
  'dsCreate.sourceLabelChurchProfile': 'seu perfil da Minha marca',
  'dsCreate.churchProfileTitle': 'Você já preencheu isso em Minha marca',
  'dsCreate.churchProfileBody': 'As cores, as fontes, os logos e a voz que você salvou ficam prontos aqui. Dá para mudar tudo depois — ou preencher do zero, se este visual for outro.',
  'dsCreate.churchProfileUse': 'Usar o perfil da Minha marca',
  'dsCreate.churchProfileApplied': 'Veio do seu perfil da Minha marca',
  'dsCreate.churchProfileDrop': 'Não usar o perfil',
};
